(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({"./src/app/index.js":[function(require,module,exports){
/**
  Project created by Ciris Solutions - Jan 2015
  Improved and continued by SpaceDev.uy - March 2017 - Current
*/
"use strict";
var _name = require("../../package.json").name;
var prefix = "ciris-" + _name;
var lenguaje = "en";

//URL del backend en constante "urlApi"
var mod = angular.module(_name, [
  "ngAnimate",
  "ngMessages",
  "ngTouch",
  "ngStorage",
  "ngSanitize",
  "ui.router",
  "ui.bootstrap",
  "firebase",
  "toastr",
  "satellizer",
  "angular-loading-bar",
  "angularUtils.directives.uiBreadcrumbs",
  "pascalprecht.translate",
  "Backend",
  "ja.qr",
  "as.sortable",
  "uiGmapgoogle-maps",
  "ngFileUpload",
  "angular.filter",
  "ui.mask",
  "angular-intro",
  "angular-tour",
  require("ng-infinite-scroll"),
  //require('ng-infinite-scroll'),
  require("./base").name,
  require("./login").name,
  require("./main").name,
  require("./customers").name,
  require("./employees").name,
  require("./inspections/").name,
  require("./jobboard").name,
  require("./servicerequest").name,
  require("./reports").name,
  require("./clients").name,
  require("./customerportal").name,
  require("./helpvideos").name
]);

mod.config(config);
mod.run(run);

config.$inject = [
  "$locationProvider",
  "$compileProvider",
  "toastrConfig",
  "$authProvider",
  "urlNode",
  "$localStorageProvider",
  "$sessionStorageProvider",
  "cfpLoadingBarProvider",
  "$translateProvider",
  "uiGmapGoogleMapApiProvider"
];

function config(
  $locationProvider,
  $compileProvider,
  toastrConfig,
  $authProvider,
  urlNode,
  $localStorageProvider,
  $sessionStorageProvider,
  cfpLoadingBarProvider,
  $translateProvider,
  googleMaps
) {
  html5Mode(true);
  $compileProvider.debugInfoEnabled(false);

  function html5Mode(mode) {
    if (window.history && window.history.pushState) {
      $locationProvider.html5Mode({
        enabled: mode,
        requireBase: false
      });
    }
  } //html5Mode
  $localStorageProvider.setKeyPrefix(prefix + "-");
  $sessionStorageProvider.setKeyPrefix(prefix + "-");
  configureToastr(toastrConfig);
  configureSatellizer($authProvider, urlNode);
  configureI18n($translateProvider);
  require("./base/configureLoadingBar.js")(lenguaje, cfpLoadingBarProvider);
  configureGoogleMaps(googleMaps);
} //function

run.$inject = [
  "$rootScope",
  "$auth",
  "$state",
  "Notifications",
  "$http",
  "$sessionStorage",
  "$localStorage",
  "ClientAPI",
  "Validations",
  "webenvironment",
  "$timeout"
];

function run(
  $rootScope,
  $auth,
  $state,
  Notifications,
  $http,
  $sessionStorage,
  $localStorage,
  ClientAPI,
  Validations,
  webenvironment,
  $timeout
) {
  var parStateChange = require("./stateChange.js");
  var stateChange = parStateChange(
    $auth,
    $localStorage,
    $sessionStorage,
    Notifications,
    $state,
    $http,
    ClientAPI,
    Validations,
    $rootScope
  );
  $rootScope.$on("$stateChangeStart", stateChange);
  $rootScope.$on("$stateChangeError", notFound);

  $rootScope.sentryOptions = {
    debug: true,
    environment: webenvironment
  };
  $rootScope.sentryCDN =
    webenvironment != "development"
      ? "https://feaf9c82f37c4174b8457cbe7d48444c@sentry.io/111837"
      : false;

  Raven.config($rootScope.sentryCDN, $rootScope.sentryOptions);

  Raven.install();

  //TODO: we need to change this method entirely
  function notFound(event, toState, toParams, fromState, fromParams, error) {
    event.preventDefault();
    $auth.logout().then(function() {
      delete $localStorage.user;
      $state.go("login");
    });
  }
}

function configureSatellizer($authProvider, url) {
  $authProvider.storageType = "sessionStorage";
  $authProvider.loginUrl = url + "api/auth/login";
  $authProvider.baseUrl = url;
  $authProvider.tokenPrefix = prefix;
}

function configureToastr(toastrConfig) {
  angular.extend(toastrConfig, {
    autoDismiss: true,
    containerId: "toast-container",
    maxOpened: 0,
    newestOnTop: true,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    preventOpenDuplicates: false,
    target: "body",
    allowHtml: true,
    closeButton: true,
    closeHtml: "<span>x</span>",
    //extendedTimeOut: 25000,
    iconClasses: {
      error: "toast-rich",
      info: "toast-rich",
      success: "toast-rich",
      warning: "toast-rich"
    },
    messageClass: "toast-message",
    onHidden: null,
    onShown: null,
    onTap: null,
    progressBar: false,
    tapToDismiss: true,
    timeOut: 5000,
    titleClass: "toast-title",
    toastClass: "alert"
  });
}

function configureI18n($translateProvider) {
  $translateProvider.useSanitizeValueStrategy(null);
  $translateProvider.translations(
    "en",
    require("../resources/i18n/en-US.json")
  );
  $translateProvider.translations(
    "es",
    require("../resources/i18n/es-CR.json")
  );
  moment.locale(lenguaje);
  $translateProvider.preferredLanguage(lenguaje);
}

function configureGoogleMaps(API) {
  API.configure({
    key: "AIzaSyC15TkWYaTzDMlb1B2NIAn9pUuB5mY1fZE",
    v: "3.20",
    libraries: "weather,geometry,visualization"
  });
}

module.exports = mod;

angular.element(document).ready(function() {
  angular.bootstrap(document, [mod.name], { strictDi: true });
});

},{"../../package.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/package.json","../resources/i18n/en-US.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/resources/i18n/en-US.json","../resources/i18n/es-CR.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/resources/i18n/es-CR.json","./base":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/index.js","./base/configureLoadingBar.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/configureLoadingBar.js","./clients":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/clients/index.js","./customerportal":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customerportal/index.js","./customers":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/index.js","./employees":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/employees/index.js","./helpvideos":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/helpvideos/index.js","./inspections/":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/index.js","./jobboard":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/jobboard/index.js","./login":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/index.js","./main":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/main/index.js","./reports":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/index.js","./servicerequest":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/servicerequest/index.js","./stateChange.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/stateChange.js","ng-infinite-scroll":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/node_modules/ng-infinite-scroll/build/ng-infinite-scroll.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/node_modules/ng-infinite-scroll/build/ng-infinite-scroll.js":[function(require,module,exports){
/* ng-infinite-scroll - v1.3.0 - 2016-06-30 */
angular.module('infinite-scroll', []).value('THROTTLE_MILLISECONDS', null).directive('infiniteScroll', [
  '$rootScope', '$window', '$interval', 'THROTTLE_MILLISECONDS', function($rootScope, $window, $interval, THROTTLE_MILLISECONDS) {
    return {
      scope: {
        infiniteScroll: '&',
        infiniteScrollContainer: '=',
        infiniteScrollDistance: '=',
        infiniteScrollDisabled: '=',
        infiniteScrollUseDocumentBottom: '=',
        infiniteScrollListenForEvent: '@'
      },
      link: function(scope, elem, attrs) {
        var changeContainer, checkInterval, checkWhenEnabled, container, handleInfiniteScrollContainer, handleInfiniteScrollDisabled, handleInfiniteScrollDistance, handleInfiniteScrollUseDocumentBottom, handler, height, immediateCheck, offsetTop, pageYOffset, scrollDistance, scrollEnabled, throttle, unregisterEventListener, useDocumentBottom, windowElement;
        windowElement = angular.element($window);
        scrollDistance = null;
        scrollEnabled = null;
        checkWhenEnabled = null;
        container = null;
        immediateCheck = true;
        useDocumentBottom = false;
        unregisterEventListener = null;
        checkInterval = false;
        height = function(elem) {
          elem = elem[0] || elem;
          if (isNaN(elem.offsetHeight)) {
            return elem.document.documentElement.clientHeight;
          } else {
            return elem.offsetHeight;
          }
        };
        offsetTop = function(elem) {
          if (!elem[0].getBoundingClientRect || elem.css('none')) {
            return;
          }
          return elem[0].getBoundingClientRect().top + pageYOffset(elem);
        };
        pageYOffset = function(elem) {
          elem = elem[0] || elem;
          if (isNaN(window.pageYOffset)) {
            return elem.document.documentElement.scrollTop;
          } else {
            return elem.ownerDocument.defaultView.pageYOffset;
          }
        };
        handler = function() {
          var containerBottom, containerTopOffset, elementBottom, remaining, shouldScroll;
          if (container === windowElement) {
            containerBottom = height(container) + pageYOffset(container[0].document.documentElement);
            elementBottom = offsetTop(elem) + height(elem);
          } else {
            containerBottom = height(container);
            containerTopOffset = 0;
            if (offsetTop(container) !== void 0) {
              containerTopOffset = offsetTop(container);
            }
            elementBottom = offsetTop(elem) - containerTopOffset + height(elem);
          }
          if (useDocumentBottom) {
            elementBottom = height((elem[0].ownerDocument || elem[0].document).documentElement);
          }
          remaining = elementBottom - containerBottom;
          shouldScroll = remaining <= height(container) * scrollDistance + 1;
          if (shouldScroll) {
            checkWhenEnabled = true;
            if (scrollEnabled) {
              if (scope.$$phase || $rootScope.$$phase) {
                return scope.infiniteScroll();
              } else {
                return scope.$apply(scope.infiniteScroll);
              }
            }
          } else {
            if (checkInterval) {
              $interval.cancel(checkInterval);
            }
            return checkWhenEnabled = false;
          }
        };
        throttle = function(func, wait) {
          var later, previous, timeout;
          timeout = null;
          previous = 0;
          later = function() {
            previous = new Date().getTime();
            $interval.cancel(timeout);
            timeout = null;
            return func.call();
          };
          return function() {
            var now, remaining;
            now = new Date().getTime();
            remaining = wait - (now - previous);
            if (remaining <= 0) {
              $interval.cancel(timeout);
              timeout = null;
              previous = now;
              return func.call();
            } else {
              if (!timeout) {
                return timeout = $interval(later, remaining, 1);
              }
            }
          };
        };
        if (THROTTLE_MILLISECONDS != null) {
          handler = throttle(handler, THROTTLE_MILLISECONDS);
        }
        scope.$on('$destroy', function() {
          container.unbind('scroll', handler);
          if (unregisterEventListener != null) {
            unregisterEventListener();
            unregisterEventListener = null;
          }
          if (checkInterval) {
            return $interval.cancel(checkInterval);
          }
        });
        handleInfiniteScrollDistance = function(v) {
          return scrollDistance = parseFloat(v) || 0;
        };
        scope.$watch('infiniteScrollDistance', handleInfiniteScrollDistance);
        handleInfiniteScrollDistance(scope.infiniteScrollDistance);
        handleInfiniteScrollDisabled = function(v) {
          scrollEnabled = !v;
          if (scrollEnabled && checkWhenEnabled) {
            checkWhenEnabled = false;
            return handler();
          }
        };
        scope.$watch('infiniteScrollDisabled', handleInfiniteScrollDisabled);
        handleInfiniteScrollDisabled(scope.infiniteScrollDisabled);
        handleInfiniteScrollUseDocumentBottom = function(v) {
          return useDocumentBottom = v;
        };
        scope.$watch('infiniteScrollUseDocumentBottom', handleInfiniteScrollUseDocumentBottom);
        handleInfiniteScrollUseDocumentBottom(scope.infiniteScrollUseDocumentBottom);
        changeContainer = function(newContainer) {
          if (container != null) {
            container.unbind('scroll', handler);
          }
          container = newContainer;
          if (newContainer != null) {
            return container.bind('scroll', handler);
          }
        };
        changeContainer(windowElement);
        if (scope.infiniteScrollListenForEvent) {
          unregisterEventListener = $rootScope.$on(scope.infiniteScrollListenForEvent, handler);
        }
        handleInfiniteScrollContainer = function(newContainer) {
          if ((newContainer == null) || newContainer.length === 0) {
            return;
          }
          if (newContainer.nodeType && newContainer.nodeType === 1) {
            newContainer = angular.element(newContainer);
          } else if (typeof newContainer.append === 'function') {
            newContainer = angular.element(newContainer[newContainer.length - 1]);
          } else if (typeof newContainer === 'string') {
            newContainer = angular.element(document.querySelector(newContainer));
          }
          if (newContainer != null) {
            return changeContainer(newContainer);
          } else {
            throw new Error("invalid infinite-scroll-container attribute.");
          }
        };
        scope.$watch('infiniteScrollContainer', handleInfiniteScrollContainer);
        handleInfiniteScrollContainer(scope.infiniteScrollContainer || []);
        if (attrs.infiniteScrollParent != null) {
          changeContainer(angular.element(elem.parent()));
        }
        if (attrs.infiniteScrollImmediateCheck != null) {
          immediateCheck = scope.$eval(attrs.infiniteScrollImmediateCheck);
        }
        return checkInterval = $interval((function() {
          if (immediateCheck) {
            handler();
          }
          return $interval.cancel(checkInterval);
        }));
      }
    };
  }
]);

if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
  module.exports = 'infinite-scroll';
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/package.json":[function(require,module,exports){
module.exports={
  "name": "firelab-admin-dasboard",
  "version": "2.2.256",
  "description": "",
  "main": "src/app/index.js",
  "author": "Ciris Informatic Solutions",
  "devDependencies": {
    "bower": "^1.6.5",
    "browser-sync": "^2.12.3",
    "browserify": "^8.1.0",
    "connect-history-api-fallback": "0.0.5",
    "git-guppy": "^1.2.1",
    "gulp": "^3.8.10",
    "gulp-angular-templatecache": "^1.5.0",
    "gulp-complexity": "^0.3.2",
    "gulp-concat": "^2.4.3",
    "gulp-jscs": "^3.0.2",
    "gulp-jshint": "^1.11.2",
    "gulp-jsinspect": "^2.0.0",
    "gulp-less": "^3.0.5",
    "gulp-minify-html": "^0.1.8",
    "gulp-ng-constant": "^0.3.0",
    "gulp-notify": "^2.2.0",
    "gulp-plumber": "^1.0.1",
    "gulp-qunit": "^1.2.1",
    "gulp-rename": "^1.2.2",
    "gulp-size": "^2.0.0",
    "gulp-sloc": "^1.0.4",
    "gulp-sourcemaps": "1.6.0",
    "gulp-uglify": "^1.1.0",
    "gulp-util": "^3.0.2",
    "gulp-watch": "^4.1.0",
    "guppy-pre-commit": "^0.4.0",
    "jasmine-core": "^2.3.4",
    "jshint": "^2.8.0",
    "jshint-stylish": "^2.0.1",
    "karma": "^0.13.15",
    "karma-browserify": "^4.4.0",
    "karma-chrome-launcher": "^0.2.1",
    "karma-jasmine": "^0.3.6",
    "karma-phantomjs-launcher": "^0.2.1",
    "karma-spec-reporter": "0.0.22",
    "less-plugin-autoprefix": "^1.5.1",
    "less-plugin-clean-css": "^1.5.1",
    "lodash": "^3.7.0",
    "log": "^1.4.0",
    "main-bower-files": "^2.5.0",
    "map-stream": "0.0.6",
    "mkdirp": "^0.5.1",
    "phantomjs": "^1.9.18",
    "readline-sync": "^1.4.5",
    "rimraf": "^2.2.8",
    "vinyl-buffer": "^1.0.0",
    "vinyl-source-stream": "^1.0.0",
    "watchify": "^2.2.1",
    "webdriver-manager": "^8.0.0",
    "yargs": "^3.26.0"
  },
  "scripts": {
    "lint": "lessc --lint src/less/main.less"
  },
  "dependencies": {
    "ng-infinite-scroll": "^1.3.0"
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/configureLoadingBar.js":[function(require,module,exports){
"use strict";

module.exports = configureLoadingBar;

var ingles = require("../../resources/i18n/en-US.json");
var espaniol = require("../../resources/i18n/es-CR.json");

function configureLoadingBar(language, cfpLoadingBarProvider) {
  cfpLoadingBarProvider.includeSpinner = false;

  cfpLoadingBarProvider.loadingBarTemplate =
    "<div id='loading-bar'>" +
    "<aside class='splash-title'>" +
    "<h1>" +
    texts(language, "title") +
    "</h1>" +
    "<div class='bar'></div>" +
    "<p>" +
    texts(language, "loadingbar") +
    "</p>" +
    "<i class='fa fa-fw fa-circle-o-notch fa-2x fa-spin'></i>" +
    "</aside>" +
    "</div>";
}

function texts(language, key) {
  switch (language) {
    case "es":
      return espaniol[key];
    default:
      return ingles[key];
  }
}

},{"../../resources/i18n/en-US.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/resources/i18n/en-US.json","../../resources/i18n/es-CR.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/resources/i18n/es-CR.json"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/btnBack.js":[function(require,module,exports){
"use strict";
module.exports = btnBack;

function btnBack() {
  return {
    restric: "EA",
    link: link
  };
}

function link(scope, elem) {
  elem.on("click", function() {
    window.history.back();
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisEnter.js":[function(require,module,exports){
"use strict";

module.exports = cisEnter;

function cisEnter() {
  return function(scope, element, attrs) {
    element.bind("keydown keypress", function(event) {
      if (event.which === 13 || event.which === 32 || event.which === 188) {
        scope.$apply(function() {
          scope.$eval(attrs.cisEnter);
        });
        event.preventDefault();
      }
    });
  };
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisMinimize.js":[function(require,module,exports){
"use strict";

module.exports = cisMinimize;

function cisMinimize() {
  return {
    restrict: "A",
    scope: true,
    link: function($scope, $element) {
      if ($(window).width() < 768) {
        darken();
        styles();
      }
      $element.on("click", minimize);
      function minimize() {
        darken();
        styles();
      }
    }
  };
}

function styles() {
  $("#wrapper").toggleClass("minimized");
  $("#logo").toggleClass("hideLogo");
  if ($("#wrapper").hasClass("minimized")) {
    $("#MinifierIcon").removeClass("fa-chevron-left");
    $("#MinifierIcon").addClass("fa-chevron-right");
  } else {
    $("#MinifierIcon").removeClass("fa-chevron-right");
    $("#MinifierIcon").addClass("fa-chevron-left");
  }
}

function darken() {
  if ($(window).width() < 768) {
    if ($("#wrapper").hasClass("minimized")) {
      $("#darken").removeClass("hidden");
    } else {
      $("#darken").addClass("hidden");
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisMonthpicker.js":[function(require,module,exports){
"use strict";
module.exports = cisMonthpicker;

cisMonthpicker.$inject = [];
function cisMonthpicker() {
  return {
    restrict: "AE",
    require: "ngModel",
    replace: true,
    scope: {},
    templateUrl: "base/views/cisMonthpicker.html",
    link: link
  };
  function link($scope, $elem, $attrs, ngModelCtrl) {
    $scope.today = moment();
    $scope.year = year;
    $scope.open = open;
    $scope.disableMonth = disableMonth;
    $scope.activeMonth = activeMonth;
    $scope.moveYear = moveYear;
    $scope.setDate = setDate;
    $scope.hidden = true;
    $scope.showBackButton = showBackButton;

    $scope.$watch(
      function() {
        return ngModelCtrl.$viewValue;
      },
      function(val) {
        $scope.model = val;
      }
    );

    function moveYear(val) {
      var newDate = moment($scope.model, "YYYY-MM-DD").add(val, "years");
      if (newDate.year() >= $scope.today.year()) {
        $scope.model = newDate.format("YYYY-MM-DD");
        $scope.months = months($scope.model);
      }
    }

    function year() {
      return moment($scope.model, "YYYY-MM-DD").format("YYYY");
    }

    function months(startDate) {
      var point = moment(startDate).startOf("year");
      var data = [];
      var length = 12;
      for (var i = 0; i < length; i += 1) {
        data.push(moment(point).add(i, "months"));
      }
      return data;
    }

    function disableMonth(month) {
      return month.isBefore(moment($scope.today).startOf("month"));
    }

    function activeMonth(month) {
      return month.month() === moment($scope.model, "YYYY-MM-DD").month();
    }

    function setDate(month) {
      ngModelCtrl.$setViewValue(month.format("YYYY-MM-DD"));
      $scope.model = ngModelCtrl.$viewValue;
      $scope.hidden = true;
    }

    function open() {
      if ($scope.hidden) {
        if (ngModelCtrl.$viewValue) {
          $scope.model = ngModelCtrl.$viewValue;
        } else {
          $scope.model = moment($scope.today).format("YYYY-MM-DD");
        }
        $scope.months = months($scope.model);
        $scope.hidden = false;
      } else {
        $scope.hidden = true;
      }
    }

    function showBackButton() {
      var lastYear = moment($scope.model, "YYYY-MM-DD")
        .subtract(1, "years")
        .year();
      var currentYear = $scope.today.year();
      return lastYear >= currentYear;
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisNumericalInput.js":[function(require,module,exports){
"use strict";
module.exports = cisNumericalInput;
cisNumericalInput.$inject = ["$filter"];
function cisNumericalInput($filter) {
  return {
    require: "ngModel",
    restrict: "E",
    link: link($filter)
  };
}

function link($filter) {
  return function(scope, element, attrs, ngModelCtrl) {
    if (attrs.type === "numerical") {
      ngModelCtrl.$parsers.push(function(val) {
        var clean = val.replace(/[^0-9,\,]+/g, "");
        if (val !== clean) {
          ngModelCtrl.$setViewValue(clean);
          ngModelCtrl.$render();
        }
        if (clean === "") {
          clean = "0";
        }
        return parseFloat(clean.replace(",", "."));
      });
      ngModelCtrl.$formatters.push(function(val) {
        var DecimalCount = String(val).split(".")[1];
        var decimals = 0;
        if (DecimalCount) {
          decimals = DecimalCount.length;
        }
        return $filter("Number")(val, decimals);
      });

      element.bind("keypress", function(event) {
        if (event.keyCode === 32) {
          event.preventDefault();
        }
      });
    }
    return;
  };
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisScrollHover.js":[function(require,module,exports){
"use strict";
module.exports = cisScrollHover;

var mapPosition = {
  "left-hover": {
    scrollLeft: "-=35"
  },
  "right-hover": {
    scrollLeft: "+=35"
  },
  "top-hover": {
    scrollTop: "-=35"
  },
  "bottom-hover": {
    scrollTop: "+=35"
  }
};

function cisScrollHover() {
  return {
    restrict: "A",
    scope: {
      isDragging: "="
    },
    link: link
  };
}

function link($scope, $elem) {
  var idElem, scroll, table, exit;
  $elem.hover(
    function() {
      if ($scope.isDragging) {
        exit = false;
        table = $elem[0].getAttribute("class");
        scroll = mapPosition[table];
        idElem =
          table === "left-hover" || table === "right-hover"
            ? "#" + $elem.parent()[0].childNodes[2].getAttribute("id")
            : "#right-panel";
        scrollTable();
      }
    },
    function() {
      exit = true;
    }
  );

  function scrollTable() {
    $(idElem).animate(scroll, 100, "linear", function() {
      if (!exit) {
        scrollTable();
      }
    });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisSwitch.js":[function(require,module,exports){
"use strict";

module.exports = cisSwitch;

function cisSwitch() {
  return {
    restrict: "EA",
    replace: true,
    templateUrl: "base/views/cisSwitch.html",
    require: "ngModel",
    scope: true,
    link: link
  };
}

function link($scope, $elem, $attr, ngModelCtrl) {
  $scope.id = uuid();
  $scope.type = $attr.type || null;
  $scope.value = false;
  $scope.apply = apply;

  $scope.$watch(
    function() {
      return $scope.$eval($attr.ngDisabled);
    },
    function(val) {
      if (val) {
        $elem.addClass("disabled");
      } else {
        $elem.removeClass("disabled");
      }
    }
  );

  $scope.$watch(
    function() {
      return ngModelCtrl.$modelValue;
    },
    function(val) {
      if (val) {
        $scope.value = ngModelCtrl.$modelValue;
      } else {
        ngModelCtrl.$setViewValue($scope.value);
      }
    }
  );

  function apply(val) {
    ngModelCtrl.$setViewValue(val);
  }
}

function uuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisTitle.js":[function(require,module,exports){
"use strict";

module.exports = title;

title.$inject = ["$rootScope", "$timeout", "$translate"];
function title($rootScope, $timeout, $translate) {
  return {
    restrict: "EA",
    scope: true,
    link: link
  };

  function link(scope, element) {
    $rootScope.$on("$stateChangeStart", change);

    function change(event, toState) {
      var title = headliner(toState);
      $timeout(function() {
        element.text(title);
      });
    }

    function headliner(toState) {
      var title = $translate.instant("title");
      if (toState.data && toState.data.title) {
        return $translate.instant(toState.data.title) + " | " + title;
      }
      return title;
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisUpload.js":[function(require,module,exports){
"use strict";

module.exports = cisUpload;

cisUpload.$inject = [
  "urlApi",
  "ImageAPI",
  "$auth",
  "Upload",
  "Notifications",
  "$sessionStorage"
];
function cisUpload(
  urlApi,
  ImageAPI,
  $auth,
  Upload,
  Notifications,
  $sessionStorage
) {
  return {
    restrict: "EA",
    replace: true,
    templateUrl: "base/views/cisUpload.html",
    require: "ngModel",
    scope: true,
    link: link
  };

  function link($scope, $elem, $attr, ngModelCtrl) {
    $scope.id = uuid();
    $scope.zoomIn = zoomIn;
    $scope.zoomOut = zoomOut;
    $scope.exportCrop = exportCrop;
    $scope.cancelCrop = cancelCrop;
    $scope.suffix = $attr.suffix;
    $scope.idImage = "image" + $scope.suffix;
    $scope.imageElem = $elem[0].children[0].children[1];
    $scope.estados = {
      seleccion: "seleccion",
      previa: "previa",
      subiendo: "subiendo",
      exito: "exito"
    };

    $($scope.imageElem).on("load", function() {
      initiateCropper();
    });

    function initiateCropper() {
      $($scope.imageElem).cropper({
        highlight: false,
        modal: false,
        guides: false,
        dragMode: "move",
        background: false,
        crop: bringToFront
      });
    }

    function bringToFront(e) {
      $scope.currentContainer = e.currentTarget.nextElementSibling;
      var style = $scope.currentContainer.getAttribute("style");
      $scope.currentContainer.setAttribute("style", style + "z-index: 666;");
    }

    function zoomIn() {
      $($scope.imageElem).cropper("zoom", 0.1);
    }

    function zoomOut() {
      $($scope.imageElem).cropper("zoom", -0.1);
    }

    function exportCrop() {
      var data = $($scope.imageElem).cropper("getContainerData");
      $($scope.imageElem).cropper("setCropBoxData", data);
      $scope.resultImage = $($scope.imageElem)
        .cropper("getCroppedCanvas")
        .toDataURL("image/png");
      subirArchivo();
    }

    function cancelCrop() {
      $scope.cisArchivo = null;
      $scope.resultImage = null;

      $($scope.imageElem).cropper("destroy");
      $scope.estado = $scope.estados.seleccion;
    }

    $scope.updateResultImage = function(base64) {
      $scope.resultImage = base64;
      $scope.$apply(); // Apply the changes.
    };

    $scope.acepta = $attr.acepta || "";
    $scope.small = $attr.small || false;
    $scope.subirArchivo = subirArchivo;
    $scope.estado = $scope.estados.seleccion;
    $scope.borrarSeleccion = borrarSeleccion;
    $scope.archivoSeleccionado = archivoSeleccionado;

    function archivoSeleccionado(file) {
      $scope.estado = $scope.estados.previa;
      $scope.cisArchivo = file;
    }

    function borrarSeleccion() {
      delete $scope.cisArchivo;
      $scope.estado = $scope.estados.seleccion;
    }

    function subirArchivo() {
      $scope.estado = $scope.estados.subiendo;
      $scope.uploaded = 0;
      ImageAPI.upload(
        $scope.resultImage,
        $scope.suffix,
        $sessionStorage.user.$id
      )
        .then(function(result) {
          if (result.success) {
            $scope.currentContainer.setAttribute("class", "cropper-container");
            $scope.estado = $scope.estados.exito;
            ngModelCtrl.$setViewValue($scope.resultImage);
          } else {
            Notifications.add(
              500,
              "There was an error while uploading image, please try again."
            );
          }
        })
        .catch(function(exp) {
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error, check your network connection and try again."
          );
        });
    }
  }
}

function uuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/clickOn.js":[function(require,module,exports){
"use strict";
module.exports = clickEn;

function clickEn() {
  return {
    restrict: "A",
    link: link
  };
}

function link($scope, $elem, attr) {
  $elem.on("click", function() {
    $("#" + attr.clickEn).click();
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/compareTo.js":[function(require,module,exports){
"use strict";

module.exports = compareTo;

function compareTo() {
  return {
    require: "ngModel",
    scope: {
      otherModelValue: "=compareTo"
    },
    link: link
  };
}

function link(scope, element, attributes, ngModel) {
  ngModel.$validators.compareTo = function(modelValue) {
    return modelValue === scope.otherModelValue;
  };
  scope.$watch("otherModelValue", function() {
    ngModel.$validate();
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/countrySelect.js":[function(require,module,exports){
"use strict";

module.exports = countrySelect;

countrySelect.$inject = ["$timeout", "$compile"];
function countrySelect($timeout, $compile) {
  return {
    restrict: "AE",
    require: "ngModel",
    scope: true,
    templateUrl: "base/views/country-select.tpl.html",
    link: link
  };

  function link($scope, $elem, $attrs, $ngModelCtrl) {
    $scope.id = $attrs.id;
    $scope.aplicar = aplicar;
    $scope.ngRequired = $attrs.ngRequired === "true";
    $scope.countries = require("../../../resources/js/addressfield.json");

    function aplicar() {
      if (_.get($scope, "vm.customer.fb.$save")) {
        $scope.vm.customer.fb.$save();
      }
      $timeout(function() {
        var select = $("#state-" + $attrs.id);
        select.attr("ng-model", "model.state");
        select.attr("ng-change", "vm.customer.fb.$save()");
        $compile(select)($scope);
      }, 100);
    }

    $scope.$watch(
      function() {
        return $ngModelCtrl.$viewValue;
      },
      function(val) {
        if (val) {
          $scope.model = _.isEmpty(val)
            ? { country: $scope.vm.client.country }
            : val;
        }
      }
    );

    $scope.$watch("model", function(val) {
      if (val) {
        $ngModelCtrl.$setViewValue(val);
      }
    });
    $timeout(function() {
      $($elem)
        .children("#" + $attrs.id)
        .addressfield({
          json: $scope.countries,
          fields: {
            country: "#country-" + $attrs.id,
            locality: "#locality-fields-" + $attrs.id,
            localityname: "#city-" + $attrs.id,
            administrativearea: "#state-" + $attrs.id,
            postalcode: "#zip-" + $attrs.id
          }
        });
      $scope.aplicar();
    }, 100);
  }
}

},{"../../../resources/js/addressfield.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/resources/js/addressfield.json"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/dateInput.js":[function(require,module,exports){
"use strict";
module.exports = dateInput;

function dateInput() {
  return {
    restrict: "AE",
    require: "ngModel",
    scope: true,
    templateUrl: "base/views/dateInput.html",
    link: link
  };
}

function link(scope, element, attrs, ngModelCtrl) {
  scope.name = attrs.name;
  scope.openCal = openCal;

  setTimeout(function() {
    $(function() {
      $("input[name*='" + scope.name + "']")
        .datepicker({
          dateFormat: "mm/dd/yy",
          changeYear: true,
          yearRange: "1980:2037",
          onSelect: function(date) {
            scope.$apply(function() {
              var newDate = moment(date, "MM-DD-YYYY");
              scope.model = newDate.format("MM-DD-YYYY");
              ngModelCtrl.$setViewValue(newDate.format("YYYY-MM-DD"));
            });
          }
        })
        .keydown(function(e) {
          if (e.which !== 9) {
            e.preventDefault();
          }
        });
    });
  }, 150);

  function openCal() {
    $("input[name*='" + scope.name + "']").focus();
  }

  scope.$watch(
    function() {
      return ngModelCtrl.$modelValue;
    },
    function(val) {
      if (val) {
        if (val !== "N/A") {
          scope.model = moment(val, "YYYY-MM-DD").format("MM-DD-YYYY");
        } else {
          scope.model = "N/A";
        }
      } else {
        //scope.model = moment().format( "MM-DD-YYYY" );
        scope.model = "mm/dd/yyyy";
      }
    }
  );

  /*ngModelCtrl.$formatters.push( function( val ) {
    if ( val ) {
      return moment( val ).format( "MM/DD/YYYY" );
    }
  } );*/
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/hideAction.js":[function(require,module,exports){
"use strict";
module.exports = hideAction;
hideAction.$inject = ["$auth"];

function hideAction($auth) {
  return {
    restrict: "EA",
    require: "?ngModel",
    scope: true,
    link: link($auth)
  };
}

function link($auth) {
  return function(scope, element, attrs) {
    scope.permission = attrs.permission;
    scope.action = attrs.action;
    try {
      if (!$auth.getPayload().permissions[scope.permission][scope.action]) {
        element.hide();
      }
    } catch (err) {
      element.hide();
    }
  };
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/monthYearInput.js":[function(require,module,exports){
"use strict";
module.exports = monthYearInput;

function monthYearInput() {
  return {
    restrict: "AE",
    require: "ngModel",
    scope: true,
    templateUrl: "base/views/monthYearInput.html",
    link: link
  };
}

function link(scope, element, attrs, ngModelCtrl) {
  scope.name = attrs.name;

  scope.$watch(
    function () {
      return ngModelCtrl.$modelValue;
    },
    function (val) {
      if (val) {
        if (val !== "N/A") {
          var date = val.split('-');
          var year = +date[0];
          var month = +date[1];
          scope.model = new Date(year, month - 1);
        } else {
          scope.model = NaN;
        }
      } else {
        scope.model = null;
      }
    }
  );

  scope.$watch('model', function (val) {
    if (val) {
      if (val !== "N/A") {
        ngModelCtrl.$setViewValue(moment(val).format('YYYY-MM'));
      } 
    } else if (_.isNaN(val)) {
      ngModelCtrl.$setViewValue("N/A");
    } else {
      ngModelCtrl.$setViewValue(null);
    }
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/tbScroll.js":[function(require,module,exports){
"use strict";
module.exports = tbScroll;

function tbScroll() {
  return {
    restric: "A",
    link: link
  };
}

function link(scope, elem, attrs) {
  scope.px = parseInt(attrs.px);
  $(elem).scrollLeft(scope.px);
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/filters.js":[function(require,module,exports){
"use strict";

exports.date = date;
exports.percentage = percentage;
exports.month = month;

function date() {
  var dateFormat = "YYYY-MM-DD";
  return filter;

  function filter(date, displayFormat) {
    if (date) {
      return moment(date, dateFormat).format(displayFormat);
    } else {
      return "";
    }
  }
}

percentage.$inject = ["$filter"];

function percentage($filter) {
  return filter;
  function filter(num, decimals) {
    if (isNumber(num)) {
      return $filter("number")(num * 100, decimals || 2) + "%";
    }
    return "Undefined";
  }

  function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }
}

function month() {
  return function monthInner(num) {
    return _.isUndefined(num)
      ? "Not specified"
      : moment()
          .month(num)
          .format("MMM");
  };
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/index.js":[function(require,module,exports){
"use strict";

var angular = window.angular;

var mod = angular.module("BaseProject.base", []);

mod.config(require("./routes"));

mod.controller("NavigationCtrl", require("./services/navigationCtrl.js"));
mod.controller("StepCtrl", require("./services/StepCtrl.js"));
mod.controller("VersionCtrl", require("./services/versionCtrl.js"));

mod.factory("Notifications", require("./services/notifications"));
mod.factory("Futures", require("./services/futures"));
mod.factory("Validations", require("./services/validations.js"));

mod.factory("modalService", require("./services/modal.js"));

mod.factory("Geocoder", require("./services/geocoder.js"));

mod.directive("clickOn", require("./directives/clickOn.js"));
mod.directive("cisSwitch", require("./directives/cisSwitch.js"));
mod.directive("cisTitle", require("./directives/cisTitle.js"));
mod.directive("cisMinimize", require("./directives/cisMinimize.js"));
mod.directive("numerical", require("./directives/cisNumericalInput.js"));
mod.directive("cisEnter", require("./directives/cisEnter.js"));
mod.directive("hideAction", require("./directives/hideAction.js"));
mod.directive("tbScroll", require("./directives/tbScroll.js"));
mod.directive("compareTo", require("./directives/compareTo.js"));
mod.directive("btnBack", require("./directives/btnBack.js"));
mod.directive("dateInput", require("./directives/dateInput"));
mod.directive("monthYearInput", require("./directives/monthYearInput"));
mod.directive("cisUpload", require("./directives/cisUpload"));
mod.directive("cisScrollHover", require("./directives/cisScrollHover"));
mod.directive("cisMonthpicker", require("./directives/cisMonthpicker.js"));
mod.directive("countrySelect", require("./directives/countrySelect.js"));

var filters = require("./filters");
mod.filter("Date", filters.date);
mod.filter("Percentage", filters.percentage);
mod.filter("month", filters.month);

module.exports = mod;

},{"./directives/btnBack.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/btnBack.js","./directives/cisEnter.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisEnter.js","./directives/cisMinimize.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisMinimize.js","./directives/cisMonthpicker.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisMonthpicker.js","./directives/cisNumericalInput.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisNumericalInput.js","./directives/cisScrollHover":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisScrollHover.js","./directives/cisSwitch.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisSwitch.js","./directives/cisTitle.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisTitle.js","./directives/cisUpload":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/cisUpload.js","./directives/clickOn.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/clickOn.js","./directives/compareTo.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/compareTo.js","./directives/countrySelect.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/countrySelect.js","./directives/dateInput":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/dateInput.js","./directives/hideAction.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/hideAction.js","./directives/monthYearInput":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/monthYearInput.js","./directives/tbScroll.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/directives/tbScroll.js","./filters":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/filters.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/routes.js","./services/StepCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/StepCtrl.js","./services/futures":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/futures.js","./services/geocoder.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/geocoder.js","./services/modal.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/modal.js","./services/navigationCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/navigationCtrl.js","./services/notifications":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/notifications.js","./services/validations.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/validations.js","./services/versionCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/versionCtrl.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;
routes.$inject = ["$stateProvider", "$urlRouterProvider"];

function routes($stateProvider, $urlRouterProvider) {
  $stateProvider.state("index", {
    templateUrl: "base/views/template.html",
    abstract: true
  });

  $stateProvider.state("404", {
    url: "/404",
    templateUrl: "base/views/404.html",
    free: true,
    data: {
      title: "routes.base.404"
    }
  });

  $stateProvider.state("403", {
    url: "/403",
    templateUrl: "base/views/403.html",
    free: true,
    data: {
      title: "routes.base.403"
    }
  });

  $urlRouterProvider.otherwise("/");
} //routes

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/StepCtrl.js":[function(require,module,exports){
"use strict";

module.exports = StepCtrl;

StepCtrl.$inject = [
  "$sessionStorage",
  "ClientAPI",
  "CustomerAPI",
  "$rootScope"
];
function StepCtrl($sessionStorage, ClientAPI, CustomerAPI, $rootScope) {
  var step = this;
  step.finishTour = finishTour;
  step.current = -1;

  $rootScope.startTourOld = function() {
    step.current = 1;
  };

  //no need to handle catch here as it won't affect the process
  if ($sessionStorage.user.isClient) {
    /* ClientAPI.checkTourFirstTime().then( function( data ) {
      if ( data ) {
        step.current = 0;
      }
    } );*/
  } else {
    CustomerAPI.checkTourFirstTime().then(function(data) {
      if (data) {
        step.current = 0;
      }
    });
  }

  function finishTour() {
    if ($sessionStorage.user.isClient) {
      // ClientAPI.changeTourFirstTimeUser();
    } else {
      CustomerAPI.changeTourFirstTimeUser();
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/futures.js":[function(require,module,exports){
"use strict";

module.exports = futures;

function futures($q, $timeout) {
  futures.aFuture = aFuture;
  futures.aRejected = aRejected;
  return futures;

  function aFuture(value, timeout) {
    return promise("resolve", value, timeout);
  } //function

  function aRejected(value, timeout) {
    return promise("reject", value, timeout);
  } //function

  function promise(_type, value, timeout) {
    try {
      var future = $q.defer();
      $timeout(
        function() {
          future[_type](value);
        },
        _.isUndefined(timeout) ? 0 : timeout
      );
      return future.promise;
    } catch (ex) {
      return ex;
    } //catch
  } //function
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/geocoder.js":[function(require,module,exports){
"use strict";
/* globals google */

module.exports = GeocoderAPI;
GeocoderAPI.$inject = ["uiGmapGoogleMapApi", "$q"];

function GeocoderAPI(uiGmapGoogleMapApi, $q) {
  GeocoderAPI.get = get;
  return GeocoderAPI;

  function get(address) {
    var future = $q.defer();
    geocode(
      address,
      function success(results) {
        future.resolve(results);
      },
      function(status) {
        future.reject(status);
      }
    );
    return future.promise;
  }

  function geocode(address, success, failure) {
    uiGmapGoogleMapApi
      .then(function mapsReady() {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: address }, function(results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            return success(results);
          } else {
            return failure(status);
          }
        });
      })
      .catch(function(exp) {
        Raven.captureException(exp);
      });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/modal.js":[function(require,module,exports){
"use strict";

module.exports = modalService;

modalService.$inject = ["$uibModal"];

function modalService($uibModal) {
  var modalDefaults = {
    backdrop: true,
    keyboard: true,
    modalFade: true,
    templateUrl: "base/views/modal.html"
  };

  var modalOptions = {
    closeButtonText: "Close",
    actionButtonText: "OK",
    headerText: "Proceed?",
    bodyText: "Perform this action?"
  };

  modalService.showModal = showModal;

  function showModal(customModalDefaults, customModalOptions) {
    if (!customModalDefaults) customModalDefaults = {};
    customModalDefaults.backdrop = "static";
    return show(customModalDefaults, customModalOptions);
  }

  function show(customModalDefaults, customModalOptions) {
    //Create temp objects to work with since we're in a singleton service
    var tempModalDefaults = {};
    var tempModalOptions = {};

    //Map angular-ui modal custom defaults to modal defaults defined in service
    angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

    //Map modal.html $scope custom properties to defaults defined in service
    angular.extend(tempModalOptions, modalOptions, customModalOptions);

    if (!tempModalDefaults.controller) {
      tempModalDefaults.controller = function($scope, $uibModalInstance) {
        $scope.modalOptions = tempModalOptions;
        $scope.modalOptions.ok = function(result) {
          $uibModalInstance.close(result);
        };
        $scope.modalOptions.close = function(result) {
          $uibModalInstance.dismiss("cancel");
        };
      };

      tempModalDefaults.controller.$inject = ["$scope", "$uibModalInstance"];
    }

    return $uibModal.open(tempModalDefaults).result;
  }

  return modalService;
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/navigationCtrl.js":[function(require,module,exports){
"use strict";

module.exports = NavigationCtrl;

var missed = require("../../inspections/controllers/missed.js");
var Client = require("../../clients/models/client.js");

NavigationCtrl.$inject = [
  "$state",
  "$localStorage",
  "Notifications",
  "$auth",
  "$sessionStorage",
  "$translate",
  "InspectionAPI",
  "ServicerequestAPI",
  "ClientAPI",
  "$rootScope",
  "Validations",
  "ngIntroService",
  "$timeout"
];
function NavigationCtrl(
  $state,
  $localStorage,
  Notifications,
  $auth,
  $sessionStorage,
  $translate,
  InspectionAPI,
  ServicerequestAPI,
  ClientAPI,
  $rootScope,
  Validations,
  ngIntroService,
  $timeout
) {
  var nav = this;
  nav.logout = logout;
  nav.today = moment();
  nav.getTitle = getTitle;
  nav.icon = icon;
  nav.user = $sessionStorage.user;
  nav.states = filterUnwantedStates($state.get());
  nav.changeActive = changeActive;

  if (!$localStorage.alreadyClear) {
    $timeout(function() {
      nav.logout();
      $timeout(function() {
        // $sessionStorage.empty();
        $localStorage.$reset();
        try {
          localStorage.clear();
        } catch (exp) {}
        $localStorage.alreadyClear = true;
      }, 200);
    }, 10);
  }
  /*nav.introOptions = {
        steps:[
        {
            element: "#menuidEmployees",
            intro: "Next, let's add an employee. Start by clicking here to go to the employee section."
        }
        ],
        showStepNumbers: false,
        showBullets: false,
        showButtons: false,
        exitOnOverlayClick: false,
        keyboardNavigation: false,
        hidePrev: true,
        hideNext: true,
        hideSkip: true,
        exitOnEsc: true,
        nextLabel: 'Next',
        prevLabel: 'Previous',
        skipLabel: 'Skip',
        doneLabel: 'Thanks'
  };*/

  /*$rootScope.startTourMenu = function()
  {
    $timeout(function(){
      ngIntroService.clear();
      ngIntroService.setOptions(nav.introOptions);
      ngIntroService.refresh();
      ngIntroService.start();
    }, 500);
  }*/

  window.Intercom("boot", {
    app_id: "z403jngt",
    user_id: $sessionStorage.user.$id,
    name: $sessionStorage.user.firstName,
    email: $sessionStorage.user.email,
    created_at: moment().unix()
  });

  //Only needs to catch the higher .then in the hierarchy as it will also capture those under him
  if ($sessionStorage.user.isClient) {
    InspectionAPI.listMonths()
      .then(function(data) {
        nav.missed = getReads(missed(data));
        data.$watch(function() {
          nav.missed = getReads(missed(data));
        });
        ServicerequestAPI.list($sessionStorage.user.$id).then(function(rqsts) {
          nav.rqsts = getReads(_.filter(rqsts, { status: 0 }));
          rqsts.$watch(function() {
            nav.rqsts = getReads(_.filter(rqsts, { status: 0 }));
          });
        });
      })
      .catch(function(exp) {
        Raven.captureException(exp);
        // Notifications.addCustom( 500, "Error retrieving data, check your network connection and try again." );
      });

    ClientAPI.get()
      .then(function(client) {
        var jsonObj = Client.loadObj(client);
        jsonObj.isClient = true;
        jsonObj.token = $sessionStorage.user.token;
        nav.user = jsonObj;
        $sessionStorage.user = nav.user;
        $localStorage.user = $localStorage.user ? nav.user : null;
        initTrialHeader(nav.user);
        client.$watch(function() {
          var jsonObj = Client.loadObj(client);
          jsonObj.isClient = true;
          jsonObj.token = $sessionStorage.user.token;
          nav.user = jsonObj;
          $sessionStorage.user = nav.user;
          $localStorage.user = $localStorage.user ? nav.user : null;
          initTrialHeader(nav.user);
        });
      })
      .catch(function(exp) {
        Raven.captureException(exp);
        // Notifications.addCustom( 500, "Error retrieving data, check your network connection and try again." );
      });
  }

  function initTrialHeader(client) {
    $rootScope.showTrial = false;
    if (!Validations.checkPermission(client, "basic")) {
      $rootScope.onlyFeatures = true;
    } else {
      $rootScope.onlyFeatures = false;
    }
    if (client.trial) {
      $rootScope.onlyFeatures = false;
      var todayDate = moment();
      var trialEndDate = moment(client.subscribedOn);
      var daysDiff = todayDate.diff(trialEndDate, "days");
      var daysDiff2 = todayDate.diff(trialEndDate, "day");

      var daysLeft = 30 - daysDiff;
      if (daysLeft < 0) daysLeft = 0;

      if (daysLeft >= 0) {
        $rootScope.showTrial = true;
        $rootScope.trialMessage = daysLeft + " days left in trial";
      }
    }

    if (client.freeExpDate && moment(client.freeExpDate) > moment()) {
      $rootScope.showTrial = true;
      $rootScope.onlyFeatures = false;
      $rootScope.trialMessage =
        "Free User until " + moment(client.freeExpDate).format("MM/DD/YYYY");
    }
  }

  function getReads(list) {
    return _.filter(list, function(e) {
      return !e.read;
    });
  }

  function logout() {
    $auth
      .logout()
      .then(function() {
        delete $sessionStorage.user;
        delete $localStorage.user;
        Notifications.addCustom(200, "Successfully logged out");
        window.Intercom("shutdown");
        $state.go("login");
      })
      .catch(function(exp) {
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error logging out, check your network connection and try again."
        );
      });
  }

  function getTitle() {
    if ($state.current.data && $state.current.data.title) {
      return $translate.instant($state.current.data.title);
    } else {
      return "Error";
    }
  }

  function icon() {
    if ($state.current.data && $state.current.data.icon) {
      return $state.current.data.icon;
    } else {
      return "fa-home";
    }
  }

  function filterUnwantedStates(states) {
    var filteredStates = filterStatesByCredentials(states);
    return _.reject(filteredStates, function(state) {
      return (
        state.abstract ||
        state.name === "login" ||
        state.name === "404" ||
        state.name === "403" ||
        state.name === "index.qrcodes" ||
        state.name === "index.reports" ||
        state.name === "index.logo" ||
        state.name === "index.customer-portal.buildings" ||
        state.name === "index.incomplete" ||
        state.name === "privacyPolicy" ||
        state.data.hidden ||
        state.name.match(/-one((\.\w*)?)$/) ||
        state.name.match(/^(\w*\.\w*)\..*$/)
      );
    });
  }

  function filterStatesByCredentials(states) {
    var p = $auth.getPayload().permissions;
    if (p && all(p.user) && all(p.role)) {
      return _.reject(states, function(state) {
        return state.name === "index.administration";
      });
    }
    return states;
  }

  function all(permissions) {
    return _.every(_.values(permissions), function(value) {
      return !value;
    });
  }

  function changeActive(state) {
    _.forEach(nav.states, function(state) {
      state.active = false;
    });
    state.active = true;
  }
}

},{"../../clients/models/client.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/clients/models/client.js","../../inspections/controllers/missed.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/missed.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/notifications.js":[function(require,module,exports){
"use strict";

module.exports = notifications;

notifications.$inject = ["toastr"];

function notifications(toastr) {
  notifications.add = add;
  notifications.addCustom = addCustom;
  return notifications;

  function type(status) {
    switch (String(status).substr(0, 1)) {
      case "2":
        return toastr.success;
      case "4":
        return toastr.info;
      case "5":
        return toastr.error;
      default:
        return toastr.warning;
    }
  }

  function add(status, obj) {
    type(status)(ofStatus(status, obj));
  } //function

  function addCustom(status, message) {
    type(status)(message);
  } //function

  function ofStatus(status, obj) {
    var elem = obj || "document";
    switch (status) {
      case 0:
        return "<strong>0</strong> - There's no communication to the server";
      case 200:
        return "<strong>200</strong> - Your request has been successful";
      case 201:
        return (
          "<strong>201</strong> - The element " +
          elem +
          " has been successfully saved"
        );
      case 204:
        return (
          "<strong>204</strong> - The element " +
          elem +
          " has been successfully deleted"
        );
      case 400:
        return "<strong>400</strong> - Missing data required to complete the request";
      case 403:
        return "<strong>493</strong> - Invalid credentials";
      case 404:
        return "<strong>404</strong> - " + elem + " not found";
      case 409:
        return (
          "<strong>409</strong> - " +
          "The action can't execute because it will generate conflict"
        );
      case 470:
        return (
          "<strong>470</strong> - Identification of " + elem + " is not valid"
        );
      case 471:
        return "<strong>471</strong> - " + elem + " already exists";
      case 472:
        return "<strong>472</strong> - Expired credentials";
      case 473:
        return "<strong>473</strong> - Incorrect credentials";
      case 500:
        return (
          "<strong>500</strong> - " +
          "There has been an unexpected error, please try again later"
        );
      case 501:
        return "<strong>501</strong> - The service has not been implemented";
      case 530:
        return (
          "<strong>530</strong> - We couldn't complete your request because" +
          " It took us too long to process, please try again later"
        );
      default:
        return "<strong>0</strong> - Notification without a message";
    }
  }
} //functions

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/validations.js":[function(require,module,exports){
"use strict";

module.exports = Validations;

function Validations() {
  Validations.checkPermission = checkPermission;
  return Validations;

  function checkPermission(client, permissionName) {
    //return true;

    if (!client || client.deactivated) {
      return false;
    }

    if (client.trial || client.freeExpDate) {
      return true;
    }

    if (!client.permissions) return false;

    if (permissionName == "basic"){
      return client.permissions["basic"] || client.permissions["plan_H6QDyY9duvBE6X"];
    }

    return client.permissions[permissionName];
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/base/services/versionCtrl.js":[function(require,module,exports){
"use strict";

module.exports = versionCtrl;

versionCtrl.$inject = ["$scope"];
function versionCtrl($scope) {
  $scope.version = require("../../../../package.json").version;
}

},{"../../../../package.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/package.json"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/clients/controllers/featuresCtrl.js":[function(require,module,exports){
"use strict";

module.exports = FeaturesCtrl;

var Client = require("../../clients/models/client.js");

FeaturesCtrl.$inject = [
  "client",
  "ClientAPI",
  "$state",
  "UserAPI",
  "cfpLoadingBar",
  "EmailAPI",
  "$auth",
  "$sessionStorage",
  "$localStorage",
  "$timeout",
  "$http",
  "urlNode",
  "Notifications",
  "stripekey",
  "$rootScope"
];

function FeaturesCtrl(
  client,
  ClientAPI,
  $state,
  UserAPI,
  cfpLoadingBar,
  EmailAPI,
  $auth,
  $sessionStorage,
  $localStorage,
  $timeout,
  $http,
  urlNode,
  Notifications,
  stripekey,
  $rootScope
) {
  var vm = this;
  vm.client = client;
  vm.updateSubscriptions = updateSubscriptions;

  var ref = urlNode + "api/stripe/subscribe";

  //testing purposes
  var noStripe = false;

  var handler = StripeCheckout.configure({
    key: stripekey + "",
    image: "/resources/images/Aries-Icon.png",
    locale: "auto",
    token: function(token) {
      apiCallUpdateSubscriptions(token.id);
    }
  });

  window.addEventListener("popstate", function() {
    handler.close();
  });

  /**
   * Save user data in sessionStorage
   */
  function clientSaved() {
    cfpLoadingBar.complete();
    var user = Client.loadObj(vm.client);
    $sessionStorage.user = user;
    Notifications.addCustom(200, "Subscriptions successfully updated");
  }

  /**
   * Save user subscriptions
   */
  function updateSubscriptions() {
    if (noStripe) {
      cfpLoadingBar.start();

      ClientAPI.save(vm.client)
        .then(clientSaved())
        .catch(function(exp) {
          cfpLoadingBar.complete();
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error saving data, check your network connection and try again."
          );
        });
    } else {
      if (vm.client.stripeId) {
        apiCallUpdateSubscriptions("");
      } else {
        handler.open({
          name: "Aries by FireLab",
          email: vm.client.email,
          description: "Module Subscriptions"
        });
      }
    }
  }

  /**
   * Updates subscriptions on stripe
   * @param  {} stripeToken user Stripe token
   */
  function apiCallUpdateSubscriptions(stripeToken) {
    var body = {
      token: stripeToken,
      id_user: vm.client.$id,
      planItems: getPlanItems()
    };

    cfpLoadingBar.start();

    //api call to backend to update subscriptions
    $http
      .post(ref, body)
      .then(
        function(resp) {
          //get client
          cfpLoadingBar.complete();
          $sessionStorage.user = vm.client;
          Notifications.addCustom(200, "Subscriptions successfully updated");
        },
        function(err) {
          cfpLoadingBar.complete();
          if (err.message) {
            Notifications.addCustom(
              580,
              "Error processing the request: " + err.message
            );
          } else {
            Notifications.addCustom(
              580,
              "Error processing the request, please try again"
            );
          }
        }
      )
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(500, "Error, please try again.");
      });
  }

  /**
   * Returns Aries subscriptions plan list
   * @return {Array} plans list
   */
  function getPlanItems() {
    var planItems = [];

    if (vm.client.permissions.inspections)
      planItems.push({ plan: "inspections" });

    if (vm.client.permissions.jobboard) planItems.push({ plan: "jobboard" });

    if (vm.client.permissions.qrcodes) planItems.push({ plan: "qrcodes" });

    if (vm.client.permissions.inventory) planItems.push({ plan: "inventory" });

    if (vm.client.permissions.invoicing) planItems.push({ plan: "invoicing" });

    if (vm.client.permissions.portal) planItems.push({ plan: "portal" });

    if (vm.client.permissions.gps) planItems.push({ plan: "gps" });

    if (vm.client.permissions.customreports)
      planItems.push({ plan: "customreports" });

    return planItems;
  }
}

},{"../../clients/models/client.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/clients/models/client.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/clients/controllers/formClientCtrl.js":[function(require,module,exports){
"use strict";

module.exports = FormClientCtrl;

FormClientCtrl.$inject = [
  "client",
  "ClientAPI",
  "$state",
  "UserAPI",
  "cfpLoadingBar",
  "EmailAPI",
  "$auth",
  "$sessionStorage",
  "$localStorage",
  "$timeout",
  "Notifications",
  "$rootScope",
  "$http",
  "urlNode",
  "stripekey",
  "$scope",
  "$stateParams"
];
function FormClientCtrl(
  client,
  ClientAPI,
  $state,
  UserAPI,
  cfpLoadingBar,
  EmailAPI,
  $auth,
  $sessionStorage,
  $localStorage,
  $timeout,
  Notifications,
  $rootScope,
  $http,
  urlNode,
  stripekey,
  $scope,
  $stateParams
) {
  var vm = this;
  vm.client = client;
  vm.credentials = {
    email: client.email,
    oldPassword: null,
    newPassword: null
  };
  vm.passtype = "password";
  vm.togglePass = togglePass;
  vm.saveAccountDetails = saveAccountDetails;
  vm.changePassword = changePassword;
  vm.getPlanName = getPlanName;

  vm.updateSubscriptions = updateSubscriptions;
  //vm.unsubscribe = unsubscribe;

  var subscribeUrl = urlNode + "api/stripe/subscribe";
  var updateCardUrl = urlNode + "api/stripe/customer/update";
  var cancelUrl = urlNode + "api/stripe/subscription/cancel";
  //testing purposes
  var noStripe = false;

  vm.auxPermissions = [];

  var handler = StripeCheckout.configure({
    key: stripekey + "",
    image: "/resources/images/Aries-Icon.png",
    locale: "auto",
    token: function(token) {
      apiCallUpdateSubscriptions(token.id);
    }
  });

  var updateCardHandler = StripeCheckout.configure({
    key: stripekey + "",
    image: "/resources/images/Aries-Icon.png",
    locale: "auto",
    token: function(token) {
      updateCustomerCard(token.id);
    }
  });

  window.addEventListener("popstate", function() {
    handler.close();
  });

  if ($stateParams.permission) {
    $timeout(function() {
      alert(
        "You are not subscribed to " +
          getPlanName($stateParams.permission) +
          " feature. Please select it from our options below and upgrade your plan."
      );
    }, 200);
  }

  /*function unsubscribe() {
    if (confirm("Are you sure you want to unsubscribe and stop using Aries?")) {
      cfpLoadingBar.start();
      $http.post(cancelUrl, { id_customer: vm.client.stripeId }).then(function (resp) {
        alert("Thank you for using Aries. You will be able to use the software your next billing cycle. Your information will be stored if you decide to subscribe back again!");
      }, function (err) {
        cfpLoadingBar.complete();
        if (err.message) {
          Notifications.addCustom(580, "Error processing the request: " + err.message);
        } else {
          Notifications.addCustom(580, "Error processing the request, please try again later.");
        }
      }).catch(function (exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(500, "Error, please try again.");
      });

    }
  }*/

  /**
   * Save user data on sessionStorage
   */
  function clientSaved() {
    cfpLoadingBar.complete();
    var user = Client.loadObj(vm.client);
    $sessionStorage.user = user;
    Notifications.addCustom(200, "Subscriptions successfully updated");
  }

  vm.updatePaymentMethod = updatePaymentMethod;

  /**
   * Stripe service for updating client credit card
   */
  function updatePaymentMethod() {
    updateCardHandler.open({
      name: "Aries by FireLab",
      email: vm.client.email,
      description: "Update Card",
      panelLabel: "Update Card Details",
      label: "Update Card Details"
    });
  }

  /**
   * Updates user subscriptions
   */
  function updateSubscriptions() {
    if (
      $rootScope.newPermissions.length == 0 &&
      $rootScope.removePermissions.length == 0
    ) {
      Notifications.addCustom(
        500,
        "There are no changes in the actual subscription to update. "
      );
      goBack();
    } else {
      if (noStripe) {
        cfpLoadingBar.start();

        ClientAPI.save(vm.client)
          .then(clientSaved())
          .catch(function(exp) {
            cfpLoadingBar.complete();
            Raven.captureException(exp);
            Notifications.addCustom(
              500,
              "Error saving data, check your network connection and try again."
            );
          });
      } else {
        if (vm.client.stripeId) {
          apiCallUpdateSubscriptions("");
        } else {
          handler.open({
            name: "Aries by FireLab",
            email: vm.client.email,
            description: "Module Subscriptions"
          });
        }
      }
    }
  }

  /**
   * Returns all user permissions in a object
   * @return {Object} permissions
   */
  function getUserPermissionsObject() {
    var permissionObj = {};
    for (var i = 0; i < vm.permissions.length; i++) {
      var planId = vm.permissions[i].id;
      permissionObj[planId] = true;
    }
    return permissionObj;
  }

  /**
   * Stripe service for updating card details
   * @param  {} stripeToken stripe user token
   */
  function updateCustomerCard(stripeToken) {
    var body = {
      token: stripeToken,
      id_user: vm.client.$id
    };

    cfpLoadingBar.start();

    $http
      .post(updateCardUrl, body)
      .then(
        function(resp) {
          Notifications.addCustom(200, "Credit card successfully updated");
          goBack();
        },
        function(err) {
          cfpLoadingBar.complete();
          if (err.message) {
            Notifications.addCustom(
              580,
              "Error processing the request: " + err.message
            );
          } else {
            Notifications.addCustom(
              580,
              "Error processing the request, please try again later."
            );
          }
        }
      )
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(500, "Error, please try again.");
      });
  }

  /**
   * Stripe API call for subscription update
   * @param  {} stripeToken stripe api token
   */
  function apiCallUpdateSubscriptions(stripeToken) {
    var body = {
      token: stripeToken,
      id_user: vm.client.$id,
      planItems: getPlanItems()
    };

    cfpLoadingBar.start();

    //calls backend for updating subscriptions
    $http
      .post(subscribeUrl, body)
      .then(
        function(resp) {
          //get client
          cfpLoadingBar.complete();
          //all of this is needed so we update immediately whatever is needed for the screen and using the new features right away
          $sessionStorage.user.permissions = getUserPermissionsObject();
          $rootScope.newPermissions = [];
          $rootScope.removePermissions = [];
          vm.permissionsEnd = moment(
            resp.data.current_period_end * 1000
          ).format("Do");
          $rootScope.onlyFeatures = false;
          $sessionStorage.user.permissionsEnd = resp.data.current_period_end;
          $localStorage.user = $sessionStorage.user;
          initPermissions();
          vm.showCheckoutPlans = false;
          Notifications.addCustom(200, "Subscriptions successfully updated");
          goBack();
        },
        function(err) {
          cfpLoadingBar.complete();
          if (err.message) {
            Notifications.addCustom(
              580,
              "Error processing the request: " + err.message
            );
          } else {
            Notifications.addCustom(
              580,
              "Error processing the request, please try again"
            );
          }
        }
      )
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(500, "Error, please try again.");
      });
  }

  /**
   * Returns plans id list
   * @return {Array} plans id list
   */
  function getPlanItems() {
    var planItems = [];

    for (var i = 0; i < vm.permissions.length; i++) {
      planItems.push({ plan: vm.permissions[i].id });
    }

    return planItems;
  }

  vm.permissionsEnd = moment().format("Do");
  if (vm.client.permissionsEnd)
    vm.permissionsEnd = moment(vm.client.permissionsEnd * 1000).format("Do");

  vm.goToCheckout = goToCheckout;

  /**
   * Checkout screen redirection
   */
  function goToCheckout() {
    calculatePermissionsChange();

    $state.go("index.client-one.checkout");
  }

  /**
   * Updates permissions box on the left to see differences in selected permissiosn against current ones
   */
  function calculatePermissionsChange() {
    $rootScope.newPermissions = [];
    $rootScope.removePermissions = [];

    for (var i = 0; i < vm.permissions.length; i++) {
      var permission = vm.permissions[i];
      if (!$sessionStorage.user.permissions[permission.id]) {
        //Permission not in the list, we need to add it
        $rootScope.newPermissions.push(permission);
      } else {
      }
    }

    for (var permission in $sessionStorage.user.permissions) {
      if ($sessionStorage.user.permissions.permission) {
        var index = vm.permissions
          .map(function(e) {
            return e.id;
          })
          .indexOf(permission);
        if (index == -1)
          $rootScope.removePermissions.push({
            id: permission,
            plan: getPlanName(permission),
            price: "$" + getPlanPrice(permission) + ".00 / mo",
            description: getPlanDescription(permission)
          });
      }
    }

    if (
      $rootScope.newPermissions.length > 0 ||
      $rootScope.removePermissions.length > 0
    ) {
      vm.showCheckoutPlans = true;
    } else {
      vm.showCheckoutPlans = false;
    }
  }

  $rootScope.changePermission = changePermission;

  /**
   * Helper function for changing permission from plan
   * @param  {} idPlan selected plan id
   */
  function changePermission(idPlan) {
    var index = vm.permissions
      .map(function(e) {
        return e.id;
      })
      .indexOf(idPlan);

    var planPrice = getPlanPrice(idPlan);

    if (index == -1) {
      //The feature is not on the list
      vm.total += planPrice;
      vm.permissions.push({
        id: idPlan,
        plan: getPlanName(idPlan),
        price: "$" + planPrice + ".00 / mo",
        description: getPlanDescription(idPlan)
      });
    } else {
      vm.total -= planPrice;
      vm.permissions.splice(index, 1);
    }

    calculatePermissionsChange();
  }

  $rootScope.newPermissions = [];
  $rootScope.removePermissions = [];

  /**
   * Returns plan full name
   * @param  {String} idPlan Plan id
   * @return {String} Plan name
   */
  function getPlanName(idPlan) {
    var name = "";
    switch (idPlan) {
      case "inspections":
        name = "Recurring Inspection";
        break;
      case "jobboard":
        name = "Job Scheduling";
        break;
      case "qrcodes":
        name = "QR Codes";
        break;
      case "inventory":
        name = "Inventory Management";
        break;
      case "invoicing":
        name = "Automatic Invoicing";
        break;
      case "portal":
        name = "Customer Portal";
        break;
      case "gps":
        name = "GPS";
        break;
      case "customreports":
        name = "Custom Reports";
        break;
      case "basic":
      case "plan_H6QDyY9duvBE6X":
        name = "Standard";
        break;
    }
    return name;
  }

  /**
   * Returns plan description
   * @param  {String} idPlan Plan id
   * @return {String} Plan description
   */
  function getPlanDescription(idPlan) {
    var name = "";
    switch (idPlan) {
      case "inspections":
        name =
          "Aries will remind you of all the inspections that are due that month. You can also view next month's inspections as well as any missed inspections from the previous month.";
        break;
      case "jobboard":
        name =
          "Drag and drop inspections to the Joblink to schedule jobs for that day, the whole week or the entire month. Inspectors will receive updates to the schedule on their mobile device in real time.";
        break;
      case "qrcodes":
        name =
          "Use QR codes to track devices or systems. Information will be saved in the cloud and easily accessed during future inspections.";
        break;
      case "inventory":
        name = "Manage inventory in your warehouse and on your trucks";
        break;
      case "invoicing":
        name =
          "Aries will automatically create and email invoices to your customers for inspections and work orders";
        break;
      case "portal":
        name =
          "Your customers can login to the portal to view upcoming inspections, view completed inspections, download PDF reports and schedule service.";
        break;
      case "gps":
        name =
          "Keep track of your techs in real time. Know where they are and what job they are doing throughout the day.";
        break;
      case "customreports":
        name =
          "We can create a custom report for you to use with our system. This can be a new report of your choice or it can be a replica of an existing report.";
        break;
      case "basic":
      case "plan_H6QDyY9duvBE6X":
        name = "Aries standard monthly subscription";
        break;
    }
    return name;
  }

  /**
   * Returns plan price
   * @param  {String} idPlan Plan id
   * @return {Number} Plan price
   */
  function getPlanPrice(idPlan) {
    var price = 0;
    switch (idPlan) {
      case "inspections":
        price = 50;
        break;
      case "jobboard":
        price = 50;
        break;
      case "qrcodes":
        price = 25;
        break;
      case "inventory":
        price = 25;
        break;
      case "invoicing":
        price = 100;
        break;
      case "portal":
        price = 25;
        break;
      case "gps":
        price = 25;
        break;
      case "customreports":
        price = 50;
        break;
      case "basic":
        price = 199;
        break;
      case "plan_H6QDyY9duvBE6X":
        price = 299;
    }
    return price;
  }

  initPermissions();

  /**
   * Build list plans with id, plan, price and description
   */
  function initPermissions() {
    vm.permissions = [];
    vm.auxPermissions = [];

    if (!vm.client.permissions || (!vm.client.permissions.basic && !vm.client.permissions.plan_H6QDyY9duvBE6X)) {
      vm.permissions = [
        {
          id: "plan_H6QDyY9duvBE6X",
          plan: getPlanName("plan_H6QDyY9duvBE6X"),
          price: "$299.00 / mo",
          description: getPlanDescription("basic")
        }
      ];
      vm.total = 299.0;
      $rootScope.newPermissions = vm.permissions;
      vm.showCheckoutPlans = true;
    }

    //loads plan and permissions
    if (vm.client.permissions) {
      if (vm.client.permissions.basic) {
        vm.permissions.push({
          id: "basic",
          plan: getPlanName("basic"),
          price: "$199.00 / mo",
          description: getPlanDescription("basic")
        });
        vm.total = 199.0;
        vm.auxPermissions["basic"] = true;
      } else {
        vm.permissions.push({
          id: "plan_H6QDyY9duvBE6X",
          plan: getPlanName("plan_H6QDyY9duvBE6X"),
          price: "$299.00 / mo",
          description: getPlanDescription("plan_H6QDyY9duvBE6X")
        });
        vm.total = 299.0;
        vm.auxPermissions["plan_H6QDyY9duvBE6X"] = true;
      }

      if (vm.client.permissions.inspections) {
        vm.total += 50;
        vm.permissions.push({
          id: "inspections",
          plan: "Recurring Inspection",
          price: "$50.00 / mo",
          description: getPlanDescription("inspections")
        });
        vm.auxPermissions["inspections"] = true;
      }

      if (vm.client.permissions.jobboard) {
        vm.total += 50;
        vm.permissions.push({
          id: "jobboard",
          plan: "Job Scheduling",
          price: "$50.00 / mo",
          description: getPlanDescription("jobboard")
        });
        vm.auxPermissions["jobboard"] = true;
      }

      if (vm.client.permissions.qrcodes) {
        vm.total += 25;
        vm.permissions.push({
          id: "qrcodes",
          plan: "QR Codes",
          price: "$25.00 / mo",
          action: "default",
          description: getPlanDescription("qrcodes")
        });
        vm.auxPermissions["qrcodes"] = true;
      }

      if (vm.client.permissions.inventory) {
        vm.total += 25;
        vm.permissions.push({
          id: "inventory",
          plan: "Inventory Management",
          price: "$25.00 / mo",
          action: "default",
          description: getPlanDescription("inventory")
        });
        vm.auxPermissions["inventory"] = true;
      }

      if (vm.client.permissions.invoicing) {
        vm.total += 100;
        vm.permissions.push({
          id: "invoicing",
          plan: "Automatic Invoicing",
          price: "$100.00 / mo",
          action: "default",
          description: getPlanDescription("invoicing")
        });
        vm.auxPermissions["invoicing"] = true;
      }

      if (vm.client.permissions.portal) {
        vm.total += 25;
        vm.permissions.push({
          id: "portal",
          plan: "Customer Portal",
          price: "$25.00 / mo",
          action: "default",
          description: getPlanDescription("portal")
        });
        vm.auxPermissions["portal"] = true;
      }

      if (vm.client.permissions.gps) {
        vm.total += 25;
        vm.permissions.push({
          id: "gps",
          plan: "GPS",
          price: "$25.00 / mo",
          action: "default",
          description: getPlanDescription("gps")
        });
        vm.auxPermissions["gps"] = true;
      }

      if (vm.client.permissions.customreports) {
        vm.total += 50;
        vm.permissions.push({
          id: "customreports",
          plan: "Custom Reports",
          price: "$50.00 / mo",
          action: "default",
          description: getPlanDescription("customreports")
        });
        vm.auxPermissions["customreports"] = true;
      }
    }
  }

  initCountries();

  /**
   * Builds country combo list
   */
  function initCountries() {
    vm.countries = require("../../../resources/js/addressfield.json");
    $timeout(function() {
      $("#client-address").addressfield({
        json: vm.countries,
        fields: {
          country: "#country",
          locality: "#locality-fields",
          localityname: "#city",
          administrativearea: "#state",
          postalcode: "#zip"
        }
      });
    }, 100);
  }

  /**
   * Save client account data on firebase
   * @param  {Object} validForm Form data
   * @param  {Object} client Client
   */
  function saveAccountDetails(validForm, client) {
    if (validForm) {
      client.email = client.email.toLowerCase();
      vm.credentials.email = vm.credentials.email.toLowerCase();
      if (vm.credentials.email !== client.email) {
        var body = {
          oldEmail: client.email,
          newEmail: vm.credentials.email
        };
        UserAPI.editUser(body)
          .then(
            function() {
              $sessionStorage.user.email = vm.credentials.email;
              $localStorage.user.email = vm.credentials.email;
              client.email = vm.credentials.email;
              ClientAPI.save(client)
                .then(function() {
                  EmailAPI.sendEmail({
                    type: "NOTIFICATION",
                    addresses: [body.oldEmail],
                    subject: "Email changed",
                    content: {
                      data: body.newEmail,
                      name: vm.client.firstName,
                      field: "email"
                    }
                  });
                })
                .catch(function(exp) {
                  Raven.captureException(exp);
                  Notifications.addCustom(
                    500,
                    "Error, check your network connection and try again."
                  );
                });
            },
            function(err) {
              Notifications.addCustom(400, err.message);
            }
          )
          .catch(function(exp) {
            Raven.captureException(exp);
            Notifications.addCustom(
              500,
              "Error, check your network connection and try again."
            );
          });
      } else {
        ClientAPI.save(client).catch(function(exp) {
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error, check your network connection and try again."
          );
        });
      }
    }
  }

  /**
   * Change user password
   * @param  {Object} validForm form
   * @param  {Object} credentials user credentials
   */
  function changePassword(validForm, credentials) {
    if (validForm) {
      UserAPI.changePassword(credentials)
        .then(function() {
          EmailAPI.sendEmail({
            type: "NOTIFICATION",
            addresses: [credentials.email],
            subject: "Password changed",
            content: {
              data: credentials.newPassword,
              name: vm.client.firstName,
              field: "password"
            }
          });
          vm.credentials.oldPassword = null;
          vm.credentials.newPassword = null;
          $state.go("^.details");
        })
        .catch(function(exp) {
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error changing password, please try again."
          );
        });
    }
  }

  vm.removeFeature = removeFeature;

  /**
   * Remove permissions according to plan
   * @param  {} idPlan plan id
   */
  function removeFeature(idPlan) {
    var planPrice = getPlanPrice(idPlan);
    var index = $rootScope.newPermissions
      .map(function(e) {
        return e.id;
      })
      .indexOf(idPlan);
    if (index != -1) $rootScope.newPermissions.splice(index, 1);

    vm.total -= planPrice;
    index = vm.permissions
      .map(function(e) {
        return e.id;
      })
      .indexOf(idPlan);
    if (index != -1) vm.permissions.splice(index, 1);
  }

  vm.readdFeature = readdFeature;

  /**
   * Re add new feature to list features
   * @param  {String} idPlan Plan Id
   */
  function readdFeature(idPlan) {
    var planPrice = getPlanPrice(idPlan);
    vm.total += planPrice;

    var index = $rootScope.removePermissions
      .map(function(e) {
        return e.id;
      })
      .indexOf(idPlan);
    if (index != -1) {
      var permission = $rootScope.removePermissions[index];
      vm.permissions.push(permission);
      $rootScope.removePermissions.splice(index, 1);
    }
  }

  vm.goBack = goBack;
  function goBack() {
    window.history.back();
  }

  /**
   * Show/Hide password in password field
   */
  function togglePass() {
    if (vm.passtype === "password") {
      vm.passtype = "text";
    } else if (vm.passtype === "text") {
      vm.passtype = "password";
    }
  }
}

},{"../../../resources/js/addressfield.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/resources/js/addressfield.json"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/clients/controllers/rest/clientAPI.js":[function(require,module,exports){
"use strict";

module.exports = ClientAPI;

ClientAPI.$inject = [
  "urlApi",
  "$firebaseArray",
  "$firebaseObject",
  "Notifications",
  "$sessionStorage",
  "$http",
  "urlNode",
  "$q"
];

function ClientAPI(
  urlApi,
  $firebaseArray,
  $firebaseObject,
  Notifications,
  $sessionStorage,
  $http,
  urlNode,
  $q
) {
  var ref = new Firebase(urlApi + "Clients/");
  ClientAPI.get = get;
  ClientAPI.save = save;
  ClientAPI.getAccess = getAccess;
  ClientAPI.changeFirstTimeUser = changeFirstTimeUser;
  ClientAPI.changeTourFirstTimeUser = changeTourFirstTimeUser;
  ClientAPI.checkTourFirstTime = checkTourFirstTime;
  ClientAPI.getClientEmail = getClientEmail;
  ClientAPI.getPermissions = getPermissions;
  //ClientAPI.getTemplateReportsIds = getTemplateReportsIds;

  return ClientAPI;
  //no need to handle rejection here as it will be handled whenever any of these methos are called

  /**
   * Returns data of user who is logged in the system
   * @return {Object} Client
   */
  function get() {
    return $firebaseObject(ref.child($sessionStorage.user.$id)).$loaded(
      function(resp) {
        return resp;
      }
    );
  }

  /**
   * Returns client access data
   * @param  {String} uid Client Id
   * @return {Object} Client
   */
  function getAccess(uid) {
    return ref
      .child(uid)
      .once("value")
      .then(function(snap) {
        var value = snap.val();
        return value;
      });
  }

  /**
   * Returns client permissions
   * @param  {String} id Client Id
   * @return {Object} Permissions
   */
  function getPermissions(id) {
    return $firebaseArray(ref.child(id).child("permissions")).$loaded(function(
      resp
    ) {
      return resp;
    });
  }

  /**
   * Base firebase save object helper function
   * @param  {} obj client object
   */
  function save(obj) {
    var future = $q.defer();
    try {
      obj.$save().then(function(resp) {
        Notifications.addCustom(200, "Information saved successfully.");
        future.resolve(resp.key());
      });
    } catch (e) {
      Raven.captureException(e);
      Notifications.addCustom(500, "There was a problem. Please try again.");
      future.reject(false);
    }
    return future.promise;
  }

  /**
   * Removes user firstTime attribute (needed for tutorial)
   */
  function changeFirstTimeUser() {
    get().then(function(user) {
      delete user.firstTime;
      user.$save();
    });
  }

  /**
   * Removes user tourFirstTime attribute (needed for tutorial)
   */
  function changeTourFirstTimeUser() {
    get().then(function(user) {
      delete user.tourFirstTime;
      user.$save();
    });
  }

  /**
   * Returns user tourFirstTime attribute (needed for tutorial)
   * @return {Boolean} tourFirstTime
   */
  function checkTourFirstTime() {
    return get().then(function(user) {
      return user.tourFirstTime;
    });
  }

  /**
   * Returns client mail
   * @param  {String} idClient Client id
   * @return {String} Client email
   */
  function getClientEmail(idClient) {
    return ref
      .child(idClient)
      .once("value")
      .then(function(data) {
        return data.val().email;
      });
  }

  /* function getTemplateReportsIds(clientId) {
    var query = ref.child(clientId)

    return $firebaseArray( query ).$loaded( function(data) {
      var customRepIds = _.filter(data, function(elem) {
        if (elem.$id == "customReports") {
          return true;
        } else {
          return false;
        }
      })
      return customRepIds;
    });
  } */
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/clients/index.js":[function(require,module,exports){
"use strict";

var _name = require("../../../package.json").name;

var mod = angular.module(_name + ".Clients", []);
mod.config(require("./routes"));

mod.controller("FormClientCtrl", require("./controllers/formClientCtrl.js"));
mod.controller("FeaturesCtrl", require("./controllers/featuresCtrl.js"));

mod.factory("ClientAPI", require("./controllers/rest/clientAPI.js"));

module.exports = mod;

},{"../../../package.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/package.json","./controllers/featuresCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/clients/controllers/featuresCtrl.js","./controllers/formClientCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/clients/controllers/formClientCtrl.js","./controllers/rest/clientAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/clients/controllers/rest/clientAPI.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/clients/routes.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/clients/models/client.js":[function(require,module,exports){
"use strict";

module.exports = Customer;

function Customer(
  firstName,
  email,
  token,
  isClient,
  $id,
  permissions,
  trial,
  freeExpDate,
  deactivated,
  subscribedOn,
  stripeId
) {
  this.firstName = firstName || null;
  this.email = email;
  this.token = token;
  this.isClient = isClient;
  this.$id = $id;

  if (permissions) this.permissions = permissions;
  else this.permissions = {};

  this.trial = trial ? true : false;
  this.freeExpDate = freeExpDate;
  this.deactivated = deactivated ? true : false;
  this.subscribedOn = subscribedOn;
  this.stripeId = stripeId;
}

Customer.loadObj = loadObj;

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new Customer(
    json.firstName,
    json.email,
    json.token,
    json.isClient,
    json.$id,
    json.permissions,
    json.trial,
    json.freeExpDate,
    json.deactivated,
    json.subscribedOn,
    json.stripeId
  );
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/clients/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;

routes.$inject = ["$stateProvider"];
function routes($stateProvider) {
  $stateProvider.state("index.client-one", {
    abstract: true,
    templateUrl: "clients/views/formClient.html",
    url: "/client",
    controller: "FormClientCtrl",
    controllerAs: "vm",
    resolve: {
      client: getClient
    },
    data: {
      title: "Client Form",
      icon: "fa-file-o",
      menu: "Client Form"
    },
    params: {
      permission: null
    }
  });

  $stateProvider.state("index.client-one.details", {
    templateUrl: "clients/views/accountDetails.html",
    url: "/details",
    data: {
      title: "Account Details"
    }
  });

  $stateProvider.state("index.client-one.password", {
    templateUrl: "clients/views/passwordChange.html",
    url: "/password",
    data: {
      title: "Change Password"
    }
  });

  $stateProvider.state("index.client-one.payment", {
    templateUrl: "clients/views/payment.html",
    url: "/features",
    free: true,
    data: {
      title: "Features"
    }
  });

  $stateProvider.state("index.client-one.checkout", {
    templateUrl: "clients/views/checkout.html",
    url: "/checkout",
    free: true,
    data: {
      title: "Checkout"
    }
  });

  getClient.$inject = ["ClientAPI"];
  /**
   * Loads client into controller
   * @param  {Controller} ClientAPI
   * @return {Object} Client
   */
  function getClient(ClientAPI) {
    return ClientAPI.get();
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customerportal/controllers/CPBuildingsCtrl.js":[function(require,module,exports){
"use strict";

module.exports = CPBuildingsCtrl;

CPBuildingsCtrl.$inject = [
  "list",
  "CustomerAPI",
  "$state",
  "$stateParams",
  "$uibModal",
  "$timeout",
  "cfpLoadingBar",
  "$sessionStorage",
  "DeviceAPI",
  "ReportAPI",
  "ServicerequestAPI",
  "ClientAPI",
  "Notifications"
];
function CPBuildingsCtrl(
  list,
  CustomerAPI,
  $state,
  $stateParams,
  $uibModal,
  $timeout,
  cfpLoadingBar,
  $sessionStorage,
  DeviceAPI,
  ReportAPI,
  ServicerequestAPI,
  ClientAPI,
  Notifications
) {
  var vm = this;
  //la list viene
  //.master para la master
  //.sub para las subs del master
  //.buildings para diccionario con idSub y lista build
  if (!$sessionStorage.currentCustomer) {
    vm.currentCustomer = list.master;
    $sessionStorage.currentCustomer = vm.currentCustomer;
  } else {
    vm.currentCustomer = $sessionStorage.currentCustomer;
  }

  vm.customers = list;
  vm.user = $sessionStorage.user.firstName;
  vm.formatAddress = formatAddress;
  vm.needsShowBuildings = false;
  vm.selectedSubaccount = null;
  vm.selectAccount = selectAccount;
  vm.open = open;
  /*function openCustomer( customer ) {
    $( "html, body" ).animate( { scrollTop: 0 }, "slow" );
    var objs = getChildren( vm.customers.subs, vm.customers.buildings, customer.$id );
    if ( objs.isEmpty() ) {
      vm.customerIsOpen = false;
      $state.go( "index.customer-one.home", {id: customer.$id} );
    } else {
      vm.customerIsOpen = true;
      $state.go( "index.customers.subaccounts", {customer: customer, childs: objs} );
    }
  }

  function getChildren( subs, builds, id ) {
    var temp = {
      subs: _.union( _.filter( subs, {idParent:id} ), _.filter( builds, {idParent:id} ) )
    };
    temp.isEmpty = isEmpty;

    function isEmpty() {
      return _.isEmpty( temp.subs );
    }
    return temp;
  }*/

  /**
   * Opens master account or shows list of it's sub account
   * @param  {} sub account
   */
  function open(sub) {
    vm.needsShowBuildings = false;
    vm.selectedSubaccount = null;
    if (
      vm.customers.buildings[sub.$id] &&
      vm.customers.buildings[sub.$id].length > 0
    ) {
      vm.needsShowBuildings = true;
      vm.selectedSubaccount = sub;
    } else {
      selectAccount(sub);
    }
  }

  /**
   * Select an account and go to inspections page
   * @param  {String} account selected account
   */
  function selectAccount(account) {
    $sessionStorage.currentCustomer = account;
    //$sessionStorage.user.customerId = account.$id;
    //$state.go("index.customer-portal.inspections");
    $state.go("index.customer-portal.inspections", {}, { reload: true });
    /*cfpLoadingBar.start();
    $timeout(function()
    {
      $state.reload();
    }, 200);*/
  }

  /**
   * Formats building Address
   * @param  {Object} address Address data
   * @return {String} Formated Address
   */
  function formatAddress(address) {
    var part1 = address.line2 ? " " + address.line2 + ", " : ", ";
    var part2 = address.city ? address.city + ", " : "";
    var part3 = address.state ? address.state + " " : "";
    return address.line1 + part1 + part2 + part3 + (address.zip || "");
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customerportal/controllers/custPortalInspectionsCtrl.js":[function(require,module,exports){
"use strict";

module.exports = CustPortalInspectionsCtrl;

var sorter = require("../../customers/models/inspectionsSorter.js");

CustPortalInspectionsCtrl.$inject = ["inspections", "$stateParams"];
function CustPortalInspectionsCtrl(inspections, $stateParams) {
  var ins = this;
  ins.due = $stateParams.due;
  ins.inspections =
    ins.due === "this"
      ? sorter.sortDueInspections(filterMissed(inspections))
      : sorter.sortByYearMonthWeek(inspections);

  /**
   * Filter missed inspections
   * @param  {Array} inspections full inspection list
   * @return {Array} Missed inspections
   */
  function filterMissed(inspections) {
    var isBefore;
    return _.reject(inspections, function(insp) {
      isBefore = insp.assignationDate
        ? insp.assignationDate < moment().format("YYYY-MM-DD")
        : moment().isoWeek() > insp.week;
      return !insp.completed && moment().year() >= insp.year && isBefore;
    });
  }
}

},{"../../customers/models/inspectionsSorter.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/models/inspectionsSorter.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customerportal/controllers/customerPortalCtrl.js":[function(require,module,exports){
"use strict";

module.exports = CustomerPortalCtrl;

CustomerPortalCtrl.$inject = [
  "customer",
  "ServicerequestAPI",
  "$sessionStorage",
  "EmailAPI",
  "cfpLoadingBar",
  "ClientAPI",
  "Notifications"
];
function CustomerPortalCtrl(
  customer,
  ServicerequestAPI,
  $sessionStorage,
  EmailAPI,
  cfpLoadingBar,
  ClientAPI,
  Notifications
) {
  var vm = this;
  vm.customer = customer;

  if (!$sessionStorage.currentCustomer)
    $sessionStorage.currentCustomer = vm.customer.fb;

  vm.addJob = addJob;
  vm.userCanView = function() { return true; }

  

  /**
   * Add a job to a portal customer
   */
  function addJob() {
    vm.jobForm.$submitted = true;
    if (vm.jobForm.$valid) {
      var request = {
        description: vm.newJob.description,
        date: moment(vm.newJob.date).format("YYYY-MM-DD"),
        status: 0, //-1 rejected, 0 pending, 1 approved
        idCustomer: vm.customer.fb.$id,
        customerName: vm.customer.fb.custInfo.customerName,
        read: false
      };
      cfpLoadingBar.start();
      ServicerequestAPI.create($sessionStorage.user.clientId, request)
        .then(function() {
          vm.jobForm.$submitted = false;
          vm.newJob = {};
          ClientAPI.getClientEmail($sessionStorage.user.clientId).then(function(
            email
          ) {
            EmailAPI.sendEmail({
              type: "SERVICE_REQUEST",
              subject: "Service Request",
              addresses: [email],
              content: {
                customerName: request.customerName,
                inspectionDate: request.date,
                description: request.description
              }
            }).then(function() {
              cfpLoadingBar.complete();
            });
          });
        })
        .catch(function(exp) {
          cfpLoadingBar.complete();
          Raven.captureException(exp);
          Notifications.addCustom(500, "Error, please try again.");
        });
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customerportal/controllers/portalPassChangeCtrl.js":[function(require,module,exports){
"use strict";

module.exports = PortalPassChangeCtrl;

PortalPassChangeCtrl.$inject = [
  "customer",
  "UserAPI",
  "cfpLoadingBar",
  "$state",
  "$sessionStorage",
  "Notifications",
  "EmailAPI"
];
function PortalPassChangeCtrl(
  customer,
  UserAPI,
  cfpLoadingBar,
  $state,
  $sessionStorage,
  Notifications,
  EmailAPI
) {
  var vm = this;
  vm.customer = customer;
  vm.credentials = {
    email: customer.fb.custInfo.email,
    oldPassword: null,
    newPassword: null
  };
  vm.passtype = "password";
  vm.togglePass = togglePass;
  vm.changePassword = changePassword;

  /**
   * Change customer portal password
   * @param  {Object} form Form data
   * @param  {Object} credentials Customer data
   */
  function changePassword(form, credentials) {
    form.$submitted = true;
    if (form.$valid) {
      cfpLoadingBar.start();
      UserAPI.changePassword(credentials)
        .then(function() {
          EmailAPI.sendEmail({
            type: "NOTIFICATION",
            addresses: [credentials.email],
            subject: "Password changed",
            content: {
              data: credentials.newPassword,
              name: vm.customer.fb.custInfo.customerName,
              field: "email"
            }
          });
          $state.go("index.customer-portal.inspections");
        })
        .catch(function(exp) {
          closeLB();
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error changing password, please try again."
          );
        });
    }
  }

  /**
   * Close loading pop-up
   */
  function closeLB() {
    cfpLoadingBar.complete();
  }

  /**
   * Show/Hide password
   */
  function togglePass() {
    if (vm.passtype === "password") {
      vm.passtype = "text";
    } else if (vm.passtype === "text") {
      vm.passtype = "password";
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customerportal/index.js":[function(require,module,exports){
"use strict";

var _name = require("../../../package.json").name;

var mod = angular.module(_name + ".CustomerPortal", []);
mod.config(require("./routes"));

mod.controller(
  "CustomerPortalCtrl",
  require("./controllers/customerPortalCtrl.js")
);
mod.controller(
  "CustPortalInspectionsCtrl",
  require("./controllers/custPortalInspectionsCtrl.js")
);
mod.controller(
  "PortalPassChangeCtrl",
  require("./controllers/portalPassChangeCtrl.js")
);
mod.controller("CPBuildingsCtrl", require("./controllers/CPBuildingsCtrl.js"));

module.exports = mod;

},{"../../../package.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/package.json","./controllers/CPBuildingsCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customerportal/controllers/CPBuildingsCtrl.js","./controllers/custPortalInspectionsCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customerportal/controllers/custPortalInspectionsCtrl.js","./controllers/customerPortalCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customerportal/controllers/customerPortalCtrl.js","./controllers/portalPassChangeCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customerportal/controllers/portalPassChangeCtrl.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customerportal/routes.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customerportal/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;

var mapper = require("../reports/models/reportMapper.js");
routes.$inject = ["$stateProvider"];
function routes($stateProvider) {
  $stateProvider.state("index.customer-portal", {
    abstract: true,
    templateUrl: "customerportal/views/indexCust.html",
    url: "/customerportal",
    controller: "CustomerPortalCtrl",
    controllerAs: "vm",
    resolve: {
      customer: getPortalCustomer
    },
    data: {
      title: "routes.main.module",
      icon: "fa-home",
      menu: "routes.main.module",
      role: "customer"
    }
  });

  $stateProvider.state("index.customer-portal.inspections", {
    templateUrl: "customers/views/subviews/home.html",
    url: "/inspections",
    controller: "CustomerHomeCtrl",
    controllerAs: "home",
    resolve: {
      inspections: getCustomerInspections
    },
    data: {
      title: "Dashboard"
    }
  });

  $stateProvider.state("index.customer-portal.buildings", {
    templateUrl: "customerportal/views/buildings.html",
    url: "/buildings",
    controller: "CPBuildingsCtrl",
    controllerAs: "vm",
    resolve: {
      inspections: getCustomerInspections,
      list: listCustomer
    },
    data: {
      title: "Buildings"
    }
  });

  $stateProvider.state("index.customer-portal.reports", {
    templateUrl: "customers/views/subviews/reportList.html",
    url: "/reports/:type?subType",
    controller: "CustomerReportsCtrl",
    controllerAs: "rep",
    resolve: {
      reports: getPortalReports,
      v1reports: getCustomerV1Reports,
      templates: getTemplateReports,
      employees: getEmployees
    },
    data: {
      title: "Reports",
      hidden: true
    }
  });

  $stateProvider.state("index.customer-portal.reports.report", {
    url: "/:report",
    views: {
      "@index.customer-portal": {
        templateUrl: getReportTemplate,
        controller: "SingleReportCtrl",
        controllerAs: "sr"
      }
    },
    resolve: {
      report: getPortalReport
    },
    data: {
      title: "Reports",
      hidden: true
    }
  });

  $stateProvider.state("index.customer-portal.job", {
    templateUrl: "customerportal/views/custPortalJob.html",
    url: "/job",
    data: {
      title: "Service Request",
      hidden: true
    }
  });

  $stateProvider.state("index.portal-password", {
    templateUrl: "customerportal/views/passwordChange.html",
    url: "/password",
    controller: "PortalPassChangeCtrl",
    controllerAs: "vm",
    data: {
      title: "Password Change",
      hidden: true
    },
    resolve: {
      customer: getPortalCustomer
    }
  });

  /**
   * Show all customer's subaccounts
   * @param  {Controller} CustomerAPI
   * @param  {} $stateParams
   * @param  {Provider} cfpLoadingBar
   */
  listCustomer.$inject = ["CustomerAPI", "$stateParams", "cfpLoadingBar"];
  function listCustomer(CustomerAPI, $stateParams, cfpLoadingBar) {
    cfpLoadingBar.start();
    return CustomerAPI.listSubAccountFromMaster().finally(function() {
      cfpLoadingBar.complete();
    });
  }

  /**
   * Returns portal customer reports of an especific type
   * @param  {Controller} ReportAPI
   * @param  {Parameter} $stateParams
   * @param  {Provider} cfpLoadingBar
   * @param  {} $sessionStorage
   * @param  {Provider} Notifications
   * @return {Array} Reportes
   */
  getPortalReports.$inject = [
    "ReportAPI",
    "$stateParams",
    "cfpLoadingBar",
    "$sessionStorage",
    "Notifications"
  ];
  function getPortalReports(
    ReportAPI,
    $stateParams,
    cfpLoadingBar,
    $sessionStorage,
    Notifications
  ) {
    var reportSorter = require("../customers/models/reportsSorter.js");
    cfpLoadingBar.start();

    var customerId = $sessionStorage.user.customerId;

    if ($sessionStorage.currentCustomer) {
      customerId = $sessionStorage.currentCustomer.$id;
    }

    //retrieves all workorders or reports for that customer
    if ($stateParams.type !== "Work Order" && $stateParams.type !== "Quote") {
      return ReportAPI.listFromCustomer($stateParams.type)
        .then(function(data) {
          cfpLoadingBar.complete();
          return data;
        })
        .catch(function(exp) {
          cfpLoadingBar.complete();
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error retrieving reports, please try again."
          );
        });
    }
    return ReportAPI.getWorkOrders(
      $sessionStorage.user.clientId,
      customerId,
      $stateParams
    )
      .then(function(data) {
        cfpLoadingBar.complete();
        return data;
      })
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error retrieving wordorders, please try again."
        );
      });
  }

  /**
   * Returns portal customer V1reports of an especific type
   * @param  {Parameter} $stateParams
   * @param  {Controller} ReportAPI
   * @param  {Provider} cfpLoadingBar
   * @param  {Provider} Notifications
   * @param  {} $sessionStorage
   * @return {Array} reportV1 list
   */
  getCustomerV1Reports.$inject = [
    "$stateParams",
    "ReportAPI",
    "cfpLoadingBar",
    "Notifications",
    "$sessionStorage"
  ];
  function getCustomerV1Reports(
    $stateParams,
    ReportAPI,
    cfpLoadingBar,
    Notifications,
    $sessionStorage
  ) {
    cfpLoadingBar.start();

    var customerId = $sessionStorage.user.customerId;

    if ($sessionStorage.currentCustomer) {
      customerId = $sessionStorage.currentCustomer.$id;
    }

    //load all data for legacy v1 system
    if ($stateParams.type !== "Work Order" && $stateParams.type !== "Quote") {
      return ReportAPI.listCustomerV1Reports(customerId, $stateParams.type)
        .then(function(data) {
          cfpLoadingBar.complete();
          return data;
        })
        .catch(function(exp) {
          cfpLoadingBar.complete();
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error retrieving reports, please try again."
          );
        });
    }
    return ReportAPI.getV1WorkOrders(
      $sessionStorage.user.clientId,
      customerId,
      $stateParams
    )
      .then(function(data) {
        cfpLoadingBar.complete();
        return data;
      })
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error retrieving workorders, please try again."
        );
      });
  }

  /**
   * Search and returns the route by type to open an html file
   * @param  {} $stateParams
   * @return {String} Ruta de la ubicacion del archivo
   */
  function getReportTemplate($stateParams) {
    return "customers/views/reports/" + mapper[$stateParams.type] + ".html";
  }

  /**
   * Returns a report to a customer portal
   * @param  {Parameter} $sessionStorage
   * @param  {Parameter} $stateParams
   * @param  {Controller} ReportAPI
   * @param  {Provider} cfpLoadingBar
   * @param  {Controller} DeviceAPI
   * @param  {Controller} ImageAPI
   * @param  {Provider} Notifications
   */
  getPortalReport.$inject = [
    "$sessionStorage",
    "$stateParams",
    "ReportAPI",
    "cfpLoadingBar",
    "DeviceAPI",
    "ImageAPI",
    "Notifications"
  ];
  function getPortalReport(
    $sessionStorage,
    $stateParams,
    ReportAPI,
    cfpLoadingBar,
    DeviceAPI,
    ImageAPI,
    Notifications
  ) {
    cfpLoadingBar.start();

    var customerId = $sessionStorage.user.customerId;

    if ($sessionStorage.currentCustomer) {
      customerId = $sessionStorage.currentCustomer.$id;
    }

    return ReportAPI.get(
      $sessionStorage.user.clientId,
      customerId,
      $stateParams.type,
      $stateParams.report
    )
      .then(function(resp) {
        cfpLoadingBar.complete();
        return DeviceAPI.getDevices(
          $sessionStorage.user.clientId,
          customerId,
          _.pluck(resp.fb.devices, "id")
        ).then(function(result) {
          return ImageAPI.download($stateParams.report).then(function(
            respImages
          ) {
            resp.images = respImages;
            cfpLoadingBar.complete();
            return { values: resp, devices: result };
          });
        });
      })
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error retrieving reports, please try again."
        );
      });
  }

  /**
   * Returns portal customer data
   * @param  {Controller} CustomerAPI
   * @param  {Provider} cfpLoadingBar
   * @param  {Factory} Notifications
   * @param  {} $sessionStorage
   * @return {Object} Customer data
   */
  getPortalCustomer.$inject = [
    "CustomerAPI",
    "cfpLoadingBar",
    "Notifications",
    "$sessionStorage"
  ];
  function getPortalCustomer(
    CustomerAPI,
    cfpLoadingBar,
    Notifications,
    $sessionStorage
  ) {
    cfpLoadingBar.start();

    var customerId = $sessionStorage.user.customerId;

    if ($sessionStorage.currentCustomer) {
      customerId = $sessionStorage.currentCustomer.$id;
    }

    return CustomerAPI.getFromCustomerWithId(customerId)
      .then(function(resp) {
        cfpLoadingBar.complete();
        return resp;
      })
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(500, "Error, please try again.");
      });
  }

  /**
   * Returns a list with all customer inspections
   * @param  {Controller} InspectionAPI
   * @param  {} $sessionStorage
   * @param  {Factory} Notifications
   * @return {Array} List inspections
   */
  getCustomerInspections.$inject = [
    "InspectionAPI",
    "$sessionStorage",
    "Notifications"
  ];
  function getCustomerInspections(
    InspectionAPI,
    $sessionStorage,
    Notifications
  ) {
    var customerId = $sessionStorage.user.customerId;

    if ($sessionStorage.currentCustomer) {
      customerId = $sessionStorage.currentCustomer.$id;
    }

    return InspectionAPI.listByCust(customerId, $sessionStorage.user.clientId)
      .then(function(data) {
        return data;
      })
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error retrieving inspections, please try again."
        );
      });
  }

  /**
   * Returns a template to a customer portal
   * @param  {Parameter} $stateParams
   * @param  {Controller} ReportAPI
   * @param  {Provider} Notifications
   */
  getTemplateReports.$inject = ["$stateParams", "ReportAPI", "Notifications"];
  function getTemplateReports($stateParams, ReportAPI, Notifications) {
    return ReportAPI.getTemplates($stateParams.type)
      .then(function(data) {
        console.log("data", data);
        return { values: data };
      })
      .catch(function(exp) {
        Notifications.addCustom(
          500,
          "Error retrieving report, please try again."
        );
      });
  }

  /**
   * Returns employee list
   * @param  {Controller} EmployeeAPI
   * @return {Array} Employee list
   */
  getEmployees.$inject = ["EmployeeAPI"];
  function getEmployees(EmployeeAPI) {
    console.log("entra");
    return EmployeeAPI.list();
  }
}

},{"../customers/models/reportsSorter.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/models/reportsSorter.js","../reports/models/reportMapper.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/reportMapper.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/DeviceModalCtrl.js":[function(require,module,exports){
"use strict";

module.exports = DeviceModalCtrl;

var deviceList = {
  Alarm: [
    "AHU Shutdown",
    "Beam Detector",
    "Bell",
    "Door Holder",
    "Door Lock",
    "Duct Detector",
    "Elevator Recall",
    "Fire/Smoke Dampers",
    "Fire Phone",
    "Fire Phone Jack",
    "Heat Detector",
    "Horn",
    "Horn/Strobe",
    "Pull Station",
    "Smoke Detector",
    "Speaker",
    "Strobe",
    "Speaker/Strobe",
    "Tamper/Supervisory Indicator",
    "Vertical Roll Down Door",
    "WAN Door",
    "Water Flow Alarm",
    "Other"
  ],
  Suppression: [
    "AHU Shutdown",
    "Beam Detector",
    "Bell",
    "Door Holder",
    "Door Lock",
    "Duct Detector",
    "Elevator Recall",
    "Fire Phone",
    "Fire Phone Jack",
    "Heat Detector",
    "Horn",
    "Horn/Strobe",
    "Pull Station",
    "Smoke Detector",
    "Speaker",
    "Strobe",
    "Speaker/Strobe",
    "Tamper/Supervisory Indicator",
    "Vertical Roll Down Door",
    "WAN Door",
    "Water Flow Alarm",
    "Other"
  ],
  Sprinkler: [
    "Bell",
    "Horn",
    "Horn/Strobe",
    "OS&Y Valve",
    "Butterfly Valve",
    "Ball Valve",
    "Control Valve",
    "Post Indicator Valve",
    "Supervisory Switch",
    "Water Motor Gong",
    "Wall Indicator Valve",
    "Waterflow Alarm",
    "Air Pressure Supervisory Switch",
    "Other"
  ],
  "Emergency Exit": ["Emergency Light", "Exit Sign", "Combo Unit"]
};

function generateFloors() {
  //TODO: move this a single helper service/factory
  var floors = ["N/A", "Other"];
  for (var i = 1; i < 101; i += 1) {
    var floorSuffix = "";
    switch (i % 10) {
      case 1:
        floorSuffix = "st";
        break;
      case 2:
        floorSuffix = "nd";
        break;
      case 3:
        floorSuffix = "rd";
        break;
      default:
        floorSuffix = "th";
    }
    if (Math.floor(i / 10) == 1) floorSuffix = "th";
    floors.push(i + floorSuffix + " Floor");
  }
  return floors;
}

DeviceModalCtrl.$inject = [
  "$uibModalInstance",
  "report",
  "devicesIn",
  "$uibModal",
  "$scope",
  "$sessionStorage",
  "ReportAPI"
];
function DeviceModalCtrl(
  $uibModalInstance,
  report,
  devicesIn,
  $uibModal,
  $scope,
  $sessionStorage,
  ReportAPI
) {
  var vm = this;
  vm.devIndex = devicesIn.length - 1;
  vm.report = report;
  vm.option = initOption(report.type);
  vm.floors = generateFloors();
  vm.cancel = cancel;
  vm.save = save;
  vm.addDevice = addDevice;
  vm.device = devicesIn[vm.devIndex];
  vm.verifyDev = verifyDev;
  vm.deviceList = deviceList[report.type] || deviceList.Default;
  vm.modelOptions = { allowInvalid: true, debounce: 1000 };
  vm.option = "individual";
  getDeviceTypes();

  vm.report.$bindTo($scope, "vm.report").then(function(unbind) {
    $scope.$on("$destroy", function() {
      unbind();
    });
  });

  vm.device.$bindTo($scope, "vm.device").then(function(unbind) {
    $scope.$on("$destroy", function() {
      unbind();
    });
  });

  /**
   * Verifies a device
   * @param  {} dev
   */
  function verifyDev(dev) {
    if (findDev(dev)) {
      var group = isGroupType(dev);
      if (group) {
        vm.option = "group";
        vm.device.group = true;
      } else {
        vm.option = "individual";
        vm.device.group = false;
      }
    } else {
      var devices = $uibModal.open({
        controller: "DeviceModalCtrl2",
        controllerAs: "vm2",
        templateUrl: "customers/views/reports/deviceModal2.html"
      });
      devices.result.then(function(resul) {
        vm.option = resul;
        vm.device.group = resul === "group";
      });
    }
  }

  /**
   * Returns devices list filtered by type
   * @param  {String} dev Device type
   */
  function findDev(dev) {
    return _.find(devicesIn, { type: dev });
  }

  /**
   * Returns if a type is already in a grouped device or not
   * @param  {String} type Device type
   * @return {Boolean} True if a type is a grouped devices, False otherwise
   */
  function isGroupType(type) {
    //asumo que ya esta el tipo en devices
    //hacer funcion que retorne si esta el tipo en istypealreadyin
    var isGroup = false;
    if (devicesIn) {
      for (var i = 0; i < devicesIn.length && !isGroup; i++) {
        if (devicesIn[i].type === type) {
          isGroup = devicesIn[i].group ? true : false;
        }
      }
    }
    return isGroup;
  }

  /**
   * Allows to choose if a new device is individual or a device group
   */
  function addDevice() {
    if (vm.option === "individual") {
      vm.device.group = false;
    } else if (vm.option === "group") {
      vm.device.group = true;
    }
    $uibModalInstance.close(vm.device);
  }

  /**
   * Closes device modal
   * @param  {} form
   */
  function cancel(form) {
    /*form.$submitted = true;
    if ( !vm.device.type || ( vm.device.type === "Other" && !vm.device.typeOther ) ) {
      return;
    }*/
    //sr.objDevices = _.reject( sr.objDevices, thing );
    // vm.report.fb.devices = _.reject( vm.report.fb.devices, {id: vm.device.$id} );
    // _.remove( vm.deviceList, {$id: vm.device.$id} );
    $uibModalInstance.close(false);
  }

  /**
   * Saves device information
   * @param  {} form
   */
  function save(form) {
    form.$submitted = true;
    if (vm.device.reportType == "Sensitivity")
      vm.device.type = "Smoke Detector";

    //if the status has value, the device has been tested, we save the date the change was made
    if (vm.report.devices[vm.devIndex].status) {
      vm.report.devices[vm.devIndex].modifiedStatus = moment().format(
        "MM/DD/YYYY hh:mm:ss a"
      );
    }

    if (
      !vm.device.type ||
      (vm.device.type === "Other" && !vm.device.typeOther)
    ) {
      return;
    }
    $uibModalInstance.close(true);
  }

  /**
   * Adds more device options depending on report type
   * @param  {String} reportType Report type
   * @return {String}
   */
  function initOption(reportType) {
    var individuals = ["Emergency Exit", "Special Hazard", "Sensitivity"];
    if (_.includes(individuals, reportType)) {
      return "individual";
    }
    return null;
  }

  function getDeviceTypes() {
    ReportAPI.getDeviceTypes(vm.report.type, $sessionStorage.user.$id)
      .then(function (userDevices) {
        vm.deviceList = userDevices.concat(vm.deviceList);
      });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/DeviceModalCtrl2.js":[function(require,module,exports){
"use strict";

module.exports = DeviceModalCtrl;

DeviceModalCtrl.$inject = ["$uibModalInstance"];
function DeviceModalCtrl($uibModalInstance) {
  var vm2 = this;
  vm2.close = close;
  vm2.cancel = cancel;

  /**
   * Closes device modal with a result
   * @param  {} resul
   */
  function close(resul) {
    $uibModalInstance.close(resul);
  }

  /**
   * Closes device modal without an option selected
   */
  function cancel() {
    $uibModalInstance.dismiss("cancel");
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/StandpipeValveCtrl.js":[function(require,module,exports){
"use strict";

module.exports = StandpipeValveCtrl;

StandpipeValveCtrl.$inject = [
  "valve",
  "name",
  "$uibModalInstance",
  "$sessionStorage"
];
function StandpipeValveCtrl(valve, name, $uibModalInstance, $sessionStorage) {
  var vm = this;
  vm.valve = valve;
  vm.name = name;
  vm.save = save;
  vm.cancel = cancel;
  vm.disableInput = $sessionStorage.user.isClient;

  /**
   * Saves standpipe valve
   * @param  {} validForm
   */
  function save(validForm) {
    if (validForm) {
      $uibModalInstance.close(vm.valve);
    }
  }

  /**
   * Closes modal
   */
  function cancel() {
    $uibModalInstance.dismiss("cancel");
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/buildingsCtrl.js":[function(require,module,exports){
"use strict";

module.exports = buildingsCtrl;

buildingsCtrl.$inject = ["$state", "$stateParams"];
function buildingsCtrl($state, $stateParams) {
  var bc = this;
  bc.subaccount = $stateParams.subaccount;
  bc.buildings = $stateParams.buildings;
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/bulkModalCtrl.js":[function(require,module,exports){
"use strict";
/*jslint evil: true */

module.exports = BulkModalCtrl;
var Customer = require("../models/customer.js");
BulkModalCtrl.$inject = [
  "$uibModalInstance",
  "$interval",
  "CustomerAPI",
  "Notifications"
];
function BulkModalCtrl(
  $uibModalInstance,
  $interval,
  CustomerAPI,
  Notifications
) {
  var mc = this;
  mc.cancel = cancel;
  mc.addBulkCustomers = addBulkCustomers;
  mc.customerList = [];

  /**
   * Creates customers from excel file
   */
  function addBulkCustomers() {
    var customers = _.map(mc.customerList, Customer.fromExcel);
    CustomerAPI.createFromExcel(customers)
      .then(function() {
        Notifications.addCustom(
          200,
          "Customers are being created. It may take a while. Please wait..."
        );
        $uibModalInstance.close(mc.customerList.length);
      })
      .catch(function(exp) {
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error creating customers, please try again."
        );
      });
  }
  /**
   * Closes modal
   */
  function cancel() {
    $uibModalInstance.dismiss("cancel");
  }
}

},{"../models/customer.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/models/customer.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/cisFrequency.js":[function(require,module,exports){
"use strict";

module.exports = cisFrequency;

var frequencies = [
  "Weekly",
  "Bi-weekly",
  "Monthly",
  "Bi-monthly",
  "Quarterly",
  "Annual",
  "Bi-annual",
  "Semi-annual",
  "3 year",
  "5 year",
  "Other"
];

cisFrequency.$inject = ["$timeout"];
function cisFrequency($timeout) {
  return {
    restrict: "EA",
    require: "ngModel",
    templateUrl: "customers/views/reports/cisFrequency.html",
    scope: true,
    link: link
  };

  function link($scope, $elem, $attr, ngModelCtrl) {
    $scope.frequencies = frequencies;
    $scope.select = select;
    $scope.otherChanged = otherChanged;

    $timeout(function() {
      $scope.$watch(
        function() {
          return ngModelCtrl.$viewValue;
        },
        function(val) {
          if (val) {
            selectInitialFrequency(val);
          }
        }
      );
    }, 150);

    /**
     * Sets ngModel value
     * @param  {Anything} selected
     */
    function select(selected) {
      if (selected !== "Other") {
        ngModelCtrl.$setViewValue(selected);
      }
      // ngModelCtrl.$setViewValue( selected );
    }

    function otherChanged(other) {
      ngModelCtrl.$setViewValue(other);
    }

    /**
     * Sets report initial frequency
     * @param  {String} val Value frequency
     */
    function selectInitialFrequency(val) {
      var i = $scope.frequencies.indexOf(val);
      if (i >= 0) {
        $scope.selected = $scope.frequencies[i];
        delete $scope.freq;
      } else {
        $scope.selected = $scope.frequencies[$scope.frequencies.length - 1];
        $scope.freq = $scope.selected;
        $scope.other = val;
      }
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/cisMonitoring.js":[function(require,module,exports){
"use strict";

module.exports = cisMonitoring;

cisMonitoring.$inject = ["$timeout"];
function cisMonitoring($timeout) {
  return {
    restrict: "E",
    scope: true,
    replace: true,
    require: "ngModel",
    templateUrl: "customers/views/reports/cisMonitoring.html",
    link: link
  };

  function link($scope, $elem, $attr, ngModelCtrl) {
    $timeout(function() {
      $scope.$watch(
        function() {
          return ngModelCtrl.$viewValue;
        },
        function(val) {
          if (val) {
            $scope.model = val;
          }
        }
      );
    }, 150);

    $scope.$watch("model", function(val) {
      if (val) {
        ngModelCtrl.$setViewValue(val);
      }
    });

    $scope.update = update;

    /** Helper fuction that deletes monitoring information if the radio button value is changed to NO
     * @param  {} val removes name, phone and account if set to NO
     */
    function update(val) {
      if (val === "No") {
        delete $scope.model.name;
        delete $scope.model.phone;
        delete $scope.model.account;
      }
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/cisNote.js":[function(require,module,exports){
"use strict";

module.exports = cisNote;

cisNote.$inject = ["$compile"];

function cisNote($compile) {
  return {
    restrict: "A",
    scope: true,
    link: link
  };

  function link($scope, $elem, $attr) {
    var name = $attr.cisNote + "Note";
    $scope.$watch(function() {
      return $scope.$eval($attr.cisNote);
    }, evalRequired);
    var note =
      "<i class='fa fa-pencil-square-o icon--note' ng-hide=" + name + "></i>";
    $($elem.children("label")[0]).append($compile(note)($scope));

    $($elem.find(".icon--note")[0]).on("click", function(event) {
      event.preventDefault();
      $scope.$apply(function() {
        $scope.showNote = !$scope.showNote;
      });
    });

    var input =
      "<div class='item--note' ng-show='showNote || " +
      name +
      "'>" +
      "<input class='form-control' ng-model=" +
      name +
      " ng-required='required'" +
      " type='text' placeholder='Click here to type a note' ng-model-options='{allowInvalid: true, debounce: 2000}'></div>";
    $elem.after($compile(input)($scope));

    /**
     * Helper function that states what values are required depending on the radio button answer
     * @param  {} val
     */
    function evalRequired(val) {
      if (val === ($attr.requiredWhen || "No")) {
        $scope.showNote = true;
        $scope.required = true;
      } else {
        $scope.required = false;
        $scope.showNote = false;
      }
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/custInfoModalCtrl.js":[function(require,module,exports){
"use strict";

module.exports = CustInfoModalCtrl;

CustInfoModalCtrl.$inject = [
  "customer",
  "client",
  "$uibModalInstance",
  "CustomerAPI",
  "Notifications"
];
function CustInfoModalCtrl(
  customer,
  client,
  $uibModalInstance,
  CustomerAPI,
  Notifications
) {
  var vm = this;
  vm.customer = customer;
  vm.client = client;
  vm.save = save;
  vm.cancel = cancel;

  /**
   * Updates customer information
   * @param  {} form
   */
  function save(form) {
    form.$submitted = true;
    var fields = ["address-line1", "city", "state", "zip"];
    var validCountryForm = true;
    _.forEach(fields, function(field) {
      //check field validation
      var elem = $("#" + field + "-customer-address");
      if (elem[0].style.display !== "none" && !elem.val()) {
        validCountryForm = false;
      }
    });
    //saves if valid
    if (form.$valid && validCountryForm) {
      CustomerAPI.save(vm.customer.fb)
        .then(function() {
          $uibModalInstance.close(true);
        })
        .catch(function(exp) {
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error saving the data, please try again."
          );
        });
    }
  }

  /**
   * Closes customer information modal
   */
  function cancel() {
    $uibModalInstance.dismiss("cancel");
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/customerIndexCtrl.js":[function(require,module,exports){
"use strict";

module.exports = customerHomeCtrl;
var reportTypes = require("../../reports/models/reportMapper.js");
customerHomeCtrl.$inject = [
  "customer",
  "CustomerAPI",
  "$state",
  "$uibModal",
  "cfpLoadingBar",
  "InspectionAPI",
  "UserAPI",
  "EmailAPI",
  "ClientAPI",
  "$sessionStorage",
  "Validations",
  "modalService",
  "Notifications",
  "urlNode",
  "$http",
  "ReportAPI",
  "$stateParams"
];
function customerHomeCtrl(
  customer,
  CustomerAPI,
  $state,
  $uibModal,
  cfpLoadingBar,
  InspectionAPI,
  UserAPI,
  EmailAPI,
  ClientAPI,
  $sessionStorage,
  Validations,
  modalService,
  Notifications,
  urlNode,
  $http,
  ReportAPI,
  $stateParams
) {
  var vm = this;
  vm.customer = customer;
  vm.inspectionsList = _.groupBy(customer.fb.recurringInspections, "type");
  vm.save = save;
  vm.updateCustomerName = updateCustomerName;
  vm.remove = remove;
  vm.showCustomers = showCustomers;
  vm.addJob = addJob;
  vm.giveAccess = giveAccess;
  vm.removeAccess = removeAccess;

  vm.modelOptions = { allowInvalid: true, debounce: 1000 };
  vm.cancelJob = cancelJob;
  vm.reportTypes = _.keys(reportTypes);
  vm.reportTypes.pop();
  vm.reportTypes.pop();
  vm.reportTypes.pop();
  vm.reportTypes.push("Other");
  vm.changeEmail = changeEmail;
  vm.accessToPortalEmail = vm.customer.fb.custInfo.email;
  vm.accessToPortalAuxCheck = vm.customer.fb.accessToPortal;
  vm.exportDevices = exportDevices;
  vm.checkIfUser = checkIfUser;
  vm.uncheckOther = uncheckOther;
  vm.getClientCustomReports = getClientCustomReports;
  vm.userCanView = userCanView;
  getMasterEmails();
  getClientCustomReports($stateParams.id);

  /**
   * Goes to home route
   */
  function cancelJob() {
    $state.go("^.home");
  }

  function getMasterEmails() {
    vm.customer.getMasterEmails($sessionStorage.user.$id, CustomerAPI)
      .then(function (emails) {
        vm.masterEmails = emails;
      });
  }

  /**
   * Method to add job
   * If workorder is selected, deselect quote. And the other way round
   * @param  {Number} unchekedVariable
   */
  function uncheckOther(unchekedVariable) {
    if (unchekedVariable == 1) vm.newJob.isWorkorder = false;
    else vm.newJob.isQuote = false;
  }
  /**
   * Opens export devices modal
   */
  function exportDevices() {
    var newExport = $uibModal.open({
      templateUrl: "customers/views/modals/exportModal.html",
      controller: "ExportModalCtrl",
      controllerAs: "mc",
      size: "sm"
    });
  }

  /**
   * Checks if user id is one of the followings
   * @returns {Boolean} True if it is, False otherwise
   */
  function checkIfUser() {
    return (
      "59baf22b35c7b57ab25da539" == $sessionStorage.user.$id ||
      "9b4e2bde-8fbd-4826-be5b-1acb1c067d35" == $sessionStorage.user.$id ||
      "5c688ef6b571526490b419b4" == $sessionStorage.user.$id ||
      "59fb923eee5e0402da0348f7" == $sessionStorage.user.$id
    );
    //return true;
  }

  getMaster();
  initRecurring(vm.customer);

  /**
   * Saves the updated customer name
   */
  function updateCustomerName() {
    vm.customer.fb.$save();
    InspectionAPI.listByCustThisYear(
      vm.customer.fb.$id,
      $sessionStorage.user.$id
    ).then(function(resp) {
      //loop through all the associate Inspections
      resp.forEach(function(elem) {
        InspectionAPI.updateCustomerName(
          elem,
          vm.customer.fb.custInfo.customerName
        );
      });
    });
  }

  /**
   * Save customer data
   * @param  {Form} validForm
   */
  function save(validForm) {
    if (validForm) {
      CustomerAPI.save(vm.customer.fb, vm.originalLength)
        .then(function(resp) {
          reload(resp.key(), vm.customer.tab);
        })
        .catch(function(exp) {
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error saving the data, please try again."
          );
        });
    }
  }

  /**
   * Removes the customer selected
   */
  function remove() {
    CustomerAPI.remove(vm.customer)
      .then(function() {
        $state.go("^.customer-list");
      })
      .catch(function(exp) {
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error removing the customer, please try again."
        );
      });
  }

  /**
   * Reloads the page
   * @param  {String} id Customer Id
   * @param  {Object} tab Customer Tab
   */
  function reload(id, tab) {
    $state.go($state.current, { id: id, tab: tab }, { reload: true });
  }

  /**
   * Gets the master account if customer is subaccount or building
   */
  function getMaster() {
    if (vm.customer.fb.idParent) {
      CustomerAPI.get($sessionStorage.user.$id, vm.customer.fb.idParent)
        .then(function(resp) {
          vm.master = resp.fb.custInfo.customerName;
        })
        .catch(function(exp) {
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error retrieving the data, please try again."
          );
        });
    }
  }

  /**
   * Initiates recurring inspection to a customer
   * @param  {Object} customer Customer data
   */
  function initRecurring(customer) {
    if (!customer.fb.recurringInspections) {
      customer.fb.recurringInspections = [];
    }
    vm.originalLength = customer.fb.recurringInspections.length;
  }

  /**
   * Shows a customer list to select a master account
   * @param  {} oldValue
   */
  function showCustomers(oldValue) {
    vm.master = null;
    if (vm.customer.fb.accountType === "Master") {
      vm.customer.fb.idParent = null;
      vm.customer.fb.masterName = null;
      vm.customer.fb.$save();
    } else {
      var selectedCust = $uibModal.open({
        templateUrl: "customers/views/modals/selectMaster.html",
        controller: "SelectMasterCtrl",
        controllerAs: "mc",
        resolve: {
          customers: function() {
            cfpLoadingBar.start();
            return CustomerAPI.list().finally(function() {
              cfpLoadingBar.complete();
            });
          },
          currentCust: function() {
            return vm.customer.fb;
          }
        }
      });

      selectedCust.result
        .then(function(selected) {
          vm.customer.fb.masterName = selected.custInfo.customerName;
          vm.customer.fb.idParent = selected.$id;
          vm.customer.fb.$save();
        })
        .catch(function(exp) {
          vm.customer.fb.accountType = oldValue;
          Notifications.addCustom(400, "Warning. No account was selected.");
        });
    }
  }

  /**
   * Adds a job to a customer
   */
  function addJob() {
    vm.jobForm.$submitted = true;

    if (
      !vm.newJob.isQuote &&
      !vm.newJob.isWorkorder &&
      vm.newJob.type === "Other"
    ) {
      alert("Type Other can't be selected if it's not a Work Order or Quote");
    } else if (vm.newJob.type === "Other" && !vm.newJob.woTypeOther) {
      alert("Please add a type name");
      vm.jobForm.woTypeOther.$invalid = true;
    } else {
      if (vm.jobForm.$valid) {
        cfpLoadingBar.start();
        //creates all needed object to save the job
        var realDate = moment(vm.newJob.date);
        var endOfMonthWeek = realDate.month() !== 11
          ? realDate.endOf("month").isoWeek()
          : realDate.endOf("month").subtract(1, "w").isoWeek() + 1;
        var inspection = {
          completed: false,
          customerName: vm.customer.fb.custInfo.customerName,
          generationDate: moment().format(),
          idCustomer: vm.customer.fb.$id,
          month: realDate.month(),
          week: endOfMonthWeek,
          year: realDate.year(),
          description: vm.newJob.description,
          expirationDate: realDate.endOf("month").format("YYYY-MM-DD")
        };
        if (vm.newJob.isWorkorder) {
          inspection.type = "Work Order";
          inspection.woType = vm.newJob.type;
          inspection.invoiceNumber = vm.newJob.invoiceNumber
            ? vm.newJob.invoiceNumber
            : "";
          inspection.poNumber = vm.newJob.poNumber ? vm.newJob.poNumber : "";
          if (vm.newJob.type === "Other") {
            inspection.woTypeOther = vm.newJob.woTypeOther;
          }
        } else if (vm.newJob.isQuote) {
          inspection.type = "Quote";
          inspection.woType = vm.newJob.type;
          if (vm.newJob.type === "Other") {
            inspection.woTypeOther = vm.newJob.woTypeOther;
          }
        } else {
          inspection.type = vm.newJob.type;
        }

        InspectionAPI.insertInJobBoard(inspection)
          .then(function() {
            vm.jobForm.$submitted = false;
            vm.newJob = {};
            cfpLoadingBar.complete();
          })
          .catch(function(exp) {
            Raven.captureException(exp);
            Notifications.addCustom(
              500,
              "Error adding in jobboard, please try again."
            );
          });
      }
    }
  }

  /**
   * Removes access to a customer
   * @param  {Object} customer Customer data
   */
  function removeAccess(customer) {
    if (!vm.accessToPortalAuxCheck) {
      customer.fb.accessToPortal = false;
      customer.fb.$save();

      if (customer.fb.uid) {
        Notifications.addCustom(200, "Removing account. Please wait...");
        //removes customer portal access from the customer
        CustomerAPI.removeAccess(customer.fb.uid)
          .then(function() {
            //it also needs to update the user auth
            UserAPI.removeUser(customer.fb.uid)
              .then(function() {
                cfpLoadingBar.complete();
                delete customer.fb.uid;
                customer.fb.accessToPortal = false;
                customer.fb.$save();
              })
              .catch(function(exp) {
                cfpLoadingBar.complete();
                Raven.captureException(exp);
              });
          })
          .catch(function(exp) {
            cfpLoadingBar.complete();
            Raven.captureException(exp);
          });
      }
    }
  }

  /**
   * Gives access to a customer to system
   * @param  {Object} customer Customer data
   * @return {}
   */
  function giveAccess(customer) {
    if (!customer.fb.custInfo.email) {
      Notifications.addCustom(
        500,
        "An email hasn't been set for this customer which is required" +
          " to create the account."
      );
      vm.customer.fb.accessToPortal = false;
      return;
    }

    var loggedUser = $sessionStorage.user;

    //checks if the user has permission
    if (!Validations.checkPermission(loggedUser, "portal")) {
      vm.customer.fb.accessToPortal = false;
      //text options
      var modalOptions = {
        closeButtonText: "No",
        actionButtonText: "Yes",
        headerText:
          "This feature is not currently included in your subscription.",
        bodyText: "Would you like to add it now?"
      };

      //not necesarry to handle then
      modalService.showModal({}, modalOptions).then(function(result) {
        //Cancel option selected
        if (result === "cancel") {
        } else {
          //Accept option selected
          $state.go("index.client-one.payment");
        }
      });

      return;
    }

    cfpLoadingBar.start();

    if (customer.fb.uid) {
      Notifications.addCustom(200, "Removing previous account. Please wait...");
      //if it already had permissions, to prevent any issue, we first remove all previous access and then grant it back
      CustomerAPI.removeAccess(customer.fb.uid)
        .then(function() {
          UserAPI.removeUser(customer.fb.uid)
            .then(function() {
              // cfpLoadingBar.complete();
              delete customer.fb.uid;
              customer.fb.accessToPortal = false;
              customer.fb.$save();
              //regive access
              createUserAndGiveAccess(customer);
            })
            .catch(function(exp) {
              cfpLoadingBar.complete();
              Raven.captureException(exp);
            });
        })
        .catch(function(exp) {
          cfpLoadingBar.complete();
          Raven.captureException(exp);
        });
    } else {
      //if not just grant access
      createUserAndGiveAccess(customer);
    }
  }

  /**
   * Creates a user and gives portal access to system
   * @param  {Object} customer customer data
   */
  function createUserAndGiveAccess(customer) {
    customer.fb.accessToPortal = true;
    customer.fb.$save();
    var newCredentials = generateCredentials(customer.fb.custInfo.email);
    //updates user data on firebase and creates auth data to log in
    UserAPI.createAccount(newCredentials)
      .then(
        function(userData) {
          CustomerAPI.giveAccess(userData.uid, customer.fb.$id)
            .then(function() {
              customer.fb.uid = userData.uid;
              customer.fb.$save();
              ClientAPI.get()
                .then(function(data) {
                  //sends email notifying this
                  EmailAPI.sendEmail({
                    type: "PORTAL_ACCESS",
                    subject: "Welcome to Aries!",
                    content: {
                      username: newCredentials.email,
                      companyName: data.businessName,
                      password: newCredentials.password
                    },
                    addresses: [newCredentials.email]
                  })
                    .then(function(emailResp) {
                      if (_.isNull(emailResp.data)) {
                        //If there was an error sending email it's possibly because the user inputed it incorrectly
                        //If the emails is wrong he won't get password information, we
                        CustomerAPI.removeAccess(userData.uid)
                          .then(function() {
                            delete customer.fb.uid;
                            customer.fb.accessToPortal = false;
                            customer.fb.$save();
                            UserAPI.removeUser(userData.uid)
                              .then(function() {
                                cfpLoadingBar.complete();
                              })
                              .catch(function(exp) {
                                cfpLoadingBar.complete();
                                Raven.captureException(exp);
                              });
                          })
                          .catch(function(exp) {
                            cfpLoadingBar.complete();
                            Raven.captureException(exp);
                          });
                      } else {
                        cfpLoadingBar.complete();
                      }
                    })
                    .catch(function(exp) {
                      cfpLoadingBar.complete();
                      Raven.captureException(exp);
                      Notifications.addCustom(500, "Error sending email.");
                    });
                })
                .catch(function(exp) {
                  cfpLoadingBar.complete();
                  Raven.captureException(exp);
                  Notifications.addCustom(500, "Error sending email.");
                });
            })
            .catch(function(exp) {
              cfpLoadingBar.complete();
              Raven.captureException(exp);
              Notifications.addCustom(
                500,
                "Error giving access to the customer, please try again."
              );
            });
        },
        function(err) {
          Notifications.addCustom(400, err.message);
          customer.fb.accessToPortal = false;
          cfpLoadingBar.complete();
        }
      )
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error creating account, please try again."
        );
      });
  }

  /**
   * Generates new credentials
   * @param {String} custEmail Customer email
   */
  function generateCredentials(custEmail) {
    var newPassword = require("../../login/models/passwordGen.js")();
    return {
      email: custEmail,
      password: newPassword
    };
  }

  /**
   * Changes customer email
   * @param  {String} newEmail New customer email
   */
  function changeEmail(newEmail) {
    newEmail = newEmail.toLowerCase();
    if (vm.customer.fb.custInfo.email.toLowerCase() !== newEmail) {
      var body = {
        oldEmail: vm.customer.fb.custInfo.email,
        newEmail: newEmail
      };
      UserAPI.editUser(body)
        .then(
          function(scs) {
            vm.customer.fb.custInfo.email = newEmail;
            vm.customer.fb.$save();
            vm.editEmail = false;
            EmailAPI.sendEmail({
              type: "NOTIFICATION",
              addresses: [body.oldEmail],
              subject: "Email changed",
              content: {
                data: body.newEmail,
                name: vm.customer.fb.custInfo.customerName,
                field: "email"
              }
            });
            Notifications.addCustom(200, scs.message);
          },
          function(err) {
            Notifications.addCustom(400, err.message);
          }
        )
        .catch(function(exp) {
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error changing email, please try again."
          );
        });
    } else {
      vm.editEmail = false;
    }
  }

  /**
   * Old function: Gets all custom reports for a customer
   * @param  {String} customerId Customer id
   */
  function getClientCustomReports(customerId) {
    CustomerAPI.getTemplateReportsIds(customerId).then(function(resp) {
      var reportIds = resp["0"];

      vm.templateReports = [];
      console.log("reportsIds", reportIds);
      if (reportIds) {
        for (var i = 0; i < reportIds.length; i++) {
          ReportAPI.getTemplate(reportIds[i]).then(function(obj) {
            if (!obj.type) {
              vm.templateReports.push(obj);
            }
          });
        }
      }

      console.log("vm.templateReports", vm.templateReports);
    });
  }

  function userCanView(reportType) {
    var permissions = {
      "5d56efd69f36fe2fc90aeebb": ["Grease Cleaning"]
    }
    var userId = $sessionStorage.user.$id;
    if (!permissions[userId]) {
      return true;
    }
    return _.includes(permissions[userId], reportType);
  }
}

},{"../../login/models/passwordGen.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/models/passwordGen.js","../../reports/models/reportMapper.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/reportMapper.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/alarmPanelHelper.js":[function(require,module,exports){
module.exports = { isComplete: isComplete };

function isComplete(panel) {
  return propertiesAreComplete(panel) && annunciatorsAreComplete(panel);
}

function propertiesAreComplete(panel) {
  var properties = [
    'type',
    'location',
    'make',
    'model',
    'operateProperly',
    'lampTest',
    'chargingCircuit',
    'protection',
    'breakerPanel',
    'remoteAnnunciator',
    'panelSignalsReceived',
    'timeToReachSignal',
    'troubleSupervision',
    'batteriesReplaced',
    'batteryVolts',
    'batteryAmps',
    'batteryQuantity',
    'voltageOn',
    'voltageOff',
    'properVoltDuring5min'
  ];
  return properties.reduce(function (accumulator, property) {
    return panel[property] && accumulator;
  }, true);
}

function annunciatorsAreComplete(panel) {
  if (!panel.annunciators) {
    return true;
  }
  return panel.annunciators.reduce(function (accumulator, annunciator) {
    return accumulator && annunciator.annunciatorProperly && annunciator.another
      && annunciator.location;
  }, true);
}
},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/deviceHelper.js":[function(require,module,exports){
module.exports = { isComplete: isComplete };

function isComplete(device, reportDevice, reportType) {
  var hasProperties = hasCommonProperties(device);

  if (!hasExtraProperties(device) || !hasStatus(reportDevice))
    hasProperties = false;

  if (reportType === "Sensitivity"
    && !hasSensitivityProperties(device, reportDevice))
    hasProperties = false;

  if (reportType === "Sprinkler"
    && !hasSprinklerProperties(device))
    hasProperties = false;

  if (reportType === "Emergency Exit"
    && !hasService(reportDevice))
    hasProperties = false;

  return hasProperties;
}

function hasCommonProperties(device) {
  var properties = [
    'floor',
    'location',
    'reportType',
    'type',
  ];

  return properties.reduce(function (accumulator, property) {
    if (!device[property]) {
      return false;
    }
    return accumulator;
  }, true);
}

function hasExtraProperties(device) {
  return device.group ?
    device.accumulator :
    device.make && device.model;
}

function hasSensitivityProperties(device, reportDevice) {
  return device.smokeDetectID && device.manufacRangeMin
    && device.manufacRangeMax
    && reportDevice.todayReading;
}

function hasStatus(device) {
  return device.status;
}

function hasSprinklerProperties(device) {
  return device.type !== 'Air Pressure Supervisory Switch'
    || device.size;
}

function hasService(device) {
  return device.service;
}
},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/extinguisherHelper.js":[function(require,module,exports){
module.exports = { isComplete: isComplete };

function isComplete(extinguisher, report) {
  const extinProperties = [
    "location",
    "floor",
    "manufacturer",
    "serialNumber",
    "size",
    "manufactureDate",
    "dueDate6years",
    "dueDateHydrotest",
    "type",
    "servicePerformed",
    "status"
  ];
  let isComplete = extinguisher["hasParts"] || report.partsType === "group";
  extinProperties.forEach(function (prop) {
    if (!extinguisher[prop]) {
      isComplete = false;
    }
  });
  return isComplete;
}
},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/hoodCylinderHelper.js":[function(require,module,exports){
module.exports = { isComplete: isComplete };

function isComplete(cylinder) {
  var properties = [
    'size',
    'make',
    'model',
    'lastHydroDate',
    'lastRechargeDate'
  ];
  return properties.reduce(function (accumulator, property) {
    return cylinder[property] && accumulator;
  }, true);
}
},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/hydrantHelper.js":[function(require,module,exports){
module.exports = { isComplete: isComplete };

function isComplete(hydrant) {
  return hydrant.hydType &&
    hydrant.hydLocation &&
    hydrant.hydMake &&
    hydrant.hydModel &&
    hydrant.hydNumber &&
    hydrant.staticPsi &&
    hydrant.flowPsi &&
    hydrant.residualPsi;
}
},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/riserHelper.js":[function(require,module,exports){
module.exports = { isComplete: isComplete };

var showInput = require("./showInput");

var riserTypes = [
  "Antifreeze Loop",
  "Deluge System",
  "Dry System",
  "Foam System",
  "Preaction System",
  "Wet System"
];

var riserTypesComplete = [
  isAntifreezeLoopComplete,
  isDelugeSystemComplete,
  isDrySystemComplete,
  isFoamSystemComplete,
  isPreactionSystemComplete,
  isWetSystemComplete,
];

function isComplete(riser, frequency) {
  if (!riser.type)
    return false;
  const riserTypeIndex = riserTypes.indexOf(riser.type);
  const typeComplete = riserTypesComplete[riserTypeIndex](riser, frequency);
  const commonComplete = areCommonQuestionsComplete(riser, frequency);
  return typeComplete && commonComplete;
}

function areCommonQuestionsComplete(riser, frequency) {
  return riser.location && riser.make && riser.model &&
    riser.size && riser.staticPressure &&
    (!showInput(['Q', 'S', 'A', '3', '5'], frequency) ||
      riser.residualPressure &&
      riser.drainPressure &&
      riser.readableHydraulicNameplate);
}

function isAntifreezeLoopComplete(riser, frequency) {
  return riser.quest01 &&
    (!showInput(['A', '3', '5'], frequency) ||
      riser.quest02 &&
      riser.quest03);
}

function isDelugeSystemComplete(riser, frequency) {
  return riser.quest01 &&
    riser.quest02 &&
    riser.quest03 &&
    riser.quest07 &&
    (!showInput(['A', '3', '5'], frequency) ||
      riser.quest04 &&
      riser.quest05 &&
      riser.quest06 &&
      riser.quest08 &&
      riser.quest09);
}

function isDrySystemComplete(riser, frequency) {
  return riser.quest01 &&
    riser.quest02 &&
    (!showInput(['A', '3', '5'], frequency) ||
      riser.quest03 &&
      riser.quest04 &&
      riser.quest05 &&
      riser.quest06 &&
      riser.quest07 &&
      riser.quest08 &&
      riser.quest09 &&
      riser.quest10 &&
      riser.quest11);
}

function isFoamSystemComplete(riser, frequency) {
  return riser.quest01 &&
    riser.quest02 &&
    riser.quest03 &&
    riser.quest04 &&
    (!showInput(['A', '3', '5'], frequency) ||
      riser.quest07 &&
      riser.quest08);
}

function isPreactionSystemComplete(riser, frequency) {
  return riser.quest01 &&
    riser.quest02 &&
    riser.quest03 &&
    (!showInput(['A', '3', '5'], frequency) ||
      riser.quest04 &&
      riser.quest05 &&
      riser.quest06 &&
      riser.quest07 &&
      riser.quest08);
}

function isWetSystemComplete(riser, frequency) {
  return !showInput(['Q', 'S', 'A', '3', '5'], frequency) ||
    riser.quest01 &&
    riser.quest02 &&
    riser.quest03;
}
},{"./showInput":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/showInput.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/showInput.js":[function(require,module,exports){
module.exports = showInput;

var mapType = {
  Monthly: "M",
  Quarterly: "Q",
  "Semi-annual": "S",
  Annual: "A",
  "Bi-annual": "B",
  "3 year": "3",
  "5 year": "5",
  Other: "O"
};

function showInput(typeList, frequency) {
  return _.includes(typeList, mapType[frequency]);
}
},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/specialHazardCylinderHelper.js":[function(require,module,exports){
module.exports = { isComplete: isComplete };

function isComplete(cylinder) {
  var properties = [
    'size',
    'make',
    'model',
    'lastHydroDate',
    'lastRechargeDate',
    'compliance6years'
  ];
  return properties.reduce(function (accumulator, property) {
    return cylinder[property] && accumulator;
  }, true);
}
},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/standpipeHelper.js":[function(require,module,exports){
module.exports = { 
  isStandpipeComplete: isStandpipeComplete, 
  isCabinetComplete: isCabinetComplete, 
  isStationComplete: isStationComplete
};

var showInput = require("./showInput");

function isStandpipeComplete(standpipe, frequency) {
  var isComplete = standpipe.location;
  if (showInput(['5'], frequency)) {
    isComplete = isComplete && standpipe.hydrostaticTest && standpipe.flowTest
      && standpipe.flowTestStatic && standpipe.flowTestGMP && standpipe.flowTestTopmost
      && areValvesComplete(standpipe.reducingValves)
      && areValvesComplete(standpipe.restrictValves);
  }
  return isComplete;
}

function isCabinetComplete(cabinet, frequency) {
  var isComplete = cabinet.location;
  if (showInput(['A', '3', '5'], frequency)) {
    isComplete = isComplete && cabinet.cabinetVisible && cabinet.cabinetFreeOfDamage
      && cabinet.looksFunctional && cabinet.hoseCabFreeOfDamage && cabinet.hoseProperlyRacked
      && cabinet.hoseSwing && cabinet.isHoseReRacked && cabinet.hoseReplaced;
  }
  return isComplete;
}

function isStationComplete(station, frequency) {
  var isComplete = station.location;
  if (showInput(['A', '3', '5'], frequency)) {
    isComplete = isComplete && station.freeOfDamage && station.hoseRacked
      && station.hoseReRacked && station.hydroTested;
  }
  if (showInput(['5'], frequency)) {
    isComplete = isComplete && areValvesComplete(station.reducingValves)
      && areValvesComplete(station.restrictValves);
  }
  return isComplete;
}

function areValvesComplete(valves) {
  if (!valves) {
    return true;
  }
  return valves.reduce(function (accumulator, valve) {
    return valve.location && valve.staticInletPressure && valve.staticOutletPressure
      && valve.inletPressure && valve.outletPressure && valve.flowGPM && accumulator;
  }, true);
}
},{"./showInput":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/showInput.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/suppressionCylinderHelper.js":[function(require,module,exports){
module.exports = { isComplete: isComplete };

function isComplete(cylinder) {
  return cylinder.location && cylinder.make && cylinder.model && cylinder.size
    && cylinder.weight && cylinder.pressure && cylinder.passedInspection;
}
},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/suppressionPanelHelper.js":[function(require,module,exports){
module.exports = { isComplete: isComplete };

function isComplete(panel, frequency) {
  var properties = [
    'type',
    'location',
    'make',
    'model',
    'areaProtected',
    'protection',
    'breakerPanel',
    'troubleSupervision',
    'batteriesReplaced',
    'batteryVolts',
    'batteryAmps',
    'batteryQuantity',
    'voltageWithPowerOn'
  ];

  var isComplete = properties.reduce(function (accumulator, property) {
    return accumulator && panel[property];
  }, true);

  if (frequency === 'Annual') {
    isComplete = isComplete && panel.voltageWithPowerOff && panel.properVoltage5min;
  }

  return isComplete;
}
},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/listCustomerCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListCustomerCtrl;

ListCustomerCtrl.$inject = [
  "list",
  "CustomerAPI",
  "$state",
  "$stateParams",
  "$uibModal",
  "$timeout",
  "cfpLoadingBar",
  "$sessionStorage",
  "DeviceAPI",
  "ReportAPI",
  "ServicerequestAPI",
  "ClientAPI",
  "Notifications",
  "$scope",
  "ngIntroService",
  "$rootScope"
];
function ListCustomerCtrl(
  list,
  CustomerAPI,
  $state,
  $stateParams,
  $uibModal,
  $timeout,
  cfpLoadingBar,
  $sessionStorage,
  DeviceAPI,
  ReportAPI,
  ServicerequestAPI,
  ClientAPI,
  Notifications,
  $scope,
  ngIntroService,
  $rootScope
) {
  var vm = this;
  var flag = true;
  vm.remove = remove;
  vm.createCustomer = createCustomer;
  vm.showBulkModal = showBulkModal;
  vm.customers = list;
  vm.filteredCustomers = splitCustomersByType(list);
  vm.openCustomer = openCustomer;
  vm.user = $sessionStorage.user.firstName;
  vm.formatAddress = formatAddress;
  vm.numberOfCustomerShown = 100;
  vm.getMoreData = getMoreData;
  vm.search = search;
  vm.tourStarted = false;
  vm.searchText = '';

  $scope.$on('$locationChangeStart', function (event, next, current) {
    if (current.includes('subaccounts')) {
      vm.customerIsOpen = false;
    }
  });

  function search(value) {
    return vm.searchText || 
      vm.filteredCustomers.masters
        .find(function (master) { 
          return master.$id === value.$id 
        });
  }

  if ($sessionStorage.user.isClient) {
    ClientAPI.checkTourFirstTime().then(function(data) {
      if (data) {
        startTour();
      }
    });
  }

  list.$watch(function() {
    if (flag) {
      vm.filteredCustomers = angular.copy(splitCustomersByType(list));
    }
  });

  vm.introOptions = {
    steps: [
      {
        intro:
          "Hi " +
          $sessionStorage.user.firstName +
          ". The following will be a 3 minute intro video. Please make sure your volume is on before clicking the next button."
      },
      {
        intro:
          "<iframe style='width: 800px; height:460px' src='https://www.youtube.com/embed/eJa2o_EXjqs?rel=0&fs=1&showinfo=0&autoplay=1&modestbranding=1' webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>"
      },
      {
        intro:
          "The following steps are provided to help you get setup with the minimum amount of information needed to begin using Aries."
      },
      {
        intro:
          "In the background is your customer list screen. You will see here all the customers you have added on Aries."
      },
      {
        element: "#tourStep2",
        intro: "Let's add a customer. Click on this button."
      },
      {
        intro:
          "Complete all required fields marked with a black star. This can be a real customer or a made up one. Don't worry, you can delete it later if you wish."
      }
    ],
    showStepNumbers: false,
    showBullets: false,
    exitOnOverlayClick: false,
    keyboardNavigation: false,
    hidePrev: true,
    hideNext: true,
    hideSkip: true,
    exitOnEsc: true,
    overlayOpacity: 0.4,
    nextLabel: "Next",
    prevLabel: "Previous",
    skipLabel: "Skip",
    doneLabel: "Continue"
  };

  vm.introOptions2 = {
    steps: [
      {
        element: "#demoScroll",
        intro: "Good Job! Your new customer is now added to the customer list.",
        position: "right"
      },
      {
        intro: "Let's go to the employee screen"
      }
    ],
    showStepNumbers: false,
    showBullets: false,
    exitOnOverlayClick: false,
    keyboardNavigation: false,
    hidePrev: true,
    hideNext: true,
    hideSkip: true,
    exitOnEsc: true,
    overlayOpacity: 0.4,
    disableInteraction: true,
    nextLabel: "Next",
    prevLabel: "Previous",
    skipLabel: "Skip",
    doneLabel: "Go to employee screen"
  };

  ngIntroService.clear();

  /**
   * Starts application tour
   */
  function startTour() {
    $timeout(function() {
      ngIntroService.setOptions(vm.introOptions);
      ngIntroService.onExit(function() {
        vm.tourStarted = false;
      });

      ngIntroService.onBeforeChange(function() {
        $timeout(function() {
          //hack to change styles and visibility of tutorial plugin according to current step
          var intro = ngIntroService.intro;
          document.querySelectorAll(".introjs-skipbutton")[0].style.display =
            "none";
          document.querySelectorAll(".introjs-nextbutton")[0].style.display =
            "inline-block";

          if (intro._currentStep > 0)
            document.querySelectorAll(".introjs-prevbutton")[0].style.display =
              "inline-block";

          if (intro._currentStep == 1) {
            document.querySelectorAll(".introjs-nextbutton")[0].style.display =
              "none";
            document.querySelectorAll(".introjs-prevbutton")[0].style.display =
              "none";

            $timeout(function() {
              document.querySelectorAll(
                ".introjs-nextbutton"
              )[0].style.display = "inline-block";
            }, 160000);
          }

          if (intro._currentStep == 4 || intro._currentStep == 5) {
            document.querySelectorAll(".introjs-nextbutton")[0].style.display =
              "none";
            document.querySelectorAll(".introjs-prevbutton")[0].style.display =
              "none";
          }

          if (intro._currentStep == 5) {
            document.querySelectorAll(".introjs-skipbutton")[0].style.display =
              "inline-block";
          }

          ngIntroService.refresh();
        });
      });

      ngIntroService.start();
      vm.tourStarted = true;
    }, 500);
  }

  /**
   * Helper function to load more customers increasing limitTo value by 100 each time
   */
  function getMoreData() {
    vm.numberOfCustomerShown += 100;
  }

  /**
   * Split customers by account type: 'Master', 'Subaccount' or 'Builing'
   * @param  {Array} list Customer list
   */
  function splitCustomersByType(list) {
    return {
      masters: _.filter(list, { accountType: "Master" }),
      subs: _.filter(list, { accountType: "Sub-account" }),
      buildings: _.filter(list, { accountType: "Building" })
    };
  }

  /**
   * Removes a customer
   * @param  {Object} customer Customer data
   */
  function remove(customer) {
    var msj =
      "Are you sure you want to delete this customer?\n" +
      "This action will remove some related data (devices, reports, service requests)";
    if (confirm(msj)) {
      var idClient = $sessionStorage.user.$id;
      cfpLoadingBar.start();
      CustomerAPI.remove(customer)
        .then(function() {
          DeviceAPI.removeCustDevices(idClient, customer.$id)
            .then(function() {
              ReportAPI.removeCustReports(idClient, customer.$id)
                .then(function() {
                  ReportAPI.removeCustIncompletes(idClient, customer.$id)
                    .then(function() {
                      ServicerequestAPI.removeCustRequests(
                        idClient,
                        customer.$id
                      )
                        .then(function() {
                          if (customer.accessToPortal) {
                            CustomerAPI.removeAccess(customer.uid)
                              .then(function() {
                                cfpLoadingBar.complete();
                              })
                              .catch(function(exp) {
                                cfpLoadingBar.complete();
                                Raven.captureException(exp);
                              });
                          } else {
                            cfpLoadingBar.complete();
                          }
                        })
                        .catch(function(exp) {
                          cfpLoadingBar.complete();
                          Raven.captureException(exp);
                        });
                    })
                    .catch(function(exp) {
                      cfpLoadingBar.complete();
                      Raven.captureException(exp);
                    });
                })
                .catch(function(exp) {
                  cfpLoadingBar.complete();
                  Raven.captureException(exp);
                });
            })
            .catch(function(exp) {
              cfpLoadingBar.complete();
              Raven.captureException(exp);
            });
        })
        .catch(function(exp) {
          cfpLoadingBar.complete();
          Raven.captureException(exp);
          Notifications.addCustom(500, "Error removing the customer.");
        });
    }
  }

  /**
   * Opens customer childrens page (if it has) or open customer home page
   * @param  {Object} customer Customer data
   */
  function openCustomer(customer) {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    var objs = getChildren(
      vm.filteredCustomers.subs,
      vm.filteredCustomers.buildings,
      customer.$id
    );
    if (objs.isEmpty()) {
      vm.customerIsOpen = false;
      $state.go("index.customer-one.home", { id: customer.$id });
    } else {
      vm.customerIsOpen = true;
      $state.go("index.customers.subaccounts", {
        customer: customer,
        childs: objs
      });
    }
  }

  /**
   * Returns customers subaccounts and buildings
   * @param  {Array} subs Customer subaccounts
   * @param  {Array} builds Customer buildings
   * @param  {String} id Customer master id
   * @return {Array} All customer subaccouts and buildings
   */
  function getChildren(subs, builds, id) {
    var temp = {
      subs: _.union(
        _.filter(subs, { idParent: id }),
        _.filter(builds, { idParent: id })
      )
    };
    temp.isEmpty = isEmpty;

    function isEmpty() {
      return _.isEmpty(temp.subs);
    }
    return temp;
  }

  /**
   * Creates customers from an excel
   */
  function showBulkModal() {
    /* CustomerAPI.removeAll().then(
     function(err){
       console.log(err)
     }.catch(function(exp){
       console.log(exp)
     }
     ));*/
    $uibModal
      .open({
        templateUrl: "customers/views/bulkModal.html",
        controller: "BulkModalCtrl",
        controllerAs: "mc",
        resolve: {}
      })
      .result.then(function(records) {
        flag = false;
        var wait = records;
        cfpLoadingBar.start();
        $timeout(function() {
          cfpLoadingBar.complete();
          Notifications.addCustom(200, "Created customers successfully.");
          $state.reload();
        }, wait);
      });
  }

  /**
   * Creates a new customer
   */
  function createCustomer() {
    $uibModal
      .open({
        templateUrl: "customers/views/custInfoModal.html",
        controller: "CustInfoModalCtrl",
        controllerAs: "vm",
        size: "lg",
        resolve: {
          customer: function() {
            return CustomerAPI.get();
          },
          client: ClientAPI.get()
        }
      })
      .result.then(function(res) {
        newTour();
      })
      .catch(function(res) {
        if (vm.continueTour) {
          vm.continueTour = false;
          $timeout(function() {
            vm.tourStarted = true;
            ngIntroService.goToStepNumber(4).start();
          }, 500);
        }
      });
    if (vm.tourStarted) {
      $timeout(function() {
        ngIntroService.next();
        vm.continueTour = true;
      });
    }
  }

  /**
   * Starts a new application tour for a client
   */
  function newTour() {
    if (vm.continueTour) {
      vm.continueTour = false;
      $timeout(function() {
        ngIntroService.clear();
        ngIntroService.setOptions(vm.introOptions2);
        ngIntroService.onExit(function() {
          $timeout(function() {
            $state.go("index.employees");
          });
        });

        ngIntroService.onBeforeChange(function() {
          $timeout(function() {
            var intro = ngIntroService.intro;
            document.querySelectorAll(".introjs-skipbutton")[0].style.display =
              "none";
            if (intro._currentStep == 1) {
              document.querySelectorAll(
                ".introjs-skipbutton"
              )[0].style.display = "inline-block";
            }

            ngIntroService.refresh();
          });
        });

        ngIntroService.start();
      });
    }
  }

  /**
   * Returns full customer address
   * @param  {Object} address
   */
  function formatAddress(address) {
    var part1 = address.line2 ? " " + address.line2 + ", " : ", ";
    var part2 = address.city ? address.city + ", " : "";
    var part3 = address.state ? address.state + " " : "";
    return address.line1 + part1 + part2 + part3 + (address.zip || "");
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/AddDeviceModalCtrl.js":[function(require,module,exports){
"use strict";

module.exports = AddDeviceModalCtrl;

var deviceList = {
  Alarm: [
    "AHU Shutdown",
    "Beam Detector",
    "Bell",
    "Door Holder",
    "Door Lock",
    "Duct Detector",
    "Elevator Recall",
    "Fire/Smoke Dampers",
    "Fire Phone",
    "Fire Phone Jack",
    "Heat Detector",
    "Horn",
    "Horn/Strobe",
    "Pull Station",
    "Smoke Detector",
    "Speaker",
    "Strobe",
    "Speaker/Strobe",
    "Tamper/Supervisory Indicator",
    "Vertical Roll Down Door",
    "WAN Door",
    "Water Flow Alarm",
    "Other"
  ],
  Suppression: [
    "AHU Shutdown",
    "Beam Detector",
    "Bell",
    "Door Holder",
    "Door Lock",
    "Duct Detector",
    "Elevator Recall",
    "Fire Phone",
    "Fire Phone Jack",
    "Heat Detector",
    "Horn",
    "Horn/Strobe",
    "Pull Station",
    "Smoke Detector",
    "Speaker",
    "Strobe",
    "Speaker/Strobe",
    "Tamper/Supervisory Indicator",
    "Vertical Roll Down Door",
    "WAN Door",
    "Water Flow Alarm",
    "Other"
  ],
  Sprinkler: [
    "Bell",
    "Horn",
    "Horn/Strobe",
    "OS&Y Valve",
    "Butterfly Valve",
    "Ball Valve",
    "Control Valve",
    "Post Indicator Valve",
    "Supervisory Switch",
    "Water Motor Gong",
    "Wall Indicator Valve",
    "Waterflow Alarm",
    "Air Pressure Supervisory Switch",
    "Other"
  ],
  "Emergency Exit": ["Emergency Light", "Exit Sign", "Combo Unit"],
  Extinguisher: ["Extinguisher"]
};

function generateFloors() {
  //TODO: move this a single helper service/factory
  var floors = ["N/A", "Other"];
  for (var i = 1; i < 101; i += 1) {
    var floorSuffix = "";
    switch (i % 10) {
      case 1:
        floorSuffix = "st";
        break;
      case 2:
        floorSuffix = "nd";
        break;
      case 3:
        floorSuffix = "rd";
        break;
      default:
        floorSuffix = "th";
    }
    if (Math.floor(i / 10) == 1) floorSuffix = "th";
    floors.push(i + floorSuffix + " Floor");
  }
  return floors;
}

AddDeviceModalCtrl.$inject = [
  "group",
  "type",
  "$uibModalInstance",
  "$uibModal",
  "$scope",
  "device",
  "$timeout",
  "cfpLoadingBar"
];
function AddDeviceModalCtrl(
  group,
  type,
  $uibModalInstance,
  $uibModal,
  $scope,
  device,
  $timeout,
  cfpLoadingBar
) {
  var vm = this;
  vm.group = group;
  vm.reportType = type;
  vm.option = initOption(vm.reportType);
  vm.floors = generateFloors();
  vm.cancel = cancel;
  vm.addDevice = addDevice;
  vm.device = {};
  if (device) {
    vm.device = device;
    vm.device.deletePrevious = true;
  }
  vm.deviceList = deviceList[vm.reportType] || deviceList.Default;
  vm.modelOptions = { allowInvalid: true, debounce: 1000 };
  vm.option = "individual";

  /**
   * Load device data and closes modal
   */
  function addDevice() {
    cfpLoadingBar.start();
    $timeout(function() {
      vm.device.group = false;
      vm.device.groupDevice = vm.group;
      vm.device.reportType = vm.reportType;
      $uibModalInstance.close(vm.device);
      cfpLoadingBar.complete();
    }, 4000);
  }
  /**
   * Closes device modal
   * @param  {} form
   */
  function cancel(form) {
    $uibModalInstance.dismiss("cancel");
  }

  /**
   * Verifies if report type allows groups or individual devices
   * @param  {String} reportType Report type
   */
  function initOption(reportType) {
    var individuals = ["Emergency Exit", "Special Hazard", "Sensitivity"];
    if (_.includes(individuals, reportType)) {
      return "individual";
    }
    return null;
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/AddExtinguisherModalCtrl.js":[function(require,module,exports){
"use strict";

module.exports = AddExtinguisherModalCtrl;

var deviceList = {
  Extinguisher: [
    "ABC",
    "Class D",
    "Foam",
    "BC",
    "CO2",
    "Purple K",
    "Water",
    "Wet chem",
    "Clean agent",
    "Other"
  ]
};

AddExtinguisherModalCtrl.$inject = [
  "group",
  "type",
  "$uibModalInstance",
  "$uibModal",
  "$scope",
  "device",
  "$timeout",
  "cfpLoadingBar"
];
function AddExtinguisherModalCtrl(
  group,
  type,
  $uibModalInstance,
  $uibModal,
  $scope,
  device,
  $timeout,
  cfpLoadingBar
) {
  var vm = this;
  vm.group = group;
  vm.reportType = type;
  vm.cancel = cancel;
  vm.addDevice = addDevice;
  vm.device = {};
  if (device) {
    vm.device = device;
    vm.device.deletePrevious = true;
  }
  vm.deviceList = deviceList[vm.reportType] || deviceList.Default;
  vm.modelOptions = { allowInvalid: true, debounce: 1000 };
  vm.option = "individual";

  /**
   * Load extinguisher data and closes extinguisher modal
   */
  function addDevice() {
    cfpLoadingBar.start();
    $timeout(function() {
      vm.device.group = false;
      vm.device.groupDevice = vm.group;
      vm.device.reportType = vm.reportType;
      $uibModalInstance.close(vm.device);
      cfpLoadingBar.complete();
    }, 4000);
  }

  /**
   * Closes extinguisher modal
   * @param  {Object} form
   */
  function cancel(form) {
    $uibModalInstance.dismiss("cancel");
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/deviceListModalCtrl.js":[function(require,module,exports){
"use strict";

module.exports = deviceListModalCtrl;
deviceListModalCtrl.$inject = [
  "group",
  "type",
  "customer",
  "urlApi",
  "$uibModalInstance",
  "$firebaseArray",
  "$firebaseObject",
  "$sessionStorage"
];
function deviceListModalCtrl(
  group,
  type,
  customer,
  urlApi,
  $uibModalInstance,
  $firebaseArray,
  $firebaseObject,
  $sessionStorage
) {
  var urlDevices = $sessionStorage.user.$id + "/" + customer.fb.$id;
  var devicesRef = new Firebase(urlApi + "Devices/" + urlDevices);

  var mc = this;
  mc.type = type;
  mc.group = group;
  mc.cancel = cancel;
  mc.addBulkDevices = addBulkDevices;
  mc.devicesExcel = [];
  mc.acepta = "";

  /**
   * Load devices data from an excel
   */
  function addBulkDevices() {
    $firebaseArray(devicesRef).$loaded(function(resp) {
      var customerDevices = resp;

      deleteAllDevicesFromGroup(customerDevices);

      var errorRows = "";

      for (var i = 0; i < mc.devicesExcel.length; i++) {
        var deviceToAdd = mc.devicesExcel[i];
        var deviceJson = parseDeviceFromExcel(deviceToAdd);

        if (deviceJson) addDeviceToCustomer(customerDevices, deviceJson);
        else errorRows += i + 2 + ", ";
      }

      if (errorRows != "") {
        errorRows = errorRows.substring(0, errorRows.length - 2);

        alert(
          "These rows were ignored and could not be added due to incorrect device type: \n " +
            errorRows
        );
      }

      $uibModalInstance.close("cancel");
    });
  }

  /**
   * Remove all devices from a group
   * @param  {Array} deviceList device list
   */
  function deleteAllDevicesFromGroup(deviceList) {
    for (var i = 0; i < deviceList.length; i++) {
      if (deviceList[i].groupDevice && deviceList[i].groupDevice == mc.group) {
        var ref = devicesRef
          .child(deviceList[i].$id);
        $firebaseObject(ref)
          .$loaded(function(res) {
            delete res.groupDevice;
            res.$save();
          });
      }
    }
  }

  /**
   * Transform to camel case a text
   * @param  {String} text
   * @return {String} Formated text
   */
  function toCamelCase(text) {
    return text.replace(/^([A-Z])|[\s-_/](\w)/g, function(
      match,
      p1,
      p2,
      offset
    ) {
      if (p2) return p2.toUpperCase();
      return p1.toLowerCase();
    });
  }

  /**
   * Transform to title case a text
   * @param  {String} str text
   * @return {String} Formated text
   */
  function toTitleCase(str) {
    var ret = "";
    var list = str.split("/");
    ret = list[0].replace(/\w\S*/g, function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
    if (list[1])
      ret +=
        "/" +
        list[1].replace(/\w\S*/g, function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });

    return ret;
  }

  /**
   * Generates an array with 101 floors
   * @return {Array} Floor list
   */
  function generateFloors() {
    //TODO: move this a single helper service/factory
    var floors = ["N/A", "Other"];
    for (var i = 1; i < 101; i += 1) {
      var floorSuffix = "";
      switch (i % 10) {
        case 1:
          floorSuffix = "st";
          break;
        case 2:
          floorSuffix = "nd";
          break;
        case 3:
          floorSuffix = "rd";
          break;
        default:
          floorSuffix = "th";
      }
      if (Math.floor(i / 10) == 1) floorSuffix = "th";
      floors.push(i + floorSuffix + " Floor");
    }
    return floors;
  }

  /**
   * Adjust type report text
   * @param  {String} type Text
   * @param  {Array} validType Valid types
   * @return {Object} adjusted type
   */
  function adjustType(type, validType) {
    if (!type) return "N/A";

    if (validType.indexOf(type) > -1) {
      return { type: type };
    } else {
      return { type: "Other", typeOther: type };
    }
  }

  /**
   * Adjust and verifies building floor field
   * @param  {String} floor
   * @param  {Array} validFloors
   * @return {String} Adjusted floor
   */
  function adjustFloor(floor, validFloors) {
    if (!floor) return "N/A";

    return floor;
  }

  /**
   * Returns devices data from excel file fields
   * @param  {Object} deviceExcel
   * @return {Object} device
   */
  function parseDeviceFromExcel(deviceExcel) {
    if (mc.type == "Extinguisher") {
      var location = deviceExcel["Location"];
      var manuf = deviceExcel["Manufacturer"];
      var serNum = deviceExcel["Serial Number"];

      //    return str.replace(new RegExp(find, 'g'), replace);
      var objType = adjustType(
        deviceExcel["Extinguisher Type"],
        validateType["Extinguisher"]
      );
      var type = objType.type;
      var sze = deviceExcel["Size"];
      var manufDate = moment(
        deviceExcel["Manufacture Date"],
        "MM/DD/YYYY"
      ).format("YYYY-MM-DD");
      var dd6y = moment(
        deviceExcel["Due date for 6y maintenance"],
        "MM/DD/YYYY"
      ).format("YYYY-MM-DD");
      var ddht = moment(
        deviceExcel["Due date for hydrotest"],
        "MM/DD/YYYY"
      ).format("YYYY-MM-DD");

      var deviceJson = {
        group: false,
        groupDevice: mc.group,
        location: location,
        dueDate6years: dd6y,
        dueDateHydrotest: ddht,
        manufactureDate: manufDate,
        manufacturer: manuf,
        serialNumber: serNum,
        reportType: mc.type,
        size: sze,
        type: type
      };

      if (objType.typeOther) {
        deviceJson.typeOther = objType.typeOther;
      }

      return removeUndefinedValues(deviceJson);
    } else {
      var validFloors = generateFloors();
      var floor = deviceExcel["Floor This Device is Located on (optional)"];
      var adjustedFloor = adjustFloor(floor, validFloors);

      var deviceType = getDeviceTypeAux(deviceExcel["Device Type"]);

      var deviceJson = {
        floor: adjustedFloor,
        group: false,
        groupDevice: mc.group,
        location: deviceExcel["Device Location, Address or ID Number"],
        make: deviceExcel["Device Make"],
        model: deviceExcel["Device Model"],
        size: deviceExcel["Device Size (if applicable)"]
          ? deviceExcel["Device Size (if applicable)"]
          : "",
        reportType: mc.type,
        type: deviceType
      };

      var otherType = deviceExcel["Other Device Type (optional)"];

      if (otherType && otherType != "" && otherType != " ") {
        deviceJson.typeOther = otherType;
        deviceJson.type = "Other";
      }

      if (adjustedFloor == "Other") deviceJson.floorOther = floor;

      if (validateDeviceType(deviceJson.type)) {
        return removeUndefinedValues(deviceJson);
      } else {
        return null;
      }
    }
  }

  function removeUndefinedValues(obj) {
    var keys = Object.keys(obj);
    return keys.reduce(function (accumulator, current) {
      var currentValue = obj[current];
      if (currentValue) {
        accumulator[current] = currentValue;
      }
      return accumulator;
    }, {});
  }

  /**
   * Modifies device type if it's misspelled
   * @param  {String} type Device type
   * @return {String} Modified device type text
   */
  function getDeviceTypeAux(type) {
    try {
      var validTypes = validateType[mc.type];

      for (var i = 0; i < validTypes.length; i++) {
        var lowerCasedType = validTypes[i].toLowerCase();

        if (type.toLowerCase() == lowerCasedType) {
          return validTypes[i];
        }
      }
    } catch (exp) {
      return "";
    }
    return null;
  }

  /**
   * Validates type device
   * @param  {String} type
   * @return {Boolean} True if it's correct, otherwise it's False
   */
  function validateDeviceType(type) {
    var validTypes = validateType[mc.type];

    if (!type) return false;

    if (validTypes.indexOf(type) > -1) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Add a device to a customer
   * @param  {Object} customerDevices
   * @param  {Object} device
   */
  function addDeviceToCustomer(customerDevices, device) {
    customerDevices.$add(device).then(function(resp) {
      console.log("Device added correctly");
    });
  }

  /**
   * Close device list modal
   */
  function cancel() {
    $uibModalInstance.dismiss("cancel");
  }

  var alarm = [
    "AHU Shutdown",
    "Beam Detector",
    "Bell",
    "Door Holder",
    "Door Lock",
    "Duct Detector",
    "Elevator Recall",
    "Fire/Smoke Dampers",
    "Fire Phone",
    "Fire Phone Jack",
    "Heat Detector",
    "Horn",
    "Horn/Strobe",
    "Pull Station",
    "Smoke Detector",
    "Speaker",
    "Strobe",
    "Speaker/Strobe",
    "Tamper/Supervisory Indicator",
    "Vertical Roll Down Door",
    "WAN Door",
    "Water Flow Alarm",
    "Other"
  ];

  var suppression = [
    "AHU Shutdown",
    "Beam Detector",
    "Bell",
    "Door Holder",
    "Door Lock",
    "Duct Detector",
    "Elevator Recall",
    "Fire Phone",
    "Fire Phone Jack",
    "Heat Detector",
    "Horn",
    "Horn/Strobe",
    "Pull Station",
    "Smoke Detector",
    "Speaker",
    "Strobe",
    "Speaker/Strobe",
    "Tamper/Supervisory Indicator",
    "Vertical Roll Down Door",
    "WAN Door",
    "Water Flow Alarm",
    "Other"
  ];

  var validateType = {
    Alarm: alarm,
    Suppression: suppression,
    Sprinkler: [
      "Bell",
      "Horn",
      "Horn/Strobe",
      "OS&Y Valve",
      "Butterfly Valve",
      "Ball Valve",
      "Control Valve",
      "Post Indicator Valve",
      "Supervisory Switch",
      "Water Motor Gong",
      "Wall Indicator Valve",

      "Waterflow Alarm",
      "Air Pressure Supervisory Switch",
      "Other"
    ],
    "Emergency Exit": ["Emergency Light", "Exit Sign", "Combo Unit"],
    Extinguisher: [
      "ABC",
      "Class D",
      "Foam",
      "BC",
      "CO2",
      "Purple K",
      "Water",
      "Wet chem",
      "Clean agent",
      "Other"
    ]
  };
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/exportModalCtrl.js":[function(require,module,exports){
"use strict";

module.exports = exportModalCtrl;

var types = require("../../../reports/models/reportMapper.js");
exportModalCtrl.$inject = ["$uibModalInstance", "$state"];
function exportModalCtrl($uibModalInstance, $state) {
  var mc = this;
  mc.export = {};
  mc.save = save;

  mc.types = _.keys(types);
  mc.types.pop();
  mc.types.pop();

  mc.cancel = cancel;

  /**
   * Closes modal and go to Export Devices page
   * @param  {} validData
   */
  function save(validData) {
    if (validData) {
      $uibModalInstance.close({ type: mc.export.type });
      $state.go("index.customer-one.export", { type: mc.export.type });
    }
  }

  /**
   * Closes modal
   */
  function cancel() {
    $uibModalInstance.dismiss("cancel");
  }
}

},{"../../../reports/models/reportMapper.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/reportMapper.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/noteModalCtrl.js":[function(require,module,exports){
"use strict";

module.exports = NoteModalCtrl;
NoteModalCtrl.$inject = ["$uibModalInstance"];
function NoteModalCtrl($uibModalInstance) {
  var mc = this;
  mc.cancel = cancel;
  mc.add = add;

  /**
   * Closes modal and send the note to modal instance by parameter
   * @param  {} validForm
   */
  function add(validForm) {
    if (validForm) {
      $uibModalInstance.close(mc.newNote);
    }
  }

  /**
   * Closes modal
   */
  function cancel() {
    $uibModalInstance.dismiss("cancel");
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/recurringModalCtrl.js":[function(require,module,exports){
"use strict";

module.exports = recurringModalCtrl;

var types = require("../../../reports/models/reportMapper.js");
recurringModalCtrl.$inject = ["$uibModalInstance"];
function recurringModalCtrl($uibModalInstance) {
  var mc = this;
  mc.newInspec = {};
  mc.save = save;
  mc.types = _.keys(types);
  mc.frequencies = [
    "Weekly",
    "Bi-weekly",
    "Monthly",
    "Bi-monthly",
    "Quarterly",
    "Semi-annual",
    "Annual",
    "Bi-annual",
    "3 year",
    "5 year"
  ];
  mc.weeksParity = ["Even weeks", "Odd weeks"];
  mc.monthsParity = ["Even months", "Odd months"];
  mc.yearsParity = ["Even years", "Odd years"];
  mc.months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  mc.years = yearList();
  mc.calcNextMonths = calcNextMonths;
  mc.cancel = cancel;
  mc.cleanModel = cleanModel;
  mc.addAnnualInspecs = addAnnualInspecs;

  /**
   * Creates helper object for inspections from type and frequency
   */
  function cleanModel() {
    var cleanInspec = {
      type: mc.newInspec.type,
      frequency: mc.newInspec.frequency
    };
    if (mc.newInspec.woTypeOther) {
      cleanInspec.woTypeOther = mc.newInspec.woTypeOther;
      cleanInspec.woType = "Other";
    }
    mc.newInspec = cleanInspec;
  }

  /**
   * Closes modal and returns data
   * @param  {} validData data
   */
  function save(validData) {
    if (validData) {
      if (mc.newInspec.type == "Other") {
        mc.newInspec.type = "Work Order";
        mc.newInspec.woType = "Other";
      }
      if (mc.newInspec._nextMonths) {
        delete mc.newInspec._nextMonths;
      }
      $uibModalInstance.close(mc.newInspec);
    }
  }

  /**
   * Returns a list that contains years from 2016 to 2050
   * @return {Array} Year list
   */
  function yearList() {
    var list = [];
    for (var i = 2016; i <= 2050; i += 1) {
      list.push(i.toString());
    }
    return list;
  }

  /**
   * Calculates from the inspection month the following inspection months depending on its frequency
   */
  function calcNextMonths() {
    mc.newInspec.annually = [];
    mc.newInspec._nextMonths = [];
    var nextMonth = mc.newInspec.month;
    mc.newInspec._nextMonths.push(
      moment()
        .month(nextMonth)
        .format("MMMM")
    );
    switch (mc.newInspec.frequency) {
      case mc.frequencies[4]:
        for (var i = 0; i < 3; i += 1) {
          nextMonth = moment()
            .month(nextMonth)
            .add(3, "M")
            .format("MMMM");
          mc.newInspec._nextMonths.push(nextMonth);
        }
        break;
      case mc.frequencies[5]:
        mc.newInspec._nextMonths.push(
          moment()
            .month(nextMonth)
            .add(6, "M")
            .format("MMMM")
        );
        break;
    }
  }

  /**
   * Cancels and closes modal
   */
  function cancel() {
    $uibModalInstance.dismiss("cancel");
  }

  /**
   * Add all inspections which its frequency is annual
   * @param  {Number} i Index
   * @param  {} state
   */
  function addAnnualInspecs(i, state) {
    if (state) {
      mc.newInspec.annually.push(mc.newInspec._nextMonths[i]);
    } else {
      mc.newInspec.annually = _.without(
        mc.newInspec.annually,
        mc.newInspec._nextMonths[i]
      );
    }
  }
}

},{"../../../reports/models/reportMapper.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/reportMapper.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/reportEmailModalCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ReportEmailModalCtrl;

ReportEmailModalCtrl.$inject = [
  "report",
  "customer",
  "webenvironment",
  "EmailAPI",
  "$uibModalInstance",
  "Notifications"
];

function ReportEmailModalCtrl(
  report,
  customer,
  webenvironment,
  EmailAPI,
  $uibModalInstance,
  Notifications
) {
  var rem = this;
  rem.addEmail = addEmail;
  rem.removeEmail = removeEmail;
  rem.sendEmail = sendEmail;
  rem.cancel = cancel;
  rem.emails = customer.custInfo.email ? [customer.custInfo.email] : [];

  /**
   * Adds an email to sender report list
   * @param  {Object} form Form
   */
  function addEmail(form) {
    if (rem.newEmail && rem.newEmail != "" && $.trim(rem.newEmail)) {
      form.$submitted = true;
      if (form.$valid) {
        rem.emails.push(rem.newEmail);
        form.$submitted = false;
        rem.newEmail = "";
      }
    }
  }

  /**
   * Removes an email from sender report list
   * @param  {Number} index
   */
  function removeEmail(index) {
    rem.emails = _.reject(rem.emails, function(v, k) {
      return index === k;
    });
  }

  /**
   * Sends an email to the sender list
   * @param  {Object} form
   */
  function sendEmail(form) {
    //form.$submitted = true;
    //if ( form.$invalid ) {
    //  return false;
    //}
    rem.addEmail(form);

    if (rem.emails && rem.emails.length) {
      var getSubject = function(report, today) {
        return report.woType
          ? report.customerName + " - " + today
          : report.customerName + " - " + report.frequency + " - " + today;
      };
      var getAlias = function(report) {
        var txt =
          report.type === "Grease Cleaning" ? " Report" : " Inspection Report";
        return (
          "Aries - " +
          (report.woType
            ? report.type + " - " + report.woType
            : report.type + txt)
        );
      };
      var getReportUrl = function(report) {
        var url = "http://localhost:3000/";
        switch (webenvironment) {
          case "staging":
            url = "https://test-beta.firelabinc.com/";
            break;
          case "stable":
            url = "https://aries.firelabinc.com/";
            break;
          default:
        }
        return (
          url +
          "pdf/" +
          report.clientId +
          "/" +
          report.idCustomer +
          "/" +
          report.type.replace(" ", "%20") +
          "/" +
          report.$id
        );
      };
      var getCustomerAddress = function(address) {
        return (
          address.line1 +
          ", " +
          address.city +
          ", " +
          address.state +
          " " +
          address.zip
        );
      };
      var today = moment().format("MM/DD/YYYY");
      //rem.emails.push( rem.newEmail );
      EmailAPI.sendEmail({
        type: "REPORT_FINISH",
        subject: getSubject(report, today),
        addresses: rem.emails,
        alias: getAlias(report),
        content: {
          customerName: report.customerName,
          inspectionType: report.woType ? report.woType : report.type,
          inspectionFreq: report.frequency,
          inspectionDate: today,
          customerAddress: getCustomerAddress(customer.custInfo.address),
          reportUrl: getReportUrl(report),
          template: report.woType ? report.type : "Report"
        }
      }).then(function(resp) {
        if (!_.isNull(resp.data)) {
          Notifications.addCustom(200, "Email sent succesfully.");
          cancel();
        }
      });
    } else {
      Notifications.addCustom(500, "Please add at least 1 email.");
    }
  }

  function cancel() {
    $uibModalInstance.dismiss("cancel");
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/reportHistoryModalCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ReportHistoryModalCtrl;

ReportHistoryModalCtrl.$inject = [
  "report",
  "employees",
  "webenvironment",
  "EmailAPI",
  "$uibModalInstance",
  "Notifications"
];

function ReportHistoryModalCtrl(
  report,
  employees,
  webenvironment,
  EmailAPI,
  $uibModalInstance,
  Notifications
) {
  var rem = this;

  rem.report = report;
  rem.employees = employees;
  rem.close = close;
  rem.getEmployeeName = getEmployeeName;

  /**
   * Returns the employee name that has worked in a report
   * @param  {String} id Employee Id
   */
  function getEmployeeName(id) {
    if (id.lastWorkedBy && id.lastWorkedBy == "Admin") return "Admin";
    else {
      var employee = _.find(rem.employees, function(employee) {
        return employee.$id === id.modifiedBy;
      });
      return employee ? employee.name : "";
    }
  }

  /**
   * Closes modal
   */
  function close() {
    $uibModalInstance.dismiss("cancel");
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/selectMasterCtrl.js":[function(require,module,exports){
"use strict";

module.exports = selectMasterCtrl;
selectMasterCtrl.$inject = ["customers", "currentCust", "$uibModalInstance"];
function selectMasterCtrl(customers, currentCust, $uibModalInstance) {
  var mc = this;
  mc.customers = customers;
  mc.currentCust = currentCust;
  mc.select = select;
  mc.cancel = cancel;
  filter();

  /**
   * Filters all customers that are Sub-accounts or Buildings
   */
  function filter() {
    switch (mc.currentCust.accountType) {
      case "Sub-account":
        mc.customers = _.filter(mc.customers, function(cust) {
          return (
            cust.accountType === "Master" && cust.$id !== mc.currentCust.$id
          );
        });
        break;
      case "Building":
        mc.customers = _.filter(mc.customers, function(cust) {
          return (
            cust.$id !== mc.currentCust.$id && cust.accountType !== "Building"
          );
        });
        break;
    }
  }

  /**
   * Closes modal and send the selected customer by parameter to modal instance
   * @param  {Object} customer
   */
  function select(customer) {
    $uibModalInstance.close(customer);
  }

  /**
   * Closes modal
   */
  function cancel() {
    $uibModalInstance.dismiss("cancel");
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/uploadDevicesModalCtrl.js":[function(require,module,exports){
"use strict";

module.exports = uploadDevicesModalCtrl;

uploadDevicesModalCtrl.$inject = [
  "customer",
  "groups",
  "$uibModalInstance",
  "$uibModal",
  "Notifications"
];
function uploadDevicesModalCtrl(
  customer,
  groups,
  $uibModalInstance,
  $uibModal,
  Notifications
) {
  var mc = this;
  mc.newDevicesData = {};
  mc.customer = customer;
  mc.groups = groups;
  mc.uploadList = uploadList;
  mc.cancel = cancel;
  mc.addGroup = addGroup;

  /**
   * Allows to choose a report type and devices group. Then, opens another modal to continue researching information
   * @param  {} validData
   */
  function uploadList(validData) {
    if (!mc.newDevicesData.type || !mc.newDevicesData.group)
      Notifications.addCustom(500, "Please select a type and group.");
    else {
      //Show the other modal
      var newNote = $uibModal.open({
        templateUrl: "customers/views/modals/deviceListModal.html",
        controller: "DeviceListModalCtrl",
        controllerAs: "mc",
        resolve: {
          group: function() {
            return mc.newDevicesData.group;
          },
          type: function() {
            return mc.newDevicesData.type;
          },
          customer: function() {
            return mc.customer;
          }
        }
      });
      newNote.result.then(function(resp) {
        $uibModalInstance.close("cancel");
      });
    }
  }

  /**
   * Opens a modal to write devices group name
   */
  function addGroup() {
    var newNote = $uibModal.open({
      templateUrl: "customers/views/modals/groupModal.html",
      controller: "NoteModalCtrl",
      controllerAs: "mc",
      size: "sm"
    });
    newNote.result.then(function(resp) {
      mc.groups = [];
      mc.groups.push(resp);
      mc.newDevicesData.group = resp;
    });
  }

  /**
   * Closes modal
   */
  function cancel() {
    $uibModalInstance.dismiss("cancel");
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/partExtModalCtrl.js":[function(require,module,exports){
"use strict";

module.exports = PartExtModalCtrl;
PartExtModalCtrl.$inject = [
  "$uibModal",
  "$uibModalInstance",
  "extinguishers",
  "part",
  "type"
];
function PartExtModalCtrl(
  $uibModal,
  $uibModalInstance,
  extinguishers,
  part,
  type
) {
  var vm = this;
  vm.add = add;
  vm.cancel = cancel;
  vm.part = part;
  var auxType = type && type.type ? type.type : null;
  vm.newPart = part || {
    name: null,
    qty: null,
    type: auxType,
    ex: null
  };
  vm.extinguishers = extinguishers;

  /**
   * Adds extinguisher part
   * @param  {} validForm
   */
  function add(validForm) {
    if (validForm) {
      $uibModalInstance.close(vm.newPart);
    }
  }

  /**
   * Closes modal
   */
  function cancel() {
    $uibModalInstance.dismiss("cancel");
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/rest/customerAPI.js":[function(require,module,exports){
"use strict";

module.exports = CustomerAPI;

var Customer = require("../../models/customer.js");
CustomerAPI.$inject = [
  "urlApi",
  "$firebaseArray",
  "$firebaseObject",
  "Notifications",
  "$sessionStorage",
  "$q",
  "$http",
  "urlNode"
];

function CustomerAPI(
  urlApi,
  $firebaseArray,
  $firebaseObject,
  Notifications,
  $sessionStorage,
  $q,
  $http,
  urlNode
) {
  var ref = new Firebase(urlApi);
  var customerRef = ref.child("Customer");
  var accessRef = ref.child("Access");
  var queue = ref.child("queue").child("tasks");
  CustomerAPI.get = get;
  CustomerAPI.list = list;
  CustomerAPI.save = save;
  CustomerAPI.remove = remove;
  CustomerAPI.removeAll = removeAll;
  CustomerAPI.giveAccess = giveAccess;
  CustomerAPI.getFromCustomer = getFromCustomer;
  CustomerAPI.insertIntoQueueSingle = insertIntoQueueSingle;
  CustomerAPI.createFromExcel = createFromExcel;
  CustomerAPI.removeAccess = removeAccess;
  CustomerAPI.changeFirstTimeUser = changeFirstTimeUser;
  CustomerAPI.changeTourFirstTimeUser = changeTourFirstTimeUser;
  CustomerAPI.checkTourFirstTime = checkTourFirstTime;
  CustomerAPI.listSubAccountFromMaster = listSubAccountFromMaster;
  CustomerAPI.getFromCustomerWithId = getFromCustomerWithId;
  CustomerAPI.getTemplateReportsIds = getTemplateReportsIds;
  CustomerAPI.getMasterAccount = getMasterAccount;
  return CustomerAPI;

  /**
   * Returns a client customer
   * @param  {String} idClient
   * @return {Object} Customer
   */
  function get(idClient, idCustomer) {
    if (idCustomer) {
      return $firebaseObject(
        customerRef.child(idClient).child(idCustomer)
      ).$loaded(function(resp) {
        return Customer.loadObj(resp);
      });
    } else {
      return Promise.resolve(new Customer());
    }
  }

  function getMasterAccount(clientId, customerId) {
    return CustomerAPI.get(clientId, customerId)
      .then(function (customer) {
        const parentId = customer.fb.idParent;
        return parentId ?
          getMasterAccount(clientId, parentId) :
          customer;
      });
  }

  /**
   * Returns a customer that was found by its id
   * @param  {String} customerId
   * @return {Object} Customer
   */
  function getFromCustomerWithId(customerId) {
    var path = customerRef
      .child($sessionStorage.user.clientId)
      .child(customerId);
    return $firebaseObject(path).$loaded(function(resp) {
      return Customer.loadObj(resp);
    });
  }

  /**
   * Returns a customer through by localStorage parameters
   * @return {Object} Customer
   */
  function getFromCustomer() {
    var path = customerRef
      .child($sessionStorage.user.clientId)
      .child($sessionStorage.user.customerId);
    return $firebaseObject(path).$loaded(function(resp) {
      return Customer.loadObj(resp);
    });
  }

  /**
   * Returns client customers list
   * @return {Array} Customer list
   */
  function list() {
    return $firebaseArray(customerRef.child($sessionStorage.user.$id)).$loaded(
      function(resp) {
        return resp;
      }
    );
  }

  /**
   * Returns all client master sub-accounts
   */
  function listSubAccountFromMaster() {
    return $firebaseArray(
      customerRef.child($sessionStorage.user.clientId)
    ).$loaded(function(resp) {
      var idCustomer = $sessionStorage.user.customerId;

      var ret = [];
      if (resp) {
        ret.master = _.filter(resp, {
          accountType: "Master",
          $id: idCustomer
        })[0];

        var subsAux = _.filter(resp, {
          accountType: "Sub-account",
          idParent: idCustomer
        });
        var buildingsAux = _.filter(resp, { accountType: "Building" });

        var buildings = [];
        for (var i = 0; i < subsAux.length; i++) {
          for (var j = 0; j < buildingsAux.length; j++) {
            if (buildingsAux[j].idParent == subsAux[i].$id) {
              if (!buildings[buildingsAux[j].idParent])
                buildings[buildingsAux[j].idParent] = [];

              buildings[buildingsAux[j].idParent].push(buildingsAux[j]);
            }
          }
        }

        ret.subs = subsAux;
        ret.buildings = buildings;
      }

      return ret;
    });
  }

  /**
   * Removes a customer
   * @param  {Object} obj Customer
   */
  function remove(obj) {
    var future = $q.defer();
    var path = customerRef.child($sessionStorage.user.$id).child(obj.$id);
    return path.remove(function(error) {
      if (error) {
        Notifications.addCustom(500, "There was a problem.");
        future.reject(error);
      } else {
        Notifications.addCustom(200, "Customer deleted successfully");
        future.resolve(true);
      }
      return future.promise;
    });
  }

  /**
   * Removes all customer from client "9b4e2bde-8fbd-4826-be5b-1acb1c067d35"
   * @return {Promise}
   */
  function removeAll() {
    var future = $q.defer();
    var path = customerRef.child("9b4e2bde-8fbd-4826-be5b-1acb1c067d35");
    return path.remove(function(error) {
      if (error) {
        Notifications.addCustom(500, "There was a problem.");
        future.reject(error);
      } else {
        Notifications.addCustom(200, "Customer deleted successfully");
        future.resolve(true);
      }
      return future.promise;
    });
  }

  /**
   * Save customer inspection
   * @param  {Object} obj
   * @param  {Object} inspecsLen
   */
  function save(obj, inspecsLen) {
    if (obj.$id) {
      return edit(obj, inspecsLen);
    } else {
      return create(obj);
    }
  }

  /**
   * Creates a new customer for a client
   * @param  {Object} obj Cliente
   */
  function create(obj) {
    var future = $q.defer();
    try {
      $firebaseArray(customerRef.child($sessionStorage.user.$id))
        .$add(obj)
        .then(function(resp) {
          Notifications.addCustom(200, "Customer created successfully.");
          future.resolve(resp);
        });
    } catch (e) {
      Raven.captureException(e);
      Notifications.addCustom(500, "There was a problem. Please try again.");
      future.reject(e);
    }
    return future.promise;
  }

  /**
   * Creates customers list from excel data fields
   * @param  {Array} customers Customer list
   */
  function createFromExcel(customers) {
    var url = urlNode + "api/customer/";
    var obj = {
      customers: customers,
      uid: $sessionStorage.user.$id
    };
    return $http.post(
      url,
      obj
    ); /*.then( function( resp ) {
      return Notifications.addCustom( 200, "Create customers successfully" );
    }, function() {
      Notifications.add( 404 );
    } );*/
  }

  /**
   * Modify customer data
   * @param  {Object} obj
   * @param  {Number} inspecsLen
   */
  function edit(obj, inspecsLen) {
    return obj.$save().then(ok, error);
    function ok(resp) {
      insertIntoQueue(
        _.slice(
          obj.recurringInspections,
          inspecsLen,
          obj.recurringInspections.length
        )
      );
      Notifications.addCustom(200, "Customer saved successfully");
      return resp;
    }

    function error(resp) {
      Notifications.addCustom(500, "There was a problem.");
      return resp;
    }
  }

  /**
   * Method to insert recurring inspections to a queque
   * @param  {Array} array
   */
  function insertIntoQueue(array) {
    _.forEach(array, insertIntoQueueSingle);
  }

  function insertIntoQueueSingle(inspect) {
    var stringified = angular.toJson(inspect);
    var obj = JSON.parse(stringified);
    queue.push(obj);
  }

  /**
   * Allows a customer to access a  to client account
   * @param  {String} uid Client Id
   * @param  {String} idCustomer Customer Id
   * @return {Promise}
   */
  function giveAccess(uid, idCustomer) {
    var future = $q.defer();
    return accessRef.child("" + uid).set(
      {
        customerId: idCustomer,
        clientId: $sessionStorage.user.$id,
        firstTime: true
      },
      function(err) {
        if (err) {
          future.reject(err);
        } else {
          future.resolve(true);
          Notifications.addCustom(
            200,
            "Customer account successfully created."
          );
        }
        return future.promise;
      }
    );
  }

  /**
   * Removes access to a portal customer
   * @param  {String} uid Client id
   * @return {String|Boolean}
   */
  function removeAccess(uid) {
    return accessRef.child(uid).remove(function(err) {
      if (err) {
        Notifications.addCustom(500, "Access to portal could not be removed");
        return err;
      }
      Notifications.addCustom(200, "Access to portal removed successfully");
      return true;
    });
  }

  /**
   * Removes customer firstTime attribute (needed for tutorial)
   */
  function changeFirstTimeUser() {
    $firebaseObject(accessRef.child($sessionStorage.user.$id)).$loaded(function(
      data
    ) {
      delete data.firstTime;
      data.$save();
    });
  }

  /**
   * Removes customer tourFirstTime attribute (needed for tutorial)
   */
  function changeTourFirstTimeUser() {
    $firebaseObject(accessRef.child($sessionStorage.user.$id)).$loaded(function(
      data
    ) {
      delete data.tourFirstTime;
      data.$save();
    });
  }

  /**
   * Returns customer tourFirstTime attribute (needed for tutorial)
   */
  function checkTourFirstTime() {
    return $firebaseObject(accessRef.child($sessionStorage.user.$id)).$loaded(
      function(data) {
        return data.tourFirstTime;
      }
    );
  }

  /**
   * Retuns a template report list (Custom Report list) of an especific customer
   * @param  {String} customerId Customer id
   * @return {Array} Template report list
   */
  function getTemplateReportsIds(customerId) {
    var query = customerRef.child($sessionStorage.user.$id).child(customerId);
    console.log($sessionStorage.user.$id, customerId);
    return $firebaseArray(query).$loaded(function(data) {
      var customRepIds = _.filter(data, function(elem) {
        if (elem.$id == "customReports") {
          return true;
        } else {
          return false;
        }
      });
      return customRepIds;
    });
  }
}

},{"../../models/customer.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/models/customer.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subaccountsCtrl.js":[function(require,module,exports){
"use strict";

module.exports = subaccountsCtrl;

subaccountsCtrl.$inject = ["$state", "$stateParams"];
function subaccountsCtrl($state, $stateParams) {
  var sa = this;
  sa.customer = $stateParams.customer;
  sa.childs = $stateParams.childs;
  sa.open = open;
  sa.openParent = openParent;

  /**
   * Opens subaccounts page or customer home page
   * @param  {Array} subaccount Customer subaccounts
   * @param  {Array} buildings Customer buildings
   */
  function open(subaccount, buildings) {
    var childs = _.filter(buildings, { idParent: subaccount.$id });
    //if it doesn't have subaccounts, it goes to the customer screen, if not it will show list of subaccounts
    if (_.isEmpty(childs)) {
      $state.go("index.customer-one.home", { id: subaccount.$id });
    } else {
      $state.go("index.customers.subaccounts", {
        customer: subaccount,
        childs: { subs: childs }
      });
    }
  }

  function openParent() {
    $state.go("index.customer-one.home", { id: sa.customer.$id });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/buildingInfoCtrl.js":[function(require,module,exports){
"use strict";

module.exports = buildingInfoCtrl;
var deviceList = {
  Alarm: [
    "AHU Shutdown",
    "Beam Detector",
    "Bell",
    "Door Holder",
    "Door Lock",
    "Duct Detector",
    "Elevator Recall",
    "Fire/Smoke Dampers",
    "Fire Phone",
    "Fire Phone Jack",
    "Heat Detector",
    "Horn",
    "Horn/Strobe",
    "Pull Station",
    "Smoke Detector",
    "Speaker",
    "Strobe",
    "Speaker/Strobe",
    "Tamper/Supervisory Indicator",
    "Vertical Roll Down Door",
    "WAN Door",
    "Water Flow Alarm",
    "Other"
  ],
  Suppression: [
    "AHU Shutdown",
    "Beam Detector",
    "Bell",
    "Door Holder",
    "Door Lock",
    "Duct Detector",
    "Elevator Recall",
    "Fire Phone",
    "Fire Phone Jack",
    "Heat Detector",
    "Horn",
    "Horn/Strobe",
    "Pull Station",
    "Smoke Detector",
    "Speaker",
    "Strobe",
    "Speaker/Strobe",
    "Tamper/Supervisory Indicator",
    "Vertical Roll Down Door",
    "WAN Door",
    "Water Flow Alarm",
    "Other"
  ],
  Sensitivity: ["Smoke Detector"],
  Sprinkler: [
    "Bell",
    "Horn",
    "Horn/Strobe",
    "OS&Y Valve",
    "Butterfly Valve",
    "Ball Valve",
    "Control Valve",
    "Post Indicator Valve",
    "Supervisory Switch",
    "Water Motor Gong",
    "Wall Indicator Valve",
    "Waterflow Alarm",
    "Air Pressure Supervisory Switch",
    "Other"
  ],
  "Emergency Exit": ["Emergency Light", "Exit Sign", "Combo Unit"],
  Extinguisher: [
    "ABC",
    "BC",
    "Class D",
    "Clean agent",
    "CO2",
    "Foam",
    "Purple K",
    "Water",
    "Wet chem",
    "Other"
  ]
};

buildingInfoCtrl.$inject = ["customer", "$uibModal", "cfpLoadingBar", "$scope"];
function buildingInfoCtrl(customer, $uibModal, cfpLoadingBar, $scope) {
  var build = this;
  build.showNotesModal = showNotesModal;
  build.removeNote = removeNote;
  build.reportTypes = [
    "Alarm",
    "Emergency Exit",
    "Extinguisher",
    "Sensitivity",
    "Sprinkler",
    "Suppression"
  ];
  build.view = "Building";
  console.log(customer);
  build.showColOtherType = false;
  build.addNewDataDevices = addNewDataDevices;
  build.loadDevicesType = loadDevicesType;
  build.deleteDataDevices = deleteDataDevices;
  build.loadOptionsDevices = loadOptionsDevices;
  build.changeView = changeView;
  build.changeDeviceType = changeDeviceType;
  /**
   * Add device data (quantity in the building, device type, etc) by report type
   */
  function addNewDataDevices() {
    if (build.type && build.optDevice && build.deviceType && build.quantity) {
      if (!customer.fb.buildingInfo) {
        customer.fb.buildingInfo = {};
      }
      if (!customer.fb.buildingInfo.devicesData) {
        customer.fb.buildingInfo.devicesData = [];
      }

      var obj = {
        type: build.type,
        optDevice: build.optDevice,
        deviceType: build.deviceType,
        quantity: build.quantity
      };

      if (build.deviceType === "Other") {
        obj.typeOther = build.typeOther;
      }

      customer.fb.buildingInfo.devicesData.push(obj);
      customer.fb.$save();

      build.quantity = null;
      build.typeOther = null;
      build.showColOtherType = false;
      build.deviceType = null;
    } else {
      alert("Please complete all fields");
    }
  }

  /**
   * Removes devices data
   * @param  {Number} index
   */
  function deleteDataDevices(data) {
    if (confirm("Are you sure you want to delete this info?")) {
      var index = customer.fb.buildingInfo.devicesData.indexOf(data);
      if (index > -1) {
        customer.fb.buildingInfo.devicesData.splice(index, 1);
        customer.fb.$save();
      }
    }
  }

  /**
   * Load different types of devices (Devices, Control Panels or Risers)
   */
  function loadOptionsDevices() {
    build.deviceTypes = [];
    build.optDevice = "";
    build.optionDevices = ["Devices"];
    if (build.type === "Alarm" || build.type === "Suppression") {
      build.optionDevices.push("Control Panels");
    } else if (build.type === "Sprinkler") {
      build.optionDevices.push("Risers");
    }
    build.typeOther = null;
    build.showColOtherType = false;
  }

  /**
   * Loads devices type list by report type
   * @param  {String} type Report type
   */
  function loadDevicesType() {
    cfpLoadingBar.start();
    if (build.type) {
      if (build.optDevice === "Devices") {
        build.deviceTypes = deviceList[build.type];
      } else if (build.optDevice === "Control Panels") {
        build.deviceTypes = ["Master", "Sub", "Power Supply"];
      } else {
        build.deviceTypes = [
          "Antifreeze Loop",
          "Deluge System",
          "Dry System",
          "Foam System",
          "Preaction System",
          "Wet System"
        ];
      }
      build.typeOther = null;
      build.showColOtherType = false;
      cfpLoadingBar.complete();
    }
  }

  /**
   * Deletes a note
   * @param {Number} index
   */
  function removeNote(index) {
    customer.fb.buildingInfo.notes.splice(index, 1);
    customer.fb.$save();
  }

  /**
   * Show a modal that allows to write building notes
   */
  function showNotesModal() {
    if (!customer.fb.buildingInfo) {
      customer.fb.buildingInfo = {};
    }
    var newNote = $uibModal.open({
      templateUrl: "customers/views/modals/noteModal.html",
      controller: "NoteModalCtrl",
      controllerAs: "mc",
      size: "sm"
    });
    newNote.result.then(function(resp) {
      if (!customer.fb.buildingInfo.notes) {
        customer.fb.buildingInfo.notes = [];
      }
      customer.fb.buildingInfo.notes.push(resp);
      customer.fb.$save();
    });
  }

  /**
   * Change tab view for Building Information
   * @param  {String} view Change tab to view
   */
  function changeView(view) {
    build.view = view;
  }

  /**
   * Method to change device types. If it's other type, shows another column to write device type name
   */
  function changeDeviceType() {
    if (build.deviceType === "Other") {
      build.showColOtherType = true;
    } else {
      build.typeOther = null;
      build.showColOtherType = false;
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/customerHomeCtrl.js":[function(require,module,exports){
"use strict";

module.exports = customerIndexCtrl;

var sorter = require("../../models/inspectionsSorter.js");

customerIndexCtrl.$inject = ["inspections", "InspectionAPI"];
/** -
 * @param  {} inspections
 */
function customerIndexCtrl(inspections, InspectionAPI) {
  var home = this;
  home.typeStr = typeStr;
  home.dueInspections = sorter.sortDueInspections(inspections);
  home.doneInspections = sorter.sortDoneInspections(inspections);
  function typeStr(inspection) {
    return InspectionAPI.typeStr(inspection);
  }
}

},{"../../models/inspectionsSorter.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/models/inspectionsSorter.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/devicesInfoCtrl.js":[function(require,module,exports){
"use strict";

module.exports = devicesInfoCtrl;

devicesInfoCtrl.$inject = [
  "urlApi",
  "customer",
  "$uibModal",
  "$firebaseArray",
  "$firebaseObject",
  "$sessionStorage",
  "cfpLoadingBar",
  "Notifications",
  "$timeout",
  "$state"
];
function devicesInfoCtrl(
  urlApi,
  customer,
  $uibModal,
  $firebaseArray,
  $firebaseObject,
  $sessionStorage,
  cfpLoadingBar,
  Notifications,
  $timeout,
  $state
) {
  var urlDevices = $sessionStorage.user.$id + "/" + customer.fb.$id;
  var devicesRef = new Firebase(urlApi + "Devices/" + urlDevices);

  var build = this;
  build.showHeaders = false;
  build.modelOptions = { allowInvalid: true, debounce: 1000 };
  build.showUploadDevicesModal = showUploadDevicesModal;
  build.refreshList = refreshList;
  build.devices = [];

  build.reportType = "ALL";
  build.reportGroup = "ALL";
  build.customer = customer;
  loadCustomerGroups();
  loadCustomerDevicesByType();
  build.reportTypeListChanged = reportTypeListChanged;
  build.groupTypeListChanged = groupTypeListChanged;
  build.removeGroup = removeGroup;
  build.backToGroup = backToGroup;
  build.goToGroup = goToGroup;
  build.addDeviceToGroup = addDeviceToGroup;
  build.editDeviceToGroup = editDeviceToGroup;
  build.removeDevice = removeDevice;
  return build;

  /**
   * Add a device to a group devices (Device or Extinguisher)
   */
  function addDeviceToGroup() {
    var group = build.reportGroup;
    var type = build.reportType;

    var templateUrl = "customers/views/modals/addDeviceModal.html";
    var controller = "AddDeviceModalCtrl";
    if (type == "Extinguisher") {
      templateUrl = "customers/views/modals/addExtinguisherModal.html";
      controller = "AddExtinguisherModalCtrl";
    }

    var newDeviceModal = $uibModal.open({
      templateUrl: templateUrl,
      controller: controller,
      cache: false,
      controllerAs: "vm",
      resolve: {
        group: function() {
          return group;
        },
        type: function() {
          return type;
        },
        device: function() {
          return null;
        }
      }
    });

    newDeviceModal.result.then(function(newDevice) {
      //save device
      cfpLoadingBar.start();
      $firebaseArray(devicesRef).$loaded(function(resp) {
        resp.$add(newDevice).then(function(resp) {
          Notifications.addCustom(200, "Device added correctly");
          loadCustomerDevicesByType();
          cfpLoadingBar.complete();
        });
      });
    });
  }

  /**
   * Removes a device
   * @param  {Object} device
   */
  function removeDevice(device) {
    var devRef = devicesRef
      .child(device.$id);
    $firebaseObject(devRef)
      .$loaded(function(res) { 
        delete res.groupDevice;
        res.$save();
      })
      .then(function() {
        Notifications.addCustom(200, "Device deleted correctly");
        loadCustomerDevicesByType();
      });
  }

  /**
   * Modify a group devices
   * @param  {Object} device
   */
  function editDeviceToGroup(device) {
    var group = build.reportGroup;
    var type = build.reportType;
    var templateUrl = "customers/views/modals/addDeviceModal.html";
    var controller = "AddDeviceModalCtrl";
    if (type == "Extinguisher") {
      templateUrl = "customers/views/modals/addExtinguisherModal.html";
      controller = "AddExtinguisherModalCtrl";
    }
    var editDeviceModal = $uibModal.open({
      templateUrl: templateUrl,
      cache: false,
      controller: controller,
      controllerAs: "vm",
      resolve: {
        group: function() {
          return group;
        },
        type: function() {
          return type;
        },
        device: function() {
          return device;
        }
      }
    });

    editDeviceModal.result.then(function(newDevice) {
      //save device
      //   newDevice.$save();.
      cfpLoadingBar.start();
      const id = newDevice.$id;
      delete newDevice.$$hashKey;
      delete newDevice.$id;
      delete newDevice.$priority;
      delete newDevice.deletePrevious;
      devicesRef
        .child(id)
        .set(newDevice)
        .then(function(res) {
          Notifications.addCustom(200, "Device edited correctly");
          loadCustomerDevicesByType();
          cfpLoadingBar.complete();
        });
    });
      //    loadCustomerDevicesByType();
      //cfpLoadingBar.start();
      // $firebaseArray(devicesRef).$loaded(function (resp) {
      //remove previous device and add new
      //   resp.$add(newDevice).then(function (resp) {
      //     Notifications.addCustom(200, "Device added correctly");
      //     loadCustomerDevicesByType();
      //     cfpLoadingBar.complete();
      //   });
      // });
  }

  /**
   * Hide devices
   */
  function backToGroup() {
    build.showDevices = false;
  }

  /**
   * Shows devices by report type and device group
   * @param  {String} groupName Devices group name
   * @param  {String} reportType Report type
   */
  function goToGroup(groupName, reportType) {
    build.reportGroup = groupName;
    build.reportType = reportType;
    build.showDevices = true;
    groupTypeListChanged();
  }

  /**
   * Get all the devices and save them in a list filtered by report type and device group
   */
  function refreshList() {
    build.devices = [];
    for (var i = 0; i < build.allDevices.length; i++) {
      var device = build.allDevices[i];

      if (
        (!build.reportGroup ||
          build.reportGroup == "ALL" ||
          (device.groupDevice && build.reportGroup == device.groupDevice)) &&
        (!build.reportType ||
          build.reportType == "ALL" ||
          (device.reportType && build.reportType == device.reportType))
      )
        build.devices.push(device);
    }

    if (build.devices && build.devices.length > 0) build.showHeaders = true;
  }

  /**
   * Load customer devices group
   */
  function reportTypeListChanged() {
    refreshList();
    build.reportGroup = "ALL";
    loadCustomerGroups();
  }

  function groupTypeListChanged() {
    refreshList();
  }

  /**
   * Load customer devices filtered by type
   */
  function loadCustomerDevicesByType() {
    build.allDevices = [];
    $firebaseArray(devicesRef).$loaded(function(resp) {
      for (var i = 0; i < resp.length; i++) {
        var device = resp[i];

        if (device.groupDevice) build.allDevices.push(device);
      }

      refreshList();
    });
  }

  /**
   * Load customer devices group
   */
  function loadCustomerGroups() {
    build.groups = ["ALL"];
    build.groupsObject = [];

    // if (build.reportType!='ALL'){
    $firebaseArray(devicesRef).$loaded(function(resp) {
      for (var i = 0; i < resp.length; i++) {
        var device = resp[i];

        if (
          (device.reportType == build.reportType ||
            build.reportType == "ALL") &&
          device.groupDevice &&
          build.groups.indexOf(device.groupDevice) == -1
        ) {
          build.groups.push(device.groupDevice);
          build.groupsObject.push({
            name: device.groupDevice,
            reportType: device.reportType
          });
        }
      }
    });
    //}
  }

  /**
   * Removes customer device group
   * @param  {String} groupName Device group name
   */
  function removeGroup(groupName) {
    cfpLoadingBar.start();

    var urlDevices = $sessionStorage.user.$id + "/" + customer.fb.$id;
    var devicesRef = new Firebase(urlApi + "Devices/" + urlDevices);

    $firebaseArray(devicesRef).$loaded(function(resp) {
      var customerDevices = resp;

      deleteGroupFromDevices(groupName, customerDevices, urlDevices);
    });
  }

  /**
   * Deletes all customer devices from a group
   * @param  {String} groupName Device group name
   * @param  {Array} deviceList Devices list
   */
  function deleteGroupFromDevices(groupName, deviceList, urlDevices) {
    for (var i = 0; i < deviceList.length; i++) {
      if (deviceList[i].groupDevice && deviceList[i].groupDevice == groupName) {
        const urlDevice =
          urlApi + "Devices/" + urlDevices + "/" + deviceList[i].$id;
        const deviceRef = new Firebase(urlDevice);

        $firebaseObject(deviceRef).$loaded(function(resp) {
          delete resp.groupDevice;
          resp.$save();
        });
      }
    }
    loadCustomerGroups();
    cfpLoadingBar.complete();
  }

  /**
   * Returns devices groups names
   * @returns {Array} Group devices list
   */
  function getGroupsForType() {
    var groups = [];
    return $firebaseArray(devicesRef).$loaded(function(resp) {
      for (var i = 0; i < resp.length; i++) {
        var device = resp[i];

        if (device.groupDevice && groups.indexOf(device.groupDevice) == -1)
          groups.push(device.groupDevice);
      }

      return groups;
    });
  }

  /**
   * Shows upload devices modal
   */
  function showUploadDevicesModal() {
    cfpLoadingBar.start();
    getGroupsForType().then(function(res) {
      cfpLoadingBar.complete();
      var devicesUpdated = $uibModal.open({
        templateUrl: "customers/views/modals/uploadDevices.html",
        controller: "UploadDevicesModalCtrl",
        controllerAs: "mc",
        resolve: {
          groups: function() {
            return res;
          },
          customer: function() {
            return build.customer;
          }
        }
      });

      devicesUpdated.result.then(function() {
        $timeout(function() {
          /*build.reportGroup = "ALL";
          build.reportType = "ALL"
          reportTypeListChanged();
          groupTypeListChanged()*/
          $state.reload();
        });
      });
    });
  }

  /**
   * Opens notes modal and allows user to write extra builiding information
   */
  function showNotesModal() {
    if (!customer.fb.buildingInfo) {
      customer.fb.buildingInfo = {};
    }
    var newNote = $uibModal.open({
      templateUrl: "customers/views/modals/noteModal.html",
      controller: "NoteModalCtrl",
      controllerAs: "mc",
      size: "sm"
    });
    newNote.result.then(function(resp) {
      if (!customer.fb.buildingInfo.notes) {
        customer.fb.buildingInfo.notes = [];
      }
      customer.fb.buildingInfo.notes.push(resp);
      customer.fb.$save();
    });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/exportDevicesCtrl.js":[function(require,module,exports){
"use strict";

module.exports = exportDevicesCtrl;

exportDevicesCtrl.$inject = [
  "customer",
  "reports",
  "$uibModal",
  "client",
  "CustomerAPI",
  "InspectionAPI",
  "$stateParams",
  "$scope",
  "$state",
  "urlNode",
  "$sessionStorage"
];
function exportDevicesCtrl(
  customer,
  reports,
  $uibModal,
  client,
  CustomerAPI,
  InspectionAPI,
  $stateParams,
  $scope,
  $state,
  urlNode,
  $sessionStorage
) {
  var exp = this;
  exp.type = $stateParams.type ? $stateParams.type : showInspecModal();
  exp.reports = reports;
  exp.exportDevices = exportDevices;
  exp.customer = customer;

  /**
   * Opens export devices modal
   */
  function showInspecModal() {
    var newExport = $uibModal.open({
      templateUrl: "customers/views/modals/exportModal.html",
      controller: "ExportModalCtrl",
      controllerAs: "mc",
      size: "sm"
    });

    newExport.result.then(function(resp) {
      exp.type = resp.type;
    });
  }
  /**
   * -
   * @param  {Object} report
   */
  function exportDevices(report) {
    var url = urlNode + "api/reports/deviceexport";
    var customerData = {
      customerName: exp.customer.fb.custInfo.customerName,
      address: exp.customer.fb.custInfo.address
    };

    window.open(
      url +
        "?clientId=" +
        $sessionStorage.user.$id +
        "&customerId=" +
        exp.customer.fb.$id +
        "&reportType=" +
        report.type +
        "&reportId=" +
        report.$id +
        "&extraCustomerData=" +
        encodeURIComponent(JSON.stringify(customerData))
    );
  }

  /*
  exp.showInspecModal = showInspecModal;
  exp.inspectionsList = _.groupBy(customer.fb.expurringInspections, "type");
  exp.deleteRI = deleteRI;

  

    //modal, no need for catch
    newInspection.result.then(function (resp) {
      if (!exp.inspectionsList[resp.type] || exp.inspectionsList[resp.type].length < 6) {
        resp.idCustomer = customer.fb.$id;
        resp.customerName = customer.fb.custInfo.customerName;
        resp.createdAt = moment().format();
        resp.idClient = client.$id;
        customer.addInspection(resp);
        CustomerAPI.insertIntoQueueSingle(resp);
        exp.inspectionsList = _.groupBy(customer.fb.recurringInspections, "type");
        customer.fb.$save();
      }
    });
  }



  function deleteRI(insp, customer) {
    if (confirm("Are you sure you want to delete this recurring inspection?")) {
      InspectionAPI.deleteInspections(insp, customer).then(function (res) {
        customer.fb.recurringInspections = _.reject(customer.fb.recurringInspections, {
          frequency: insp.frequency,
          type: insp.type
        });
        customer.fb.$save();
        exp.inspectionsList = _.groupBy(customer.fb.recurringInspections, "type");
      }).catch(function (exp) {

      });

    }
  } */
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/recurringCtrl.js":[function(require,module,exports){
"use strict";

module.exports = recurringCtrl;

recurringCtrl.$inject = [
  "customer",
  "$uibModal",
  "client",
  "CustomerAPI",
  "InspectionAPI"
];
function recurringCtrl(
  customer,
  $uibModal,
  client,
  CustomerAPI,
  InspectionAPI
) {
  var rec = this;

  rec.showInspecModal = showInspecModal;
  rec.inspectionsList = _.groupBy(customer.fb.recurringInspections, function (inspec) {
    if (inspec.woTypeOther) return inspec.woTypeOther;
    return inspec.type;
  });
  rec.deleteRI = deleteRI;

  /**
   * Opens recurring inspection modal in order to add new one
   */
  function showInspecModal() {
    var newInspection = $uibModal.open({
      templateUrl: "customers/views/modals/recurring.html",
      controller: "RecurringModalCtrl",
      controllerAs: "mc",
      size: "sm"
    });

    //modal, no need for catch
    newInspection.result.then(function(resp) {
      if (
        !rec.inspectionsList[resp.type] ||
        rec.inspectionsList[resp.type].length < 6
      ) {
        resp.idCustomer = customer.fb.$id;
        resp.customerName = customer.fb.custInfo.customerName;
        resp.createdAt = moment().format();
        resp.idClient = client.$id;
        customer.addInspection(resp);
        CustomerAPI.insertIntoQueueSingle(resp);
        rec.inspectionsList = _.groupBy(
          customer.fb.recurringInspections,
          function (inspec) {
            if (inspec.woTypeOther) return inspec.woTypeOther;
            return inspec.type;
          }
        );
        customer.fb.$save();
      }
    });
  }

  /**
   * Removes a customer recurring inspection
   * @param  {Object} insp Recurring inspection
   * @param  {Object} customer Customer data
   */
  function deleteRI(insp, customer) {
    if (confirm("Are you sure you want to delete this recurring inspection?")) {
      InspectionAPI.deleteInspections(insp, customer)
        .then(function(res) {
          var toRemove = _.pick({
            frequency: insp.frequency,
            type: insp.type,
            parity: insp.parity,
            createdAt: insp.createdAt
          }, _.identity);
          customer.fb.recurringInspections = _.reject(
            customer.fb.recurringInspections,
            toRemove
          );
          customer.fb.$save();
          rec.inspectionsList = _.groupBy(
            customer.fb.recurringInspections,
            "type"
          );
        })
        .catch(function(exp) {});
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/reportsCtrl.js":[function(require,module,exports){
"use strict";

module.exports = reportsCtrl;

reportsCtrl.$inject = [
  "customer",
  "reports",
  "v1reports",
  "templates",
  "ReportAPI",
  "$sessionStorage",
  "ImageAPI",
  "DeviceAPI",
  "$stateParams",
  "Notifications",
  "$state",
  "$uibModal",
  "$timeout",
  "EmployeeAPI",
  "cfpLoadingBar",
  "$scope",
  "employees",
  "InspectionAPI"
];

function reportsCtrl(
  customer,
  reports,
  v1reports,
  templates,
  ReportAPI,
  $sessionStorage,
  ImageAPI,
  DeviceAPI,
  $stateParams,
  Notifications,
  $state,
  $uibModal,
  $timeout,
  EmployeeAPI,
  cfpLoadingBar,
  $scope,
  employees,
  InspectionAPI
) {
  var rep = this;
  if ($stateParams.type === "Custom") {
    rep.reports = filterByCustomType(reports);
    rep.template = templates.values;
    console.log("rep.template", rep.template);
  } else {
    rep.reports = reports;
  }

  console.log("rep.reports", rep.reports);
  rep.v1reports = v1reports;
  rep.specialReport = $stateParams.type;
  rep.type = $stateParams.subType ? $stateParams.subType : $stateParams.type;
  rep.subType = $stateParams.subType ? rep.type : $stateParams.subType;
  rep.typeStr = typeStr;
  rep.removeReport = removeReport;
  rep.removeV1Report = removeV1Report;
  rep.downloadReport = downloadReport;
  rep.downloadV1Report = downloadV1Report;
  rep.hideAction = $sessionStorage.user.isClient;
  rep.openModified = openModified;
  rep.startReport = startReport;
  rep.sendEmail = sendEmail;
  rep.copyReportToWo = copyReportToWo;
  rep.selectTypeTemplate = selectTypeTemplate;
  rep.newReportWarning = newReportWarning;
  rep.goToRoute = goToRoute;
  rep.getLastWorkedByName = getLastWorkedByName;
  rep.employees = employees;

  rep.templateId = $stateParams.templateId;
  console.log("templateid", rep.templateId);
  filterTemplatesByType();

  if (rep.type != undefined && rep.type !== "Custom")
    selectMenuReportType(rep.type);

  /**
   * Returns custom reports whose templateId is the same as $stateParams.templateId
   * @param  {Array} reports
   * @return {Array} Filtered custom reports
   */
  function filterByCustomType(reports) {
    var filtered = _.filter(reports, function(report) {
      return report.templateId === $stateParams.templateId;
    });
    return filtered;
  }

  /**
   * Filters templates by type and customer (who is logged)
   * (Currently is not in use because reports don't have custom report type == 'Custom')
   */
  function filterTemplatesByType() {
    rep.templateReports = [];
    var data = templates.values;
    console.log(templates.values.length);
    console.log("template.values", templates.values);
    console.log("$stateParams", $stateParams);

    _.forEach(data, function(template) {
      if (template && template.type && template.type === $stateParams.type) {
        if (template.clients) {
          var found = false;
          for (var i = 0; i < template.clients.length && !found; i++) {
            if (template.clients[i].clientId === $sessionStorage.user.$id) {
              _.forEach(template.clients[i].customers, function(customer) {
                if (customer === $stateParams.id) {
                  rep.templateReports.push(template);
                }
              });
              found = true;
            }
          }
        }
      }
    });
    console.log("repep", rep.templateReports);
  }

  if (rep.templateId != undefined) {
    $timeout(function() {
      $("#" + rep.templateId).addClass("active");
    });
  }

  /**
   *  Returns employee name who was the last to modify the report
   *  @param  {Object} report Report
   */
  function getLastWorkedByName(report) {
    if (report.modifiedBy)
      report.lastWorkedBy = getEmployeeName(report.modifiedBy);

    return report.lastWorkedBy;
  }

  /**
   * Returns the employee name searched by id
   * @param  {String} id Employee id
   * @return {String} Employee name
   */
  function getEmployeeName(id) {
    var employee = _.find(rep.employees, function(employee) {
      return employee.$id === id;
    });
    return employee ? employee.name : "";
  }

  /**
   * returns input id for the menu (used to css style)
   * @param  {String} reportType Report type
   * @return {String} Menu Id
   */
  function selectMenuReportType(reportType) {
    var reportMenuId = "";
    switch (reportType) {
      case "Alarm":
        reportMenuId = "report-alarm";
        break;
      case "Back Flow":
        reportMenuId = "report-back";
        break;
      case "Emergency Exit":
        reportMenuId = "report-emergency";
        break;
      case "Extinguisher":
        reportMenuId = "report-extinguisher";
        break;
      case "Fire Hydrant":
        reportMenuId = "report-fire-hydrant";
        break;
      case "Fire Pump":
        reportMenuId = "report-fire-pump";
        break;
      case "Grease Cleaning":
        reportMenuId = "report-grease";
        break;
      case "Hood System":
        reportMenuId = "report-hood";
        break;
      case "Monitoring":
        reportMenuId = "report-monitoring";
        break;
      case "Sensitivity":
        reportMenuId = "report-sensitivity";
        break;
      case "Special Hazard":
        reportMenuId = "report-special";
        break;
      case "Sprinkler":
        reportMenuId = "report-sprinkler";
        break;
      case "Standpipe Hose":
        reportMenuId = "report-standpipe";
        break;
      case "Suppression":
        reportMenuId = "report-suppression";
        break;
      case "Other":
        reportMenuId = "report-other";
        break;
    }
    $timeout(function() {
      $("#" + reportMenuId).addClass("active");
    });
  }
  /**
   * show a popup for starting a new report
   */
  function newReportWarning() {
    $sessionStorage.user.flags = $sessionStorage.user.flags || [];
    if ($sessionStorage.user.flags.hideNewReportWarning) {
      selectTypeTemplate();
    } else {
      $scope.flags = $sessionStorage.user.flags;
      rep.modalInstance = $uibModal.open({
        templateUrl: "customers/views/modals/newReportWarningModal.html",
        scope: $scope
      });
      rep.modalInstance.result.then(function(flag) {
        selectTypeTemplate();
      });
    }
  }
  /**
   * If there aren't template reports or choose an original then starts a new report, else allows to choose the
   * template report to start
   */
  function selectTypeTemplate() {
    if (
      $stateParams.type == "Work Order" ||
      $stateParams.type == "Quote" ||
      rep.templateReports.length == 0
    ) {
      startReport($stateParams.type);
    } else {
      rep.modalInstance = $uibModal.open({
        templateUrl: "customers/views/modals/templateReportModal.html",
        scope: $scope
      });

      rep.modalInstance.result.then(function(typeTemplate) {
        if (typeTemplate)
          if (typeTemplate === "Custom") {
            selectTemplateReport();
          } else {
            startReport(typeTemplate);
          }
      });
    }
  }

  /**
   * Starts new report
   * @param  {String} typeTemplate Template type
   * @param  {Object} template Template data
   */
  function startReport(typeTemplate, template) {
    var route = "index.customer-one.incomplete";
    var obj = {
      clientId: $sessionStorage.user.$id,
      idCustomer: customer.fb.$id,
      customerName: customer.fb.custInfo.customerName,
      type: $stateParams.type,
      createdAt: moment().format("YYYY-MM-DD"),
      modifiedAt: moment().format("YYYY-MM-DD"),
      startTime: moment().format("YYYY-MM-DD, h:mm:ss a"),
      monitoring: { exists: "" },
      startedBy: "Admin",
      lastWorkedBy: "Admin",
      pdfPath: null
    };

    if (typeTemplate === "Custom") {
      if (rep.template) {
        template = rep.template;
      }
      route = "index.customer-one.custom-incomplete";
      var customObj = {
        templateId: template.$id,
        questions: template.questions,
        reportName: template.name,
        isCustom: true,
        sections: template.sections
      };

      obj = Object.assign(obj, customObj);
      console.log("obj", obj);
      //TODO: need  to find a better way to do this
      ReportAPI.save(obj).then(function(resp) {
        $state.go(route, {
          id: obj.idCustomer,
          type: obj.type,
          report: resp
        });
      });
    } else {
      InspectionAPI.getTemplateQuestions(obj).then(function (data) {
        if (data && data.customQuestions.length > 0)
          obj.customQuestions = data.customQuestions;

        //TODO: need  to find a better way to do this
        ReportAPI.save(obj).then(function(resp) {
          $state.go(route, {
            id: obj.idCustomer,
            type: obj.type,
            report: resp
          });
        });
      });
    }
  }

  /**
   * Opens modal in order to choose template report and then start new one
   */
  function selectTemplateReport() {
    rep.templateModal = $uibModal.open({
      templateUrl: "customers/views/modals/selectTemplateModal.html",
      scope: $scope
    });

    rep.templateModal.result.then(function(template) {
      if (template) {
        console.log("template choosen", template);
        startReport("Custom", template);
      }
    });
  }

  /**
   * Opens a modal that shows employees who modified the report
   * @param  {Object} report Report data
   */
  function openModified(report) {
    $uibModal.open({
      templateUrl: "customers/views/modals/reportHistory.html",
      controller: "ReportHistoryModalCtrl",
      controllerAs: "rem",
      resolve: {
        report: function() {
          return report;
        },
        employees: function() {
          return EmployeeAPI.list();
        }
      }
    });
  }

  /**
   * Removes report
   * @param  {Object} report Report data
   */
  function removeReport(report) {
    var index = rep.reports.indexOf(report);
    console.log(index);
    var isCustom = report.isCustom;
    if (confirm("Are you sure you want to delete this report?")) {
      ReportAPI.remove($sessionStorage.user.$id, customer.fb.$id, report).then(
        function(res) {}
      );
    }
  }

  /**
   * Removes v1 report
   * @param  {Object} report Report data
   */
  function removeV1Report(report) {
    if (confirm("Are you sure you want to delete this report?")) {
      ReportAPI.removev1($sessionStorage.user.$id, customer.fb.$id, report);
    }
  }

  /**
   * Shows pdf report in a new blank tab
   * @param  {Object} report Report data
   */
  function downloadReport(report) {
    var url =
      "/pdf/" +
      report.clientId +
      "/" +
      report.idCustomer +
      "/" +
      report.type +
      "/" +
      report.$id;
    window.open(url);
  }

  /**
   * Shows pdf v1 report in a new blank tab
   * @param  {Object} report Report data
   */
  function downloadV1Report(report) {
    var url = "/v1_reports/" + report.url + ".pdf";
    window.open(url);
  }

  /**
   * Sends an email with the report pdf url
   * @param  {Object} report Report data
   */
  function sendEmail(report) {
    $uibModal.open({
      templateUrl: "customers/views/modals/reportEmailModal.html",
      controller: "ReportEmailModalCtrl",
      controllerAs: "rem",
      resolve: {
        report: function() {
          return report;
        },
        customer: function() {
          return customer.fb;
        }
      }
    });
  }

  /**
   * Converts a quote report to a work order report
   * @param  {Object} report Report data
   */
  function copyReportToWo(report) {
    if (confirm("Do you want to convert this quote to a work order?")) {
      ReportAPI.get(report.clientId, report.idCustomer, report.type, report.$id)
        .then(function(data) {
          var inspection = angular.copy(data.fb);

          inspection.type = "Work Order";

          inspection.createdAt = moment().format("YYYY-MM-DD");
          inspection.modifiedAt = moment().format("YYYY-MM-DD");
          inspection.startTime = moment().format("YYYY-MM-DD, h:mm:ss a");
          inspection.monitoring = { exists: "" }; //no se si va o no
          inspection.startedBy = "Admin";
          inspection.lastWorkedBy = "Admin";

          //borro datos del reporte copia
          delete inspection.$id;
          delete inspection.$$conf;
          delete inspection.$priority;
          delete inspection.$$hashKey;

          delete inspection.hoursNeeded;
          delete inspection.techsNeeded;
          delete inspection.ownerName;

          //guardo reporte nuevo
          ReportAPI.save(inspection)
            .then(function(inspectionId) {
              console.log(inspectionId); //es ref.key();
              $state.go("index.customer-one.incomplete", {
                id: inspection.idCustomer,
                type: inspection.type,
                report: inspectionId
              });
            })
            .catch(function(exp) {
              console.log(exp);
            });
        })
        .catch(function(exp) {
          console.log(exp);
        });
    }
  }

  /**
   * Goes to custom report route (if it is a custom report) or original report route
   * (Shows report data)
   * @param  {Object} rep Report data
   */
  function goToRoute(rep) {
    if (rep.type === "Custom" || rep.isCustom) {
      $state.go("index.customer-one.custom-reports.report", {
        report: rep.$id,
        templateId: rep.templateId,
        type: rep.type
      });
    } else {
      $state.go("index.customer-one.reports.report", { report: rep.$id });
    }
  }
  function typeStr(inspection) {
    return InspectionAPI.typeStr(inspection);
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/singleCustReportCtrl.js":[function(require,module,exports){
"use strict";

module.exports = SingleCustReportCtrl;

SingleCustReportCtrl.$inject = [
  "report",
  "customer",
  "$uibModal",
  "$sessionStorage",
  "$scope",
  "$state",
  "$stateParams",
  "$timeout",
  "Notifications",
  "urlApi",
  "InspectionAPI"
];
function SingleCustReportCtrl(
  report,
  customer,
  $uibModal,
  $sessionStorage,
  $scope,
  $state,
  $stateParams,
  $timeout,
  Notifications,
  urlApi,
  InspectionAPI
) {
  var sr = this;
  var url = $sessionStorage.user.$id + "/" + customer.fb.$id;
  var reportRef = new Firebase(
    urlApi +
      $stateParams.collection +
      url +
      "/Custom" +
      "/" +
      $stateParams.reportId
  );

  sr.report = report.values;
  console.log("report", report);
  sr.reportImages = report.images;
  st.typeStr = typeStr;
  report = report.values; //watch bind
  sr.modelOptions = { allowInvalid: true, debounce: 1000 };
  sr.disableInput = $sessionStorage.user.isClient;
  sr.openCustomQuestionPopup = openCustomQuestionPopup;
  sr.saveCustomQuestion = saveCustomQuestion;
  sr.addReportNote = addReportNote;

  if ($stateParams.collection === "Incomplete/") {
    sr.incompleteRef = reportRef;
  }

  putModifiedDate();

  /**
   * Changes modified data (modified by and modified at) report when the report is being opened
   */
  function putModifiedDate() {
    var data = sr.report;
    data.lastWorkedBy = "Admin";
    data.modifiedBy = null;
    data.modifiedAt = moment().format("YYYY-MM-DD");
    if (!data.modifiedList) data.modifiedList = [];

    data.modifiedList.push({
      lastWorkedBy: "Admin",
      modifiedAt: moment().format("MM/DD/YYYY hh:mm:ss a")
    });
  }

  function typeStr(inspection) {
    var typeString = InspectionAPI.typeStr(inspection);

    return typeString;
  }

  sr.report.$bindTo($scope, "sr.report").then(function(unbind) {
    $scope.$on("$destroy", function() {
      sr.watchReport();
      unbind();
    });
  });

  sr.yaEntro = false;
  sr.watchReport = report.$watch(function() {
    if (sr.incompleteRef) {
      sr.incompleteRef.once("value").then(function(obj) {
        if (obj.val() == null) {
          if (!sr.yaEntro) {
            sr.yaEntro = true;
            // $timeout(function () {

            /*  isDeleted().then(function (val) {
                if (val) {
                  Notifications.addCustom(200, "This report has been deleted.");
                  window.history.back();
                } else {
                  Notifications.addCustom(200, "This report has been completed.");
                  $state.go("index.customer-one.reports.report", {
                    type: $stateParams.type,
                    report: $stateParams.report
                  });
                }
              }).catch(function () {
                Notifications.addCustom(200, "This report has been deleted.");
                window.history.back();
              }); */

            // }, 100);
          }
        }
      });
    }
  });

  /*
  function isDeleted() {
    var reportRef = new Firebase(sr.reportURLforRef);
    return reportRef.once("value").then(function (obj) {
      if (obj.val() == null) {
        return true;
      } else {
        return false;
      }
    });
  } */

  /**
   * Opens modal that allows to add new questions to report (Only for original reports)
   * @param  {Number} index
   */
  function openCustomQuestionPopup(index) {
    sr.customQuestion = { createdAt: moment().format("YYYY-MM-DD") };
    $scope.reportType = InspectionAPI.typeStr(sr.report.fb);
    sr.modalInstance = $uibModal.open({
      templateUrl: "customers/views/modals/customQuestionModal.html",
      scope: $scope
    });

    sr.modalInstance.result.then(function(data) {
      console.log("sr.report", sr.report);
    });
  }

  /**
   * Saves new custom questions in report
   * @param  {Object} customQuestion Custom question data
   */
  function saveCustomQuestion(customQuestion) {
    if (!sr.report.customQuestions) sr.report.customQuestions = [];

    sr.report.customQuestions.push(customQuestion);
    if (customQuestion.template == "true")
      InspectionAPI.postTemplateQuestions(sr.report);

    sr.modalInstance.close(true);
  }

  /**
   * Adds notes to report
   * @param  {Array} array Array notes
   */
  function addReportNote(array) {
    var newNote = $uibModal.open({
      templateUrl: "customers/views/modals/noteModal.html",
      controller: "NoteModalCtrl",
      controllerAs: "mc",
      size: "sm"
    });
    newNote.result.then(function(resp) {
      if (!array.notes) {
        array.notes = [];
      }
      array.notes.push(resp);
    });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/singleReportCtrl.js":[function(require,module,exports){
"use strict";

module.exports = singleReportCtrl;
var deviceHelper = require("../helpers/deviceHelper");
var alarmPanelHelper = require("../helpers/alarmPanelHelper");
var extinguisherHelper = require("../helpers/extinguisherHelper");
var hydrantHelper = require("../helpers/hydrantHelper");
var hoodCylinderHelper = require("../helpers/hoodCylinderHelper");
var specialHazardCylinderHelper = require("../helpers/specialHazardCylinderHelper");
var riserHelper = require("../helpers/riserHelper");
var standpipeHelper = require("../helpers/standpipeHelper");
var suppressionPanelHelper = require("../helpers/suppressionPanelHelper");
var suppressionCylinderHelper = require("../helpers/suppressionCylinderHelper");

function generateFloors() {
  //TODO: move this a single helper service/factory
  var floors = ["N/A", "Other"];
  for (var i = 1; i < 101; i += 1) {
    var floorSuffix = "";
    switch (i % 10) {
      case 1:
        floorSuffix = "st";
        break;
      case 2:
        floorSuffix = "nd";
        break;
      case 3:
        floorSuffix = "rd";
        break;
      default:
        floorSuffix = "th";
    }
    if (Math.floor(i / 10) == 1) floorSuffix = "th";
    floors.push(i + floorSuffix + " Floor");
  }
  return floors;
}

singleReportCtrl.$inject = [
  "report",
  "$uibModal",
  "$sessionStorage",
  "$scope",
  "$state",
  "$stateParams",
  "$timeout",
  "urlApi",
  "customer",
  "$firebaseArray",
  "$firebaseObject",
  "DeviceAPI",
  "$q",
  "Notifications",
  "cfpLoadingBar",
  "InspectionAPI",
  "ReportAPI"
];
function singleReportCtrl(
  report,
  $uibModal,
  $sessionStorage,
  $scope,
  $state,
  $stateParams,
  $timeout,
  urlApi,
  customer,
  $firebaseArray,
  $firebaseObject,
  DeviceAPI,
  $q,
  Notifications,
  cfpLoadingBar,
  InspectionAPI,
  ReportAPI
) {
  var sr = this;
  console.log("single");
  sr.devices = report.devices || [];
  var url = $sessionStorage.user.$id + "/" + customer.fb.$id;

  $scope.$on('$locationChangeStart', function (event, next, current) {
    if (current.includes($stateParams.report)) {
      saveDevicesTested();
    }
  });

  sr.reportURLforRef =
    urlApi +
    "Reports/" +
    url +
    "/" +
    $stateParams.type +
    "/" +
    $stateParams.report;

  var devRef = new Firebase(urlApi + "Devices/" + url);
  var reportRef = new Firebase(
    urlApi +
      $stateParams.collection +
      url +
      "/" +
      $stateParams.type +
      "/" +
      $stateParams.report
  );

  sr.devicesCurrentMax = 100;

  if ($stateParams.collection === "Incomplete/") {
    sr.incompleteRef = reportRef;
  }
  report = report.values;
  sr.report = report;
  console.log(sr.report);

  if (sr.report.fb.templateId) {
    reorderQuestionsBySection();
  }

  sr.defaultQuestions = defaultQuestions;
  function defaultQuestions() {
    var ok = false;
    if (sr.report.fb.sections) {
      for (var i = 0; i < sr.report.fb.sections.length && !ok; i++) {
        if (sr.report.fb.sections[i] === "default") {
          ok = true;
        }
      }
    }
    return ok;
  }
  sr.floors = generateFloors();
  sr.openDevice = openDevice;
  sr.addReportNote = addReportNote;
  sr.addPartExtinguisher = addPartExtinguisher;
  sr.removePartExtinguisher = removePartExtinguisher;
  sr.openStandpipeValve = openStandpipeValve;
  sr.disableInput = $sessionStorage.user.isClient;
  sr.modelOptions = { allowInvalid: true, debounce: 20, updateOn: "blur" };
  sr.supervisorAcc = true;
  sr.alarmAcc = true;
  sr.openSupervisorAcc = openSupervisorAcc;
  sr.openAlarmAcc = openAlarmAcc;
  sr.getDevices = getDevices;
  sr.remove = remove;
  sr.validateDevices = validateDevices;
  sr.refreshDevices = refreshDevices;
  sr.verifySerial = verifySerial;
  sr.addWorkOrderPartJob = addWorkOrderPartJob;
  sr.openBulkPopup = openBulkPopup;
  sr.openCustomQuestionPopup = openCustomQuestionPopup;
  sr.spliceCustomQuestion = spliceCustomQuestion;
  sr.openFlowPopup = openFlowPopup;
  sr.getMoreData = getMoreData;
  sr.modifyStatus = modifyStatus;
  sr.modifyExStatus = modifyExStatus;
  sr.changeChoice = changeChoice;
  sr.isChecked = isChecked;
  sr.isDeviceComplete = isDeviceComplete;
  sr.addNewListRow = addNewListRow;
  sr.removeRow = removeRow;
  sr.isAlarmPanelComplete = isAlarmPanelComplete;
  sr.isExtinguisherComplete = isExtinguisherComplete;
  sr.isHydrantComplete = isHydrantComplete;
  sr.isHoodCylinderComplete = isHoodCylinderComplete;
  sr.isSpecialHazardCylinderComplete = isSpecialHazardCylinderComplete;
  sr.isRiserComplete = isRiserComplete;
  sr.isStandpipeComplete = isStandpipeComplete;
  sr.isCabinetComplete = isCabinetComplete;
  sr.isStationComplete = isStationComplete;
  sr.isSuppressionPanelComplete = isSuppressionPanelComplete;
  sr.isSuppressionCylinderComplete = isSuppressionCylinderComplete;
  
  getExtinguisherTypes();

  /**
   * Modifies report device status (date)
   * @param  {Number} index
   */
  function modifyStatus(index) {
    sr.report.fb.devices[index].modifiedStatus = moment().format(
      "MM/DD/YYYY hh:mm:ss a"
    );
  }
  function modifyExStatus(index) {
    sr.report.fb.extinguishers[index].modifiedStatus = moment().format(
      "MM/DD/YYYY hh:mm:ss a"
    );
  }

  function getMoreData() {
    sr.devicesCurrentMax += 100;
    console.log("more data: " + sr.devicesCurrentMax);
  }

  /**
   * Adds old Hydrant to array
   */
  function AddOldHydrant() {
    if (
      sr.report.fb.hydLocation ||
      sr.report.fb.hydMake ||
      sr.report.fb.hydModel ||
      sr.report.fb.hydNumber ||
      sr.report.fb.hydType ||
      sr.report.fb.staticPsi ||
      sr.report.fb.flowPsi ||
      sr.report.fb.residualPsi
    ) {
      if (!sr.report.fb.hydrants) {
        sr.report.fb.hydrants = [];
      }

      sr.report.fb.hydrants.push({
        hydLocation: sr.report.fb.hydLocation,
        hydMake: sr.report.fb.hydMake,
        hydModel: sr.report.fb.hydModel,
        hydNumber: sr.report.fb.hydNumber,
        hydType: sr.report.fb.hydType,
        staticPsi: sr.report.fb.staticPsi,
        flowPsi: sr.report.fb.flowPsi,
        residualPsi: sr.report.fb.residualPsi,
        createdAt: sr.report.fb.createdAt
      });

      sr.report.fb.hydLocation = null;
      sr.report.fb.hydMake = null;
      sr.report.fb.hydModel = null;
      sr.report.fb.hydNumber = null;
      sr.report.fb.hydType = null;
      sr.report.fb.staticPsi = null;
      sr.report.fb.flowPsi = null;
      sr.report.fb.residualPsi = null;
      sr.report.fb.createdAt = null;
    }
  }

  AddOldHydrant();
  putModifiedDate();

  /**
   * Changes report modified data (last worked by (employee) and modified at (date))
   */
  function putModifiedDate() {
    var data = sr.report.fb;
    data.lastWorkedBy = "Admin";
    data.modifiedBy = null;
    data.modifiedAt = moment().format("YYYY-MM-DD");
    if (!data.modifiedList) data.modifiedList = [];

    data.modifiedList.push({
      lastWorkedBy: "Admin",
      modifiedAt: moment().format("MM/DD/YYYY hh:mm:ss a")
    });
  }

  /**
   * Closes devices group modal
   */
  function closeGroupModal() {
    $scope.devicesGroup.close("cancel");
  }

  /**
   * Saves selected group device
   * @param  {} selected
   */
  function saveGroupModal(selected) {
    $scope.devicesGroup.close(selected);
  }

  /**
   * Closes Flow modal
   */
  function closeFlowModal() {
    $scope.flowPopup.close("cancel");
  }

  /**
   * Saves selected flow device
   * @param  {} selected
   */
  function saveFlowModal(selected) {
    $scope.flowPopup.close(selected);
  }

  /**
   * Opens devices group list modal
   * @param  {Boolean} isExtin Extinguisher type
   */
  function openBulkPopup(isExtin) {
    $scope.deviceGroups = [];

    cfpLoadingBar.start();

    $scope.closeGroupModal = closeGroupModal;
    $scope.saveGroupModal = saveGroupModal;

    var report = sr.report.fb;

    $scope.hashResponse = {};

    DeviceAPI.getDevicesGroups(report.clientId, report.idCustomer, report.type)
      .then(function(resp) {
        cfpLoadingBar.complete();
        if (resp) {
          $scope.hashResponse = resp;
          var groups = Object.keys(resp);
          $scope.deviceGroups = groups;
        }

        if ($scope.deviceGroups && $scope.deviceGroups.length) {
          $scope.devicesGroup = $uibModal.open({
            templateUrl: "customers/views/modals/devicesGroups.html",
            scope: $scope
          });
          $scope.devicesGroup.result.then(function(resp) {
            if (resp != "cancel") {
              $scope.groupChosen = resp;
              if ($scope.groupChosen) {
                var list = $scope.hashResponse[$scope.groupChosen];
                if (!list) return;
                for (var i = 0; i < list.length; i++) {
                  if (isExtin) {
                    if (!sr.report.fb.extinguishers)
                      sr.report.fb.extinguishers = [];

                    sr.report.fb.extinguishers.push(list[i]);
                  } else {
                    if (!sr.report.fb.devices) sr.report.fb.devices = [];

                    const newDevice = { id: list[i].$id };

                    const index = _.findIndex(sr.report.fb.devices, function (device) {
                      return newDevice.id === (device.id || device.$id);
                    });

                    if (index === -1) {
                      sr.report.fb.devices.push(newDevice);
                    }

                    $timeout(function() {
                      window.location.reload();
                    }, 100);
                  }
                }
              }
            }
          });
        } else {
          cfpLoadingBar.complete();
          $timeout(function() {
            alert(
              "There is no device group list associated with this customer"
            );
          }, 200);
        }
      })
      .catch(function(exp) {
        cfpLoadingBar.complete();
        $ionicPopup.alert({
          title: "Something went wrong",
          template: "Please try again."
        });
      });
  }

  sr.cancel = cancel;
  sr.saveCustomQuestion = saveCustomQuestion;

  sr.woTypes = [
    "Alarm",
    "Back Flow",
    "Emergency Exit",
    "Extinguisher",
    "Fire Hydrant",
    "Fire Pump",
    "Grease Cleaning",
    "Hood System",
    "Monitoring",
    "Sensitivity",
    "Special Hazard",
    "Sprinkler",
    "Standpipe Hose",
    "Suppression",
    "Other"
  ];

  /**
   * Closes modal
   * @param  {} form
   */
  function cancel(form) {
    sr.modalInstance.close(false);
  }

  /**
   * Save report custom questions
   * @param  {} customQuestion
   */
  function saveCustomQuestion(customQuestion) {
    if (!sr.report.fb.customQuestions) sr.report.fb.customQuestions = [];

    sr.report.fb.customQuestions.push(customQuestion);

    if (customQuestion.template == "true")
      InspectionAPI.postTemplateQuestions(sr.report.fb);

    sr.modalInstance.close(true);
  }

  /**
   * Opens custom question report modal
   * @param  {Number} index
   */
  function openCustomQuestionPopup(index) {
    var canClick = true;

    sr.customQuestion = { createdAt: moment().format("YYYY-MM-DD") };

    $scope.type = sr.report.fb.type;
    $scope.reportType = InspectionAPI.typeStr(sr.report.fb);
    sr.modalInstance = $uibModal.open({
      templateUrl: "customers/views/modals/customQuestionModal.html",
      scope: $scope
    });

    sr.modalInstance.result.then(function(data) {
      console.log("sr.report", sr.report);
    });
  }

  /**
   * removes a question from the report
   * @param  {Number} index
   */
  function spliceCustomQuestion(index) {
    if (
      sr.report.fb.customQuestions[index].template &&
      sr.report.fb.customQuestions[index].template == "true"
    ) {
      $scope.closeRemovalModal = closeRemovalModal;
      $scope.index = index;
      sr.modalInstance = $uibModal.open({
        templateUrl: "customers/views/modals/templateRemovalModal.html",
        scope: $scope
      });
    } else sr.report.fb.customQuestions.splice(index, 1);
  }

  function closeRemovalModal(shouldRemove, index) {
    if (shouldRemove) {
      var question = sr.report.fb.customQuestions[index];
      InspectionAPI.removeTemplateQuestion(sr.report.fb, question);
    }
    sr.report.fb.customQuestions.splice(index, 1);
    sr.modalInstance.close(true);
  }
  /**
   * Opens flow modal
   */
  function openFlowPopup() {
    var canClick = true;

    $scope.flowTestOptions = sr.report.flowTestOptions;

    $scope.flowPopup = $uibModal.open({
      templateUrl: "customers/views/modals/flowTestModal.html",
      scope: $scope
    });

    $scope.closeFlowModal = closeFlowModal;
    $scope.saveFlowModal = saveFlowModal;

    $scope.flowPopup.result.then(function(resp) {
      if (resp != "cancel") {
        if (resp) {
          sr.report.addNewFlowTest(resp);
        }
      }
    });
  }

  sr.yaEntro = false;

  refreshDevices();

  /**
   * Verifies extinguishers serial number
   * @param  {Object} info
   */
  function verifySerial(info) {
    if (
      _.countBy(sr.report.fb.extinguishers, { serialNumber: info.serialNumber })
        .true >= 2
    ) {
      info.serialNumber = "";
      Notifications.addCustom(
        500,
        "This serial number has already been entered."
      );
    }
  }

  /**
   * Add work order job to a report
   * @param  {String} isLaborValue
   */
  function addWorkOrderPartJob(isLaborValue) {
    if (sr.report.fb.works)
      sr.report.fb.works.push({
        createdAt: moment().format("YYYY-MM-DD"),
        isLabor: isLaborValue
      });
    else
      sr.report.fb.works = [
        { createdAt: moment().format("YYYY-MM-DD"), isLabor: isLaborValue }
      ];
  }

  /**
   * Returns devices list refreshed
   * @returns {Array} Devices list
   */
  function refreshDevices() {
    sr.objDevices = _.map(sr.report.fb.devices, function(dev) {
      return getDevices(dev.id);
    });
  }

  /**
   * Returns devices whose id is the same of devId
   * @param  {String} devId Device id
   * @return {Array} Devices list
   */
  function getDevices(devId) {
    return _.where(sr.devices, { $id: devId })[0];
  }

  sr.report.fb.$bindTo($scope, "sr.report.fb").then(function(unbind) {
    $scope.$on("$destroy", function() {
      sr.watchReport();
      unbind();
    });
  });

  sr.watchReport = report.fb.$watch(function() {
    //bind device added from mobile
    $timeout(function() {
      //check if report devices id and current list of devices are of the same length
      if (
        sr.report.fb.devices &&
        sr.report.fb.devices.length > sr.objDevices.length
      ) {
        var diff = sr.report.fb.devices.length - sr.objDevices.length;
        if (diff > 1) {
          //if there is a more than 1 device difference we reload the state to get synced data
          sr.devices = [];
          sr.objDevices = [];
        } else {
          //if it's just one, we get the device data and update it
          var lastId = _.last(sr.report.fb.devices).id;
          DeviceAPI.getDeviceFbObj(devRef.child(lastId)).then(function(dev) {
            sr.devices.push(dev);
            refreshDevices();
          });
        }
      }
      //this is the case for when devices where removed
      if (!sr.report.fb.devices && sr.objDevices.length > 0) {
        sr.devices = [];
        sr.objDevices = [];
      } else if (
        sr.report.fb.devices &&
        sr.report.fb.devices.length < sr.objDevices.length
      ) {
        var different = _.filter(sr.devices, function(device) {
          return !_.find(sr.report.fb.devices, function(dev) {
            return dev.id === device.$id;
          });
        })[0];
        _.remove(sr.devices, { $id: different.$id });
        _.remove(sr.objDevices, { $id: different.$id });
      }
    }, 500);

    if (sr.incompleteRef) {
      //we check if the incomplete report reference is still with values
      //if it doesn't have values, it's because report was submitted on mobile
      //So we redirect the report to the completed screen
      sr.incompleteRef.once("value").then(function(obj) {
        if (obj.val() == null) {
          if (!sr.yaEntro) {
            sr.yaEntro = true;
            $timeout(function() {
              isDeleted()
                .then(function(val) {
                  if (val) {
                    Notifications.addCustom(
                      200,
                      "This report has been deleted."
                    );
                    window.history.back();
                  } else {
                    Notifications.addCustom(
                      200,
                      "This report has been completed."
                    );
                    $state.go("index.customer-one.reports.report", {
                      type: $stateParams.type,
                      report: $stateParams.report
                    });
                  }
                })
                .catch(function() {
                  Notifications.addCustom(200, "This report has been deleted.");
                  window.history.back();
                });
            }, 100);
          }
        }
      });
    }
  });

  /**
   * Helper function to check if the report was deleted
   */
  function isDeleted() {
    var reportRef = new Firebase(sr.reportURLforRef);
    return reportRef.once("value").then(function(obj) {
      if (obj.val() == null) {
        return true;
      } else {
        return false;
      }
    });
  }

  /**
   * Adds report notes
   * @param  {Array} array Report data
   */
  function addReportNote(array) {
    var newNote = $uibModal.open({
      templateUrl: "customers/views/modals/noteModal.html",
      controller: "NoteModalCtrl",
      controllerAs: "mc",
      size: "sm"
    });
    newNote.result.then(function(resp) {
      if (!array.fb.notes) {
        array.fb.notes = [];
      }
      array.fb.notes.push(resp);
    });
  }

  /**
   * Adds extinguisher parts to a report
   * @param  {Number} index
   */
  function addPartExtinguisher(index) {
    var newPart = $uibModal.open({
      templateUrl: "customers/views/partExtModal.html",
      controller: "PartExtModalCtrl",
      controllerAs: "vm",
      resolve: {
        extinguishers: function() {
          var keys = _.keys(sr.report.fb.extinguishers);
          return _.map(keys, function(v, key) {
            return parseInt(key);
          });
        },
        part: function() {
          if (index) return sr.report.fb.parts[index];
          else return null;
        },
        type: { type: sr.report.fb.partsType }
      }
    });
    newPart.result.then(function(resp) {
      if (index === undefined) {
        sr.report.addNewPart(resp);
      } else {
        sr.report.fb.parts[index] = resp;
      }
    });
  }

  /**
   * Removes extinguisher part
   * @param  {Number} index
   */
  function removePartExtinguisher(index) {
    if (confirm("Are you sure you want to remove this part?")) {
      sr.report.fb.parts.splice(index, 1);
    }
  }

  /**
   * Adds a new device
   * @param  {String} monitoringType
   */
  function openDevice(monitoringType) {
    var devValues = {
      createdAt: moment().format(),
      group: false,
      floor: "N/A",
      reportType: sr.report.fb.type
    };
    if (monitoringType) {
      devValues.type = monitoringType;
    }
    var devArray = $firebaseArray(devRef);
    var newDevice = function(values) {
      return addDevice(devArray, devValues)
        .then(function(resp) {
          return DeviceAPI.getDeviceFbObj(devRef.child(resp.key()))
            .then(function(dev) {
              sr.devices.push(dev);
              var devStat = { id: dev.$id };
              if (values.status) {
                devStat.status = values.status;
                devStat.modifiedStatus = moment().format(
                  "MM/DD/YYYY hh:mm:ss a"
                );
              }
              if (values.statusNote) {
                devStat.statusNote = values.statusNote;
              }
              return devStat;
            })
            .catch(function(exp) {
              Raven.captureException(exp);
              Notifications.addCustom(
                500,
                "Error adding device, please try again."
              );
            });
        })
        .catch(function(exp) {
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error adding the device, please try again."
          );
        });
    };

    //no need to handle this as we are handling it when its being called (this should be in API file)
    return newDevice(devValues).then(function(result) {
      reportRef
        .child("devices")
        .child(sr.objDevices.length)
        .set(result);
      var createdDev = getDevices(result.id);
      sr.objDevices.push(createdDev);
      if (sr.report.fb.type === "Monitoring") {
        return;
      }
      var modal = $uibModal.open({
        controller: "DeviceModalCtrl",
        controllerAs: "vm",
        templateUrl: "customers/views/reports/deviceModal.html",
        backdrop: "static",
        resolve: {
          report: function() {
            return $firebaseObject(reportRef).$loaded();
          },
          devicesIn: function() {
            return sr.devices;
          }
        }
      });

      modal.result.then(function(option) {
        if (!option) {
          sr.objDevices = _.reject(sr.objDevices, createdDev);
          sr.report.fb.devices = _.reject(sr.report.fb.devices, {
            id: createdDev.$id
          });
          _.remove(sr.devices, { $id: createdDev.$id });
        }
      });
    });
  }

  /**
   * Removes panel, device, extinguisher, cylinder or hydrant
   * @param  {Object} thing Device data
   * @param  {String} type Device type
   */
  function remove(thing, type) {
    if (!confirm("Are you sure you want to delete this " + type + "?")) {
      return;
    }
    switch (type) {
      case "Panel":
        var index = _.lastIndexOf(sr.report.fb.controlPanels, thing);
        if (index >= 0) sr.report.fb.controlPanels.splice(index, 1);
        break;
      case "Device":
        var index = _.lastIndexOf(sr.objDevices, thing);
        if (index >= 0) {
          sr.objDevices.splice(index, 1);
          sr.report.fb.devices = _.reject(sr.report.fb.devices, {
            id: thing.$id
          });
          _.remove(sr.devices, { $id: thing.$id });
        }
        break;
      case "Extinguisher":
        var index = _.lastIndexOf(sr.report.fb.extinguishers, thing);
        if (index >= 0) {
          sr.report.fb.extinguishers.splice(index, 1);
          sr.report.fb.parts = _.reject(sr.report.fb.parts, { ex: index });
        }
        break;
      case "Cylinder":
        var index = _.lastIndexOf(sr.report.fb.cylinders, thing);
        if (index >= 0) sr.report.fb.cylinders.splice(index, 1);
        break;
      case "Hydrant":
        var index = _.lastIndexOf(sr.report.fb.hydrants, thing);
        if (index >= 0) sr.report.fb.hydrants.splice(index, 1);
        break;
    }
    if (type === "Device" || type === "Extinguisher") {
      removeDeviceTested(type, thing);
    }
  }

  /**
   * Returns devices that have the same type as ptype
   * @param  {String} ptype Device type
   * @return {Array} Devices list
   */
  function validateDevices(ptype) {
    var resul = false;
    _.forEach(sr.devices, function(device) {
      if (device.type === ptype) {
        resul = true;
      }
    });
    return resul;
  }

  /**
   * Adds a device
   * @param  {} devArray
   * @param  {} resp
   */
  function addDevice(devArray, resp) {
    var deferred = $q.defer();
    var promise = deferred.promise;
    $q.resolve(
      devArray.$add(resp).then(
        function(devResp) {
          deferred.resolve(devResp);
        },
        function(err) {
          deferred.reject(err);
        }
      )
    );
    return promise;
  }

  /**
   * Helper function to open standpipe valve screen
   * @param  {} colection
   * @param  {} colType
   * @param  {} parentIndex
   * @param  {} valveIndex
   */
  function openStandpipeValve(colection, colType, parentIndex, valveIndex) {
    var mapColNames = {
      standpipesreducingValves: "Standpipe pressure reducing valve",
      standpipesrestrictValves: "Standpipe restricting valve",
      hoseStationsreducingValves: "Hose system pressure reducing valve",
      hoseStationsrestrictValves: "Hose system restricting valve"
    };
    var done = $uibModal.open({
      controller: "StandpipeValveCtrl",
      controllerAs: "vm",
      templateUrl: "customers/views/reports/standpipeValve.html",
      resolve: {
        valve: function() {
          if (!_.isUndefined(valveIndex)) {
            return angular.copy(
              sr.report.fb[colection][parentIndex][colType][valveIndex]
            );
          }
          return {};
        },
        name: function() {
          return mapColNames[colection + colType];
        }
      }
    });
    done.result.then(function(newValve) {
      if (!sr.report.fb[colection][parentIndex][colType]) {
        sr.report.fb[colection][parentIndex][colType] = [];
      }
      var valveRef = reportRef
        .child(colection)
        .child(parentIndex)
        .child(colType)
        .child(
          valveIndex || sr.report.fb[colection][parentIndex][colType].length
        );
      valveRef.set(newValve);
    });
  }

  /**
   * Sets alarmAcc attribute as true
   */
  function openAlarmAcc() {
    sr.alarmAcc = true;
  }

  /**
   * Sets supervisorAcc attribute as true
   */
  function openSupervisorAcc() {
    sr.supervisorAcc = true;
  }

  // ------ Custom reports ----------

  /**
   * Adds or removes custom report questions (type multiple choice or select)
   * @param  {Object} question Question choices
   * @param  {String} value Value
   */
  function changeChoice(question, value) {
    if (!question.value) {
      question.value = [];
      question.value.push(value);
    } else {
      var index = question.value.indexOf(value);
      if (index > -1) {
        question.value.splice(index, 1);
      } else {
        question.value.push(value);
      }
    }
  }

  /**
   * Method to check if a choice is selected
   * @param  {Object} resp Array values
   * @param  {String} value Option value
   * @return {Boolean} True if it is checked or false otherwise
   */
  function isChecked(resp, value) {
    if (resp) {
      var index = resp.indexOf(value);
      if (index > -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  /**
   * ????
   */
  function reorderQuestionsBySection() {
    if (sr.report.fb.sections) {
      var sections = sr.report.fb.sections;
    }
  }

  /**
   * Adds a new row in type list questions (custom reports)
   * @param  {Object} question question data
   */
  function addNewListRow(question) {
    var values = [];
    if (question.list) {
      var exists = -1;
      if (!sr.report.fb.listValues) {
        sr.report.fb.listValues = [];
      } else {
        for (
          var i = 0;
          i < sr.report.fb.listValues.length && exists === -1;
          i++
        ) {
          if (sr.report.fb.listValues[i].idQuestion === question.idQuestion) {
            exists = i;
          }
        }
      }

      for (var i = 0; i < question.list.length; i++) {
        var toCopy = angular.copy(question.list[i]);
        values.push(toCopy);
      }

      var answerRow = [];
      answerRow.push(values);

      if (exists === -1) {
        var obj = {
          idQuestion: question.idQuestion,
          values: answerRow
        };
        sr.report.fb.listValues.push(obj);
      } else {
        sr.report.fb.listValues[exists].values.push(values);
      }
    }
  }

  /**
   * Removes a row in type list questions (custom reports)
   * @param  {Object} item Row data
   * @param  {Number} index Item position
   */
  function removeRow(item, index) {
    item.values.splice(index, 1);
    if (!item.values || item.values.length === 0) {
      var index2 = sr.report.fb.listValues.indexOf(item);
      sr.report.fb.listValues.splice(index2, 1);
    }
  }

  function saveDevicesTested() {
    var devices = report.fb.extinguishers || sr.devices;
    var typeDevice = report.fb.extinguishers ? "Extinguishers" : "Devices";
    ReportAPI.saveDevicesTested(report, devices, typeDevice);
  }

  function removeDeviceTested(type, device) {
    ReportAPI.removeDeviceTested(type, device, report);
  }

  function isDeviceComplete(index) {
    var reportDevice = sr.report.fb.devices[index];
    var device = sr.devices[index];
    var reportType = sr.report.fb.type;
    return deviceHelper.isComplete(device, reportDevice, reportType);
  }

  function isAlarmPanelComplete(panel) {
    return alarmPanelHelper.isComplete(panel);
  }

  function isExtinguisherComplete(extinguisher) {
    return extinguisherHelper.isComplete(extinguisher, sr.report.fb);
  }

  function isHydrantComplete(hydrant) {
    return hydrantHelper.isComplete(hydrant);
  }

  function isHoodCylinderComplete(cylinder) {
    return hoodCylinderHelper.isComplete(cylinder);
  }

  function isSpecialHazardCylinderComplete(cylinder) {
    return specialHazardCylinderHelper.isComplete(cylinder);
  }

  function isRiserComplete(riser) {
    return riserHelper.isComplete(riser, sr.report.fb.frequency);
  }

  function isStandpipeComplete(standpipe) {
    return standpipeHelper.isStandpipeComplete(standpipe, sr.report.fb.frequency);
  }

  function isCabinetComplete(cabinet) {
    return standpipeHelper.isCabinetComplete(cabinet, sr.report.fb.frequency);
  }

  function isStationComplete(station) {
    return standpipeHelper.isStationComplete(station, sr.report.fb.frequency);
  }

  function isSuppressionPanelComplete(panel) {
    return suppressionPanelHelper.isComplete(panel, sr.report.fb.frequency);
  }

  function isSuppressionCylinderComplete(cylinder) {
    return suppressionCylinderHelper.isComplete(cylinder);
  }

  function getExtinguisherTypes() {
    ReportAPI.getDeviceTypes("Extinguisher", $sessionStorage.user.$id)
      .then(function (extinguisherTypes) {
        sr.extinguisherTypes = extinguisherTypes;
      });
  }
}

},{"../helpers/alarmPanelHelper":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/alarmPanelHelper.js","../helpers/deviceHelper":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/deviceHelper.js","../helpers/extinguisherHelper":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/extinguisherHelper.js","../helpers/hoodCylinderHelper":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/hoodCylinderHelper.js","../helpers/hydrantHelper":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/hydrantHelper.js","../helpers/riserHelper":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/riserHelper.js","../helpers/specialHazardCylinderHelper":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/specialHazardCylinderHelper.js","../helpers/standpipeHelper":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/standpipeHelper.js","../helpers/suppressionCylinderHelper":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/suppressionCylinderHelper.js","../helpers/suppressionPanelHelper":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/helpers/suppressionPanelHelper.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/directives/cisOtherOption.js":[function(require,module,exports){
"use strict";

module.exports = cisOtherOption;

cisOtherOption.$inject = ["$compile", "$uibModal", "ReportAPI", "$sessionStorage"];

function cisOtherOption($compile, $uibModal, ReportAPI, $sessionStorage) {
  return {
    restrict: "AE",
    scope: true,
    link: link
  };

  function link($scope, $elem, $attr) {
    var name = $attr.field + "Other";
    var ngChange = "";
    $scope.onChange = onChange;

    if ($attr.ngchangevalue) ngChange = $attr.ngchangevalue;

    $scope.$watch(function() {
      return $scope.$eval($attr.field);
    }, evalRequired);

    var input =
      `<input type='text' class='form-control' ng-model='` +
      name +
      `' ng-show='showOther' ng-model-options='{debounce: 500, updateOn: "blur"}' ng-change='onChange()' ng-required='required' placeholder='Enter other' " +
      ngChange +
      "/>`;
    $elem.after($compile(input)($scope));

    function evalRequired(val) {
      if (val === "Other") {
        $scope.showOther = true;
        $scope.required = true;
      } else {
        $scope.required = false;
        $scope.showOther = false;
      }
    }

    function onChange() {
      if ($attr.field.includes("type")) {
        var saveOptionModal = $uibModal
          .open({
            templateUrl: "customers/directives/otherOptionModal.html",
            controller: [
              '$scope',
              '$uibModalInstance',
              function ($scope, $uibModalInstance) {
                $scope.save = function () {
                  $uibModalInstance.close();
                };
                $scope.cancel = function () {
                  $uibModalInstance.dismiss('cancel');
                };
              }]
          });

        saveOptionModal.result.then(function() {
          var reportType = $scope.$eval("vm.report.type") || $scope.$eval("sr.report.fb.type");
          var deviceType = $scope.$eval($attr.field + "Other");
          ReportAPI.saveNewDeviceType(reportType, $sessionStorage.user.$id, deviceType)
            .then(function () {
              if (reportType === "Extinguisher") {
                $scope.sr.extinguisherTypes.push(deviceType);
              }
            })
            .catch(function (err) {
              Notifications.addCustom(
                500,
                "Error saving device type. Please try again."
              );
            });
        });
      }
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/directives/excelDirective.js":[function(require,module,exports){
"use strict";
module.exports = excelDirective;
function excelDirective() {
  return {
    restrict: "E",
    require: "ngModel",
    scope: {
      loading: "@"
    },
    link: link,
    templateUrl: "customers/directives/excelTemplate.html"
  };
}

function link(scope, element, attrs, ngModelCtrl) {
  if (attrs.linkTemplate) scope.linkTemplate = attrs.linkTemplate;

  if (attrs.type) scope.titleText = attrs.type;

  element.bind("change", function(event) {
    scope.$apply(function() {
      var filename = event.target.files[0].name;
      if (
        filename.split(".").pop() !== "xls" &&
        filename.split(".").pop() !== "xlsx"
      ) {
        alert("Incorrect format, use a xls or xlsx format");
      } else {
        var files = event.target.files,
          file;
        if (!files || files.length === 0) {
          return;
        }
        file = files[0];
        var self = {};
        self.model = ngModelCtrl;
        scope.loading = true;

        if (FileReader.prototype.readAsBinaryString === undefined) {
          FileReader.prototype.readAsBinaryString = function(fileData) {
            var binary = "";
            var pt = this;
            fileReader.onload = function(e) {
              var bytes = new Uint8Array(fileReader.result);
              var length = bytes.byteLength;
              for (var i = 0; i < length; i++) {
                binary += String.fromCharCode(bytes[i]);
              }
              pt.content = binary;
              self.filename = file.name;

              self.oFile = XLSX.read(pt.content, { type: "binary" });
              var sheetName = _.keys(self.oFile.Sheets)[0];
              self.data = self.oFile.Sheets[sheetName];
              scope.loading = false;

              const rowStart = attrs.type === "extinguisher" ? 0 : 1;
              var list = XLSX.utils.sheet_to_row_object_array(self.data, { range: rowStart });
              self.model.$setViewValue(
                filterValid(list, attrs.filter, attrs.type)
              );
            };
            fileReader.readAsArrayBuffer(fileData);
          };

          var fileReader = new FileReader();
        } else {
          var fileReader = new FileReader();

          fileReader.onload = function(event2) {
            // ATTENTION: to have the same result than the Flash object we need to split
            // our result to keep only the Base64 part
            self.filename = file.name;

            self.oFile = XLSX.read(event2.target.result, { type: "binary" });
            var sheetName = _.keys(self.oFile.Sheets)[0];
            self.data = self.oFile.Sheets[sheetName];
            scope.loading = false;
            const rowStart = attrs.type === "extinguisher" ? 0 : 1;
            var list = XLSX.utils.sheet_to_row_object_array(self.data, { range: rowStart });
            self.model.$setViewValue(
              filterValid(list, attrs.filter, attrs.type)
            );
          };
        }

        fileReader.readAsBinaryString(file);
      }
    }, false);
  });
}

/**
 * Validates floor in excel
 * @param  {String} floor
 * @param  {Array} validFloors
 * @return {Boolean} Returns true if is valid, false otherwise
 */
function isFloorValid(floor, validFloors) {
  if (!floor) return true;

  if (validFloors.indexOf(floor) > -1) {
    //In the array!
    return true;
  } else {
    //Not in the array
    return false;
  }
}

/**
 * Generates floor
 */
function generateFloors() {
  var floors = ["N/A", "Other"];
  for (var i = 1; i < 101; i += 1) {
    var floorSuffix = "";
    switch (i % 10) {
      case 1:
        floorSuffix = "st";
        break;
      case 2:
        floorSuffix = "nd";
        break;
      case 3:
        floorSuffix = "rd";
        break;
      default:
        floorSuffix = "th";
    }
    if (Math.floor(i / 10) == 1) floorSuffix = "th";
    floors.push(i + floorSuffix + " Floor");
  }
  return floors;
}

/**
 * verifies if excel data is correct for devices, extinguishers or customers
 * @param  {Array} list Customers, Extinguishers or Devices list
 * @param  {Boolean} filter
 * @param  {String} type Type to filter
 * @return {Boolean}
 */
function filterValid(list, filter, type) {
  if (filter == "false") return list;

  if (type == "customers")
    return _.filter(list, function(cust) {
      var propName = cust["Property Name  "];
      var propSt = cust["Property Street "];
      var propCity = cust["Property City"];
      var propState = cust["Property State"];
      var propZip = cust["Property Zip Code"];

      if (propName && propSt && propCity && propState && propZip) {
        //Filtering out example device
        if (
          propName == "ACME Furniture Co." &&
          propSt == "1010 Main St." &&
          propCity == "Little Town" &&
          propState == "AL" &&
          propZip == "54321"
        ) {
          return false;
        }
        return true;
      }
      return false;
    });

  //var validFlors=generateFloors();
  if (type == "devices")
    return _.filter(list, function(cust) {
      var floor = cust["Floor This Device is Located on (optional)"];
      var location = cust["Device Location, Address or ID Number"];
      var make = cust["Device Make"];
      var model = cust["Device Model"];
      var type = cust["Device Type"];
      var typeOther = cust["Other Device Type (optional)"];

      if ((type || typeOther) && location) {
        //Filtering out example device
        if (
          location == "Lobby" &&
          model == "FSP-851" &&
          floor &&
          floor == "3" &&
          type == "Smoke Detector" &&
          make == "Notifier"
        ) {
          return false;
        }
        return true;
      }
      return false;
    });

  if (type == "extinguisher")
    return _.filter(list, function(cust) {
      var location = cust["Location"];
      var manuf = cust["Manufacturer"];
      var serialNumber = cust["Serial Number"];
      var type = cust["Extinguisher Type"];

      var size = cust["Size"];
      var manufDate = cust["Manufacture Date"];
      var dd6y = cust["Due date for 6y maintenance"];
      var ddht = cust["Due date for hydrotest"];

      if (
        location ||
        manuf ||
        serialNumber ||
        type ||
        size ||
        manufDate ||
        dd6y ||
        ddht
      ) {
        //Filtering out example device
        if (
          location == "Lobby" &&
          manuf == "Kidde" &&
          serialNumber == "123456" &&
          size == '3"' &&
          type == "CO2"
        ) {
          return false;
        }
        return true;
      }
      return false;
    });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/index.js":[function(require,module,exports){
"use strict";

var _name = require("../../../package.json").name;

var mod = angular.module(_name + ".Customers", ["ui.bootstrap"]);
mod.config(require("./routes"));

mod.factory("CustomerAPI", require("./controllers/rest/customerAPI.js"));

mod.directive("cisMonitoring", require("./controllers/cisMonitoring.js"));
mod.directive("cisNote", require("./controllers/cisNote.js"));
mod.directive("cisFrequency", require("./controllers/cisFrequency.js"));

mod.controller(
  "ListCustomerCtrl",
  require("./controllers/listCustomerCtrl.js")
);
mod.controller("SubaccountsCtrl", require("./controllers/subaccountsCtrl.js"));
mod.controller("BuildingsCtrl", require("./controllers/buildingsCtrl.js"));

mod.controller(
  "CustomerIndexCtrl",
  require("./controllers/customerIndexCtrl.js")
);
mod.controller(
  "CustomerHomeCtrl",
  require("./controllers/subviews/customerHomeCtrl.js")
);
mod.controller(
  "BuildingInfoCtrl",
  require("./controllers/subviews/buildingInfoCtrl.js")
);
mod.controller(
  "DevicesInfoCtrl",
  require("./controllers/subviews/devicesInfoCtrl.js")
);
mod.controller(
  "RecurringCtrl",
  require("./controllers/subviews/recurringCtrl.js")
);
mod.controller(
  "ExportDevicesCtrl",
  require("./controllers/subviews/exportDevicesCtrl.js")
);
mod.controller(
  "CustomerReportsCtrl",
  require("./controllers/subviews/reportsCtrl.js")
);
//mod.controller( "CustomReportsCtrl", require( "./controllers/subviews/customReportsCtrl.js" ) );

mod.controller(
  "SingleReportCtrl",
  require("./controllers/subviews/singleReportCtrl.js")
);
mod.controller(
  "SingleCustReportCtrl",
  require("./controllers/subviews/singleCustReportCtrl.js")
);

mod.controller(
  "SelectMasterCtrl",
  require("./controllers/modals/selectMasterCtrl.js")
);
mod.controller(
  "NoteModalCtrl",
  require("./controllers/modals/noteModalCtrl.js")
);
mod.controller(
  "DeviceListModalCtrl",
  require("./controllers/modals/deviceListModalCtrl.js")
);
mod.controller(
  "AddDeviceModalCtrl",
  require("./controllers/modals/AddDeviceModalCtrl.js")
);
mod.controller(
  "AddExtinguisherModalCtrl",
  require("./controllers/modals/AddExtinguisherModalCtrl.js")
);
mod.controller(
  "RecurringModalCtrl",
  require("./controllers/modals/recurringModalCtrl.js")
);
mod.controller(
  "ExportModalCtrl",
  require("./controllers/modals/exportModalCtrl.js")
);
mod.controller(
  "UploadDevicesModalCtrl",
  require("./controllers/modals/uploadDevicesModalCtrl.js")
);
mod.controller(
  "ReportEmailModalCtrl",
  require("./controllers/modals/reportEmailModalCtrl.js")
);
mod.controller(
  "ReportHistoryModalCtrl",
  require("./controllers/modals/reportHistoryModalCtrl.js")
);

mod.controller(
  "CustInfoModalCtrl",
  require("./controllers/custInfoModalCtrl.js")
);
mod.controller("BulkModalCtrl", require("./controllers/bulkModalCtrl.js"));
mod.controller(
  "PartExtModalCtrl",
  require("./controllers/partExtModalCtrl.js")
);
mod.controller(
  "StandpipeValveCtrl",
  require("./controllers/StandpipeValveCtrl.js")
);
mod.controller("DeviceModalCtrl", require("./controllers/DeviceModalCtrl.js"));
mod.controller(
  "DeviceModalCtrl2",
  require("./controllers/DeviceModalCtrl2.js")
);
mod.directive("excelDirective", require("./directives/excelDirective.js"));
mod.directive("cisOtherOption", require("./directives/cisOtherOption.js"));
module.exports = mod;

},{"../../../package.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/package.json","./controllers/DeviceModalCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/DeviceModalCtrl.js","./controllers/DeviceModalCtrl2.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/DeviceModalCtrl2.js","./controllers/StandpipeValveCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/StandpipeValveCtrl.js","./controllers/buildingsCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/buildingsCtrl.js","./controllers/bulkModalCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/bulkModalCtrl.js","./controllers/cisFrequency.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/cisFrequency.js","./controllers/cisMonitoring.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/cisMonitoring.js","./controllers/cisNote.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/cisNote.js","./controllers/custInfoModalCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/custInfoModalCtrl.js","./controllers/customerIndexCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/customerIndexCtrl.js","./controllers/listCustomerCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/listCustomerCtrl.js","./controllers/modals/AddDeviceModalCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/AddDeviceModalCtrl.js","./controllers/modals/AddExtinguisherModalCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/AddExtinguisherModalCtrl.js","./controllers/modals/deviceListModalCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/deviceListModalCtrl.js","./controllers/modals/exportModalCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/exportModalCtrl.js","./controllers/modals/noteModalCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/noteModalCtrl.js","./controllers/modals/recurringModalCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/recurringModalCtrl.js","./controllers/modals/reportEmailModalCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/reportEmailModalCtrl.js","./controllers/modals/reportHistoryModalCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/reportHistoryModalCtrl.js","./controllers/modals/selectMasterCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/selectMasterCtrl.js","./controllers/modals/uploadDevicesModalCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/modals/uploadDevicesModalCtrl.js","./controllers/partExtModalCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/partExtModalCtrl.js","./controllers/rest/customerAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/rest/customerAPI.js","./controllers/subaccountsCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subaccountsCtrl.js","./controllers/subviews/buildingInfoCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/buildingInfoCtrl.js","./controllers/subviews/customerHomeCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/customerHomeCtrl.js","./controllers/subviews/devicesInfoCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/devicesInfoCtrl.js","./controllers/subviews/exportDevicesCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/exportDevicesCtrl.js","./controllers/subviews/recurringCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/recurringCtrl.js","./controllers/subviews/reportsCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/reportsCtrl.js","./controllers/subviews/singleCustReportCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/singleCustReportCtrl.js","./controllers/subviews/singleReportCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/controllers/subviews/singleReportCtrl.js","./directives/cisOtherOption.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/directives/cisOtherOption.js","./directives/excelDirective.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/directives/excelDirective.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/routes.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/models/customer.js":[function(require,module,exports){
"use strict";

module.exports = Customer;

function Customer(fb) {
  this.fb = fb || {
    custInfo: {
      address: {}
    },
    ownerInfo: {
      address: {}
    },
    accountType: "Master",
    accessToPortal: false
  };
}

Customer.loadObj = loadObj;
Customer.fromExcel = fromExcel;
Customer.prototype.addEmail = addEmail;
Customer.prototype.removeEmail = removeEmail;
Customer.prototype.addInspection = addInspection;
Customer.prototype.copyCreatedInfo = copyCreatedInfo;
Customer.prototype.copyNewInfo = copyNewInfo;
Customer.prototype.copyModel = copyModel;
Customer.prototype.getMasterEmails = getMasterEmails;

function addEmail() {
  if (!this.fb.emails) {
    this.fb.emails = [];
  }
  if (this.newEmail) {
    this.fb.emails.push(this.newEmail);
  }
  this.newEmail = null;
  this.fb.$save();
}

function removeEmail(mail) {
  this.fb.emails = _.without(this.fb.emails, mail);
  this.fb.$save();
}

function getMasterEmails(clientId, CustomerAPI) {
  return CustomerAPI.getMasterAccount(clientId, this.fb.$id)
    .then(function (masterAccount) {
      return masterAccount.fb.emails || [];
    });
}

function addInspection(newInsp) {
  var th = this;
  if (!th.fb.recurringInspections) {
    th.fb.recurringInspections = [];
  }
  th.fb.recurringInspections.push(newInsp);
  th.fb.$save();
}

function copyNewInfo(fromForm, toForm, toFormName) {
  this.copyModel(fromForm, toForm, toFormName);
  $("#country-" + toFormName + "-address")
    .val(fromForm.address.country)
    .change();
  setTimeout(function() {
    $("#address-line1-" + toFormName + "-address").val(fromForm.address.line1);
    $("#address-line2-" + toFormName + "-address").val(fromForm.address.line2);
    $("#city-" + toFormName + "-address").val(fromForm.address.city);
    $("#state-" + toFormName + "-address").val(fromForm.address.state);
    $("#zip-" + toFormName + "-address").val(fromForm.address.zip);
  }, 100);
}

function copyCreatedInfo(fromForm, toForm, toFormName) {
  this.copyModel(fromForm, toForm, toFormName);
  this.fb.$save();
}

function copyModel(fromForm, toForm, toFormName) {
  if (!fromForm) {
    this.fb[toFormName + "Info"] = {
      address: {}
    };
  }
  if (toFormName === "owner") {
    toForm.ownerName = fromForm.customerName ? fromForm.customerName : null;
    toForm.phone = fromForm.office ? fromForm.office : null;
  } else if (toFormName === "customer") {
    toForm.customerName = fromForm.ownerName ? fromForm.ownerName : null;
    toForm.office = fromForm.phone ? fromForm.phone : null;
  }
  _.forEach(fromForm.address, function(v, k) {
    toForm.address[k] = v;
  });
  toForm.contactPrefix = fromForm.contactPrefix ? fromForm.contactPrefix : null;
  toForm.contactName = fromForm.contactName ? fromForm.contactName : null;
  toForm.cell = fromForm.cell ? fromForm.cell : null;
  toForm.fax = fromForm.fax ? fromForm.fax : null;
}

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function fromExcel(data) {
  var newCustomer = new Customer();
  newCustomer.fb.custInfo.customerName = data["Property Name  "] || ""; //important
  newCustomer.fb.custInfo.address.line1 = data["Property Street "] || ""; //important
  newCustomer.fb.custInfo.address.city = data["Property City"] || ""; //important
  newCustomer.fb.custInfo.address.state = data["Property State"] || ""; //important
  newCustomer.fb.custInfo.address.zip = data["Property Zip Code"] || ""; //important
  newCustomer.fb.custInfo.stateTax = data["State Tax"] || "";

  newCustomer.fb.custInfo.contactName = data["Contact Name"] || "";
  newCustomer.fb.custInfo.email = data.Email || "";
  newCustomer.fb.custInfo.contactTitle = data.Title || "";
  newCustomer.fb.custInfo.cell = data.Cell || "";
  newCustomer.fb.custInfo.office = data.Office || "";
  newCustomer.fb.custInfo.fax = data.Fax || "";

  // owner/Agent information
  newCustomer.fb.ownerInfo.ownerName =
    data["Owner/Agent Name (billing name)"] || "";
  newCustomer.fb.ownerInfo.address.line1 = data["Billing Street"] || "";
  newCustomer.fb.ownerInfo.address.city = data["Billing City"] || "";
  newCustomer.fb.ownerInfo.address.state = data["Billing State"] || "";
  newCustomer.fb.ownerInfo.address.zip = data["Billing Zip Code"] || "";
  newCustomer.fb.ownerInfo.contactName = data["Owner/Contact Name"] || "";
  newCustomer.fb.ownerInfo.contactTitle = data["Owner/Title"] || "";
  newCustomer.fb.ownerInfo.email = data["Owner/Email"] || "";
  newCustomer.fb.ownerInfo.cell = data["Owner/Cell"] || "";
  newCustomer.fb.ownerInfo.phone = data["Owner/Office"] || "";
  newCustomer.fb.ownerInfo.fax = data["Owner/Fax"] || "";

  return newCustomer;
}

function instance(json) {
  return new Customer(json);
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/models/inspectionsSorter.js":[function(require,module,exports){
"use strict";

module.exports = {
  sortByYearMonthWeek: sortByYearMonthWeek,
  sortByAssignationDate: sortByAssignationDate,
  sortDueInspections: sortDueInspections,
  sortDoneInspections: sortDoneInspections,
  getUnassigned: getUnassigned,
  getAssigned: getAssigned,
  removeCompleted: removeCompleted,
  removeIncompleted: removeIncompleted,
  sortLastMonthInspections: sortLastMonthInspections
};

function getQtyByType(inspections, frequency) {
  var inspectionsGroupByType = _.groupBy(inspections[frequency], "type");
  var groupByCustomer = _.map(_.keys(inspectionsGroupByType), function(key) {
    var groupcust = _.groupBy(inspectionsGroupByType[key], "customerName");
    return _.map(groupcust, function(group, name) {
      return {
        type: key,
        qty: group.length + " left",
        frequency: frequency,
        customerName: name
      };
    });
  });
  return _.flatten(groupByCustomer);
}

function sortDueInspections(inspections) {
  var incompleted = removeCompleted(inspections);
  var unassigned = getUnassigned(incompleted);
  var assigned = getAssigned(incompleted);
  var sortedUnassigned = sortByYearMonthWeek(unassigned);
  var sortedAssigned = sortByAssignationDate(assigned);
  var dueInspections = _.union(sortedUnassigned, sortedAssigned);
  var frequencyInsp = _.groupBy(dueInspections, "frequency");
  var biWeeklyInsp = _.groupBy(frequencyInsp["Bi-weekly"] || [], "parity");
  _.remove(dueInspections, function(inspect) {
    return _.contains(["Weekly", "Bi-weekly"], inspect.frequency);
  });
  var weeklyInsp = getQtyByType(frequencyInsp, "Weekly");
  dueInspections = dueInspections.concat(weeklyInsp);
  var evenInsp = getQtyByType(biWeeklyInsp || [], "Even weeks");
  dueInspections = dueInspections.concat(evenInsp);
  var oddInsp = getQtyByType(biWeeklyInsp || [], "Odd weeks");
  dueInspections = dueInspections.concat(oddInsp);
  return dueInspections;
}

function sortDoneInspections(inspections, month) {
  if (month === undefined) {
    month = moment().month();
  }
  var completed = removeIncompleted(inspections);
  var completed2 = removeOtherMonth(completed, month);
  var sorted = sortByModifiedDate(completed2).reverse();
  return sorted;
}

function getUnassigned(inspections) {
  return _.filter(inspections, assignationComparator);
}

function getAssigned(inspections) {
  return _.reject(inspections, assignationComparator);
}

function assignationComparator(ins) {
  return !ins.assignationDate;
}

function removeCompleted(inspections) {
  return _.reject(inspections, function completedFilter(ins) {
    return ins.completed || (ins.inspectedBefore && !ins.year); //remove dummy inspections as well
  });
}

function removeIncompleted(inspections) {
  return _.reject(inspections, function completedFilter(ins) {
    return !ins.completed;
  });
}

function removeOtherMonth(inspections, month) {
  return _.reject(inspections, function completedFilter(ins) {
    return moment(ins.modifiedAt, "YYYY-MM-DD").month() != month;
  });
}

function sortByYearMonthWeek(inspections) {
  function parseDate(inspection) {
    return moment()
      .year(inspection.year)
      .isoWeek(inspection.week);
  }
  return _.sortBy(inspections, function(inspection) {
    return parseDate(inspection).unix();
  });
}

function sortByAssignationDate(inspections) {
  return _.sortBy(inspections, function(inspection) {
    return moment(inspection.assignationDate, "YYYY-MM-DD").unix();
  });
}

function sortByModifiedDate(inspections) {
  return _.sortBy(inspections, function(inspection) {
    return moment(inspection.modifiedAt, "YYYY-MM-DD").unix();
  });
}

function sortLastMonthInspections(inspections) {
  var completed = removeIncompleted(inspections);
  var month = moment().subtract(1, "M").month();
  var lastMonth = removeOtherMonth(completed, month);
  var sorted = sortByModifiedDate(lastMonth).reverse();
  return sorted;
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/models/reportsSorter.js":[function(require,module,exports){
"use strict";

module.exports = {
  sortByDate: sortByDate
};

function sortByDate(reports, dateName) {
  return _.sortBy(reports, function(report) {
    return 1 - moment(report[dateName], "YYYY-MM-DD").unix();
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;

var mapper = require("../reports/models/reportMapper.js");

routes.$inject = ["$stateProvider"];
function routes($stateProvider) {
  $stateProvider.state("index.customers", {
    templateUrl: "customers/views/listCustomer.html",
    url: "/customers",
    controller: "ListCustomerCtrl",
    controllerAs: "vm",
    resolve: {
      list: listCustomer
    },
    data: {
      title: "Customers",
      icon: "fa-users",
      menu: "Customers",
      role: "client"
    }
  });

  $stateProvider.state("index.customers.subaccounts", {
    templateUrl: "customers/views/subaccounts.html",
    url: "/subaccounts",
    controller: "SubaccountsCtrl",
    controllerAs: "sa",
    params: {
      childs: [],
      customer: null
    },
    data: {
      title: "Customer Sub-accounts"
    }
  });

  $stateProvider.state("index.customers.subaccounts.buildings", {
    templateUrl: "customers/views/buildings.html",
    url: "/buildings",
    controller: "BuildingsCtrl",
    controllerAs: "bc",
    params: {
      buildings: [],
      subaccount: null
    },
    data: {
      title: "Customer Sub-accounts - Buildings"
    }
  });

  $stateProvider.state("index.customer-one", {
    abstract: true,
    templateUrl: "customers/views/customerIndex.html",
    url: "/customers/customer/:id",
    controller: "CustomerIndexCtrl",
    controllerAs: "vm",
    resolve: {
      customer: getCustomer
    },
    data: {
      title: "Customer",
      icon: "fa-file-o",
      menu: "Customer",
      role: "client"
    }
  });

  $stateProvider.state("index.customer-one.home", {
    templateUrl: "customers/views/subviews/home.html",
    url: "/home",
    controller: "CustomerHomeCtrl",
    controllerAs: "home",
    resolve: {
      inspections: getCustomerInspections
    },
    data: {
      title: "Customer - Jobs"
    }
  });

  $stateProvider.state("index.customer-one.info", {
    templateUrl: "customers/views/subviews/customerInfo.html",
    url: "/info",
    data: {
      title: "Customer Information"
    }
  });

  $stateProvider.state("index.customer-one.owner", {
    templateUrl: "customers/views/subviews/ownerInfo.html",
    url: "/owner",
    data: {
      title: "Owner Information"
    }
  });

  $stateProvider.state("index.customer-one.devices", {
    templateUrl: "customers/views/subviews/devicesInfo.html",
    controller: "DevicesInfoCtrl",
    controllerAs: "build",
    url: "/devices",
    data: {
      title: "Upload Devices"
    }
  });

  $stateProvider.state("index.customer-one.export", {
    templateUrl: "customers/views/subviews/exportDevices.html",
    controller: "ExportDevicesCtrl",
    controllerAs: "exp",
    url: "/export",
    resolve: {
      client: getClient,
      reports: getCustomerReports
    },
    params: {
      type: null
    },
    data: {
      title: "Export Devices"
    }
  });

  $stateProvider.state("index.customer-one.building", {
    templateUrl: "customers/views/subviews/buildingInfo.html",
    url: "/building",
    controller: "BuildingInfoCtrl",
    controllerAs: "build",
    data: {
      title: "Building Information"
    }
  });

  $stateProvider.state("index.customer-one.recurring", {
    templateUrl: "customers/views/subviews/recurringInspections.html",
    url: "/recurring",
    controller: "RecurringCtrl",
    controllerAs: "rec",
    resolve: {
      client: getClient
    },
    data: {
      title: "Recurring Inspections"
    }
  });

  $stateProvider.state("index.customer-one.portal", {
    templateUrl: "customers/views/subviews/portal.html",
    url: "/portal",
    data: {
      title: "Access to Portal"
    }
  });

  $stateProvider.state("index.customer-one.job", {
    templateUrl: "customers/views/subviews/jobs.html",
    url: "/job",
    data: {
      title: "Jobs"
    }
  });

  $stateProvider.state("index.customer-one.emails", {
    templateUrl: "customers/views/subviews/emails.html",
    url: "/emails",
    data: {
      title: "Emails"
    }
  });

  $stateProvider.state("index.customer-one.reports", {
    templateUrl: "customers/views/subviews/reportList.html",
    url: "/reportList/:type?subType",
    controller: "CustomerReportsCtrl",
    controllerAs: "rep",
    resolve: {
      reports: getCustomerReports,
      v1reports: getCustomerV1Reports,
      templates: getTemplateReports,
      employees: getEmployees
    },
    data: {
      title: "Reports",
      hidden: true
    }
  });

  $stateProvider.state("index.customer-one.custom-reports", {
    templateUrl: "customers/views/subviews/customReportList.html",
    url: "/cstReportList/:templateId/:type",
    controller: "CustomerReportsCtrl",
    controllerAs: "rep",
    resolve: {
      templates: getTemplateReport,
      reports: getCustomerReports,
      v1reports: getCustomerV1Reports
    },
    params: {
      templateId: null,
      type: null
    },
    data: {
      title: "Custom reports",
      hidden: true
    }
  });

  $stateProvider.state("index.customer-one.reports.report", {
    url: "/:report",
    params: {
      collection: "Reports/"
    },
    views: {
      "@index.customer-one": {
        templateUrl: getReportTemplate,
        controller: "SingleReportCtrl",
        controllerAs: "sr"
      }
    },
    resolve: {
      report: getReport
    },
    data: {
      title: "Reports",
      hidden: true
    }
  });

  $stateProvider.state("index.customer-one.custom-reports.report", {
    url: "/:report",
    params: {
      collection: "Reports/"
    },
    views: {
      "@index.customer-one": {
        templateUrl: "customers/views/reports/customReport.html",
        controller: "SingleReportCtrl",
        controllerAs: "sr"
      }
    },
    resolve: {
      report: getReport
    },
    data: {
      title: "Reports",
      hidden: true
    }
  });

  $stateProvider.state("index.customer-one.incomplete", {
    url: "/incomplete/:type/:report",
    params: {
      collection: "Incomplete/"
    },
    templateUrl: getReportTemplate,
    controller: "SingleReportCtrl",
    controllerAs: "sr",
    resolve: {
      report: getIncomplete
    }
  });

  $stateProvider.state("index.customer-one.custom-incomplete", {
    url: "/incomplete/Custom?type/:report",
    params: {
      collection: "Incomplete/",
      id: null,
      report: null,
      type: null
    },
    templateUrl: "customers/views/reports/customReport.html",
    controller: "SingleReportCtrl",
    controllerAs: "sr",
    resolve: {
      report: getIncomplete
      //template: getTemplate
    },
    data: {
      title: "Custom Reports",
      hidden: true
    }
  });

  /**
   * Return customer list
   * @param  {Controller} CustomerAPI
   * @param  {Object} $stateParams
   * @param  {Provider} cfpLoadingBar
   * @return {Array} Customer list
   */
  listCustomer.$inject = ["CustomerAPI", "$stateParams", "cfpLoadingBar"];
  function listCustomer(CustomerAPI, $stateParams, cfpLoadingBar) {
    cfpLoadingBar.start();
    return CustomerAPI.list($stateParams.page, $stateParams.qty).finally(
      function() {
        cfpLoadingBar.complete();
      }
    );
  }

  /**
   * Return a customer
   * @param  {Controller} CustomerAPI
   * @param  {Object} $stateParams
   * @param  {Provider} cfpLoadingBar
   * @param  {Object} $sessionStorage
   * @return {Object} Customer data
   */
  getCustomer.$inject = [
    "CustomerAPI",
    "$stateParams",
    "cfpLoadingBar",
    "$sessionStorage"
  ];
  function getCustomer(
    CustomerAPI,
    $stateParams,
    cfpLoadingBar,
    $sessionStorage
  ) {
    cfpLoadingBar.start();
    return CustomerAPI.get($sessionStorage.user.$id, $stateParams.id).finally(
      function() {
        cfpLoadingBar.complete();
      }
    );
  }

  /**
   * Returns customer inspection list
   * @param  {Controller} InspectionAPI
   * @param  {Object} $stateParams
   * @param  {Provider} cfpLoadingBar
   * @param  {Object} $sessionStorage
   * @return {Array} Customer inspection list
   */
  getCustomerInspections.$inject = [
    "InspectionAPI",
    "$stateParams",
    "cfpLoadingBar",
    "$sessionStorage"
  ];
  function getCustomerInspections(
    InspectionAPI,
    $stateParams,
    cfpLoadingBar,
    $sessionStorage
  ) {
    cfpLoadingBar.start();
    return InspectionAPI.listByCust(
      $stateParams.id,
      $sessionStorage.user.$id
    ).finally(function() {
      cfpLoadingBar.complete();
    });
  }

  /**
   * Return the client who is logged in the system
   * @param  {Controller} ClientAPI
   * @return {Object} Client data
   */
  getClient.$inject = ["ClientAPI"];
  function getClient(ClientAPI) {
    return ClientAPI.get();
  }

  /**
   * Return customer reports
   * @param  {Object} customer
   * @param  {Object} $stateParams
   * @param  {Controller} ReportAPI
   * @param  {Provider} cfpLoadingBar
   * @param  {Provider} Notifications
   * @param  {Object} $sessionStorage
   * @return {Array} Customer reports list
   */
  getCustomerReports.$inject = [
    "customer",
    "$stateParams",
    "ReportAPI",
    "cfpLoadingBar",
    "Notifications",
    "$sessionStorage"
  ];
  function getCustomerReports(
    customer,
    $stateParams,
    ReportAPI,
    cfpLoadingBar,
    Notifications,
    $sessionStorage
  ) {
    cfpLoadingBar.start();

    if ($stateParams.type !== "Work Order" && $stateParams.type !== "Quote") {
      return ReportAPI.listCustomerReports(customer.fb.$id, $stateParams.type)
        .then(function(data) {
          cfpLoadingBar.complete();
          return data;
        })
        .catch(function(exp) {
          cfpLoadingBar.complete();
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error retrieving reports, please try again."
          );
        });
    }
    return ReportAPI.getWorkOrders(
      $sessionStorage.user.$id,
      customer.fb.$id,
      $stateParams
    )
      .then(function(data) {
        cfpLoadingBar.complete();
        return data;
      })
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error retrieving workorders, please try again."
        );
      });
  }

  /**
   * Return customer v1 reports
   * @param  {Object} customer
   * @param  {Object} $stateParams
   * @param  {Controller} ReportAPI
   * @param  {Provider} cfpLoadingBar
   * @param  {Provider} Notifications
   * @param  {Object} $sessionStorage
   * @return {Array} Customer v1 reports list
   */
  getCustomerV1Reports.$inject = [
    "customer",
    "$stateParams",
    "ReportAPI",
    "cfpLoadingBar",
    "Notifications",
    "$sessionStorage"
  ];
  function getCustomerV1Reports(
    customer,
    $stateParams,
    ReportAPI,
    cfpLoadingBar,
    Notifications,
    $sessionStorage
  ) {
    cfpLoadingBar.start();
    if ($stateParams.type !== "Work Order" && $stateParams.type !== "Quote") {
      return ReportAPI.listCustomerV1Reports(customer.fb.$id, $stateParams.type)
        .then(function(data) {
          cfpLoadingBar.complete();
          return data;
        })
        .catch(function(exp) {
          cfpLoadingBar.complete();
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error retrieving reports, please try again."
          );
        });
    }
    return ReportAPI.getV1WorkOrders(
      $sessionStorage.user.$id,
      customer.fb.$id,
      $stateParams
    )
      .then(function(data) {
        cfpLoadingBar.complete();
        return data;
      })
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error retrieving workorders, please try again."
        );
      });
  }

  /**
   * Returns report type route
   * @param  {Object} $stateParams
   * @return {String} Report route
   */
  function getReportTemplate($stateParams) {
    return "customers/views/reports/" + mapper[$stateParams.type] + ".html";
  }

  /**
   * Returns a report
   * @param  {Object} customer
   * @param  {Object} $stateParams
   * @param  {Controller} ReportAPI
   * @param  {Provider} cfpLoadingBar
   * @param  {Controller} ImageAPI
   * @param  {Controller} DeviceAPI
   * @param  {Object} $sessionStorage
   * @param  {Provider} Notifications
   * @return {Object} Report data
   */
  getReport.$inject = [
    "customer",
    "$stateParams",
    "ReportAPI",
    "cfpLoadingBar",
    "ImageAPI",
    "DeviceAPI",
    "$sessionStorage",
    "Notifications"
  ];
  function getReport(
    customer,
    $stateParams,
    ReportAPI,
    cfpLoadingBar,
    ImageAPI,
    DeviceAPI,
    $sessionStorage,
    Notifications
  ) {
    cfpLoadingBar.start();
    console.log("$stateparams en getreport", $stateParams);

    return ReportAPI.get(
      $sessionStorage.user.$id,
      customer.fb.$id,
      $stateParams.type,
      $stateParams.report
    )
      .then(function(resp) {
        return DeviceAPI.getDevices(
          $sessionStorage.user.$id,
          customer.fb.$id,
          _.pluck(resp.fb.devices, "id")
        ).then(function(result) {
          return ImageAPI.download($stateParams.report)
            .then(function(respImages) {
              resp.images = respImages;
              cfpLoadingBar.complete();
              return { values: resp, devices: result };
            })
            .catch(function(exp) {
              cfpLoadingBar.complete();
              Raven.captureException(exp);
              Notifications.addCustom(
                500,
                "Error retrieving images, please try again."
              );
            });
        });
      })
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error retrieving reports, please try again."
        );
      });
  }

  /**
   * Return a custom report
   * @param  {Object} customer
   * @param  {Object} $stateParams
   * @param  {Controller} ReportAPI
   * @param  {Provider} cfpLoadingBar
   * @param  {Controller} ImageAPI
   * @param  {Object} $sessionStorage
   * @param  {Provider} Notifications
   * @return {Object} Custom report data
   */
  getCustomReport.$inject = [
    "customer",
    "$stateParams",
    "ReportAPI",
    "cfpLoadingBar",
    "ImageAPI",
    "$sessionStorage",
    "Notifications"
  ];
  function getCustomReport(
    customer,
    $stateParams,
    ReportAPI,
    cfpLoadingBar,
    ImageAPI,
    $sessionStorage,
    Notifications
  ) {
    cfpLoadingBar.start();
    console.log("$stateparams en getreport", $stateParams);
    return ReportAPI.get(
      $sessionStorage.user.$id,
      customer.fb.$id,
      $stateParams.type,
      $stateParams.report
    )
      .then(function(resp) {
        return ImageAPI.download($stateParams.report)
          .then(function(respImages) {
            //resp.images = respImages;
            cfpLoadingBar.complete();
            return { values: resp, images: respImages };
          })
          .catch(function(exp) {
            cfpLoadingBar.complete();
            Raven.captureException(exp);
            Notifications.addCustom(
              500,
              "Error retrieving images, please try again."
            );
          });
      })
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error retrieving reports, please try again."
        );
      });
  }

  /**
   * Get customer report incomplete
   * @param  {Object} customer
   * @param  {Object} $stateParams
   * @param  {Controller} ReportAPI
   * @param  {Provider} cfpLoadingBar
   * @param  {Controller} ImageAPI
   * @param  {Controller} DeviceAPI
   * @param  {Object} $sessionStorage
   * @param  {Provider} Notifications
   * @return {Object} Report incomplete data
   */
  getIncomplete.$inject = [
    "customer",
    "$stateParams",
    "ReportAPI",
    "cfpLoadingBar",
    "ImageAPI",
    "DeviceAPI",
    "$sessionStorage",
    "Notifications"
  ];
  function getIncomplete(
    customer,
    $stateParams,
    ReportAPI,
    cfpLoadingBar,
    ImageAPI,
    DeviceAPI,
    $sessionStorage,
    Notifications
  ) {
    cfpLoadingBar.start();
    return ReportAPI.getIncomplete(
      customer.fb.$id,
      $stateParams.report,
      $stateParams.type
    )
      .then(function(resp) {
        console.log(resp);
        return DeviceAPI.getDevices(
          $sessionStorage.user.$id,
          customer.fb.$id,
          _.pluck(resp.fb.devices, "id")
        )
          .then(function(result) {
            return ImageAPI.download($stateParams.report)
              .then(function(respImages) {
                resp.images = respImages;
                cfpLoadingBar.complete();
                return { values: resp, devices: result };
              })
              .catch(function(exp) {
                cfpLoadingBar.complete();
                Raven.captureException(exp);
                Notifications.addCustom(
                  500,
                  "Error retrieving images, please try again."
                );
              });
          })
          .catch(function(exp) {
            cfpLoadingBar.complete();
            Raven.captureException(exp);
            Notifications.addCustom(
              500,
              "Error retrieving devices, please try again."
            );
          });
      })
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error retrieving reports, please try again."
        );
      });
  }

  /**
   * Return a template report
   * @param  {Object} $stateParams
   * @param  {Controller} ReportAPI
   * @param  {Provider} Notifications
   * @return {Object} Template report data
   */
  getTemplateReport.$inject = ["$stateParams", "ReportAPI", "Notifications"];
  function getTemplateReport($stateParams, ReportAPI, Notifications) {
    return ReportAPI.getTemplate($stateParams.templateId)
      .then(function(data) {
        console.log("values", data);
        return { values: data };
      })
      .catch(function(exp) {
        Notifications.addCustom(
          500,
          "Error retrieving report, please try again."
        );
      });
  }

  /**
   * Returns customer template reports (custom reports) list
   * @param  {Object} $stateParams
   * @param  {Controller} ReportAPI
   * @param  {Provider} Notifications
   * @return {Array} Template report list
   */
  getTemplateReports.$inject = ["$stateParams", "ReportAPI", "Notifications"];
  function getTemplateReports($stateParams, ReportAPI, Notifications) {
    return ReportAPI.getTemplates($stateParams.type)
      .then(function(data) {
        console.log("data", data);
        return { values: data };
      })
      .catch(function(exp) {
        Notifications.addCustom(
          500,
          "Error retrieving report, please try again."
        );
      });
  }

  /**
   * Returns employee list
   * @param  {Controller} EmployeeAPI
   * @return {Array} Employee list
   */
  getEmployees.$inject = ["EmployeeAPI"];
  function getEmployees(EmployeeAPI) {
    return EmployeeAPI.list();
  }
}

},{"../reports/models/reportMapper.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/reportMapper.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/employees/controllers/formEmployeeCtrl.js":[function(require,module,exports){
"use strict";

module.exports = FormEmployeeCtrl;

FormEmployeeCtrl.$inject = [
  "employee",
  "EmployeeAPI",
  "$uibModalInstance",
  "EmailAPI",
  "cfpLoadingBar",
  "UserAPI",
  "$scope",
  "$sessionStorage",
  "$state",
  "$uibModal",
  "modalService",
  "Validations",
  "Notifications"
];
function FormEmployeeCtrl(
  employee,
  EmployeeAPI,
  $uibModalInstance,
  EmailAPI,
  cfpLoadingBar,
  UserAPI,
  $scope,
  $sessionStorage,
  $state,
  $uibModal,
  modalService,
  Validations,
  Notifications
) {
  var vm = this;
  vm.generatePassword = require("../../login/models/passwordGen.js");
  vm.employee = employee;
  vm.save = save;
  vm.cancel = cancel;
  vm.newEmployeeEmail = vm.employee.fb.email;

  vm.checkJoblinkPermission = function(value) {
    var loggedUser = $sessionStorage.user;

    if (!Validations.checkPermission(loggedUser, "jobboard")) {
      vm.employee.fb.showInJobBoard = false;

      //text options
      var modalOptions = {
        closeButtonText: "No",
        actionButtonText: "Yes",
        headerText:
          "This feature is not currently included in your subscription.",
        bodyText: "Would you like to add it now?"
      };

      modalService.showModal({}, modalOptions).then(function(result) {
        //Cancel option selected
        if (result === "cancel") {
        } else {
          //Accept option selected
          closePopup();
          $state.go("index.client-one.payment");
        }
      });
    }
  };

  /**
   * Updates or creates a new employee
   * @param  {} form
   * @param  {Object} employee Employee data
   */
  function save(form, employee) {
    form.$submitted = true;
    if (form.$valid) {
      if (employee.fb.$id) {
        //updates already created employee
        update(form, employee);
      } else {
        //when its a new employee, generates credentials, account and sends email
        var newCredentials = generateCredentials(employee.fb);
        UserAPI.createAccount(newCredentials)
          .then(
            function(resp) {
              cfpLoadingBar.start();
              sendEmail(employee.fb, newCredentials)
                .then(function(emailResp) {
                  if (_.isNull(emailResp.data)) {
                    form.$submitted = false;
                    UserAPI.removeUser(resp.uid)
                      .then(closeLB)
                      .catch(function(exp) {
                        cfpLoadingBar.complete();
                        Raven.captureException(exp);
                      });
                  } else {
                    EmployeeAPI.save(employee.fb)
                      .then(function(data) {
                        EmployeeAPI.giveMobileAccess(data.$id, resp.uid)
                          .then(function() {
                            data.uid = resp.uid;
                            data.$save();
                            closePopup();
                          })
                          .catch(function(exp) {
                            cfpLoadingBar.complete();
                            Raven.captureException(exp);
                          });
                      })
                      .catch(function(exp) {
                        cfpLoadingBar.complete();
                        Raven.captureException(exp);
                      });
                  }
                })
                .catch(function(exp) {
                  cfpLoadingBar.complete();
                  Raven.captureException(exp);
                });
            },
            function(err) {
              form.$submitted = false;
              setTimeout(function() {
                alert(err.message);
              }, 100);
            }
          )
          .catch(function(exp) {
            cfpLoadingBar.complete();
            Raven.captureException(exp);
            Notifications.addCustom(
              500,
              "Error creating account, please try again."
            );
          });
      }
    }
  }

  /**
   * Updates employee data
   * @param  {} form
   * @param  {Object} employee Employee data
   */
  function update(form, employee) {
    if (employee.fb.email !== vm.newEmployeeEmail) {
      var body = {
        oldEmail: employee.fb.email,
        newEmail: vm.newEmployeeEmail,
        _id: employee.fb.$id,
        password: vm.generatePassword()
      };
      UserAPI.editUser(body)
        .then(
          function(result) {
            employee.fb.email = vm.newEmployeeEmail;

            if (result.newMongoEmployee) {
              EmailAPI.sendEmail({
                type: "NOTIFICATION",
                addresses: [body.newEmail],
                subject: "Password changed",
                content: {
                  data: body.password,
                  name: employee.fb.name,
                  field: "password"
                }
              });

              EmployeeAPI.save(employee.fb).catch(function(exp) {
                cfpLoadingBar.complete();
                Raven.captureException(exp);
              });
            }

            EmployeeAPI.save(employee.fb)
              .then(function() {
                EmailAPI.sendEmail({
                  type: "NOTIFICATION",
                  addresses: [body.oldEmail],
                  subject: "Email changed",
                  content: {
                    data: body.newEmail,
                    name: employee.fb.name,
                    field: "email"
                  }
                });
                closePopup();
              })
              .catch(function(exp) {
                cfpLoadingBar.complete();
                Raven.captureException(exp);
              });
          },
          function(err) {
            vm.emailTaken = err.message;
          }
        )
        .catch(function(exp) {
          cfpLoadingBar.complete();
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error updating user, please try again."
          );
        });
    } else {
      EmployeeAPI.save(employee.fb)
        .then(closePopup)
        .catch(function(exp) {
          cfpLoadingBar.complete();
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error updating the data, please try again."
          );
        });
    }
  }

  /**
   * Sends an email to the new employee
   * @param  {Object} employee Employee data
   * @param  {Object} credentials Employee credentials
   * @return {Object} Email response
   */
  function sendEmail(employee, credentials) {
    return EmailAPI.sendEmail({
      type: "NEW_EMPLOYEE",
      addresses: [employee.email],
      subject: "Welcome to Aries!",
      content: {
        employee: employee.firstName,
        username: credentials.email,
        password: credentials.password
      }
    })
      .then(function(emailResp) {
        return emailResp;
      })
      .catch(function(exp) {
        Raven.captureException(exp);
        Notifications.addCustom(500, "Error sending email, please try again.");
      });
  }

  /**
   * Closes popup
   */
  function closePopup() {
    cfpLoadingBar.complete();
    $uibModalInstance.close();
  }

  /**
   * Closes loading bar
   */
  function closeLB() {
    cfpLoadingBar.complete();
  }

  /**
   * Closes employee modal
   */
  function cancel() {
    $uibModalInstance.dismiss("cancel");
  }

  /**
   * Generates new credentials to an employee
   * @param  {Object} employee Employee data
   */
  function generateCredentials(employee) {
    var newPassword = vm.generatePassword();
    return {
      email: employee.email,
      password: newPassword
    };
  }
}

},{"../../login/models/passwordGen.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/models/passwordGen.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/employees/controllers/listEmployeeCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListEmployeeCtrl;

var MapLogic = require("../models/map.js");

ListEmployeeCtrl.$inject = [
  "list",
  "EmployeeAPI",
  "$state",
  "$stateParams",
  "$uibModal",
  "employees",
  "$sessionStorage",
  "Validations",
  "UserAPI",
  "Notifications",
  "$timeout",
  "ngIntroService",
  "ClientAPI",
  "$rootScope"
];
function ListEmployeeCtrl(
  list,
  EmployeeAPI,
  $state,
  $stateParams,
  $uibModal,
  employees,
  $sessionStorage,
  Validations,
  UserAPI,
  Notifications,
  $timeout,
  ngIntroService,
  ClientAPI,
  $rootScope
) {
  var vm = this;
  vm.page = parseInt($stateParams.page || 0) + 1;
  vm.qty = parseInt($stateParams.qty || 10);
  vm.list = list;
  vm.remove = remove;
  vm.showEmployeeForm = showEmployeeForm;

  vm.gpspermission = false;
  vm.tourStarted = false;

  var loggedUser = $sessionStorage.user;

  ngIntroService.clear();

  vm.introOptions = {
    steps: [
      {
        intro:
          "In the background is your employee list screen. You will see here all the employees you have added on Aries."
      },
      {
        element: "#tourStep20",
        intro: "Let's add an employee. Click on this button."
      },
      {
        intro:
          "Complete all required fields. This can be a real employee or a made up one. Don't worry, you can delete it later if you wish."
      }
    ],
    showStepNumbers: false,
    showBullets: false,
    exitOnOverlayClick: false,
    keyboardNavigation: false,
    hidePrev: true,
    hideNext: true,
    hideSkip: true,
    exitOnEsc: true,
    overlayOpacity: 0.4,

    nextLabel: "Next",
    prevLabel: "Previous",
    skipLabel: "Skip",
    doneLabel: "Continue"
  };

  vm.introOptions2 = {
    steps: [
      {
        element: "#employeeListScroll",
        intro: "Good Job! Your new employee is now added to the employee list.",
        position: "left"
      },
      {
        element: "#employeeListScroll",
        intro:
          "The employee you added will receive an email with their personal login credentials. The employee can now download our app from the app store by searching for 'firelab.aries' and login using the credentials emailed to them.",
        position: "right"
      },
      {
        element: "#employeeListScroll",
        intro:
          "The employee can now login to the mobile app and search for the customer you entered, select a report type and complete the inspection report. The completed report will be emailed to the admin as well as saved in the cloud.",
        position: "top"
      },
      {
        intro:
          "It is highly recommended that you watch all the help videos located in the menu. They will provide you with detail about how to use the features of Aries.<br/><br/>Please don't hesitate to contact us via live chat, email or phone call should you have any questions.<br/><br/>Thanks and good luck!<br/>-The Aries team."
      }
    ],
    showStepNumbers: false,
    showBullets: false,
    exitOnOverlayClick: false,
    keyboardNavigation: false,
    disableInteraction: true,
    hidePrev: true,
    hideNext: true,
    hideSkip: true,
    exitOnEsc: true,
    overlayOpacity: 0.4,
    nextLabel: "Next",
    prevLabel: "Previous",
    skipLabel: "Skip",
    doneLabel: "Go to Help Videos"
  };

  if (Validations.checkPermission(loggedUser, "gps")) {
    vm.gpspermission = true;
  }

  vm.map = MapLogic.generateMap(employees);
  vm.locations = MapLogic.extractLocations(employees);

  employees.$watch(function() {
    vm.locations = MapLogic.extractLocations(employees);
  });

  vm.gotofeatures = function() {
    $state.go("index.client-one.payment");
  };

  if ($sessionStorage.user.isClient) {
    ClientAPI.checkTourFirstTime().then(function(data) {
      if (data) {
        startTour();
      }
    });
  }

  /**
   * Starts a tour for the application to an employee
   */
  function startTour() {
    $timeout(function() {
      ngIntroService.setOptions(vm.introOptions);
      ngIntroService.onExit(function() {
        vm.tourStarted = false;
      });
      ngIntroService.onBeforeChange(function() {
        $timeout(function() {
          //Same as the other hack for this library, this is necesary to hide/show actions depending on each step.
          var intro = ngIntroService.intro;
          document.querySelectorAll(".introjs-skipbutton")[0].style.display =
            "none";
          document.querySelectorAll(".introjs-nextbutton")[0].style.display =
            "inline-block";

          if (intro._currentStep > 0)
            document.querySelectorAll(".introjs-prevbutton")[0].style.display =
              "inline-block";

          if (intro._currentStep == 1 || intro._currentStep == 2) {
            document.querySelectorAll(".introjs-nextbutton")[0].style.display =
              "none";
            document.querySelectorAll(".introjs-prevbutton")[0].style.display =
              "none";
          }

          if (intro._currentStep == 2) {
            document.querySelectorAll(".introjs-skipbutton")[0].style.display =
              "inline-block";
          }

          ngIntroService.refresh();
        });
      });

      ngIntroService.start();
      vm.tourStarted = true;
    }, 500);
  }

  /**
   * Removes an employee
   * @param  {Object} employee Employee data
   */
  function remove(employee) {
    if (confirm("Are you sure you want to remove this Employee?")) {
      EmployeeAPI.remove(employee)
        .then(function() {
          UserAPI.removeUser(employee.uid).then(function() {
            Notifications.addCustom(200, "Employee deleted successfully.");
          });
        })
        .catch(function(exp) {
          Raven.captureException(exp);
          Notifications.addCustom(400, "There was an error. Please try again.");
        });
    }
  }

  function showEmployeeForm(idEmp) {
    $uibModal
      .open({
        templateUrl: "employees/views/formEmployee.html",
        controller: "FormEmployeeCtrl",
        controllerAs: "vm",
        resolve: {
          employee: function() {
            return EmployeeAPI.get(idEmp);
          }
        }
      })
      .result.then(function(res) {
        newTour();
      })
      .catch(function(res) {
        if (vm.continueTour) {
          vm.continueTour = false;
          $timeout(function() {
            vm.tourStarted = true;
            ngIntroService.goToStepNumber(1).start();
          }, 500);
        }
      });
    if (vm.tourStarted) {
      $timeout(function() {
        ngIntroService.next();
        vm.continueTour = true;
      });
    }
    if (vm.tourStarted) {
      $timeout(function() {
        ngIntroService.next();
      });
    }
  }

  function newTour() {
    if (vm.continueTour) {
      vm.continueTour = false;
      $timeout(function() {
        ngIntroService.setOptions(vm.introOptions2);
        ngIntroService.onExit(function() {
          //        ngIntroService.clear();
          $timeout(function() {
            ClientAPI.changeTourFirstTimeUser();
            ngIntroService.clear();
            $rootScope.startTourOld();
            //$state.go('index.helpvideos');
          });
        });

        ngIntroService.onBeforeChange(function() {
          $timeout(function() {
            var intro = ngIntroService.intro;
            document.querySelectorAll(".introjs-skipbutton")[0].style.display =
              "none";
            if (intro._currentStep == 3) {
              document.querySelectorAll(
                ".introjs-skipbutton"
              )[0].style.display = "inline-block";
            }

            ngIntroService.refresh();
          });
        });

        ngIntroService.start();
      });
    }
  }
}

},{"../models/map.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/employees/models/map.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/employees/controllers/rest/employeeAPI.js":[function(require,module,exports){
"use strict";

module.exports = EmployeeAPI;

var Employee = require("../../models/employee.js");
EmployeeAPI.$inject = [
  "urlApi",
  "$firebaseArray",
  "$firebaseObject",
  "Notifications",
  "$sessionStorage",
  "$q"
];
var MapLogic = require("../../../jobboard/models/map.js");

function EmployeeAPI(
  urlApi,
  $firebaseArray,
  $firebaseObject,
  Notifications,
  $sessionStorage,
  $q
) {
  var root = urlApi + "Employee/";
  var mobileRef = new Firebase(urlApi + "Mobile/");
  EmployeeAPI.get = get;
  EmployeeAPI.list = list;
  EmployeeAPI.listWithGeo = listWithGeo;
  EmployeeAPI.save = save;
  EmployeeAPI.remove = remove;
  EmployeeAPI.giveMobileAccess = giveMobileAccess;
  EmployeeAPI.removeMobileAccess = removeMobileAccess;
  return EmployeeAPI;

  /**
   * Return employee data
   * @param  {String} id Employee id
   * @return {Object} Employee data
   */
  function get(id) {
    if (id) {
      var ref = new Firebase(root + $sessionStorage.user.$id);
      return $firebaseObject(ref.child(id)).$loaded(function(resp) {
        return Employee.loadObj(resp);
      });
    } else {
      return new Employee();
    }
  }

  /**
   * Returns employee list
   * @return {Array} Employee list
   */
  function list() {
    var ref = new Firebase(root + $sessionStorage.user.$id);
    return $firebaseArray(ref).$loaded(function(resp) {
      return resp;
    });
  }

  /**
   * lists the employees with the location data for map
   */
  function listWithGeo() {
    var ref = new Firebase(root + $sessionStorage.user.$id);
    return $firebaseArray(ref).$loaded(MapLogic.prepareLocations);
  }

  /**
   * Remove a employee
   * @param  {Object} obj Employee data
   */
  function remove(obj) {
    var future = $q.defer();
    var ref = new Firebase(urlApi);
    try {
      ref
        .child("Employee")
        .child($sessionStorage.user.$id)
        .child(obj.$id)
        .remove(function(err) {
          if (err) {
            future.reject(err);
          } else {
            ref
              .child("Mobile")
              .child(obj.uid)
              .remove(function(err) {
                if (err) {
                  future.reject(err);
                } else {
                  future.resolve(true);
                }
              });
          }
        });
    } catch (e) {
      future.reject(e);
    }
    return future.promise;
  }

  /**
   * Creates or Edits a employee
   * @param  {Object} obj Employee data
   * @return {Object} Employee edited/created
   */
  function save(obj) {
    if (obj.$id) {
      return edit(obj);
    } else {
      return create(obj);
    }
  }

  function create(obj) {
    var ref = new Firebase(root + $sessionStorage.user.$id);
    return $firebaseArray(ref)
      .$add(obj)
      .then(ok, error);

    function ok(resp) {
      Notifications.addCustom(200, "Employee created successfully");
      return get(resp.key()).then(function(data) {
        return data.fb;
      });
    }

    function error(resp) {
      Notifications.addCustom(500, "There was a problem.");
      return resp;
    }
  }

  function edit(obj) {
    return obj.$save().then(ok, error);
    function ok(resp) {
      Notifications.addCustom(200, "Employee saved successfully");
      return resp;
    }

    function error(resp) {
      Notifications.addCustom(500, "There was a problem.");
      return resp;
    }
  }

  /**
   * Gives an employee mobile access
   * @param  {String} idEmployee Employee id
   * @param  {String} uid Client id
   * @return {Object}
   */
  function giveMobileAccess(idEmployee, uid) {
    var future = $q.defer();
    return mobileRef.child(uid).set(
      {
        clientId: $sessionStorage.user.$id,
        employeeId: idEmployee,
        firstTime: true
      },
      function(err) {
        if (err) {
          future.reject(err);
        } else {
          future.resolve(true);
        }
        return future.promise;
      }
    );
  }

  /**
   * Removes employee access
   * @param  {String} uid Employee id
   */
  function removeMobileAccess(uid) {
    return mobileRef.child(uid).remove();
  }
}

},{"../../../jobboard/models/map.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/jobboard/models/map.js","../../models/employee.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/employees/models/employee.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/employees/index.js":[function(require,module,exports){
"use strict";

var _name = require("../../../package.json").name;

var mod = angular.module(_name + ".Employees", []);
mod.config(require("./routes"));

mod.controller(
  "ListEmployeeCtrl",
  require("./controllers/listEmployeeCtrl.js")
);
mod.controller(
  "FormEmployeeCtrl",
  require("./controllers/formEmployeeCtrl.js")
);

mod.factory("EmployeeAPI", require("./controllers/rest/employeeAPI.js"));

module.exports = mod;

},{"../../../package.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/package.json","./controllers/formEmployeeCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/employees/controllers/formEmployeeCtrl.js","./controllers/listEmployeeCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/employees/controllers/listEmployeeCtrl.js","./controllers/rest/employeeAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/employees/controllers/rest/employeeAPI.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/employees/routes.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/employees/models/employee.js":[function(require,module,exports){
"use strict";

module.exports = Employee;

function Employee(fb) {
  this.fb = fb || {};
}

Employee.loadObj = loadObj;

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new Employee(json);
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/employees/models/map.js":[function(require,module,exports){
"use strict";

function prepareLocations(employees) {
  for (var i = 0; i < employees.length; i += 1) {
    if (employees[i].location) {
      employees[i].location.id = employees[i].$id;
      employees[i].location.options = {
        label: employees[i].name,
        title: employees[i].name,
        last_updated: employees[i].last_updated
      };
    }
  }
  return employees;
}

function generateMap() {
  return {
    center: { latitude: 40.7256134, longitude: -73.9851611 },
    zoom: 13,
    control: {},
    options: style
  };
}

function extractLocations(employees) {
  return _.compact(_.map(prepareLocations(employees), "location"));
}

var style = {
  disableDefaultUI: true,
  styles: [
    {
      stylers: [
        {
          hue: "#e43a45"
        },
        {
          visibility: "simplified"
        },
        {
          gamma: 0.5
        },
        {
          weight: 0.5
        }
      ]
    },
    {
      featureType: "water",
      stylers: [
        {
          color: "#2f353b"
        },
        {
          lightness: 20
        }
      ]
    }
  ]
};

exports.prepareLocations = prepareLocations;
exports.generateMap = generateMap;
exports.extractLocations = extractLocations;

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/employees/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;

routes.$inject = ["$stateProvider"];

function routes($stateProvider) {
  $stateProvider.state("index.employees", {
    templateUrl: "employees/views/listEmployee.html",
    url: "/employees?page&qty",
    controller: "ListEmployeeCtrl",
    controllerAs: "vm",
    resolve: {
      employees: getEmployees,
      list: listEmployee
    },
    data: {
      title: "Employee List",
      icon: "fa-user",
      menu: "Employees",
      role: "client"
    }
  });

  /**
   * Returns a employee list
   * @param  {Controller} EmployeeAPI
   * @param  {Object} $stateParams
   * @return {Array} Employee list
   */
  listEmployee.$inject = ["EmployeeAPI", "$stateParams"];
  function listEmployee(EmployeeAPI, $stateParams) {
    return EmployeeAPI.list($stateParams.page, $stateParams.qty);
  }

  /**
   * Router function to get employees location data for maps
   * @param  {} EmployeeAPI
   */
  getEmployees.$inject = ["EmployeeAPI"];
  function getEmployees(EmployeeAPI) {
    return EmployeeAPI.listWithGeo();
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/helpvideos/controllers/helpVideosCtrl.js":[function(require,module,exports){
"use strict";

module.exports = helpVideosCtrl;

helpVideosCtrl.$inject = ["$uibModal", "ngIntroService"];
function helpVideosCtrl($uibModal, ngIntroService) {
  var hv = this;
  hv.showVideoModal = showVideoModal;

  ngIntroService.clear();

  /**
   * Shows video tutorial modal
   * @param  {String} modalName Modal name
   * @param  {String} videoLink Video url
   * @return {String}
   */
  function showVideoModal(modalName, videoLink) {
    hv.link = videoLink;
    hv.modalName = modalName;
    $uibModal.open({
      templateUrl: "helpvideos/views/videomodal.html",
      controller: "modalVideoCtrl",
      controllerAs: "mv",
      resolve: {
        link: function() {
          return videoLink;
        },
        modalName: function() {
          return modalName;
        }
      }
    });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/helpvideos/controllers/modalVideoCtrl.js":[function(require,module,exports){
"use strict";

module.exports = modalVideoCtrl;

modalVideoCtrl.$inject = ["link", "modalName", "$sce", "$uibModalInstance"];

function modalVideoCtrl(link, modalName, $sce, $uibModalInstance) {
  var mv = this;
  link += "?rel=0&showinfo=0";
  mv.link = $sce.trustAsResourceUrl(link);
  mv.modalName = modalName;
  mv.cancelModal = cancelModal;

  function cancelModal() {
    $uibModalInstance.close();
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/helpvideos/index.js":[function(require,module,exports){
"use strict";

var _name = require("../../../package.json").name;

var mod = angular.module(_name + ".helpvideos", []);
mod.config(require("./routes"));

mod.controller("helpVideosCtrl", require("./controllers/helpVideosCtrl.js"));
mod.controller("modalVideoCtrl", require("./controllers/modalVideoCtrl.js"));

module.exports = mod;

},{"../../../package.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/package.json","./controllers/helpVideosCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/helpvideos/controllers/helpVideosCtrl.js","./controllers/modalVideoCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/helpvideos/controllers/modalVideoCtrl.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/helpvideos/routes.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/helpvideos/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;
routes.$inject = ["$stateProvider"];

function routes($stateProvider) {
  $stateProvider.state("index.helpvideos", {
    url: "/helpvideos",
    templateUrl: "helpvideos/views/helpvideos.html",
    controller: "helpVideosCtrl",
    controllerAs: "hv",
    data: {}
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/assigned.js":[function(require,module,exports){
"use strict";

module.exports = filterAssigned;

/**
 * Filters together all jobs that have assignation date
 * @param  {} due
 * @param  {} next
 */
function filterAssigned(due, next) {
  if ((due, next)) {
    return filter(due).concat(filter(next));
  }
}

/**
 * Filters list if it's not underfined assignation date
 * @param  {Array} list Inspection list
 */
function filter(list) {
  return _.filter(list, function(insp) {
    return !_.isUndefined(insp.assignationDate);
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/done.js":[function(require,module,exports){
"use strict";

module.exports = flatDone;

/**
 * Filters inspections list by completed
 * @param  {Array} list Inspection list
 */
function flatDone(list) {
  var newArray = [];
  _.forEach(list, function(month) {
    _.forEach(month, function(customer) {
      var filtered = _.filter(customer, { completed: true });
      newArray = newArray.concat(filtered);
    });
  });
  return newArray;
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/due.js":[function(require,module,exports){
"use strict";

module.exports = flattenDue;

/**
 * Flattens firebase data to an array
 * @param  {} list
 */
function flattenDue(list) {
  var flatArray = [];
  if (!_.isEmpty(list)) {
    if (isNaN(list[0].$id)) {
      return flattenOneDue(list);
    } else {
      return flattenMultiDue(list);
    }
  }
  return flatArray;

  /**
   * Returns customer inspections which are due
   * @param  {Array} obj Customer list
   * @return {Array} Inspection list
   */
  function flattenOneDue(obj) {
    _.forEach(obj, function(cust) {
      _.forEach(cust, function(insp, key) {
        if (isDue(insp)) {
          insp.$id = key;
          flatArray.push(insp);
        }
      });
    });
    return flatArray;
  }

  /**
   * Returns customer inspection list which are due, searched by months
   * @param  {Array} list Month list
   * @return {Array} Inspection list
   */
  function flattenMultiDue(list) {
    _.forEach(list, function(month) {
      _.forEach(month, function(cust) {
        _.forEach(cust, function(insp, key) {
          if (isDue(insp)) {
            insp.$id = key;
            flatArray.push(insp);
          }
        });
      });
    });
    return flatArray;
  }

  /**
   * Searchs if an inspection is due
   * @param  {Object} insp Inspection data
   * @return {Boolean} True if inspection is due, false otherwise
   */
  function isDue(insp) {
    if (_.isObject(insp)) {
      if (insp.month == 11 && insp.week == 1) {
        insp.week = moment(insp.year + "-" + (insp.month + 1) + "-" + insp.day + "-")
          .endOf("month")
          .subtract(1, "w")
          .isoWeek() + 1;
      }
      var isWeeklyOrBiweekly = insp.frequency === "Weekly" || insp.frequency === "Bi-weekly";
      var isSameYear = moment().year() == insp.year;
      var isBefore =
        moment().year() >= insp.year
          ? isSameYear
            ? isWeeklyOrBiweekly ? moment().isoWeek() > insp.week : moment().month() > insp.month
            : true
          : false;
      if (!insp.completed && !isBefore) {
        return true;
      }
    }
    return false;
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/filter.js":[function(require,module,exports){
"use strict";

module.exports = filter;

/**
 * Filters data
 */
function filter() {
  return function(input, array) {
    if (!array || !array.length) {
      return input;
    }
    return _.filter(input, function(e) {
      return _.includes(array, e.type);
    });
  };
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/inspectionFilter.js":[function(require,module,exports){
"use strict";

module.exports = filter;

var typeMap = require("../../reports/models/reportMapper.js");
typeMap["Work Order"] = "workOrder";

function filter() {
  return {
    restrict: "AE",
    templateUrl: "inspections/views/inspectionFilter.html",
    scope: {
      values: "="
    },
    link: link
  };

  function link($scope, $elem) {
    $scope.openFilters = openFilters;
    $scope.selectAll = selectAll;
    $scope.applyFilter = applyFilter;
    $scope.showFilters = false;
    $scope.isShowingAll = false;
    $scope.filterValues = {};
    selectAll($scope.filterValues);

    $scope.$watchCollection("filterValues", function() {
      $scope.isShowingAll = _.every($scope.filterValues, function(v, k) {
        return $scope.filterValues[k];
      });
    });

    /**
     * Shows inspection filters
     */
    function openFilters() {
      $scope.showFilters = !$scope.showFilters;
    }

    /**
     * Selects all inspection filters
     * @param  {Object} filters Inspection filters
     */
    function selectAll(filters) {
      _.forEach(typeMap, function(val) {
        filters[val] = $scope.isShowingAll;
      });
    }

    /**
     * Applies filters selected
     * @param  {Object} filters Inspection Filters
     * @return {String} Inspection filter name
     */
    function applyFilter(filters) {
      $scope.showFilters = false;
      var values = _.map(typeMap, function(val, key) {
        if (filters[val]) {
          return key;
        }
      });
      $scope.values = _.compact(values);
    }

    $(document).click(function() {
      if (!$scope.showFilters) {
        return;
      }
      $scope.showFilters = false;
      $scope.$apply();
    });

    $elem.bind("click", function(e) {
      e.stopPropagation();
    });
  }
}

},{"../../reports/models/reportMapper.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/reportMapper.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/inspectionsCtrl.js":[function(require,module,exports){
"use strict";

module.exports = InspectionsCtrl;

InspectionsCtrl.$inject = [];
function InspectionsCtrl() {
  var mod = this;
  mod.currentDate = moment();
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/listInspectionCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListInspectionCtrl;
var missed = require("./missed.js");
var due = require("./due.js");
var next = require("./next.js");
var done = require("./done.js");
var sorter = require("../../customers/models/inspectionsSorter.js");

ListInspectionCtrl.$inject = [
  "list",
  "$stateParams",
  "InspectionAPI",
  "lastInspections",
  "$scope"
];
function ListInspectionCtrl(
  list,
  $stateParams,
  InspectionAPI,
  lastInspections,
  $scope
) {
  var vm = this;
  vm.time = $stateParams.due;
  vm.typeStr = typeStr;
  vm.deleteInspection = deleteInspection;

  vm.selectedDate = moment().format('YYYY-MM');
  vm.missed = missed(list);
  vm.titles = {
    missed: "Missed Inspections",
    this: "Due This Month",
    next: "Due Next Month",
    done: "Completed Inspections"
  };
  vm.filters = {
    missed: missed,
    this: due,
    next: next,
    done: done
  };
  vm.search = search;

  var selectedYear = moment().year();

  addAllMissed();

  if (list) {
    vm.list = filterInspections();

    list.$watch(function() {
      vm.list = filterInspections();
    });
  }

  function addAllMissed() {
    var currentYear = moment().year();
    var currentMonth = moment().month();

    for (var i = 4; i >= 0; i--) {
      for (var j = 11; j >= 0; j--) {
        if (i == 0 && currentMonth <= j) {
          continue;
        }

        if (currentYear - i < 2018) {
          continue;
        }

        InspectionAPI.listMonth(currentYear - i, j).then(function(data) {
          addMissed(missed(data));
        });
      }
    }
  }

  function addMissed(moreMissed) {
    if (moreMissed && moreMissed.length > 0) {
      for (var i = 0; i < moreMissed.length; i++) {
        vm.missed.push(moreMissed[i]);
      }
    }
  }

  function typeStr(inspection) {
    return InspectionAPI.typeStr(inspection);
  }

  function filter(list) {
    var filtered = vm.filters[vm.time](list);
    if (vm.time === "done") {
      return sorter.sortDoneInspections(filtered, moment(vm.selectedDate).month());
    } else if (vm.time === "missed") {
      return vm.missed;
    } else {
      return sorter.sortDueInspections(filtered);
    }
  }

  function deleteInspection(inspection) {
    InspectionAPI.deleteInspection(inspection);
    _.remove(vm.missed, { $id: inspection.$id });
  }

  function search() {
    var year = moment(vm.selectedDate).year();
    if (year !== selectedYear) {
      selectedYear = year;
      getInspections(year).then(function (inspections) {
        list = inspections;
        vm.list = filterInspections();
      });
    } else {
      vm.list = filterInspections();
    }
  }

  function getInspections(year) {
    return InspectionAPI.listInspecsDone(year).catch(function(
      exp
    ) {
      Raven.captureException(exp);
      Notifications.addCustom(
        500,
        "Error retrieving inspections, please try again."
      );
    });
  }

  function filterInspections() {
    var allInspections = filter(list)
      .concat(filter(lastInspections));

    return _.uniq(allInspections, function(insp) {
      //var temp = JSON.parse(JSON.stringify(insp));
      //delete temp.modifiedAt;
      return insp.$id || `${insp.asignationDate}-${insp.idCustomer}-${insp.month}-${insp.type}-${insp.year}`;
      //return insp.$id || temp;
    });
  }
}

},{"../../customers/models/inspectionsSorter.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/customers/models/inspectionsSorter.js","./done.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/done.js","./due.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/due.js","./missed.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/missed.js","./next.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/next.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/missed.js":[function(require,module,exports){
"use strict";

module.exports = flattenMissed;

/**
 * Flattens data from firebase to an array
 * @param  {} list
 */
function flattenMissed(list) {
  var flatArray = [];
  if (!_.isEmpty(list)) {
    if (isNaN(list[0].$id)) {
      return flattenOneMissed(list);
    } else {
      return flattenMultiMissed(list);
    }
  }
  return flatArray;

  /**
   * Returns customer inspections which are missed
   * @param  {Array} obj Customer list
   * @return {Array} Inspection list
   */
  function flattenOneMissed(obj) {
    _.forEach(obj, function(cust) {
      _.forEach(cust, function(insp, key) {
        if (isMissed(insp)) {
          insp.$id = key;
          flatArray.push(insp);
        }
      });
    });
    return flatArray;
  }

  /**
   * Returns customer inspection list which are missed, searched by months
   * @param  {Array} list Month list
   * @return {Array} Inspection list
   */
  function flattenMultiMissed(list) {
    _.forEach(list, function(month) {
      _.forEach(month, function(cust) {
        _.forEach(cust, function(insp, key) {
          if (isMissed(insp)) {
            insp.$id = key;
            flatArray.push(insp);
          }
        });
      });
    });
    return flatArray;
  }

  /**
   * Searchs if an inspection is miseed
   * @param  {Object} insp Inspection data
   * @return {Boolean} True if inspection is missed, false otherwise
   */
  function isMissed(insp) {
    if (_.isObject(insp)) {
      var expired = insp.expirationDate
        ? insp.expirationDate < moment().format("YYYY-MM-DD")
        : false;

      if (insp.month == 11 && insp.week == 1) {
        insp.week = moment(insp.year + "-" + (insp.month + 1) + "-" + insp.day + "-")
          .endOf("month")
          .subtract(1, "w")
          .isoWeek() + 1;
      }

      var isWeeklyOrBiweekly = insp.frequency === "Weekly" || insp.frequency === "Bi-weekly";
      var isSameYear = moment().year() == insp.year;
      var isBefore =
        moment().year() >= insp.year
          ? isSameYear
            ? isWeeklyOrBiweekly ? moment().isoWeek() > insp.week : moment().month() > insp.month
            : true
          : false;

      if (!insp.completed && ((isBefore && !insp.assignationDate) || expired)) {
        return true;
      }
    }
    return false;
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/next.js":[function(require,module,exports){
"use strict";

module.exports = flattenNext;

/**
 * Flattens data from firebase to an array
 * @param  {} list
 */
function flattenNext(list) {
  var flatArray = [];
  _.forEach(list, function(cust) {
    _.forEach(cust, function(insp, key) {
      if (_.isObject(insp)) {
        insp.$id = key;
        var isAfter = compareDates(
          insp,
          insp.assignationDate ? "assignationDate" : "generationDate"
        );
        if (!insp.completed && isAfter) {
          flatArray.push(insp);
        }
      }
    });
  });
  return flatArray;
}

/**
 * Compares today date with inpsection date attributes
 * @param  {String} field Attribute name
 * @return {Boolean} True if inspection date is newer or the same, False otherwise
 */
function compareDates(insp, field) {
  return insp[field] >= moment().format("YYYY-MM-DD");
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/notificationsCtrl.js":[function(require,module,exports){
"use strict";

module.exports = NotificationsCtrl;

NotificationsCtrl.$inject = ["$stateParams", "InspectionAPI"];
function NotificationsCtrl($stateParams, InspectionAPI) {
  var vm = this;
  vm.notifications = $stateParams.notifications;
  InspectionAPI.markAsRead(vm.notifications);
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/rest/inspectionAPI.js":[function(require,module,exports){
"use strict";

module.exports = InspectionAPI;

var Inspection = require("../../models/inspection.js");

InspectionAPI.$inject = [
  "urlApi",
  "$firebaseArray",
  "$firebaseObject",
  "Notifications",
  "$sessionStorage",
  "$q",
  "$http",
  "urlNode"
];

function InspectionAPI(
  urlApi,
  $firebaseArray,
  $firebaseObject,
  Notifications,
  $sessionStorage,
  $q,
  $http,
  urlNode
) {
  var ref = new Firebase(urlApi + "Inspections/");

  var urlInspections = urlNode + "api/inspections/";
  InspectionAPI.get = get;
  InspectionAPI.getFromTree = getFromTree;
  InspectionAPI.listMonth = listMonth;
  InspectionAPI.listMonths = listMonths;
  InspectionAPI.remove = remove;
  InspectionAPI.edit = edit;
  InspectionAPI.updateCustomerName = updateCustomerName;
  InspectionAPI.create = create;
  InspectionAPI.listByCust = listByCust;
  InspectionAPI.listByCustThisYear = listByCustThisYear;
  InspectionAPI.listInspecsDone = listInspecsDone;
  InspectionAPI.insertInJobBoard = insertInJobBoard;
  InspectionAPI.markAsRead = markAsRead;
  InspectionAPI.deleteInspections = deleteInspections;
  InspectionAPI.deleteInspection = deleteInspection;
  //node API methods
  InspectionAPI.getTemplateQuestions = getTemplateQuestions;
  InspectionAPI.postTemplateQuestions = postTemplateQuestions;
  InspectionAPI.removeTemplateQuestion = removeTemplateQuestion;
  //Helpers
  InspectionAPI.typeStr = typeStr;

  return InspectionAPI;

  /**
   * Returns an inspection
   * @param  {String} id
   * @return {Object} Inspection data
   */
  function get(id) {
    if (id) {
      var query = ref.child($sessionStorage.user.$id).child(id);
      return $firebaseObject(query).$loaded(function(resp) {
        return resp;
      });
    } else {
      return new Inspection();
    }
  }

  /**
   * Gets an inspection of a customer from id
   * @param  {} year
   * @param  {} month
   * @param  {} customer
   * @param  {} id
   */
  function getFromTree(year, month, customer, id) {
    var query = ref
      .child($sessionStorage.user.$id)
      .child(year)
      .child(month)
      .child(customer);
    if (id) {
      query = query.child(id);
    }
    return $firebaseObject(query).$loaded(function(resp) {
      return resp;
    });
  }

  /**
   * Get inspectios by month
   * @param  {String} year
   * @param  {String} month
   * @return {Array} Inspection list filtered by month and year
   */
  function listMonth(year, month) {
    var query = ref
      .child($sessionStorage.user.$id)
      .child(year)
      .child(month);
    return $firebaseArray(query).$loaded(function(resp) {
      return resp;
    });
  }

  /**
   * Returns inspections by month
   * @return {Array} Inspection list
   */
  function listMonths() {
    var query = ref
      .child($sessionStorage.user.$id)
      .child(moment().year())
      .child(moment().month());
    var lastDate = moment().subtract(1, "M");
    var check = ref
      .child($sessionStorage.user.$id)
      .child(lastDate.year())
      .child(lastDate.month());
    return check.once("value").then(function(resp) {
      var val = resp.val();
      if (val && val.length) {
        var myRef = ref.child($sessionStorage.user.$id).child(moment().year());
        query = myRef
          .orderByKey()
          .startAt(lastDate.month().toString())
          .limitToFirst(2);
      }
      return $firebaseArray(query).$loaded(function(resp) {
        return resp;
      });
    });
  }

  /**
   * Marks as read inspections
   * @param  {Array} inspections Inspection list
   */
  function markAsRead(inspections) {
    _.forEach(inspections, function(single) {
      if (!single.read) {
        single.read = true;
        ref
          .child($sessionStorage.user.$id)
          .child(single.year)
          .child(single.month)
          .child(single.idCustomer)
          .child(single.$id)
          .child("read")
          .set(true);
      }
    });
  }

  /**
   * Returns customer inspection list in this year
   * @param  {String} idCust Customer Id
   * @param  {String} idClient Client Id
   */
  function listByCust(idCust, idClient) {
    var deferred = $q.defer();
    var promises = [];
    var query = null;
    _.forEach(_.range(moment().month(), 12), function(month) {
      query = ref
        .child(idClient)
        .child(moment().year())
        .child(month)
        .child(idCust);
      promises.push($firebaseArray(query).$loaded());
    });
    $q.all(promises).then(
      function(results) {
        deferred.resolve(_.flatten(results));
      },
      function(errors) {
        deferred.reject(errors);
      }
    );
    return deferred.promise;
  }

  /**
   * Returns customer inspection list in this year
   * @param  {String} idCust Customer Id
   * @param  {String} idClient Client Id
   */
  function listByCustThisYear(idCust, idClient) {
    var deferred = $q.defer();
    var promises = [];
    var query = null;
    _.forEach(_.range(0, 12), function(month) {
      query = ref
        .child(idClient)
        .child(moment().year())
        .child(month)
        .child(idCust);
      promises.push($firebaseArray(query).$loaded());
    });
    $q.all(promises).then(
      function(results) {
        deferred.resolve(_.flatten(results));
      },
      function(errors) {
        deferred.reject(errors);
      }
    );
    return deferred.promise;
  }

  /**
   * Returns user inspections list done
   * @param  {String} year
   * @return {Array} Inspection list
   */
  function listInspecsDone(year) {
    var query = ref.child($sessionStorage.user.$id).child(year);
    return $firebaseArray(query).$loaded(function(resp) {
      return resp;
    });
  }

  /**
   * Remove an inspection
   * @param  {Object} obj
   * @return {Object} Firebase response
   */
  function remove(obj) {
    return InspectionAPI.getFromTree(
      obj.year,
      obj.month,
      obj.idCustomer,
      obj.$id
    ).then(function(resp) {
      resp.$remove().then(ok, error);
    });

    function ok(resp) {
      return resp;
    }

    function error(resp) {
      Notifications.addCustom(500, "There was a problem.");
      return resp;
    }
  }

  /**
   * Creates a customer new inspection
   * @param  {Object} obj
   * @param  {String} path
   * @return {Object} Firebase response
   */
  function create(obj, path) {
    var query = ref
      .child($sessionStorage.user.$id)
      .child(path.year)
      .child(path.month)
      .child(obj.idCustomer);
    return $firebaseArray(query)
      .$add(obj)
      .then(ok, error);

    function ok(resp) {
      Notifications.addCustom(200, "Inspection assigned successfully");
      return resp.key();
    }

    function error(resp) {
      Notifications.addCustom(500, "There was a problem.");
      return resp;
    }
  }

  function edit(obj) {
    var future = $q.defer();
    try {
      obj.$save().then(function(resp) {
        future.resolve(resp.key());
      });
    } catch (e) {
      Notifications.addCustom(500, "There was a problem. Please try again.");
      Raven.captureException(e);
      future.reject(e);
    }
    return future.promise;
  }

  /**
   * @name updateCustomerName
   * @desc Updates all the inspections with a new customer  name
   * @param {Object} job The inspection object
   * @param {String} name The new name of the customer to update
   * @returns {String}
   * @memberOf InspectionAPI
   */
  function updateCustomerName(job, name) {
    $firebaseObject(
      ref
        .child($sessionStorage.user.$id)
        .child(job.year)
        .child(job.month)
        .child(job.idCustomer)
        .child(job.$id)
    ).$loaded(function(data) {
      data.customerName = name;
      data.$save();
    });
  }

  /**
   * Inserts a job in joblink
   * @param  {Object} job
   */
  function insertInJobBoard(job) {
    return $firebaseArray(
      ref
        .child($sessionStorage.user.$id)
        .child(job.year)
        .child(job.month)
        .child(job.idCustomer)
    )
      .$add(job)
      .then(ok, error);

    function ok(resp) {
      Notifications.addCustom(200, "Inspection created successfully.");
      return resp.key();
    }

    function error(resp) {
      Notifications.addCustom(500, "There was a problem.");
      return resp;
    }
  }

  /**
   * Returns next week from current date
   * @param  {} date
   */
  function findNextWeek(date) {
    var momentPeriod = { month: 1 };
    return moment(date).add(momentPeriod);
  }

  /**
   * Removes customer future inspection (from - to)
   * @param  {Date} from
   * @param  {Date} to
   * @param  {Object} insp
   * @param  {Object} customer
   * @param  {Object} future
   */
  function deleteFutureInspections(from, to, insp, customer, future) {
    if (!from.isValid() || from.isAfter(to)) {
      future.resolve();
    } else {
      //Delete the reports of the month
      var query = ref
        .child($sessionStorage.user.$id)
        .child(from.year())
        .child(from.month())
        .child(customer.fb.$id);

      var toDelete = {
        type: insp.type,
        frequency: insp.frequency,
        parity: insp.parity,
      };

      $firebaseArray(query).$loaded(function(futureInspections) {
        //Delete the not completed inspections
        angular.forEach(futureInspections, function(inspection) {
          var current = {
            type: inspection.type,
            frequency: inspection.frequency,
            parity: inspection.parity,
          };
          if (_.isEqual(toDelete, current) && !inspection.completed) {
            futureInspections.$remove(
              futureInspections.$indexFor(inspection.$id)
            );
          }
        });
      });

      //Delete next month
      var newFrom = findNextWeek(from);
      return deleteFutureInspections(newFrom, to, insp, customer, future);
    }
  }

  /**
   * Removes all customer inspections
   * @param  {Array} insp Inspection list
   * @param  {Object} customer Customer data
   */
  function deleteInspections(insp, customer) {
    var future = $q.defer();

    var startFrom = moment();
    var endPoint = moment().add(10, "y");

    if (existsInspection(insp, customer.fb.recurringInspections)) {
      future.resolve();
    } else {
      deleteFutureInspections(startFrom, endPoint, insp, customer, future);
    }

    return future.promise;
  }

  function existsInspection(inspection, customerInspections) {
    var exists = false;

    var inspectionProperties = {
      type: inspection.type,
      frequency: inspection.frequency,
      parity: inspection.parity
    };
    customerInspections.forEach(function (insp) {
      if (insp.createdAt !== inspection.createdAt) {
        var currentProperties = {
          type: insp.type,
          frequency: insp.frequency,
          parity: insp.parity
        };
        if (_.isEqual(currentProperties, inspectionProperties)) {
          exists = true;
        }
      }
    });
    return exists;
  }

  /**
   * Returns the 'readable' name of the report type
   * @param  {Object} inspection details of the inspection
   */
  function typeStr(inspection) {
    var typeString = "";
    if (
      inspection.woType &&
      inspection.woType == "Other" &&
      inspection.woTypeOther
    )
      typeString += inspection.woTypeOther;
    else if (inspection.woType) typeString += inspection.woType;
    else typeString += inspection.type;

    return typeString;
  }

  /**
   * returns templated custom questions if we have them
   * @param  {Object} inspection details of the inspection
   * @returns {Object} custom question template
   */
  function getTemplateQuestions(inspection) {
    return templateQuestionCall(inspection, "questions/view");
  }

  /**
   * posts templated custom questions if we have them
   * @param  {Object} inspection details of the inspection
   */
  function postTemplateQuestions(inspection) {
    return templateQuestionCall(inspection, "questions/add");
  }
  /**
   * delete a templated custom question
   * @param  {Object} inspection details of the inspection
   */
  function removeTemplateQuestion(inspection, question) {
    var data = {
      clientId: inspection.clientId,
      type: inspection.type
    };

    templateQuestionCall(data, "questions/view").then(function (report) {
      report.customQuestions = _.without(
        report.customQuestions,
        _.findWhere(report.customQuestions, {
          title: question.title
        })
      );

      return templateQuestionCall(report, "questions/add");
    });
  }

  /**
   * performs a api call to retrieve or modify the templated custom questions
   * @param  {Object} inspection details of the inspection
   * @param  {String} method url to call.
   */
  function templateQuestionCall(inspection, method) {
    // var future = $q.defer();

    var data = {
      clientId: inspection.clientId,
      type: inspection.type
    };

    //check to see if its an 'other' report type
    if (inspection.type == "Work Order" && inspection.woType) {
      data.woType = inspection.woType;
      if (inspection.woTypeOther) data.woTypeOther = inspection.woTypeOther;
    }

    if (inspection.customQuestions)
      data.customQuestions = inspection.customQuestions;

    return $http.post(urlInspections + method, data).then(
      function(resp) {
        return resp.data;
      },
      function() {
        Notifications.add(404);
      }
    );
  }

  function deleteInspection(inspection) {
    var obj = ref
      .child($sessionStorage.user.$id)
      .child(inspection.year)
      .child(inspection.month)
      .child(inspection.idCustomer);

    return $firebaseObject(obj).$loaded(function (inspections) {
      delete inspections[inspection.$id];
      inspections.$save();
    });
    
  }
}

},{"../../models/inspection.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/models/inspection.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/unassigned.js":[function(require,module,exports){
"use strict";

module.exports = filterUnassigned;

/**
 * Filters inspections that are unassigned
 * @param  {Array} list Inspection list
 * @return {Array} Unassigned inspection list
 */
function filterUnassigned(list) {
  if (list) {
    return _.filter(list, function(insp) {
      return _.isUndefined(insp.assignationDate);
    });
  }
  return;
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/index.js":[function(require,module,exports){
"use strict";

var _name = require("../../../package.json").name;

var mod = angular.module(_name + ".Inspections", 
  ["ngMaterial", "ngMessages"])
  .config(['$mdThemingProvider', function($mdThemingProvider) {
    $mdThemingProvider.theme('default')
      .primaryPalette('red')
      .accentPalette('orange');
  }]);
mod.config(require("./routes"));

mod.controller("InspectionsCtrl", require("./controllers/inspectionsCtrl.js"));

mod.controller(
  "ListInspectionCtrl",
  require("./controllers/listInspectionCtrl.js")
);

mod.controller(
  "NotificationsCtrl",
  require("./controllers/notificationsCtrl.js")
);

mod.directive("inspectionFilter", require("./controllers/inspectionFilter.js"));

mod.factory("InspectionAPI", require("./controllers/rest/inspectionAPI.js"));

mod.filter("filterIn", require("./controllers/filter.js"));

module.exports = mod;

},{"../../../package.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/package.json","./controllers/filter.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/filter.js","./controllers/inspectionFilter.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/inspectionFilter.js","./controllers/inspectionsCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/inspectionsCtrl.js","./controllers/listInspectionCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/listInspectionCtrl.js","./controllers/notificationsCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/notificationsCtrl.js","./controllers/rest/inspectionAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/rest/inspectionAPI.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/routes.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/models/inspection.js":[function(require,module,exports){
"use strict";

module.exports = Inspection;

function Inspection(fb) {
  this.fb = fb;
}

Inspection.loadObj = loadObj;
Inspection.prototype.isMissed = isMissed;
Inspection.prototype.isDue = isDue;

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new Inspection(json);
}

function isMissed() {
  var isBefore = this.fb.assignationDate
    ? this.fb.assignationDate < moment().format("YYYY-MM-DD")
    : moment().isoWeek() > this.fb.week;
  if (!this.fb.completed && moment().year() >= this.fb.year && isBefore) {
    return true;
  }
  return false;
}

function isDue() {
  var isAfter = this.fb.assignationDate
    ? this.fb.assignationDate >= moment().format("YYYY-MM-DD")
    : moment().isoWeek() <= this.fb.week;
  if (!this.fb.completed && isAfter) {
    return true;
  }
  return false;
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;

routes.$inject = ["$stateProvider"];
function routes($stateProvider) {
  $stateProvider.state("index.inspections", {
    templateUrl: "inspections/views/index.html",
    data: {
      title: "Inspections Module",
      icon: "fa-bar-chart",
      menu: "Inspections",
      hasDropdown: true,
      submenu: [
        {
          title: "Due This Month",
          name: "index.inspections.inspection-list({due: 'this'})"
        },
        {
          title: "Due Next Month",
          name: "index.inspections.inspection-list({due: 'next'})"
        },
        {
          title: "Missed Inspects",
          name: "index.inspections.inspection-list({due: 'missed'})"
        },
        {
          title: "Done",
          name: "index.inspections.inspection-list({due: 'done'})"
        }
      ],
      role: "client"
    }
  });

  $stateProvider.state("index.inspections.inspection-list", {
    templateUrl: "inspections/views/listInspection.html",
    url: "/inspections/:due",
    controller: "ListInspectionCtrl",
    controllerAs: "vm",
    resolve: {
      list: listInspection,
      lastInspections: getLastMonthInspections
    },
    data: {
      title: "Inspection List",
      icon: "fa-list",
      menu: "Inspection List",
      role: "client"
    }
  });

  $stateProvider.state("index.inspections.notifications", {
    templateUrl: "inspections/views/notifications.html",
    url: "/notifications",
    params: {
      notifications: []
    },
    controller: "NotificationsCtrl",
    controllerAs: "vm",
    data: {
      title: "Notifications List",
      icon: "fa-list",
      menu: "Notifications List",
      role: "client"
    }
  });

  getLastMonthInspections.$inject = ["InspectionAPI"];
  function getLastMonthInspections(InspectionAPI) {
    var date = moment().subtract(1, "M");
    return InspectionAPI.listMonth(date.year(), date.month());
  }

  /**
   * Returns inspection list (missed, this, done or next inspections)
   * @param  {Controller} InspectionAPI
   * @param  {Object} $stateParams
   * @param  {Provider} Notifications
   */
  listInspection.$inject = ["InspectionAPI", "$stateParams", "Notifications"];
  function listInspection(InspectionAPI, $stateParams, Notifications) {
    if ($stateParams.due === "missed" || $stateParams.due === "this") {
      return InspectionAPI.listMonths()
        .then(function(data) {
          return data;
        })
        .catch(function(exp) {
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error retrieving inspections, please try again."
          );
        });
    }
    if ($stateParams.due === "next") {
      var date = moment().add(1, "M");
      return InspectionAPI.listMonth(date.year(), date.month()).catch(function(
        exp
      ) {
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error retrieving inspections, please try again."
        );
      });
    }
    if ($stateParams.due === "done") {
      return InspectionAPI.listInspecsDone(moment().year()).catch(function(
        exp
      ) {
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error retrieving inspections, please try again."
        );
      });
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/jobboard/controllers/AssignInspecCtrl.js":[function(require,module,exports){
"use strict";

module.exports = AssignInspectCtrl;

AssignInspectCtrl.$inject = [
  "info",
  "$uibModalInstance",
  "InspectionAPI",
  "cfpLoadingBar",
  "Notifications"
];
function AssignInspectCtrl(
  info,
  $uibModalInstance,
  InspectionAPI,
  cfpLoadingBar,
  Notifications
) {
  var vm = this;
  vm.editing = info.editing;
  vm.durationTypes = ["Hours", "Date"];
  vm.durationOptions = generateDurationOptions();
  vm.originalInspection = info.inspection;
  vm.assignedEmployees = [];
  vm.assignedNames = [];

  InspectionAPI.getFromTree(
    info.inspection.year,
    info.inspection.month,
    info.inspection.idCustomer,
    info.inspection.$id
  )
    .then(function(data) {
      vm.inspection = data;
      if (!vm.editing) {
        vm.inspection.assignedEmployees = info.inspection.assignedEmployees;
        vm.inspection.hour = info.inspection.hour;
        vm.inspection.assignationDate = info.inspection.assignationDate;
        vm.inspection.duration = 1;
        vm.inspection.read = false;
        vm.durationBy = "Hours";
      } else {
        vm.durationBy = info.inspection.duration > 24 ? "Date" : "Hours";
        vm.expirationDate = info.inspection.expirationDate;
      }
      vm.employees = getInspectionEmployees(info.employees);
    })
    .catch(function(exp) {
      Raven.captureException(exp);
      Notifications.addCustom(
        500,
        "Error retrieving inspections, please try again."
      );
    });

  vm.finish = finish;
  vm.cancel = cancel;
  vm.assignEmployee = assignEmployee;
  vm.revokeEmployee = revokeEmployee;
  vm.setDuration = setDuration;
  vm.removeInspection = removeInspection;
  vm.deleteInspection = deleteInspection;

  /**
   * Saves or edits inspection information
   * @param  {} inspForm
   * @param  {} editing
   */
  function finish(inspForm, editing) {
    inspForm.$submitted = true;
    if (inspForm.$valid && vm.assignedNames.length > 0) {
      cfpLoadingBar.start();
      if (editing) {
        edit();
      } else {
        save();
      }
    }
  }

  /**
   * Assigns an employee to a inspection
   * @param  {Object} item Employee data
   */
  function assignEmployee(item) {
    vm.inspection.assignedEmployees.push(item.$id);
    vm.assignedNames.push(item);
    vm.newEmployee = "";
    vm.employees = _.without(vm.employees, item);
  }

  /**
   * Geneterate inspection duration
   * @return {Object} Duration inspection options
   */
  function generateDurationOptions() {
    var options = { "30 minutes": 1 };
    for (var i = 2; i <= 24; i += 1) {
      var key = (i % 2 === 0 ? i / 2 : (i - 1) / 2 + ".5") + " hours";
      options[key] = i;
    }
    return options;
  }

  /**
   * Creates or edits an inspection
   */
  function save() {
    vm.inspection.expirationDate = getExpirationDate(
      vm.inspection,
      vm.durationBy
    );
    var assignedMonth = moment(vm.inspection.assignationDate).month();
    var oldDate = vm.originalInspection.oldAssignationDate;
    if (
      (oldDate && moment(oldDate).month() !== assignedMonth) ||
      moment(vm.originalInspection.generationDate).month() !== assignedMonth
    ) {
      moveInspection();
    } else {
      InspectionAPI.edit(vm.inspection)
        .then(function() {
          Notifications.addCustom(200, "Inspection assigned successfully.");
          finishSave();
        })
        .catch(function() {
          cfpLoadingBar.complete();
        })
        .catch(function(exp) {
          cfpLoadingBar.complete();
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error retrieving inspections, please try again."
          );
        });
    }

    /**
     * Creates a new inspection
     */
    function moveInspection() {
      InspectionAPI.remove(vm.originalInspection);
      vm.inspection.week = moment(vm.inspection.assignationDate).isoWeek();
      vm.inspection.month = moment(vm.inspection.assignationDate).month();
      vm.inspection.year = moment(vm.inspection.assignationDate).year();

      InspectionAPI.create(vm.inspection, {
        month: vm.inspection.month,
        year: vm.inspection.year
      })
        .then(finishSave)
        .catch(function(exp) {
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error retrieving inspections, please try again."
          );
        });
    }
  }

  /**
   * Closes modal inspection
   */
  function finishSave() {
    cfpLoadingBar.complete();
    $uibModalInstance.close();
  }

  /**
   * Removes an inspection
   */
  function deleteInspection() {
    if (
      confirm(
        "Deleting this job will permanently remove it from the JobLink. " +
          "Are you sure you want to delete it?"
      )
    ) {
      cfpLoadingBar.complete();
      return InspectionAPI.remove(vm.originalInspection)
        .then(function() {
          $uibModalInstance.close();
        })
        .catch(function(exp) {
          cfpLoadingBar.complete();
          Raven.captureException(exp);
          Notifications.addCustom(
            500,
            "Error deleting inspections, please try again."
          );
        });
    } else {
      cfpLoadingBar.complete();
    }
  }

  /**
   * Unassign an inspection
   */
  function removeInspection() {
    vm.inspection.assignedEmployees = [];
    vm.inspection.assignationDate = null;
    vm.inspection.hour = null;
    vm.inspection.duration = null;
    vm.inspection.expirationDate = null;
    edit(true);
  }

  /**
   * Edits inspection data
   * @param  {Boolean} unassign
   */
  function edit(unassign) {
    if (!unassign) {
      vm.inspection.expirationDate = getExpirationDate(
        vm.inspection,
        vm.durationBy
      );
    }
    InspectionAPI.edit(vm.inspection)
      .then(function() {
        Notifications.addCustom(
          200,
          "Inspection " +
            (unassign ? "unassigned" : "edited") +
            " successfully."
        );
        finishSave();
      })
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error editing inspection, please try again."
        );
      });
  }

  /**
   * Close modal inspection
   */
  function cancel() {
    $uibModalInstance.dismiss("cancel");
  }

  /**
   * Removes employee from inspection assignment
   * @param  {} emp
   */
  function revokeEmployee(emp) {
    vm.assignedNames = _.without(vm.assignedNames, emp);
    vm.employees.push(emp);
    vm.inspection.assignedEmployees = _.remove(
      vm.inspection.assignedEmployees,
      function(e) {
        return emp.$id !== e;
      }
    );
  }

  /**
   * Returns inspection employees
   * @param  {Array} employees Employees list
   * @returns {Array} Employee list (filtered)
   */
  function getInspectionEmployees(employees) {
    _.forEach(vm.inspection.assignedEmployees, function(empId) {
      _.forEach(employees, function(employee) {
        if (employee.$id === empId) {
          vm.assignedNames.push(employee);
          employees = _.without(employees, employee);
        }
      });
    });
    return employees;
  }

  /**
   * Returns inspection expiration date
   * @param  {Object} inspection Inspection data
   * @param  {String} durationType Duration type (Hours or date)
   * @return {String} Expiration date
   */
  function getExpirationDate(inspection, durationType) {
    if (durationType === "Hours") {
      if (inspection.hour + inspection.duration > 49) {
        return moment(inspection.assignationDate)
          .add(1, "d")
          .format("YYYY-MM-DD");
      }
      return inspection.assignationDate;
    } else if (durationType === "Date") {
      return inspection.expirationDate;
    }
  }

  /**
   * Sets inspection duration
   * @param  {Object} inspection Inspection data
   * @param  {String} expirationDate Expiration date
   */
  function setDuration(inspection, expirationDate) {
    var diff = moment(expirationDate).diff(
      moment(inspection.assignationDate),
      "day"
    );
    inspection.duration = 49 - inspection.hour + diff * 49;
    inspection.expirationDate = moment(expirationDate).format("YYYY-MM-DD");
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/jobboard/controllers/jobboardCtrl.js":[function(require,module,exports){
"use strict";

module.exports = JobboardCtrl;
var missed = require("../../inspections/controllers/missed.js");
var due = require("../../inspections/controllers/due.js");
var next = require("../../inspections/controllers/next.js");
var unassigned = require("../../inspections/controllers/unassigned.js");
var assigned = require("../../inspections/controllers/assigned.js");
var MapLogic = require("../models/map.js");
var moveInspection = require("./moveInspection.js");

JobboardCtrl.$inject = [
  "InspectionAPI",
  "employees",
  "currentInspections",
  "nextInspections",
  "$uibModal",
  "Notifications",
  "lastInspections"
];
function JobboardCtrl(
  InspectionAPI,
  employees,
  currentInspections,
  nextInspections,
  $uibModal,
  Notifications,
  lastInspections
) {
  var mod = this;
  mod.month = [];
  mod.start = 0;
  mod.end = 7;
  var hours = generateInspections();
  var monthSince = moment().month(moment().month() - 2);
  mod.assignInspection = assignInspection;
  mod.employees = _.filter(employees, function(emp) {
    return emp.showInJobBoard;
  });
  mod.missedInspections = missed(currentInspections);
  //if (moment().year() != moment().subtract(1,'M').year()){
  // addMissed(missed(lastInspections));
  addAllMissed();
  //}
  mod.currentInspections = due(currentInspections);
  mod.nextInspections = next(nextInspections);
  mod.unassignedCurrent = unassigned(mod.currentInspections);
  mod.unassignedNext = unassigned(mod.nextInspections);
  mod.assignedInspections = assigned(
    mod.currentInspections,
    mod.nextInspections
  );
  mod.continue = true;
  mod.tables = [];
  mod.fillSchedule = fillSchedule;
  mod.nextWeek = nextWeek;
  mod.prevWeek = prevWeek;
  mod.monthShown = moment().format("MMMM, YYYY");
  mod.dateSince = monthSince.format("MMMM, YYYY");
  mod.updateShownMonth = updateShownMonth;
  mod.dailyInspections = dailyInspections;
  mod.view = "daily";
  mod.chunkedMonth = [];
  mod.editInspection = editInspection;
  mod.formatDate = formatDate;
  mod.fixColumn = fixColumn;
  mod.dragControlListeners = {
    dragStart: dragStart,
    dragEnd: dragEnd
  };
  mod.dragControlListenersFilteredList = {
    dragStart: dragStart,
    dragEnd: function(event) {
      dragEnd(event, true);
    }
  };
  mod.showItemFiltered = showItemFiltered;
  mod.dragTableListeners = {
    dragStart: function() {
      mod.isDragging = true;
    },
    dragEnd: function() {
      mod.isDragging = false;
    },
    itemMoved: itemMoved
  };
  mod.cancelDragging = cancelDragging;
  mod.showDailyCal = showDailyCal;
  mod.typeStr = typeStr;
  mod.dailyTable = [];
  mod.openDay = openDay;
  mod.map = MapLogic.generateMap(employees);
  mod.locations = MapLogic.extractLocations(employees);

  employees.$watch(function() {
    mod.locations = MapLogic.extractLocations(employees);
  });

  buildMonth();
  buildTables();
  fillSchedule();

  function showItemFiltered(item, values) {
    if (values && values.length > 0) return values.includes(item.type);
    else return true;
  }

  currentInspections.$watch(function() {
    mod.currentInspections = due(currentInspections);
    mod.missedInspections = missed(currentInspections);
    addAllMissed();
    mod.unassignedCurrent = unassigned(mod.currentInspections);
    rebuild();
  });

  nextInspections.$watch(function() {
    mod.nextInspections = next(nextInspections);
    mod.unassignedNext = unassigned(mod.nextInspections);
    rebuild();
  });
  function typeStr(inspection, showDesc) {
    var typeString = InspectionAPI.typeStr(inspection);

    var desc = showDesc ? inspection.description : "";
    typeString += inspection.frequency
      ? " (" + inspection.frequency + ")"
      : " (" + desc + ")";

    return typeString;
  }
  function addAllMissed() {
    var currentDate = moment();
    for (var i = 2; i > 0; i--) {
      currentDate.month(currentDate.month() - 1);
      InspectionAPI.listMonth(currentDate.year(), currentDate.month()).then(
        function(data) {
          addMissed(missed(data));
        }
      );
    }
  }

  /**
   * Adds as missed inspections
   * @param  {} moreMissed
   */
  function addMissed(moreMissed) {
    if (moreMissed && moreMissed.length > 0) {
      for (var i = 0; i < moreMissed.length; i++) {
        mod.missedInspections.push(moreMissed[i]);
      }
    }
    rebuild();
    setUnassigned();
  }

  /**
   * Updates joblink calendar
   */
  function rebuild() {
    mod.assignedInspections = assigned(
      mod.currentInspections,
      mod.nextInspections
    );
    mod.tables = [];
    buildTables();
    fillSchedule();
  }

  /**
   * Shows all inspections in a day
   * @param  {} table
   */
  function openDay(table) {
    mod.start = _.findIndex(mod.tables, function(elem) {
      return elem.day === table.day;
    });
    mod.end = mod.start + 1;
    mod.view = "daily";
    updateShownMonth(table);
  }

  /**
   * Returns date formatted
   * @param  {String} date
   * @return {Date} Format date
   */
  function formatDate(date) {
    var newDate = moment(date);
    newDate = newDate.format("ddd DD, MMMM");
    return newDate;
  }

  /**
   * Generates inspections
   * @return {Array} Inpsections
   */
  function generateInspections() {
    var hours = [];
    for (var i = 0; i < 49; i += 1) {
      hours.push({
        inspections: []
      });
    }
    return hours;
  }

  /**
   * Builds jobboard month
   */
  function buildMonth() {
    var current = moment();
    do {
      mod.month.push(buildWeek(current));
      current.add(1, "d");
    } while (mod.continue);
  }
  /**
   * Builds jobboard week
   * @param  {String} startDate Start date
   * @return {Array} Jobboard week
   */
  function buildWeek(startDate) {
    var week = [];
    var nextDay;
    var i = 1;
    week.push({
      name: startDate.format("dddd MMMM DD, YYYY"),
      date: startDate.format("YYYY-MM-DD"),
      hours: angular.copy(hours)
    });
    while (i < 7 && mod.continue) {
      nextDay = startDate.add(1, "d");
      if (parseInt(moment().format("DD")) === parseInt(nextDay.format("DD"))) {
        mod.continue = false;
      } else {
        week.push({
          name: nextDay.format("dddd MMMM DD, YYYY"),
          date: nextDay.format("YYYY-MM-DD"),
          hours: angular.copy(hours)
        });
        i += 1;
      }
    }
    return week;
  }

  /**
   * Assigns an inspection to employees
   * @param  {Object} inspection Inspection data
   * @param  {} editing
   */
  function assignInspection(inspection, editing) {
    var data = $uibModal.open({
      templateUrl: "jobboard/views/assignInspecModal.html",
      controller: "AssignInspectCtrl",
      controllerAs: "vm",
      resolve: {
        info: function() {
          return {
            employees: angular.copy(mod.employees),
            inspection: inspection,
            editing: editing
          };
        }
      }
    });
    data.result.then(
      function() { setUnassigned(); },
      function() {
        if (!editing) {
          cancelAssignation(inspection);
          mod.unassignedCurrent = mod.currentCopy;
          mod.unassignedNext = mod.nextCopy;
          mod.missedInspections = mod.missedCopy;
        }
        setUnassigned();
      }
    );
  }

  /**
   * Edits an inspection
   * @param  {Object} inspection Inspection data
   */
  function editInspection(inspection) {
    $uibModal.open({
      templateUrl: "jobboard/views/editInspecModal.html",
      controller: "EditInspectCtrl",
      controllerAs: "vm",
      resolve: {
        employees: function() {
          return angular.copy(mod.employees);
        },
        inspection: function() {
          return inspection;
        }
      }
    });
  }

  /**
   * Cancel joblink inspection assignation
   * @param  {Object} insp Inspection data
   */
  function cancelAssignation(insp) {
    _.forEach(mod.tables.slice(mod.start, mod.end), function(table) {
      _.forEach(table, function(row) {
        row.hours[insp.hour].inspections = _.remove(
          row.hours[insp.hour].inspections,
          function(item) {
            return item.$id !== insp.$id;
          }
        );
      });
    });
  }

  function replaceAssignation(oldInsp, newInsp) {
    _.forEach(mod.tables.slice(mod.start, mod.end), function(table) {
      _.forEach(table, function(row) {
        _.forEach(row.hours, function(cell) {
          var index = _.findIndex(cell.inspections, { $id: oldInsp.$id });
          if (index >= 0) {
            cell.inspections[index] = newInsp;
          }
        });
      });
    });
  }

  /**
   * Builds tables for joblink
   */
  function buildTables() {
    _.forEach(mod.month, function(week) {
      _.forEach(week, function(day) {
        var newTable = [];
        _.forEach(mod.employees, function(emp) {
          newTable.push({
            idEmployee: emp.$id,
            employeeName: emp.name,
            hours: angular.copy(day.hours)
          });
          newTable.day = day.name;
          newTable.date = day.date;
          newTable.inspectionCount = 0;
        });
        mod.tables.push(newTable);
      });
    });
  }

  /**
   * After a job is assigned, calculates width of each job assigned in the jobboard panel and shows it.
   */
  function fillSchedule() {
    _.forEach(mod.assignedInspections, function(insp) {
      _.forEach(mod.tables, function(table) {
        if (
          table.date >= insp.assignationDate &&
          table.date <= insp.expirationDate
        ) {
          _.forEach(table, function(row) {
            if (_.includes(insp.assignedEmployees, row.idEmployee)) {
              var inspCopy = null;
              if (insp.duration > 24) {
                var hoursLeft = 49 - insp.hour;
                if (insp.assignationDate === table.date) {
                  insp.width = "width: " + (hoursLeft * 100 + hoursLeft) + "%";
                  row.hours[insp.hour].inspections.push(insp);
                } else {
                  inspCopy = angular.copy(insp);
                  inspCopy.width = "width: 4848%";
                  row.hours[1].inspections.push(inspCopy);
                }
              } else {
                if (insp.hour + insp.duration > 49) {
                  if (insp.assignationDate === table.date) {
                    var leftPart = 49 - insp.hour;
                    insp.width = "width: " + (leftPart * 100 + leftPart) + "%";
                    row.hours[insp.hour].inspections.push(insp);
                  } else {
                    inspCopy = angular.copy(insp);
                    var rightPart = inspCopy.hour + inspCopy.duration - 49;
                    inspCopy.width =
                      "width: " + (rightPart * 100 + rightPart) + "%";
                    row.hours[1].inspections.push(inspCopy);
                  }
                } else {
                  insp.width =
                    "width: " + (insp.duration * 100 + insp.duration) + "%";
                  row.hours[insp.hour].inspections.push(insp);
                }
              }
            }
          });
        }
      });
    });
  }

  //********** DRAG AND DROP EVENTS **********

  function dragStart() {
    mod.isDragging = true;
    mod.currentCopy = angular.copy(mod.unassignedCurrent);
    mod.nextCopy = angular.copy(mod.unassignedNext);
    mod.missedCopy = angular.copy(mod.missedInspections);
  }

  function dragEnd(event, isFilteredList) {
    mod.isDragging = false;
    var inspection = event.source.itemScope.item;
    var isStillInLists = _.some(mod.unassignedCurrent, inspection) ||
      _.some(mod.unassignedNext, inspection) ||
      _.some(mod.missedInspections, inspection);
    if (!isFilteredList && isStillInLists) {
      event.dest.sortableScope.removeItem(event.dest.index);
      event.source.itemScope.sortableScope.insertItem(
        event.source.index,
        inspection
      );
    } else {
      var selectedItem = event.dest.sortableScope.modelValue[0];
      replaceAssignation(selectedItem, inspection);
      var data = getItemPosition(inspection);
      if (!_.isEmpty(data)) {
        inspection.oldAssignationDate = inspection.assignationDate;
        inspection.assignationDate = data.assignationDate;
        inspection.assignedEmployees = data.assignedEmployees;
        inspection.hour = data.hour;
        assignInspection(inspection);
      }
    }
  }

  function itemMoved(event) {
    mod.isDragging = false;
    var insp = event.source.itemScope.insp;
    var data = getDestination(insp);
    var resp = moveInspection(insp, data);
    if (_.isObject(resp)) {
      if (_.isEmpty(resp)) {
        event.source.itemScope.sortableScope.insertItem(
          event.source.index,
          insp
        );
      } else {
        saveInspection(resp);
      }
    } else {
      event.dest.sortableScope.removeItem(event.dest.index);
      event.source.itemScope.sortableScope.insertItem(event.source.index, insp);
    }
  }

  function cancelDragging(e) {
    if (mod.isDragging && e.keyCode === 27) {
      mod.isDragging = false;
    }
  }

  //******************************************

  /**
   * Saves an inspection
   * @param  {Object} insp Inspection data
   */
  function saveInspection(insp) {
    InspectionAPI.getFromTree(insp.year, insp.month, insp.idCustomer, insp.$id)
      .then(function(resp) {
        resp.assignedEmployees = insp.assignedEmployees;
        resp.hour = insp.hour;
        resp.assignationDate = insp.assignationDate;
        resp.expirationDate = insp.expirationDate;
        InspectionAPI.edit(resp);
      })
      .catch(function(exp) {
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error saving inspection, please try again."
        );
      });
  }

  /**
   * Return inspection information (position in joblink calendar)
   * @param  {Object} insp Inspection data
   * @return {Object} Inspection date, hour and employees
   */
  function getItemPosition(insp) {
    var data = {};
    _.forEach(mod.tables.slice(mod.start, mod.end), function(table) {
      _.forEach(table, function(row) {
        _.forEach(row.hours, function(cell) {
          if (_.includes(cell.inspections, insp)) {
            data = {
              assignationDate: table.date,
              hour: row.hours.indexOf(cell),
              assignedEmployees: [row.idEmployee]
            };
          }
        });
      });
    });
    return data;
  }

  /**
   * Return inspection information (position in joblink calendar)
   * @param  {Object} insp Inspection data
   * @return {Object} Inspection date, hour and employees
   */
  function getDestination(insp) {
    var data = [];
    _.forEach(mod.tables.slice(mod.start, mod.end), function(table) {
      _.forEach(table, function(row) {
        _.forEach(row.hours, function(cell) {
          if (_.some(cell.inspections, insp)) {
            data.push({
              assignationDate: table.date,
              hour: row.hours.indexOf(cell),
              assignedEmployees: [row.idEmployee]
            });
          }
        });
      });
    });
    return data;
  }

  /**
   * Loads next week in calendar
   */
  function nextWeek() {
    mod.start = mod.start + 7;
    mod.end = mod.end + 7;
    updateShownMonth();
  }

  /**
   * Loads previous week in calendar
   */
  function prevWeek() {
    mod.start = mod.start - 7;
    mod.end = mod.end - 7;
    updateShownMonth();
  }

  /**
   * Shows today assigned inspections
   */
  function dailyInspections() {
    _.forEach(mod.tables, function(day) {
      day.inspectionCount = 0;
      _.forEach(day, function(employee) {
        _.forEach(employee.hours, function(hour) {
          day.inspectionCount = day.inspectionCount + hour.inspections.length;
        });
      });
    });

    mod.chunkedMonth = _.chunk(mod.tables, 7);
  }

  /**
   * Showns month in calendar
   * @param  {Object} day Day showned
   */
  function updateShownMonth(day) {
    if (day) {
      mod.monthShown = moment(day.date).format("MMMM, YYYY");
    } else {
      mod.monthShown = moment(
        mod.tables.slice(mod.start, mod.end)[0].date
      ).format("MMMM, YYYY");
    }
  }

  /**
   * Fixes a joblink calendar column
   * @param  {String} index1 Html element
   * @param  {String} index2 Html element
   * @param  {String} name Html element
   * @return {Stirng} Elements height
   */
  function fixColumn(index1, index2, name) {
    var elem = document.getElementById("" + index1 + index2 + name + "");
    return elem ? "height: " + elem.offsetHeight + "px" : "";
  }

  /**
   * Loads daily inspections
   */
  function showDailyCal() {
    mod.start = 0;
    mod.end = 7;
    mod.view = "daily";
    updateShownMonth();
  }

  function setUnassigned() {
    var current = mod.unassignedCurrent;
    var next = mod.unassignedNext;
    var missed = mod.missedInspections;
    mod.unassignedInspections = current.concat(next, missed);
  }
}

},{"../../inspections/controllers/assigned.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/assigned.js","../../inspections/controllers/due.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/due.js","../../inspections/controllers/missed.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/missed.js","../../inspections/controllers/next.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/next.js","../../inspections/controllers/unassigned.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/inspections/controllers/unassigned.js","../models/map.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/jobboard/models/map.js","./moveInspection.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/jobboard/controllers/moveInspection.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/jobboard/controllers/moveInspection.js":[function(require,module,exports){
"use strict";

module.exports = moveInspection;

/**
 * Moves an joblink inspection
 * @param  {Object} insp Inspection data
 * @param  {Object} data
 */
function moveInspection(insp, data) {
  if (!_.isEmpty(data)) {
    if (insp.duration > 24 && data[0].assignationDate > insp.expirationDate) {
      return false;
    }
    var destEmployees = [];
    _.forEach(data, function(item) {
      destEmployees.push(item.assignedEmployees[0]);
    });
    var newInfo;
    var diffDest = _.difference(destEmployees, insp.assignedEmployees)[0]; //prev status
    var diffSource = _.difference(insp.assignedEmployees, destEmployees)[0]; //current status
    if (diffDest) {
      newInfo = _.find(data, function(elem) {
        return elem.assignedEmployees[0] === diffDest;
      });
      insp.assignedEmployees = _.without(insp.assignedEmployees, diffSource);
      insp.assignedEmployees.push(diffDest);
      insp.assignationDate = newInfo.assignationDate;
      insp.hour = newInfo.hour;
      insp.expirationDate = generateNewExpiration(insp);
      return insp;
    } else {
      //moved to a duplicated employee
      newInfo = _.find(data, function(item) {
        return item.assignationDate !== insp.assignationDate;
      });
      if (newInfo) {
        //if exists, it was moved to a different day
        insp.assignationDate = newInfo.assignationDate;
        insp.hour = newInfo.hour;
        insp.expirationDate = generateNewExpiration(insp);
        return insp;
      } else {
        //moved in the same table
        newInfo = _.find(data, function(item) {
          return item.hour !== insp.hour;
        });
        if (newInfo) {
          //if exists, it was moved to a different hour
          insp.hour = newInfo.hour;
          insp.expirationDate = generateNewExpiration(insp);
          return insp;
        }
        return {};
      }
    }
  }
  return false;
}

/**
 * Generates inspection new expiration date
 * @param  {Object} insp Inspection data
 * @return {String} Inspection expiration date
 */
function generateNewExpiration(insp) {
  if (insp.duration <= 24) {
    if (insp.hour + insp.duration > 49) {
      return moment(insp.assignationDate)
        .add(1, "day")
        .format("YYYY-MM-DD");
    }
    return insp.assignationDate;
  }
  return insp.expirationDate;
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/jobboard/index.js":[function(require,module,exports){
"use strict";

var _name = require("../../../package.json").name;

var mod = angular.module(_name + ".Jobboard", []);
mod.config(require("./routes"));

mod.controller("JobboardCtrl", require("./controllers/jobboardCtrl.js"));

mod.controller(
  "AssignInspectCtrl",
  require("./controllers/AssignInspecCtrl.js")
);

module.exports = mod;

},{"../../../package.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/package.json","./controllers/AssignInspecCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/jobboard/controllers/AssignInspecCtrl.js","./controllers/jobboardCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/jobboard/controllers/jobboardCtrl.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/jobboard/routes.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/jobboard/models/map.js":[function(require,module,exports){
"use strict";

function prepareLocations(employees) {
  for (var i = 0; i < employees.length; i += 1) {
    if (employees[i].location) {
      employees[i].location.id = employees[i].$id;
      employees[i].location.options = {
        label: employees[i].name,
        title: employees[i].name
      };
    }
  }
  return employees;
}

function generateMap() {
  return {
    center: { latitude: 40.7256134, longitude: -73.9851611 },
    zoom: 13,
    control: {},
    options: style
  };
}

function extractLocations(employees) {
  return _.compact(_.map(prepareLocations(employees), "location"));
}

var style = {
  disableDefaultUI: true,
  styles: [
    {
      stylers: [
        {
          hue: "#e43a45"
        },
        {
          visibility: "simplified"
        },
        {
          gamma: 0.5
        },
        {
          weight: 0.5
        }
      ]
    },
    {
      featureType: "water",
      stylers: [
        {
          color: "#2f353b"
        },
        {
          lightness: 20
        }
      ]
    }
  ]
};

exports.prepareLocations = prepareLocations;
exports.generateMap = generateMap;
exports.extractLocations = extractLocations;

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/jobboard/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;

routes.$inject = ["$stateProvider"];
function routes($stateProvider) {
  $stateProvider.state("index.jobboard", {
    templateUrl: "jobboard/views/index.html",
    url: "/jobboard",
    controller: "JobboardCtrl",
    controllerAs: "mod",
    resolve: {
      employees: getEmployees,
      currentInspections: getCurrentInspections,
      nextInspections: getNextInspections,
      lastInspections: getLastMonthInspections
    },
    data: {
      title: "JobLink Module",
      icon: "fa-list-alt",
      menu: "JOBLINK",
      role: "client"
    }
  });

  /**
   * Gets employees location data
   * @param  {} EmployeeAPI
   */
  getEmployees.$inject = ["EmployeeAPI"];
  function getEmployees(EmployeeAPI) {
    return EmployeeAPI.listWithGeo();
  }

  /**
   * Returns all inspections by month
   * @param  {Controller} InspectionAPI
   * @return {Array} Inspection list
   */
  getCurrentInspections.$inject = ["InspectionAPI"];
  function getCurrentInspections(InspectionAPI) {
    return InspectionAPI.listMonths();
  }

  /**
   * Returns all inspections done in the last month
   * @param  {Controller} InspectionAPI
   * @return {Array} Inspection list
   */
  getLastMonthInspections.$inject = ["InspectionAPI"];
  function getLastMonthInspections(InspectionAPI) {
    var date = moment().subtract(1, "M");
    return InspectionAPI.listMonth(date.year(), date.month());
  }

  /*getLastMonthInspections.$inject =  [ "InspectionAPI" ];
  function getLastMonthInspections( InspectionAPI ) {

    var inspectionsList = [];

    var currentYear = moment.year();

    for (var i = 4; i=0; i--)
    {
      for (var j = 0; j < 12; j++)
      {
        inspectionsList.push(InspectionAPI.listMonth( currentYear-i, j ));
      }
    }

  }*/

  /**
   * Returns next inspections
   * @param  {Controller} InspectionAPI
   * @return {Array} Inspections list
   */
  getNextInspections.$inject = ["InspectionAPI"];
  function getNextInspections(InspectionAPI) {
    var date = moment().add(1, "M");
    return InspectionAPI.listMonth(date.year(), date.month());
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/controllers/login.js":[function(require,module,exports){
"use strict";

module.exports = LoginCtrl;

var Client = require("../../clients/models/client.js");
var Access = require("../models/access.js");

LoginCtrl.$inject = [
  "$auth",
  "Notifications",
  "$state",
  "$sessionStorage",
  "$localStorage",
  "UserAPI",
  "ClientAPI",
  "cfpLoadingBar",
  "Validations",
  "$rootScope",
  "$timeout"
];
function LoginCtrl(
  $auth,
  Notifications,
  $state,
  $sessionStorage,
  $localStorage,
  UserAPI,
  ClientAPI,
  cfpLoadingBar,
  Validations,
  $rootScope,
  $timeout
) {
  var vm = this;
  vm.login = login;
  vm.user = {
    remember: true
  };
  vm.reset = false;
  vm.submitEmail = submitEmail;

  if (!$localStorage.alreadyClear) {
    $timeout(function() {
      // $sessionStorage.empty();
      $localStorage.$reset();
      try {
        localStorage.clear();
      } catch (exp) {}
      $localStorage.alreadyClear = true;
    }, 200);
  }
  /**
   * Allows user to login in the system
   * @param  {Form} form
   * @param  {Object} user User data
   */
  function login(form, user) {
    if (form.$valid) {
      cfpLoadingBar.start();
      $auth
        .login(user)
        .then(result, function(err) {
          loginError(err.data.message);
        })
        .catch(function(exp) {
          cfpLoadingBar.complete();
          Raven.captureException(exp);
          Notifications.addCustom(500, "Error logging in, please try again.");
        });
    } else {
      return Notifications.addCustom(400, "Required information missing ");
    }
  }

  /**
   * Sends an email to reset user password
   * @param  {Form} form
   * @param  {String} email User email
   */
  function submitEmail(form, email) {
    if (form.$valid) {
      cfpLoadingBar.start();
      UserAPI.resetPassword(email)
        .then(function() {
          vm.reset = !vm.reset;
        })
        .catch(function(err) {});
    }
  }

  /**
   * Notifies if there was an error when user logged in
   * @param  {String} msg Error message
   */
  function loginError(msg) {
    cfpLoadingBar.complete();
    Notifications.addCustom(200, msg);
  }

  /**
   * Verifies user login
   * @param  {} res
   */
  function result(res) {
    var data = res.data;
    UserAPI.isInspector(data.uid).then(function(is) {
      if (is) {
        loginError("These credentials are used for mobile login only.");
        return;
      } else {
        UserAPI.getAccess(data.uid)
          .then(function(resp) {
            if (resp.exists()) {
              var obj = resp.val();
              obj.token = data.token;
              obj.isClient = false;
              obj.email = vm.user.email;
              obj.$id = data.uid;
              var access = Access.loadObj(obj);
              $sessionStorage.user = access;
              $auth.setToken(data.token);
              if (vm.user.remember === true) {
                $localStorage.user = access;
              }
              setRaven(vm.user.email, data.uid);
              checkFirstTimer(obj, "index.customer-portal.inspections");
            } else {
              ClientAPI.getAccess(data.uid)
                .then(function(resp) {
                  if (resp && !resp.deactivated) {
                    resp.email = vm.user.email;
                    resp.token = data.token;
                    resp.$id = data.uid;
                    resp.isClient = true;
                    var user = Client.loadObj(resp);
                    $sessionStorage.user = user;
                    $auth.setToken(data.token);
                    if (vm.user.remember === true) {
                      $localStorage.user = user;
                    }

                    var nextState = "index.customers";
                    if (!Validations.checkPermission(user, "basic")) {
                      $rootScope.onlyFeatures = true;
                      if (vm.user.remember === true) {
                        $localStorage.user = $sessionStorage.user;
                      }

                      nextState = "index.client-one.payment";
                    }

                    setRaven(vm.user.email, data.uid);
                    checkFirstTimer(resp, nextState, {});
                    Notifications.addCustom(
                      200,
                      "Welcome " + user.firstName || ""
                    );
                  } else {
                    $auth.logout().then(function() {
                      loginError("Your account has been deactivated.");
                      $state.go("login");
                    });
                  }
                })
                .catch(function(exp) {
                  cfpLoadingBar.complete();
                  Raven.captureException(exp);
                  Notifications.addCustom(
                    500,
                    "Error logging in, please try again."
                  );
                });
            }
          })
          .catch(function(exp) {
            cfpLoadingBar.complete();
            Raven.captureException(exp);
            Notifications.addCustom(500, "Error logging in, please try again.");
          });
      }
    });
  }

  /**
   * Checks if it's user first time login
   * @param  {Object} obj User data
   * @param  {String} ruta System route
   * @param  {Object} param Parameters
   */
  function checkFirstTimer(obj, ruta, param) {
    if (obj.firstTime) {
      $state.go("terms");
      cfpLoadingBar.complete();
    } else {
      cfpLoadingBar.complete();
      $state.go(ruta, param).then(function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
      });
    }
  }

  /**
   * Raven library context for error logging
   * @param  {} email
   * @param  {} uid
   */
  function setRaven(email, uid) {
    Raven.setUserContext({
      email: email,
      id: uid
    });
  }
}

},{"../../clients/models/client.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/clients/models/client.js","../models/access.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/models/access.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/controllers/rest/userAPI.js":[function(require,module,exports){
"use strict";

module.exports = UserAPI;

UserAPI.$inject = ["$http", "urlApi", "Notifications", "$q", "urlNode"];
function UserAPI($http, urlApi, Notifications, $q, urlNode) {
  var ref = new Firebase(urlApi);
  UserAPI.login = login;
  UserAPI.getAccess = getAccess;
  UserAPI.createAccount = createAccount;
  UserAPI.changePassword = changePassword;
  UserAPI.resetPassword = resetPassword;
  UserAPI.removeUser = removeUser;
  UserAPI.editUser = editUser;
  UserAPI.isInspector = isInspector;
  return UserAPI;

  /**
   * Allows user to login in the system
   * @param  {String} email User email
   * @param  {String} password User password
   * @param  {String} remember Remember user
   */
  function login(email, password, remember) {
    var refaux = new Firebase("https://firelab-dev.firebaseio.com/");
    return function(callback) {
      return refaux.authWithPassword(
        {
          email: email,
          password: password
        },
        callback,
        {
          remember: remember
        }
      );
    };
  }

  /**
   * Gets user access
   * @param  {String} uid User id
   * @return {Object} Firebase response
   */
  function getAccess(uid) {
    var refAccess = ref.child("Access").child(uid);
    return refAccess.once("value", function(snap) {
      return snap;
    });
  }

  /**
   * Creates a new account
   * @param  {Object} credentials User credentials
   * @return {Promise}
   */
  function createAccount(credentials) {
    var future = $q.defer();
    $http
      .post(urlNode + "api/auth/signup", credentials, {
        ignoreLoadingBar: true
      })
      .then(
        function(res) {
          future.resolve(res.data);
        },
        function(err) {
          future.reject(err.data);
        }
      );
    return future.promise;
  }

  /**
   * Changes user password
   * @param  {Object} credentials User credentials
   * @return {Promise}
   */
  function changePassword(credentials) {
    var future = $q.defer();
    $http.post(urlNode + "api/auth/password/change", credentials).then(
      function(res) {
        Notifications.addCustom(200, res.data.message);
        future.resolve(res.data);
      },
      function(err) {
        Notifications.addCustom(400, err.data.message);
        future.reject(err.data);
      }
    );
    return future.promise;
  }

  /**
   * Resets user password
   * @param  {String} email User email
   * @return {Promise}
   */
  function resetPassword(email) {
    var future = $q.defer();
    $http.get(urlNode + "api/auth/password/reset/" + email).then(
      function(res) {
        Notifications.addCustom(
          200,
          "An email has been sent to your email address with your new password"
        );
        future.resolve(true);
      },
      function(err) {
        Notifications.addCustom(400, err.data.message);
        future.reject(err);
      }
    );
    return future.promise;
  }

  /**
   * Removes a user from the system
   * @param  {String} id User id
   * @return {Promise}
   */
  function removeUser(id) {
    var future = $q.defer();
    $http.delete(urlNode + "api/auth/remove/" + id).then(
      function(res) {
        future.resolve(res.data);
      },
      function(err) {
        future.reject(err.data);
      }
    );
    return future.promise;
  }

  /**
   * Edits user credentials
   * @param  {String} emails User emails
   * @param  {Boolean} ignoreLB
   * @return {Promise}
   */
  function editUser(emails, ignoreLB) {
    var future = $q.defer();
    $http
      .put(urlNode + "api/auth/edit/", emails, { ignoreLoadingBar: ignoreLB })
      .then(
        function(res) {
          future.resolve(res.data);
        },
        function(err) {
          future.reject(err.data);
        }
      );
    return future.promise;
  }

  /**
   * Return if a user is inspector
   * @param  {String} uid User id
   * @return {Boolean} True if is an inspector, False otherwise
   */
  function isInspector(uid) {
    return ref
      .child("Mobile")
      .child(uid)
      .once("value")
      .then(function(snap) {
        return snap.exists();
      });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/controllers/termsBlankCtrl.js":[function(require,module,exports){
"use strict";

module.exports = termsBlankCtrl;

termsBlankCtrl.$inject = [
  "$uibModal",
  "$sessionStorage",
  "$localStorage",
  "$state",
  "$auth",
  "cfpLoadingBar",
  "Notifications",
  "ClientAPI",
  "CustomerAPI"
];
function termsBlankCtrl(
  $uibModal,
  $sessionStorage,
  $localStorage,
  $state,
  $auth,
  cfpLoadingBar,
  Notifications,
  ClientAPI,
  CustomerAPI
) {


  var tb = this;
  tb.declineTerms = declineTerms;
  tb.showTerms = showTerms;
  tb.finishTerms = finishTerms;

  function declineTerms() {
    delete $sessionStorage.user;
    delete $localStorage.user;
    $auth.logout().then(function() {
      $state.go("login");
    });
  }

  function finishTerms() {
    if (!tb.agreeTerms || !tb.agreePrivacy) {
      Notifications.addCustom( 500, "You must accept the Terms of Agreement and Privacy Policy to continue." );
    } else if ($sessionStorage.user.isClient) {
      ClientAPI.changeFirstTimeUser();
      $state.go("index.customers").then(function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        cfpLoadingBar.complete();
      });
    } else {
      CustomerAPI.changeFirstTimeUser();
      $state.go("index.customer-portal.inspections").then(function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        cfpLoadingBar.complete();
      });
    }
  }

  /**
   * System terms and conditions
   */
  function showTerms() {
    var terms = $uibModal.open({
      templateUrl: "login/views/termsOfUse.html",
      controller: "termsCtrl",
      controllerAs: "vm",
      backdrop: true,
      keyboard: false,
      resolve: {
        client: function() {
          return $sessionStorage.user;
        }
      }
    });
    terms.result.then(function(result) {
      if (result) {
        if ($sessionStorage.user.isClient) {
          $state.go("index.customers").then(function() {
            $("html, body").animate({ scrollTop: 0 }, "slow");
            cfpLoadingBar.complete();
          });
        } else {
          $state.go("index.customer-portal.inspections").then(function() {
            $("html, body").animate({ scrollTop: 0 }, "slow");
            cfpLoadingBar.complete();
          });
        }
      }
    });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/controllers/termsCtrl.js":[function(require,module,exports){
"use strict";

module.exports = termsCtrl;

termsCtrl.$inject = [
  "$uibModalInstance",
  "client",
  "ClientAPI",
  "$location",
  "$auth",
  "$state",
  "$sessionStorage",
  "$localStorage",
  "CustomerAPI"
];
function termsCtrl(
  $uibModalInstance,
  client,
  ClientAPI,
  $location,
  $auth,
  $state,
  $sessionStorage,
  $localStorage,
  CustomerAPI
) {
  var vm = this;
  vm.client = client;
  vm.close = close;


  function close() {
    closePopup(false);
  }

  /**
   * Close modal
   * @param  {Boolean} boolean
   */
  function closePopup(boolean) {
    $uibModalInstance.close(boolean);
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/index.js":[function(require,module,exports){
"use strict";

var mod = angular.module("BaseProject.login", []);

mod.config(require("./routes"));

mod.controller("LoginCtrl", require("./controllers/login.js"));
mod.controller("termsCtrl", require("./controllers/termsCtrl.js"));
mod.controller("TermsBlankCtrl", require("./controllers/termsBlankCtrl.js"));

mod.factory("UserAPI", require("./controllers/rest/userAPI.js"));

module.exports = mod;

},{"./controllers/login.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/controllers/login.js","./controllers/rest/userAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/controllers/rest/userAPI.js","./controllers/termsBlankCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/controllers/termsBlankCtrl.js","./controllers/termsCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/controllers/termsCtrl.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/routes.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/models/access.js":[function(require,module,exports){
"use strict";

module.exports = Access;

function Access(clientId, customerId, email, token, isClient, expiresOn, $id) {
  this.clientId = clientId;
  this.customerId = customerId;
  this.email = email;
  this.token = token;
  this.isClient = isClient;
  this.expiresOn = expiresOn;
  this.$id = $id;
}

Access.loadObj = loadObj;

/*******************************************************  PUBLIC FUNCTIONS  */

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new Access(
    json.clientId,
    json.customerId,
    json.email,
    json.token,
    json.isClient,
    json.expiresOn,
    json.$id
  );
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/models/passwordGen.js":[function(require,module,exports){
"use strict";

module.exports = generatePassword;

var passwords = [
  "Antelope",
  "Barracuda",
  "Camel",
  "Deer",
  "Elephant",
  "Flamingo",
  "Gorilla",
  "Heron",
  "Jaguar",
  "Koala",
  "Lemur",
  "Moose"
];

function generatePassword() {
  var i = Math.floor(Math.random() * passwords.length);
  return passwords[i];
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/login/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;
routes.$inject = ["$stateProvider"];

function routes($stateProvider) {
  $stateProvider.state("login", {
    url: "/",
    templateUrl: "login/views/login.html",
    controller: "LoginCtrl",
    controllerAs: "vm",
    free: true
  });

  $stateProvider.state("terms", {
    url: "/terms",
    controller: "TermsBlankCtrl",
    controllerAs: "tb",
    templateUrl: "login/views/termsBlank.html",
    free: true,
    data: {}
  });

  $stateProvider.state("privacyPolicy", {
    url: "/privacy",
    templateUrl: "login/views/privacyPolicy.html",
    free: true
  });
} //routes

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/main/controllers/QRCtrl.js":[function(require,module,exports){
"use strict";

module.exports = QRCtrl;

QRCtrl.$inject = ["ReportAPI", "Notifications"];
function QRCtrl(ReportAPI, Notifications) {
  var mod = this;
  var qrPerSheet = 80;
  mod.codes = [];
  mod.generateQrs = generateQrs;
  mod.generatePDF = generatePDF;

  function generateRandomString(long) {}

  /**
   * Generates new qr codes
   * @param  {} sheets
   */
  function generateQrs(sheets) {
    //mod.codes = _.map( Array( qrPerSheet * sheets ), function() {
    //return UUID.generate();
    //  return "abcd12";
    // } );
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

    for (var i = 0; i < 6; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    mod.exampleQR = text;
  }

  /**
   * Generates new qr codes pdf
   * @param  {} codes
   */
  function generatePDF(codes) {
    ReportAPI.getQRPDF(mod.sheets * 80)
      .then(function(redirectUrl) {
        if (redirectUrl) window.location = redirectUrl;
        // var blob = new Blob( [ data ], { type: "application/pdf" } );
        // if ( window.navigator && window.navigator.msSaveOrOpenBlob ) {
        //   window.navigator.msSaveOrOpenBlob( blob, "qrcodes.pdf" );
        // } else {
        //   var url = URL.createObjectURL( blob );
        //   var downloadElement = document.createElement( "a" );
        //   downloadElement.href = url;
        //   downloadElement.target = "_blank";
        //   downloadElement.download = "qrcodes.pdf";
        //   downloadElement.click();
        // }
      })
      .catch(function(exp) {
        Raven.captureException(exp);
        Notifications.addCustom(500, "Error generating pdf, please try again.");
      });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/main/controllers/incompleteRepsCtrl.js":[function(require,module,exports){
"use strict";

module.exports = IncompleteRepsCtrl;

IncompleteRepsCtrl.$inject = [
  "incompleteReports",
  "employees",
  "ReportAPI",
  "cfpLoadingBar",
  "$state",
  "$scope"
];
function IncompleteRepsCtrl(
  incompleteReports,
  employees,
  ReportAPI,
  cfpLoadingBar,
  $state,
  $scope
) {
  var mod = this;
  mod.removeReport = removeReport;
  mod.employees = employees;
  mod.incompleteReports = flatten(incompleteReports);
  mod.goToRoute = goToRoute;

  function getEmployeeName(id) {
    var employee = _.find(mod.employees, function(employee) {
      return employee.$id === id;
    });
    return employee ? employee.name : "";
  }

  /**
   * Load incomplete report data
   * @param  {Array} reports Incomplete reports list
   */
  function flatten(reports) {
    var incompleteReports = [];
    cfpLoadingBar.start();
    _.forEach(reports, function(reportCust) {
      if (_.isObject(reportCust)) {
        _.forEach(reportCust, function(reportType, typeKey) {
          _.forEach(reportType, function(report, reportKey) {
            if (_.isObject(report)) {
              report.custId = reportCust.$id;
              report.$id = reportKey;
              report.type = typeKey;
              if (report.createdBy)
                report.startedBy = getEmployeeName(report.createdBy);
              if (report.modifiedBy)
                report.lastWorkedBy = getEmployeeName(report.modifiedBy);
              if (report.createdAt)
                report.createdAt = moment(report.createdAt).format(
                  "MM/DD/YYYY"
                );
              if (report.modifiedAt)
                report.modifiedAt = moment(report.modifiedAt).format(
                  "MM/DD/YYYY"
                );
              if (report.customerName) incompleteReports.push(report);
            }
          });
        });
      }
    });
    cfpLoadingBar.complete();
    return incompleteReports;
  }

  /**
   * Removes an incomplete report
   * @param  {} report
   */
  function removeReport(report) {
    if (confirm("Are you sure you want to delete this report?")) {
      ReportAPI.removeIncomplete(report);
    }
  }
  /**
   * Goes to incomplete report
   * @param  {Object} report Report data
   */
  function goToRoute(report) {
    var route = "index.customer-one.incomplete";

    if (report.type === "Custom" || report.isCustom) {
      route = "index.customer-one.custom-incomplete";
    }

    $state.go(route, {
      id: report.idCustomer,
      type: report.type,
      report: report.$id
    });
  }

  $scope.unwatch = incompleteReports.$watch(function() {
    mod.incompleteReports = flatten(incompleteReports);
  });

  $scope.$on('$locationChangeStart', function (event, next, current) {
    $scope.unwatch();
    if (next.includes('incomplete') && !next.includes('incomplete/')) {
      $scope.unwatch = incompleteReports.$watch(function() {
        mod.incompleteReports = flatten(incompleteReports);
      });
    }
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/main/controllers/logoCtrl.js":[function(require,module,exports){
"use strict";

module.exports = LogoCtrl;

LogoCtrl.$inject = ["logos", "$scope", "ImageAPI", "$sessionStorage"];
function LogoCtrl(logos, $scope, ImageAPI, $sessionStorage) {
  var mod = this;
  mod.companyLogo = logos ? logos._l : null;
  mod.imageAddress = logos ? logos._a : null;
  mod.editLogo = editLogo;
  mod.editImgAddress = editImgAddress;
  mod.deleteLogo = deleteLogo;

  $scope.$watch("mod.uploaded", function(value) {
    if (value) {
      mod.companyLogo = value;
      mod.firstActive = false;
      mod.secondActive = false;
    }
  });

  $scope.$watch("mod.uploadedAddress", function(value) {
    if (value) {
      mod.imageAddress = value;
      mod.firstActive = false;
      mod.secondActive = false;
    }
  });

  /**
   * Edits client logo
   */
  function editLogo() {
    mod.firstActive = true;
    mod.secondActive = false;
    mod.companyLogo = null;
  }

  /**
   * Edits image address logo
   */
  function editImgAddress() {
    mod.firstActive = false;
    mod.secondActive = true;
    mod.imageAddress = null;
  }

  /**
   * Removes logo image
   * @param  {} prefix
   */
  function deleteLogo(prefix) {
    if (confirm("Are you sure you want to delete this image?")) {
      ImageAPI.remove($sessionStorage.user.$id, prefix);
      switch (prefix) {
        case "_l":
          mod.companyLogo = null;
          break;
        case "_a":
          mod.imageAddress = null;
          break;
      }
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/main/controllers/mainCtrl.js":[function(require,module,exports){
"use strict";

module.exports = MainCtrl;

MainCtrl.$inject = [];
function MainCtrl() {
  var mod = this;
  mod.currentDate = moment();
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/main/controllers/rest/emailAPI.js":[function(require,module,exports){
"use strict";

module.exports = EmailAPI;

EmailAPI.$inject = ["Notifications", "$sessionStorage", "$http", "urlNode"];

function EmailAPI(Notifications, $sessionStorage, $http, urlNode) {
  var ref = urlNode + "api/email";
  EmailAPI.sendEmail = sendEmail;
  return EmailAPI;

  /**
   * Sends an email
   * @param  {Object} emailData Email data
   */
  function sendEmail(emailData) {
    return $http.post(ref, emailData).then(
      function(resp) {
        return resp;
      },
      function(err) {
        Notifications.addCustom(
          err.status,
          _.get(err.data, "message", "Email could not be sent.")
        );
        return err;
      }
    );
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/main/index.js":[function(require,module,exports){
"use strict";

var mod = angular.module("BaseProject.Main", []);
mod.config(require("./routes"));

mod.controller("MainCtrl", require("./controllers/mainCtrl.js"));
mod.controller("QRCtrl", require("./controllers/QRCtrl.js"));
mod.controller("LogoCtrl", require("./controllers/logoCtrl.js"));
mod.controller(
  "IncompleteRepsCtrl",
  require("./controllers/incompleteRepsCtrl.js")
);
mod.factory("EmailAPI", require("./controllers/rest/emailAPI.js"));

module.exports = mod;

},{"./controllers/QRCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/main/controllers/QRCtrl.js","./controllers/incompleteRepsCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/main/controllers/incompleteRepsCtrl.js","./controllers/logoCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/main/controllers/logoCtrl.js","./controllers/mainCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/main/controllers/mainCtrl.js","./controllers/rest/emailAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/main/controllers/rest/emailAPI.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/main/routes.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/main/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;

routes.$inject = ["$stateProvider"];
function routes($stateProvider) {
  $stateProvider.state("index.qrcodes", {
    templateUrl: "main/views/qrcodes.html",
    url: "/qrcodes",
    controller: "QRCtrl",
    controllerAs: "mod",
    data: {
      title: "QR Code Generator",
      icon: "fa-qrcode",
      menu: "QR Code Generator",
      role: "client"
    }
  });

  $stateProvider.state("index.logo", {
    templateUrl: "main/views/companyLogo.html",
    url: "/logo",
    controller: "LogoCtrl",
    controllerAs: "mod",
    resolve: {
      logos: getLogos
    },
    data: {
      title: "Company Logo",
      icon: "fa-picture-o",
      menu: "Company Logo",
      role: "client"
    }
  });

  $stateProvider.state("index.incomplete", {
    templateUrl: "main/views/incompleteReps.html",
    url: "/incomplete",
    controller: "IncompleteRepsCtrl",
    controllerAs: "mod",
    resolve: {
      incompleteReports: getIncompleteReps,
      employees: getEmployees
    },
    data: {
      title: "Incomplete Reports",
      icon: "fa-file-text-o",
      menu: "Incomplete Reports",
      role: "client"
    }
  });

  getCurrentInspecs.$inject = ["InspectionAPI"];
  function getCurrentInspecs(InspectionAPI) {
    return InspectionAPI.getInspecsFromCust(moment().month());
  }

  getNextInspections.$inject = ["InspectionAPI"];
  function getNextInspections(InspectionAPI) {
    return InspectionAPI.getInspecsFromCust(moment().add(1, "M"));
  }

  getCustomer.$inject = ["CustomerAPI"];
  function getCustomer(CustomerAPI) {
    return CustomerAPI.getFromCustomer();
  }

  getLogos.$inject = [
    "ImageAPI",
    "$sessionStorage",
    "cfpLoadingBar",
    "Notifications"
  ];
  function getLogos(ImageAPI, $sessionStorage, cfpLoadingBar, Notifications) {
    cfpLoadingBar.start();
    return ImageAPI.get($sessionStorage.user.$id)
      .then(function(logos) {
        cfpLoadingBar.complete();
        return logos;
      })
      .catch(function(exp) {
        cfpLoadingBar.complete();
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error retrieving company logos, please try again."
        );
      });
  }

  getIncompleteReps.$inject = ["ReportAPI"];
  function getIncompleteReps(ReportAPI) {
    return ReportAPI.getIncompleteReports();
  }

  getEmployees.$inject = ["EmployeeAPI"];
  function getEmployees(EmployeeAPI) {
    return EmployeeAPI.list();
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/controllers/downloadReport.js":[function(require,module,exports){
"use strict";

module.exports = Reporter;

function Reporter(
  reportp,
  customer,
  DeviceAPI,
  ImageAPI,
  ReportAPI,
  CustomerAPI,
  Notifications
) {
  var report = angular.copy(reportp);
  report.custInfo = customer.fb.custInfo;
  report.ownerInfo = customer.fb.ownerInfo;
  Reporter.download = download;
  Reporter.open = open;
  return Reporter;

  /**
   * Downloads a report
   */
  function download() {
    var name = report.type.replace(" ", "") + "Report.pdf";
    return initReport()
      .then(serveFile(name))
      .catch(function(exp) {
        Raven.captureException(exp);
        Notifications.addCustom(
          500,
          "Error download the report, please try again."
        );
      });
  }

  /**
   * Opens a dowloaded report
   * @param  {} where
   */
  function open(where) {
    return initReport().then(function(data) {
      //window.location = data.redirectUrl;
      //return serveFileToOpen( data, where );
    });
  }

  /**
   * Gets a pdf report
   */
  function initReport() {
    return DeviceAPI.getDevices(
      report.clientId,
      report.idCustomer,
      _.pluck(report.devices, "id")
    )
      .then(function(devices) {
        for (var i = 0; i < devices.length; i += 1) {
          devices[i].status = report.devices[i].status;
          devices[i].statusNote = report.devices[i].statusNote;

          devices[i].modifiedStatus = report.devices[i].modifiedStatus;

          if (report.devices[i].todayReading) {
            devices[i].todayReading = report.devices[i].todayReading;
          }
          if (report.devices[i].damper) {
            devices[i].damper = report.devices[i].damper;
          }
          if (report.devices[i].service) {
            devices[i].service = report.devices[i].service;
            devices[i].serviceOther = report.devices[i].serviceOther;
          }
        }
        report.devices = devices;
        CustomerAPI.get(report.clientId, report.idCustomer)
          .then(function (customer) {
            if (customer.fb.idParent) {
              CustomerAPI.get(report.clientId, customer.fb.idParent).then(function (parent) {
                report.ownerInfo = parent.fb.ownerInfo;
              });
            }
            ReportAPI.getPDF(report)
              .then(function(redirectUrl) {
                if (redirectUrl) window.location = redirectUrl;
              });
          })
          .catch(function(exp) {
            Notifications.addCustom(
              500,
              "Error downloading the report, please go back and try again."
            );
            Raven.captureException(exp);
          });
      })
      .catch(function(exp) {
        Raven.captureException(exp);
        // Notifications.addCustom(500, "Error getting report devices, please try again.");
      });
  }
}

/**
 * Opens the pdf file. Compatibility for IE
 * @param  {} name
 */
function serveFile(name) {
  function serveFileInner(data) {
    var blob = createBlob(data);
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //Checks if browser is IE
      window.navigator.msSaveOrOpenBlob(blob, name);
    } else {
      var url = URL.createObjectURL(blob);
      var elementoDescarga = document.createElement("a");
      document.body.appendChild(elementoDescarga);
      elementoDescarga.href = url;
      elementoDescarga.download = name;
      elementoDescarga.click();
    }
  }
  return serveFileInner;
}
/**
 * Helper function to read input data
 * @param  {} data
 * @param  {} where
 */
function serveFileToOpen(data, where) {
  var blob = createBlob(data);
  var reader = new FileReader();
  reader.onloadend = function() {
    window.open(reader.result, where);
  };
  reader.readAsDataURL(blob);
}

/**
 * Helper function to specify data type for pdf download
 * @param  {} data
 */
function createBlob(data) {
  return new Blob([data], {
    type: "application/pdf"
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/controllers/pdfCtrl.js":[function(require,module,exports){
"use strict";

module.exports = PDFCtrl;

PDFCtrl.$inject = [
  "DeviceAPI",
  "CustomerAPI",
  "ImageAPI",
  "ReportAPI",
  "UserAPI",
  "$auth",
  "$state",
  "$localStorage",
  "Notifications"
];

function PDFCtrl(
  DeviceAPI,
  CustomerAPI,
  ImageAPI,
  ReportAPI,
  UserAPI,
  $auth,
  $state,
  $localStorage,
  Notifications
) {
  /*if ( !$localStorage.user ) {
    return UserAPI.login( "daemon@firelab.com", "daemonfire", false )( function( error ) {
      if ( error ) {
        return alert( "Unable to connect to database, please try again" );
      }
      return openPDF();
    } );
  }*/

  /**
   * Opens a pdf report
   */
  function openPDF() {
    CustomerAPI.get($state.params.idClient, $state.params.idCustomer)
      .then(function(customer) {
        ReportAPI.get(
          $state.params.idClient,
          $state.params.idCustomer,
          $state.params.idType,
          $state.params.idReport
        )
          .then(function(report) {
            var Reporter = require("./downloadReport.js")(
              report.fb,
              customer,
              DeviceAPI,
              ImageAPI,
              ReportAPI,
              CustomerAPI,
              Notifications
            );
            Reporter.open("_self");
          })
          .catch(function(exp) {
            Raven.captureException(exp);
            Notifications.addCustom(
              500,
              "Error loading reports, please try again."
            );
          });
      })
      .catch(function(exp) {
        Raven.captureException(exp);
        Notifications.addCustom(500, "Error opening pdf, please try again.");
      });
  }

  openPDF();
}

},{"./downloadReport.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/controllers/downloadReport.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/controllers/reportsCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ReportsCtrl;

ReportsCtrl.$inject = [];
function ReportsCtrl() {
  var mod = this;
  mod.currentDate = moment();
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/controllers/rest/deviceAPI.js":[function(require,module,exports){
"use strict";

module.exports = DeviceAPI;

DeviceAPI.$inject = ["urlApi", "$firebaseObject", "$q", "$firebaseArray"];

function DeviceAPI(urlApi, $firebaseObject, $q, $firebaseArray) {
  var ref = new Firebase(urlApi + "Devices/");
  DeviceAPI.removeCustDevices = removeCustDevices;
  DeviceAPI.getDevices = getDevices;
  DeviceAPI.getDevice = getDevice;
  DeviceAPI.getDeviceFbObj = getDeviceFbObj;
  DeviceAPI.getDevicesGroups = getDevicesGroups;
  return DeviceAPI;

  /**
   * Returns devices group
   * @param  {String} idClient Client id
   * @param  {String} idCustomer Customer id
   * @param  {String} type Report type
   * @return {Array} Devices groups list
   */
  function getDevicesGroups(idClient, idCustomer, type) {
    var deviceRef = ref.child(idClient).child(idCustomer);
    return $firebaseArray(deviceRef).$loaded(function(resp) {
      var hashReturn = {};
      for (var i = 0; i < resp.length; i++) {
        var device = resp[i];

        if (device.groupDevice && device.reportType == type) {
          if (
            hashReturn[device.groupDevice] &&
            hashReturn[device.groupDevice].length > 0
          ) {
            hashReturn[device.groupDevice].push(device);
          } else {
            hashReturn[device.groupDevice] = [];
            hashReturn[device.groupDevice].push(device);
          }
        }
      }

      return hashReturn;
    });
  }

  /**
   * Removes customer devices
   * @param  {String} idClient Client id
   * @param  {String} idCustomer Customer id
   */
  function removeCustDevices(idClient, idCustomer) {
    var devRef = ref.child(idClient).child(idCustomer);
    return devRef.remove(function(err) {
      if (err) {
        return err;
      }
      return true;
    });
  }

  /**
   * Returns customer devices
   * @param  {String} idClient Client id
   * @param  {String} idCustomer Customer id
   * @param  {Array} ids Ids devices
   * @return {Array} Customer devices list
   */
  function getDevices(idClient, idCustomer, ids) {
    var devices = [];
    var devRef;
    var deferred = $q.defer();
    _.forEach(ids, function(id) {
      devRef = $firebaseObject(
        ref
          .child(idClient)
          .child(idCustomer)
          .child(id)
      ).$loaded();
      devices.push(devRef);
    });
    $q.all(devices).then(
      function(results) {
        deferred.resolve(_.flatten(results));
      },
      function(errors) {
        deferred.reject(errors);
      }
    );
    return deferred.promise;
  }

  /**
   * Returns a report devices
   * @param  {String} idClient Client id
   * @param  {String} idCustomer Customer id
   * @param  {String} tReport Report type
   * @param  {String} id Report id
   */
  function getDevice(idClient, idCustomer, tReport, id) {
    return $firebaseObject(
      ref
        .child(idClient)
        .child(idCustomer)
        .child(tReport)
        .child(id)
    ).$loaded(function(resp) {
      return resp;
    });
  }

  /**
   * Loads device obj data
   * @param  {} ref
   */
  function getDeviceFbObj(ref) {
    var deferred = $q.defer();
    var promise = deferred.promise;
    $q.resolve(
      $firebaseObject(ref).$loaded(function(resp) {
        deferred.resolve(resp);
      })
    );
    return promise;
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/controllers/rest/imageAPI.js":[function(require,module,exports){
"use strict";

module.exports = ImageAPI;

ImageAPI.$inject = ["urlApi", "$firebaseObject"];

function ImageAPI(urlApi, $firebaseObject) {
  var ref = new Firebase(urlApi);
  ImageAPI.download = download;
  ImageAPI.upload = upload;
  ImageAPI.get = get;
  ImageAPI.remove = remove;
  return ImageAPI;

  function download(idReport) {
    return $firebaseObject(ref.child("Images").child(idReport)).$loaded(
      function(resp) {
        return resp;
      }
    );
  }

  /**
   * Uploads a logo
   * @param  {String} img Image src
   * @param  {String} suffix Suffix
   * @param  {String} idClient Client id
   */
  function upload(img, suffix, idClient) {
    var query = ref
      .child("Logos")
      .child(idClient)
      .child(suffix);
    return query.set(img).then(
      function() {
        return { success: true };
      },
      function() {
        return { success: false };
      }
    );
  }

  /**
   * Returns client logo image
   * @param  {String} idClient Client id
   * @return {String} Logo image src
   */
  function get(idClient) {
    var query = ref.child("Logos").child(idClient);
    return query.once("value").then(function(snap) {
      return snap.val();
    });
  }

  /**
   * Removes a logo image
   * @param  {String} idClient Client id
   * @param  {String} prefix Prefix
   */
  function remove(idClient, prefix) {
    var query = ref
      .child("Logos")
      .child(idClient)
      .child(prefix);
    query.remove();
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/controllers/rest/reportAPI.js":[function(require,module,exports){
"use strict";

module.exports = ReportAPI;

var EmergencyExit = require("../../models/emergencyExit.js");
var Hydrant = require("../../models/hydrant.js");
var Sensitivity = require("../../models/sensitivity.js");
var GreaseCleaning = require("../../models/greaseCleaning.js");
var Backflow = require("../../models/backflow.js");
var Monitoring = require("../../models/monitoring.js");
var SpecialHazard = require("../../models/specialHazard.js");
var HoodSystem = require("../../models/hoodSystem.js");
var Extinguisher = require("../../models/extinguisher.js");
var StandPipe = require("../../models/standpipe.js");
var Alarm = require("../../models/alarm.js");
var Suppression = require("../../models/suppression.js");
var WorkOrder = require("../../models/suppression.js");
var Sprinkler = require("../../models/sprinkler.js");
var Pump = require("../../models/pump.js");
var Custom = require("../../models/custom.js");

ReportAPI.$inject = [
  "urlApi",
  "$firebaseArray",
  "$firebaseObject",
  "Notifications",
  "$sessionStorage",
  "$http",
  "urlNode"
];

function ReportAPI(
  urlApi,
  $firebaseArray,
  $firebaseObject,
  Notifications,
  $sessionStorage,
  $http,
  urlNode
) {
  var ref = new Firebase(urlApi);
  var urlReports = urlNode + "api/reports/";
  var reportMap = {
    "Emergency Exit": EmergencyExit,
    "Fire Hydrant": Hydrant,
    Sensitivity: Sensitivity,
    "Grease Cleaning": GreaseCleaning,
    "Back Flow": Backflow,
    Monitoring: Monitoring,
    "Special Hazard": SpecialHazard,
    "Hood System": HoodSystem,
    Extinguisher: Extinguisher,
    "Standpipe Hose": StandPipe,
    Alarm: Alarm,
    Sprinkler: Sprinkler,
    Suppression: Suppression,
    "Fire Pump": Pump,
    "Work Order": WorkOrder,
    Quote: WorkOrder,
    Custom: Custom
  };
  ReportAPI.get = get;
  ReportAPI.save = save;
  ReportAPI.remove = remove;
  ReportAPI.removev1 = removev1;
  ReportAPI.edit = edit;
  ReportAPI.listCustomerReports = listCustomerReports;
  ReportAPI.listCustomerV1Reports = listCustomerV1Reports;
  ReportAPI.getPDF = getPDF;
  ReportAPI.listFromCustomer = listFromCustomer;
  ReportAPI.getIncompleteReports = getIncompleteReports;
  ReportAPI.getIncomplete = getIncomplete;
  ReportAPI.removeIncomplete = removeIncomplete;
  ReportAPI.getQRPDF = getQRPDF;
  ReportAPI.removeCustIncompletes = removeCustIncompletes;
  ReportAPI.removeCustReports = removeCustReports;
  ReportAPI.getWorkOrders = getWorkOrders;
  ReportAPI.getV1WorkOrders = getV1WorkOrders;
  ReportAPI.saveDevicesTested = saveDevicesTested;
  ReportAPI.removeDeviceTested = removeDeviceTested;
  ReportAPI.getTemplate = getTemplate;
  ReportAPI.getTemplates = getTemplates;
  ReportAPI.getDeviceTypes = getDeviceTypes;
  ReportAPI.saveNewDeviceType = saveNewDeviceType;
  return ReportAPI;

  /**
   * Return all client customers incomplete reports
   * @return {Array} Incomplete reports
   */
  function getIncompleteReports() {
    var query = ref.child("Incomplete").child($sessionStorage.user.$id);
    return $firebaseArray(query).$loaded(function(resp) {
      return resp;
    });
  }

  /**
   * Returns customer complete reports (only one report type)
   * @param  {String} custId Customer id
   * @param  {String} reportType Report type
   * @return {Array} Complete report list
   */
  function listCustomerReports(custId, reportType) {
    var query = ref
      .child("Reports")
      .child($sessionStorage.user.$id)
      .child(custId)
      .child(reportType);
    return $firebaseArray(query).$loaded(function(resp) {
      return resp;
    });
  }

  /**
   * Returns customer complete v1 reports (only one report type)
   * @param  {String} custId Customer id
   * @param  {String} reportType Report type
   * @return {Array} Complete v1 report list
   */
  function listCustomerV1Reports(custId, reportType) {
    var query = ref
      .child("v1Reports")
      .child($sessionStorage.user.$id)
      .child(custId)
      .child(reportType);
    return $firebaseArray(query).$loaded(function(resp) {
      return resp;
    });
  }

  /**
   * Returns a report pdf url
   * @param  {Object} report Report data
   * @return {String} Pdf url
   */
  function getPDF(report) {
    if (report.$id === "-LWHsGkQw6Crm4uou6Ez") {
      return Promise.resolve("/spdf/-LWHsGkQw6Crm4uou6Ez_2019-01-21T18:44:57.327Z.pdf");
    }
    return $http.post(urlReports, report).then(
      function(resp) {
        return resp.data.redirectUrl;
      },
      function() {
        Notifications.add(404);
      }
    );
  }

  /**
   * Returns a qr code pdf
   * @param  {Number} numberQR QR number
   * @return {String} Pdf url
   */
  function getQRPDF(numberQR) {
    return $http
      .post(urlReports + "qrcodes", {
        numberQR: numberQR,
        clientId: $sessionStorage.user.$id
      })
      .then(
        function(resp) {
          return resp.data.redirectUrl;
        },
        function() {
          Notifications.add(404);
        }
      );
  }

  /**
   * Returns a customer report list of a type
   * @param  {String} type Report type
   * @return {Array} Report list
   */
  function listFromCustomer(type) {
    var query = ref
      .child("Reports")
      .child($sessionStorage.user.clientId)
      .child($sessionStorage.currentCustomer.$id)
      .child(type);
    return $firebaseArray(query).$loaded(function(resp) {
      return resp;
    });
  }

  /**
   * Return a report
   * @param  {String} pref Firebase url
   * @param  {String} id Report id
   * @return {Object} Report data
   */
  function getReport(pref, id) {
    return function getFBData(Instantiator) {
      if (id) {
        return $firebaseObject(pref.child(id))
          .$loaded(Instantiator.loadObj)
          .then(function(resp) {
            return resp;
          });
      } else {
        return new Instantiator();
      }
    };
  }

  /**
   * Returns report data
   * @param  {String} idClient Client id
   * @param  {String} custId Customer id
   * @param  {String} reportType Report type
   * @param  {String} id Report id
   * @return {Object} Report data
   */
  function get(idClient, custId, reportType, id) {
    var childRef = ref
      .child("Reports")
      .child(idClient)
      .child(custId)
      .child(reportType);
    var report = getReport(childRef, id);
    return report(reportMap[reportType]);
  }

  /**
   * Removes a report
   * @param  {String} idClient Client id
   * @param  {String} custId Customer id
   * @param  {Object} obj Report data
   */
  function remove(idClient, custId, obj) {
    var reportRef = ref
      .child("Reports")
      .child(idClient)
      .child(custId)
      .child(obj.type)
      .child(obj.$id);
    return reportRef.remove(function(err) {
      if (err) {
        Notifications.addCustom(500, "There was a problem.");
        return err;
      } else {
        Notifications.addCustom(200, "Report deleted successfully");
        var imgRef = new Firebase(urlApi).child("Images/").child(obj.$id);
        imgRef.remove();
        return true;
      }
    });
  }

  /**
   * Removes a v1 report
   * @param  {String} idClient Client id
   * @param  {String} custId Customer id
   * @param  {Object} obj Report data
   */
  function removev1(idClient, custId, obj) {
    var reportRef = ref
      .child("v1Reports")
      .child(idClient)
      .child(custId)
      .child(obj.type)
      .child(obj.$id);
    return reportRef.remove(function(err) {
      if (err) {
        Notifications.addCustom(500, "There was a problem.");
        return err;
      } else {
        Notifications.addCustom(200, "Report deleted successfully");
        return true;
      }
    });
  }

  /**
   * Returns an incomplete report
   * @param  {String} custId Customer id
   * @param  {String} reportId Report id
   * @param  {String} reportType Report type
   * @return {Object} Report data
   */
  function getIncomplete(custId, reportId, reportType) {
    var childRef = ref
      .child("Incomplete")
      .child($sessionStorage.user.$id)
      .child(custId)
      .child(reportType);

    var report = getReport(childRef, reportId);
    return report(reportMap[reportType]);
  }

  /**
   * Removes an incomplete report
   * @param  {Object} obj Report data
   */
  function removeIncomplete(obj) {
    return ReportAPI.getIncomplete(obj.custId, obj.$id, obj.type).then(function(
      resp
    ) {
      resp.fb.$remove().then(ok, error);
    });

    function ok(resp) {
      Notifications.addCustom(200, "Report deleted successfully");
      return resp;
    }

    function error(resp) {
      Notifications.addCustom(500, "There was a problem.");
      return resp;
    }
  }

  /**
   * Saves a report
   * @param  {Object} obj Report data
   * @return {Object} Firebase report id
   */
  function save(obj) {
    if (obj.$id) {
      return edit(obj);
    } else {
      return create(obj);
    }
  }

  /**
   * Creates incomplete report
   * @param  {Object} obj Report data
   * @return {String} Report id
   */
  function create(obj) {
    var query = ref
      .child("Incomplete")
      .child($sessionStorage.user.$id)
      .child(obj.idCustomer)
      .child(obj.type);

    return $firebaseArray(query)
      .$add(obj)
      .then(ok);

    function ok(resp) {
      return resp.key();
    }
  }

  /**
   * Edits a report
   * @param  {Object} obj
   */
  function edit(obj) {
    return obj.$save().then(ok, error);
    function ok(resp) {
      Notifications.addCustom(200, "Report saved successfully");
      return resp.key();
    }

    function error(resp) {
      Notifications.addCustom(500, "There was a problem.");
      return resp;
    }
  }

  /**
   * Removes all customer incomplete reports
   * @param  {String} idClient Client id
   * @param  {String} idCustomer Customer id
   */
  function removeCustIncompletes(idClient, idCustomer) {
    var incRef = ref
      .child("Incomplete")
      .child(idClient)
      .child(idCustomer);
    return incRef.remove(function(err) {
      if (err) {
        return err;
      }
      return true;
    });
  }

  /**
   * Removes all customer completed reports
   * @param  {String} idClient Client id
   * @param  {String} idCustomer Customer id
   */
  function removeCustReports(idClient, idCustomer) {
    var repRef = ref
      .child("Reports")
      .child(idClient)
      .child(idCustomer);
    return repRef.remove(function(err) {
      if (err) {
        return err;
      }
      return true;
    });
  }

  /**
   * Returns all customer work orders
   * @param  {String} idClient Client id
   * @param  {String} idCustomer Customer id
   * @param  {Object} params Work order data
   * @return {Array} Work order list
   */
  function getWorkOrders(idClient, idCustomer, params) {
    var query = ref
      .child("Reports")
      .child(idClient)
      .child(idCustomer)
      .child(params.type)
      .orderByChild("woType")
      .equalTo(params.subType);
    return $firebaseArray(query).$loaded(function(data) {
      return data;
    });
  }

  /**
   * Returns all customer v1 work orders
   * @param  {String} idClient Client id
   * @param  {String} idCustomer Customer id
   * @param  {Object} params Work order data
   * @return {Array} Work order list
   */
  function getV1WorkOrders(idClient, idCustomer, params) {
    var query = ref
      .child("v1Reports")
      .child(idClient)
      .child(idCustomer)
      .child(params.type)
      .orderByChild("woType")
      .equalTo(params.subType);
    return $firebaseArray(query).$loaded(function(data) {
      return data;
    });
  }

  /**
   * Returns a report template (custom report)
   * @param  {String} templateId Template report id
   * @return {Object} Template report data
   */
  function getTemplate(templateId) {
    var query = ref.child("ReportTemplate").child(templateId);

    return $firebaseObject(query).$loaded(function(data) {
      return data;
    });
  }

  /**
   * Returns report templates of a type
   * @param  {String} type Template type
   * @return {Array} Template reports list
   */
  function getTemplates(type) {
    var childRef = ref.child("ReportTemplate");

    return $firebaseArray(childRef).$loaded(function(data) {
      return data;
    });
  }

  function saveDevicesTested(report, devices, typeDevice) {
    var obj = ref
      .child("DevicesTested")
      .child(report.fb.clientId)
      .child(report.fb.idCustomer)
      .child(report.fb.type);

    return $firebaseObject(obj).$loaded(function (deviceList) {
      var thisyear = moment().format("YYYY");
      if (!deviceList[thisyear]) {
        deviceList[thisyear] = [];
      }

      var year = deviceList[thisyear];

      if (year && year.length > 0) {
        for (var i = 0; i < devices.length; i++) {
          var found = false;
          for (var j = 0; j < year.length && !found; j++) {
            if (typeDevice === "Devices") {
              if (year[j].id === devices[i].$id) {
                found = devices[i];
                year[i].type = devices[i].type;
              }
            } else {
              //Extinguishers: Serial number is 'id'
              if (year[j].id === devices[i].serialNumber) {
                found = devices[i];
                year[i].type = devices[i].type;
              }
            }
          }
          if (!found) {
            var obj = {
              id:
                typeDevice === "Devices"
                  ? devices[i].$id
                  : devices[i].serialNumber,
              type: devices[i].type
            };
            if (devices[i].type === "Other") {
              obj.typeOther = devices[i].typeOther;
            }
            if (devices[i].group) {
              obj.quantity = devices[i].quantity ? devices[i].quantity : 0;
            }
            year.push(obj);
          }
        }
        deviceList[thisyear] = year;
        deviceList.$save();
      } else {
        year = [];

        for (var i = 0; i < devices.length; i++) {
          var obj = {
            id:
              typeDevice === "Devices"
                ? devices[i].$id
                : devices[i].serialNumber,
            type: devices[i].type
          };
          if (devices[i].typeOther) {
            obj.typeOther = devices[i].typeOther;
          }
          if (devices[i].group) {
            obj.quantity = devices[i].quantity ? devices[i].quantity : 0;
          }
          year.push(obj);
        }
        deviceList[thisyear] = year;
        deviceList.$save();
      }
    });
  }

  function removeDeviceTested(type, device, report) {
    var obj = ref
      .child("DevicesTested")
      .child(report.fb.clientId)
      .child(report.fb.idCustomer)
      .child(report.fb.type);

    return $firebaseObject(obj).$loaded(function (deviceList) {
      var thisyear = moment().format("YYYY");
      if (!deviceList[thisyear]) {
        deviceList[thisyear] = [];
      }
      if (type === "Device") {
        _.remove(deviceList[thisyear], { id: device.$id });
      } else {
        _.remove(deviceList[thisyear], { id: device.serialNumber });
      }
      deviceList.$save();
    });
  }

  function saveNewDeviceType(reportType, clientId, deviceType) {
    var query = ref
      .child("Clients")
      .child(clientId)
      .child("deviceTypes")
      .child(reportType);
    return $firebaseArray(query).$loaded(function (types) {
      var typeFound = _.find(types, { $value: deviceType });
      if (!typeFound) {
        types.$add(deviceType);
      }
    });
  }

  function getDeviceTypes(reportType, clientId) {
    var query = ref
      .child("Clients")
      .child(clientId)
      .child("deviceTypes")
      .child(reportType);
    return $firebaseArray(query).$loaded(function(types) {
      return types.map(function (type) {
        return type.$value;
      });
    });
  }
}

},{"../../models/alarm.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/alarm.js","../../models/backflow.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/backflow.js","../../models/custom.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/custom.js","../../models/emergencyExit.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/emergencyExit.js","../../models/extinguisher.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/extinguisher.js","../../models/greaseCleaning.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/greaseCleaning.js","../../models/hoodSystem.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/hoodSystem.js","../../models/hydrant.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/hydrant.js","../../models/monitoring.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/monitoring.js","../../models/pump.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/pump.js","../../models/sensitivity.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/sensitivity.js","../../models/specialHazard.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/specialHazard.js","../../models/sprinkler.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/sprinkler.js","../../models/standpipe.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/standpipe.js","../../models/suppression.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/suppression.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/index.js":[function(require,module,exports){
"use strict";

var _name = require("../../../package.json").name;

var mod = angular.module(_name + ".Reports", []);
mod.config(require("./routes"));

mod.controller("ReportsCtrl", require("./controllers/reportsCtrl.js"));
mod.controller("PDFCtrl", require("./controllers/pdfCtrl.js"));
mod.factory("ImageAPI", require("./controllers/rest/imageAPI.js"));
mod.factory("ReportAPI", require("./controllers/rest/reportAPI.js"));
mod.factory("DeviceAPI", require("./controllers/rest/deviceAPI.js"));

module.exports = mod;

},{"../../../package.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/package.json","./controllers/pdfCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/controllers/pdfCtrl.js","./controllers/reportsCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/controllers/reportsCtrl.js","./controllers/rest/deviceAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/controllers/rest/deviceAPI.js","./controllers/rest/imageAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/controllers/rest/imageAPI.js","./controllers/rest/reportAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/controllers/rest/reportAPI.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/routes.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/alarm.js":[function(require,module,exports){
"use strict";

module.exports = Alarm;

function Alarm(fb) {
  this.fb = fb || {};
}

Alarm.loadObj = loadObj;
Alarm.prototype.addAnnunciator = addAnnunciator;
Alarm.prototype.removeAnnunciators = removeAnnunciators;
Alarm.prototype.addPanel = addPanel;
Alarm.prototype.addAnunciatorInPosition = addAnunciatorInPosition;
Alarm.prototype.removeAnnunciatorsAfter = removeAnnunciatorsAfter;

function removeAnnunciators(panel) {
  panel.annunciators = [];
}

function addAnunciatorInPosition(panel, position) {
  if (!panel.annunciators) panel.annunciators = [];

  if (panel.annunciators.length == position + 1) {
    panel.annunciators.push({ createdAt: moment().format("YYYY-MM-DD") });
  }
}

function removeAnnunciatorsAfter(panel, position) {
  if (!panel.annunciators) panel.annunciators = [];

  if (panel.annunciators.length > position + 1) {
    panel.annunciators.splice(
      position + 1,
      panel.annunciators.length - position - 1
    );
  }
}

function addPanel() {
  if (!this.fb.controlPanels) {
    this.fb.controlPanels = [];
  }
  this.fb.controlPanels.push({ createdAt: moment().format("YYYY-MM-DD") });
}

function addAnnunciator(panel) {
  if (!panel.annunciators) {
    panel.annunciators = [];
  }
  panel.annunciators.push({ createdAt: moment().format("YYYY-MM-DD") });
  panel.anotherAnnunciator = "";
}

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new Alarm(json);
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/backflow.js":[function(require,module,exports){
"use strict";

module.exports = Backflow;

function Backflow(fb) {
  this.fb = fb || {};
}

Backflow.loadObj = loadObj;
Backflow.prototype.cleanSection = cleanSection;

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new Backflow(json);
}

function cleanSection(option) {
  switch (option) {
    case "radio1":
      this.fb.airInlet = null;
      this.fb.airInletPsid = null;
      this.fb.ckValve = null;
      this.fb.ckValvePsid = null;
      this.fb.ckValveFinalPsid = null;
      this.fb.ckValveBufferPsi = null;
      this.fb.ckValveRepairsMade = null;
      break;
    case "radio3":
      this.fb.reliefValve = null;
      this.fb.psid = null;
      this.fb.finalPsid = null;
      this.fb.repairsMade1st = null;
      this.fb.checkValve1st = null;
      this.fb.psid1st = null;
      this.fb.finalPsid1st = null;
      this.fb.bufferPsi1st = null;
      this.fb.checkValve2nd = null;
      this.fb.psid2nd = null;
      this.fb.finalPsid2nd = null;
      this.fb.bufferPsi2nd = null;
      this.fb.repairsMade2nd = null;
      break;
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/custom.js":[function(require,module,exports){
"use strict";

module.exports = Custom;

function Custom(fb) {
  this.fb = fb || {};
}

Custom.loadObj = loadObj;

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new Custom(json);
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/emergencyExit.js":[function(require,module,exports){
"use strict";

module.exports = EmergencyExit;

function EmergencyExit(fb) {
  this.fb = fb || {};
}

EmergencyExit.loadObj = loadObj;

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new EmergencyExit(json);
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/extinguisher.js":[function(require,module,exports){
"use strict";

module.exports = Extinguisher;

function Extinguisher(fb) {
  this.fb = fb || {};
}

Extinguisher.loadObj = loadObj;
Extinguisher.prototype.addNewDevice = addNewDevice;
Extinguisher.prototype.addNewPart = addNewPart;

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new Extinguisher(json);
}

function addNewDevice() {
  if (!this.fb.extinguishers) {
    this.fb.extinguishers = [];
  }
  this.fb.extinguishers.push({
    location: null,
    size: null,
    manufactureDate: null,
    dueDate6years: null,
    dueDateHydrotest: null,
    type: null,
    servicePerformed: null,
    floor: 'N/A',
    date: moment().toString()
  });
}

function addNewPart(part) {
  if (!this.fb.parts) {
    this.fb.parts = [];
  }
  if (this.fb.partsType) part.type = this.fb.partsType;
  else this.fb.partsType = part.type;

  if (this.fb.partsType == "group") {
    this.fb.parts.push(part);
  } else {
    if (this.fb.extinguishers) {
      if (!this.fb.extinguishers[part.ex].parts) {
        this.fb.extinguishers[part.ex].parts = [];
      }

      this.fb.extinguishers[part.ex].parts.push(part);
    }
  }
}

function getExtinguisherFromId() {}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/greaseCleaning.js":[function(require,module,exports){
"use strict";

module.exports = GreaseCleaning;

function GreaseCleaning(fb) {
  this.fb = fb || {};
}

GreaseCleaning.loadObj = loadObj;

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new GreaseCleaning(json);
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/hoodSystem.js":[function(require,module,exports){
"use strict";

module.exports = HoodSystem;

function HoodSystem(fb) {
  this.fb = fb || {};
}

HoodSystem.loadObj = loadObj;
HoodSystem.prototype.removeMonitoringInfo = removeMonitoringInfo;
HoodSystem.prototype.openCalendar = openCalendar;
HoodSystem.prototype.addCylinder = addCylinder;

function openCalendar(input) {
  var a = document.getElementById(input);
  angular.element(a).triggerHandler("click");
}

function removeMonitoringInfo() {
  this.fb.monitoringPhone = null;
  this.fb.monitoringAccNum = null;
}

function addCylinder() {
  if (!this.fb.cylinders) {
    this.fb.cylinders = [];
  }
  this.fb.cylinders.push({ createdAt: moment().format("YYYY-MM-DD") });
}

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new HoodSystem(json);
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/hydrant.js":[function(require,module,exports){
"use strict";

/*
module.exports = Customer;
function Customer( fb ) {
  this.fb = fb || {};
}
Customer.loadObj = loadObj;

function loadObj( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instance( elem );
      } );
    } else {
      return instance( json );
    }
  }
}

function instance( json ) {
  return new Customer( json );
}

*/

module.exports = Hydrant;

function Hydrant(fb) {
  this.fb = fb || {};
}

Hydrant.loadObj = loadObj;
Hydrant.prototype.addHydrant = addHydrant;

function addHydrant() {
  if (!this.fb.hydrants) {
    this.fb.hydrants = [];
  }
  this.fb.hydrants.push({ createdAt: moment().format("YYYY-MM-DD") });
}

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new Hydrant(json);
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/monitoring.js":[function(require,module,exports){
"use strict";

module.exports = Monitoring;

function Monitoring(fb) {
  this.fb = fb || {};
}

Monitoring.loadObj = loadObj;
Monitoring.prototype.addDevice = addDevice;

function addDevice(deviceType) {
  if (!this.fb.devices) {
    this.fb.devices = [];
  }
  this.fb.devices.push({
    createdAt: moment().format("YYYY-MM-DD"),
    type: deviceType,
    name: null
  });
}

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new Monitoring(json);
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/pump.js":[function(require,module,exports){
"use strict";

module.exports = Pump;

function Pump(fb) {
  this.fb = fb || {};
}

Pump.loadObj = loadObj;
Pump.prototype.addNewFlowTest = addNewFlowTest;
Pump.prototype.validateAdding = validateAdding;
Pump.prototype.getTypeLength = getTypeLength;
Pump.prototype.removeFlow = removeFlow;
Pump.prototype.flowTestOptions = [
  "Flow Test - Churn (0%)",
  "Flow Test - Rated Flow 100%",
  "Flow Test - Rated Flow 150%"
];

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new Pump(json);
}

function addNewFlowTest(type) {
  var self = this;
  if (type) {
    if (!this.fb.flowTestArr) {
      this.fb.flowTestArr = [];
    }
    if (self.validateAdding(type)) {
      this.fb.flowTestArr.push({ type: type });
    } else {
      this.showFlowError = true;
    }
  }
}

function validateAdding(type) {
  if (type === this.flowTestOptions[0]) {
    return this.getTypeLength(type) === 0 ? true : false;
  } else {
    return this.getTypeLength(type) < 6 ? true : false;
  }
}

function getTypeLength(type) {
  return _.filter(this.fb.flowTestArr, function(elem) {
    return elem.type === type;
  }).length;
}

function removeFlow(obj) {
  if (confirm("Are you sure you want to remove this flow test?")) {
    var index = this.fb.flowTestArr.indexOf(obj);
    this.fb.flowTestArr.splice(index, 1);
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/reportMapper.js":[function(require,module,exports){
module.exports = {
  Alarm: "alarm",
  "Back Flow": "backflow",
  "Emergency Exit": "emergencyExit",
  Extinguisher: "extinguishers",
  "Fire Hydrant": "hydrants",
  "Fire Pump": "pump",
  "Grease Cleaning": "greaseCleaning",
  "Hood System": "hoodSystem",
  Monitoring: "monitoring",
  Sensitivity: "sensitivity",
  "Special Hazard": "specialHazard",
  Sprinkler: "sprinkler",
  "Standpipe Hose": "standpipe",
  Suppression: "suppression",
  Quote: "quote",
  "Work Order": "workOrder",
  Other: "workOrder"
};

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/sensitivity.js":[function(require,module,exports){
"use strict";

module.exports = Sensitivity;

function Sensitivity(fb) {
  this.fb = fb || {};
}

Sensitivity.loadObj = loadObj;
Sensitivity.prototype.addSensitivityRead = addSensitivityRead;
Sensitivity.prototype.cleanAtDevice = cleanAtDevice;

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new Sensitivity(json);
}

function addSensitivityRead() {
  if (!this.fb.sensitivityReadings) {
    this.fb.sensitivityReadings = [];
  }
  this.fb.sensitivityReadings.push({
    createdAt: moment().format("YYYY-MM-DD")
  });
}

function cleanAtDevice() {
  this.tb.atDeviceQ1 = null;
  this.tb.atDeviceQ2 = null;
  this.tb.atDeviceQ3 = null;
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/specialHazard.js":[function(require,module,exports){
"use strict";

module.exports = SpecialHazard;

function SpecialHazard(fb) {
  this.fb = fb || {};
}

SpecialHazard.loadObj = loadObj;
SpecialHazard.prototype.addNewCylinder = addNewCylinder;
SpecialHazard.prototype.addNewDevice = addNewDevice;

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new SpecialHazard(json);
}

function addNewCylinder() {
  if (!this.fb.cylinders) {
    this.fb.cylinders = [];
  }
  this.fb.cylinders.push({
    createdAt: moment().format(),
    size: null,
    make: null,
    model: null,
    lastHydroDate: null,
    lastRechargeDate: null,
    compliance6year: null
  });
}

function addNewDevice() {
  if (!this.fb.devices) {
    this.fb.devices = [];
  }
  this.fb.devices.push({
    createdAt: moment().format(),
    type: null,
    make: null,
    model: null,
    location: null,
    status: null
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/sprinkler.js":[function(require,module,exports){
"use strict";

module.exports = Sprinkler;
var mapType = {
  Monthly: "M",
  Quarterly: "Q",
  "Semi-annual": "S",
  "Bi-annual": "B",
  Annual: "A",
  "3 year": "3",
  "5 year": "5",
  Other: "O"
};

function Sprinkler(fb) {
  this.fb = fb || {};
}

Sprinkler.loadObj = loadObj;
Sprinkler.prototype.addNewRiser = addNewRiser;
Sprinkler.prototype.removeRiser = removeRiser;
Sprinkler.prototype.validate = validate;
Sprinkler.prototype.systemOptions = [
  "Antifreeze Loop",
  "Deluge System",
  "Dry System",
  "Foam System",
  "Preaction System",
  "Wet System"
];

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new Sprinkler(json);
}

function addNewRiser(systemType) {
  if (systemType) {
    if (!this.fb.risers) {
      this.fb.risers = [];
    }
    this.fb.risers.push({ type: systemType });
  }
}

function removeRiser(system) {
  if (this.fb.risers.length == 1) {
    this.fb.risers.splice(0, 1);
    return;
  }

  var index = _.lastIndexOf(this.fb.risers, system);
  if (index >= 0) this.fb.risers.splice(index, 1);
}

function validate(typeList) {
  return _.includes(typeList, mapType[this.fb.frequency]);
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/standpipe.js":[function(require,module,exports){
"use strict";

module.exports = StandPipe;

function StandPipe(fb) {
  this.fb = fb || {};
}

StandPipe.loadObj = loadObj;
StandPipe.prototype.addStandpipe = addStandpipe;
StandPipe.prototype.addHoseStation = addHoseStation;
StandPipe.prototype.addHoseCabinet = addHoseCabinet;
StandPipe.prototype.clearInspectionObjects = clearInspectionObjects;
StandPipe.prototype.validate = validate;
StandPipe.prototype.addValve = addValve;

function addStandpipe() {
  if (!this.fb.standpipes) {
    this.fb.standpipes = [];
  }
  this.fb.standpipes.push({ createdAt: moment().format("YYYY-MM-DD") });
}

function clearInspectionObjects() {
  this.fb.standpipes = [{}];
  this.fb.hoseStations = [{}];
  this.fb.hoseCabinets = [{}];
}

function addHoseStation() {
  if (!this.fb.hoseStations) {
    this.fb.hoseStations = [];
  }
  this.fb.hoseStations.push({ createdAt: moment().format("YYYY-MM-DD") });
}

function addHoseCabinet() {
  if (!this.fb.hoseCabinets) {
    this.fb.hoseCabinets = [];
  }
  this.fb.hoseCabinets.push({ createdAt: moment().format("YYYY-MM-DD") });
}

function validate(typeList) {
  return _.includes(typeList, mapType(this.fb.frequency));
}

function mapType(inspType) {
  switch (inspType) {
    case "Monthly":
      return "M";
    case "Quarterly":
      return "Q";
    case "Semi-annual":
      return "S";
    case "Annual":
      return "A";
    case "3 year":
      return "3";
    case "5 year":
      return "5";
  }
}

function addValve(obj, index, type) {
  if (!this.fb[obj][index][type]) {
    this.fb[obj][index][type] = [];
  }
  this.fb[obj][index][type].push({});
}

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new StandPipe(json);
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/suppression.js":[function(require,module,exports){
"use strict";

module.exports = Suppression;

function Suppression(fb) {
  this.fb = fb || {};
}

Suppression.loadObj = loadObj;
Suppression.prototype.addControlPanel = addControlPanel;
Suppression.prototype.addCylinder = addCylinder;

function addCylinder() {
  if (!this.fb.cylinders) {
    this.fb.cylinders = [];
  }
  this.fb.cylinders.push({
    location: ""
  });
}

function addControlPanel() {
  if (!this.fb.controlPanels) {
    this.fb.controlPanels = [];
  }
  this.fb.controlPanels.push({
    location: ""
  });
}

function loadObj(json) {
  if (json) {
    if (_.isArray(json)) {
      return _.map(json, function(elem) {
        return instance(elem);
      });
    } else {
      return instance(json);
    }
  }
}

function instance(json) {
  return new Suppression(json);
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;

routes.$inject = ["$stateProvider"];
function routes($stateProvider) {
  $stateProvider.state("index.reports", {
    templateUrl: "reports/views/index.html",
    url: "/reports",
    controller: "ReportsCtrl",
    controllerAs: "mod",
    data: {
      title: "Reports Module",
      icon: "fa-home",
      menu: "Reports"
    }
  });

  $stateProvider.state("pdf", {
    templateUrl: "reports/views/pdf.html",
    url: "/pdf/:idClient/:idCustomer/:idType/:idReport",
    free: true,
    controller: "PDFCtrl",
    controllerAs: "pdf",
    data: {
      title: "PDF Download"
    }
  });

  $stateProvider.state("blank", {
    templateUrl: "reports/views/blank.html",
    url: "/blank",
    free: true,
    data: {
      title: "PDF Download"
    }
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/servicerequest/controllers/modalApproveCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ModalApproveCtrl;
var typeOptions = require("../../reports/models/reportMapper.js");
ModalApproveCtrl.$inject = ["request", "$uibModalInstance"];
function ModalApproveCtrl(request, $uibModalInstance) {
  var mc = this;
  mc.request = angular.copy(request);
  mc.createInspection = createInspection;
  mc.cancel = cancel;
  mc.typeOptions = _.keys(typeOptions);

  /**
   * Creates a new inspection
   * @param  {} validity
   */
  function createInspection(validity) {
    if (validity) {
      var momentDate = moment(mc.request.date);
      var obj = {
        completed: false,
        customerName: mc.request.customerName,
        description: mc.request.description,
        generationDate: moment().format(),
        idCustomer: mc.request.idCustomer,
        month: momentDate.month(),
        week: momentDate.isoWeek(),
        year: momentDate.year()
      };
      if (mc.isWorkorder) {
        obj.type = "Work Order";
        obj.woType = mc.request.type;
      } else {
        obj.type = mc.request.type;
      }
      $uibModalInstance.close(obj);
    }
  }

  /**
   * Closes modal
   */
  function cancel() {
    $uibModalInstance.dismiss("cancel");
  }
}

},{"../../reports/models/reportMapper.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/reports/models/reportMapper.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/servicerequest/controllers/rest/servicerequestAPI.js":[function(require,module,exports){
"use strict";

module.exports = ServicerequestAPI;

ServicerequestAPI.$inject = [
  "urlApi",
  "$firebaseArray",
  "$firebaseObject",
  "Notifications"
];

function ServicerequestAPI(
  urlApi,
  $firebaseArray,
  $firebaseObject,
  Notifications
) {
  var ref = new Firebase(urlApi + "Requests/");
  ServicerequestAPI.get = get;
  ServicerequestAPI.create = create;
  ServicerequestAPI.list = list;
  ServicerequestAPI.edit = edit;
  ServicerequestAPI.removeCustRequests = removeCustRequests;
  return ServicerequestAPI;

  /**
   * Return a client request
   * @param  {String} idClient Client id
   * @param  {String} idObj Request id
   * @return {Object} Request data
   */
  function get(idClient, idObj) {
    return $firebaseObject(ref.child(idClient).child(idObj)).$loaded(function(
      resp
    ) {
      return resp;
    });
  }

  /**
   * Return all client requests
   * @param  {String} idClient Client id
   * @return {Array} Requests list
   */
  function list(idClient) {
    return $firebaseArray(ref.child(idClient)).$loaded(function(resp) {
      return resp;
    });
  }

  /**
   * Creates a new request
   * @param  {String} idClient Client id
   * @param  {String} obj
   * @return {Object} Request id
   */
  function create(idClient, obj) {
    return $firebaseArray(ref.child(idClient))
      .$add(obj)
      .then(ok, error);

    function ok(resp) {
      Notifications.addCustom(200, "Service requested successfully");
      return resp;
    }

    function error(resp) {
      Notifications.addCustom(500, "There was a problem.");
      return resp;
    }
  }

  /**
   * Edits a request
   * @param  {Object} obj Request object
   */
  function edit(obj) {
    return obj.$save().then(ok, error);
    function ok(resp) {
      if (obj.status > 0) {
        Notifications.addCustom(200, "Service request approved");
      } else if (obj.status < 0) {
        Notifications.addCustom(200, "Service request rejected");
      }
      return resp.key();
    }

    function error(resp) {
      Notifications.addCustom(500, "There was a problem.");
      return resp;
    }
  }

  /**
   * Removes all customer requests
   * @param  {String} idClient Client id
   * @param  {String} idCustomer Customer id
   */
  function removeCustRequests(idClient, idCustomer) {
    var reqRef = ref.child(idClient).child(idCustomer);
    return reqRef.remove(function(err) {
      if (err) {
        return err;
      }
      return true;
    });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/servicerequest/controllers/servicerequestCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ServicerequestCtrl;

ServicerequestCtrl.$inject = [
  "requests",
  "$uibModal",
  "$sessionStorage",
  "ServicerequestAPI",
  "InspectionAPI",
  "Notifications"
];
function ServicerequestCtrl(
  requests,
  $uibModal,
  $sessionStorage,
  ServicerequestAPI,
  InspectionAPI,
  Notifications
) {
  var sr = this;
  sr.requests = requests;
  sr.approve = approve;
  sr.reject = reject;

  /**
   * Approves request
   * @param  {Object} req Request data
   */
  function approve(req) {
    var inspection = $uibModal.open({
      templateUrl: "servicerequest/views/modalApprove.html",
      controller: "ModalApproveCtrl",
      controllerAs: "mc",
      resolve: {
        request: function() {
          return _.find(sr.requests, function(sr) {
            return sr.$id === req.$id;
          });
        }
      }
    });
    inspection.result.then(function(obj) {
      ServicerequestAPI.get($sessionStorage.user.$id, req.$id)
        .then(function(getResp) {
          getResp.status = 1;
          ServicerequestAPI.edit(getResp).then(function(editResp) {
            if (editResp) {
              InspectionAPI.insertInJobBoard(obj);
            }
          });
        })
        .catch(function(exp) {
          Raven.captureException(exp);
          Notifications.addCustom(500, "Error, please try again.");
        });
    });
  }

  /**
   * Rejects a request
   * @param  {Object} req Request data
   */
  function reject(req) {
    if (confirm("Reject this service request?")) {
      ServicerequestAPI.get($sessionStorage.user.$id, req.$id)
        .then(function(resp) {
          resp.status = -1;
          ServicerequestAPI.edit(resp);
        })
        .catch(function(exp) {
          Raven.captureException(exp);
          Notifications.addCustom(500, "Error logging in, please try again.");
        });
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/servicerequest/index.js":[function(require,module,exports){
"use strict";

var _name = require("../../../package.json").name;

var mod = angular.module(_name + ".Servicerequest", []);
mod.config(require("./routes"));

mod.controller(
  "ServicerequestCtrl",
  require("./controllers/servicerequestCtrl.js")
);
mod.controller(
  "ModalApproveCtrl",
  require("./controllers/modalApproveCtrl.js")
);
mod.factory(
  "ServicerequestAPI",
  require("./controllers/rest/servicerequestAPI.js")
);

module.exports = mod;

},{"../../../package.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/package.json","./controllers/modalApproveCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/servicerequest/controllers/modalApproveCtrl.js","./controllers/rest/servicerequestAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/servicerequest/controllers/rest/servicerequestAPI.js","./controllers/servicerequestCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/servicerequest/controllers/servicerequestCtrl.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/servicerequest/routes.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/servicerequest/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;

routes.$inject = ["$stateProvider"];
function routes($stateProvider) {
  $stateProvider.state("index.servicerequest", {
    templateUrl: "servicerequest/views/requestList.html",
    url: "/servicerequest",
    controller: "ServicerequestCtrl",
    controllerAs: "sr",
    resolve: {
      requests: getServiceRequests
    },
    data: {
      title: "Service Request",
      icon: "fa-calendar-plus-o",
      menu: "Service Request",
      role: "client"
    }
  });

  /**
   * Returns all client service requests
   * @param  {Controller} ServicerequestAPI
   * @param  {Provider} $sessionStorage
   * @param  {Provider} Notifications
   * @return {Array} Service request list
   */
  getServiceRequests.$inject = [
    "ServicerequestAPI",
    "$sessionStorage",
    "Notifications"
  ];
  function getServiceRequests(
    ServicerequestAPI,
    $sessionStorage,
    Notifications
  ) {
    return ServicerequestAPI.list($sessionStorage.user.$id)
      .then(function(data) {
        data.forEach(function(elem) {
          if (elem.status === 0 && !elem.read) {
            elem.read = true;
            data
              .$ref()
              .child(elem.$id)
              .child("read")
              .set(true);
          }
        });
        return data;
      })
      .catch(function(exp) {
        Raven.captureException(exp);
        Notifications.addCustom(500, "Error, please try again.");
      });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/app/stateChange.js":[function(require,module,exports){
"use strict";

module.exports = stateChange;

function stateChange(
  $auth,
  $localStorage,
  $sessionStorage,
  Notifications,
  $state,
  $http,
  ClientAPI,
  Validations,
  $rootScope
) {
  return function(event, toState) {
    try {
      $(":text").blur();
    } catch (exp) {
      console.log(exp);
    }
    $rootScope.currentState = toState.name;
    if (window.location.href.indexOf("/pdf") === -1) {
      if ($auth.isAuthenticated()) {
        avoidLoginScreen(event, toState);
        headerOdoo();
        logoutFromAnotherPlace(event);

        checkPermission(event, toState);
        // } else if ( $localStorage.user ) {
        //  loginByRemember( event );
      } else {
        withoutLogin(event, toState);
      }
    }
  };

  /**
   * Checks what modules the user has active on state changes.
   * If the user doesnt have basic subscription or a specific permission for a specific module he is trying to access it should be redirected to payment page
   * @param  {} event
   * @param  {} toState
   */
  function checkPermission(event, toState) {
    var toAppSection = toState.name;
    var loggedUser = $sessionStorage.user;

    if (!loggedUser || !loggedUser.isClient) return;

    if (toAppSection.indexOf("index.client-one") != -1) {
      return;
    } else {
      if (!Validations.checkPermission(loggedUser, "basic")) {
        event.preventDefault();
        $state.go("index.client-one.payment", { permission: "basic" });
      }
    }

    if (!loggedUser.permissions) {
      //logout?
    }

    //We might not need to handle basic plan as there is already a "trial" element on user
    /*if (!Validations.checkPermission(loggedUser, "basic"))
    {
       event.preventDefault();
        $state.go("index.client-one.payment");
    }*/

    if (
      toAppSection === "index.inspections" ||
      toAppSection === "index.inspections.inspection-list"
    ) {
      if (!Validations.checkPermission(loggedUser, "inspections")) {
        event.preventDefault();
        $state.go("index.client-one.payment", { permission: "inspections" });
      }
    }

    if (toAppSection === "index.jobboard") {
      if (!Validations.checkPermission(loggedUser, "jobboard")) {
        event.preventDefault();
        $state.go("index.client-one.payment", { permission: "jobboard" });
      }
    }

    if (toAppSection === "index.qrcodes") {
      if (!Validations.checkPermission(loggedUser, "qrcodes")) {
        event.preventDefault();
        $state.go("index.client-one.payment", { permission: "qrcodes" });
      }
    }

    if (toAppSection === "index.inventory") {
      if (!Validations.checkPermission(loggedUser, "inventory")) {
        event.preventDefault();
        $state.go("index.client-one.payment", { permission: "inventory" });
      }
    }
  }

  /**
   * It's logged in and wants to go to login site
   * @param  {} event
   * @param  {} toState
   */
  function avoidLoginScreen(event, toState) {
    if (toState.name === "login") {
      index(event);
    }
  }

  /**
   * It's logged and the default head values are set
   */
  function headerOdoo() {
    if ($sessionStorage.user) {
      $http.defaults.headers.common.odooSession =
        $sessionStorage.user.sesionOdoo;
    }
  }

  /**
   * It has credentials in session, but not in local, it's logged out.
   * @param  {} event
   */
  function logoutFromAnotherPlace(event) {
    if (!$localStorage.user && !$sessionStorage.user) {
      event.preventDefault();
      $auth.logout();
      delete $sessionStorage.user;
      Notifications.addCustom(400, "You have logged out from another place");
      $state.go("login");
    }
  }

  /**
   * It has credentials in localStorage, but not in session, then credentials are loadeded into session
   * @param  {} event
   */
  function loginByRemember(event) {
    //TODO: Validate if deactivated
    /*ClientAPI.getAccess( $localStorage.user.$id ).then( function( data ) {
      if ( data ) {*/
    Raven.setUserContext({
      email: $localStorage.user.email,
      id: $localStorage.user.$id
    });
    $sessionStorage.user = $localStorage.user;
    /* var user = Client.loadObj( resp );
              $sessionStorage.user = user;*/

    $auth.setToken($sessionStorage.user.token);

    index(event);
    if ($sessionStorage.user.isClient) {
      Notifications.addCustom(
        200,
        "Welcome back " + $sessionStorage.user.firstName || ""
      );
    }
    /*} else {
      kickOut( event );
    }
  } );*/
  }

  /**
   * It's not logged in at all, and wants to see a resource that requires login
   * @param  {} event
   * @param  {} toState
   */
  function withoutLogin(event, toState) {
    if (!toState.free) {
      event.preventDefault();
      $state.go("login");
    }
  }

  /**
   * Kicks out user if aries subscription has expired
   * @param  {} event
   */
  function kickOut(event) {
    event.preventDefault();
    $auth.logout().then(function() {
      delete $sessionStorage.user;
      delete $localStorage.user;
      Notifications.addCustom(400, "Your subscription to Aries has expired");
      $state.go("login");
    });
  }

  /**
   * Goes to route
   * @param  {} event
   */
  function index(event) {
    event.preventDefault();

    /*if(window._loq){
      window._loq.push(["tag", $sessionStorage.user.email]);
      window._loq.push(["tag", $sessionStorage.user.$id]);
    }*/
    if (!$sessionStorage.user) {
      $localStorage.$reset();
    } else if ($sessionStorage.user.isClient) {
      $state.go("index.customers");
    } else {
      $state.go("index.customer-portal.inspections");
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/resources/i18n/en-US.json":[function(require,module,exports){
module.exports=module.exports = {
  "title": "Aries",
  "index.loading": "We're loading the application, please wait",
  "loadingbar": "We're processing your request, please wait.",
  "base.views.403.h1": "Access denied",
  "base.views.403.text": "Sorry, but your user does not have the required permissions to perform the requested action, contact the system administrator.",
  "base.views.404.h1": "Page not found",
  "base.views.404.text": "Sorry, the page your looking for can't be found, check that the URL is correct, and click on the 'refresh' icon or try to find something else inside the app",
  "base.views.messages.required": "This field is required",
  "base.views.messages.minlength": "This field is too short",
  "base.views.messages.maxlength": "This field is too long",
  "base.views.messages.email": "This field needs to be a valid email",
  "base.views.messages.password": "Must match the previous entry",
  "base.views.messages.pattern": "Wrong format",
  "base.views.navigation.logout": "Log out",
  "base.views.changePassword": "Change password",
  "login.views.login": "System login",
  "login.views.user": "User:",
  "login.views.pass": "Password:",
  "login.views.remember": "Remember me:",
  "login.views.odoo": "Login with Odoo",
  "login.views.firebase": "Login",
  "login.views.forgotPassword": "Forgot password?",
  "login.views.enterEmail": "Please enter the email associated to your Aries account where you will receive instructions to reset your password:",
  "admin.views.formUser.text": "You have all the permissions granted.",
  "admin.views.index.users": "Users",
  "admin.views.index.roles": "Roles",
  "admin.views.listRole.noData": "There are no Roles registered.",
  "admin.views.listRole.new": "New Role",
  "admin.views.listUser.noData": "There are no Users registered.",
  "admin.views.listUser.new": "New User",
  "admin.views.rolePermissions.admin": "Administration",
  "admin.views.rolePermissions.roles": "Roles",
  "admin.views.formUser.user": "User",
  "admin.views.rolePermissions.users": "Users",
  "common.new": "New",
  "common.create": "Create",
  "common.read": "Read",
  "common.edit": "Edit",
  "common.update": "Update",
  "common.back": "Go back",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.delete": "Delete",
  "common.remove": "Remove",
  "common.rol": "Role",
  "common.name": "Name",
  "common.desc": "Description",
  "common.permissions": "Permissions",
  "common.email": "E-mail",
  "common.state": "State",
  "common.list": "List",
  "common.add": "Add",
  "common.select-small": "Select",
  "common.select": "Select file",
  "common.upload_file":"Upload a file",
  "common.download_file":"Download device file template",
  "common.upload": "Upload",
  "common.abort": "Abort",
  "common.submit": "Submit",
  "common.send": "Send",
  "routes.main.module": "Dashboard",
  "routes.base.404": "Page not found",
  "routes.base.403": "Access denied",
  "routes.admin.module.title": "Administration Module",
  "routes.admin.module.menu": "Administration",
  "routes.admin.user-list": "Users List",
  "routes.admin.user-form": "User Form",
  "routes.admin.role-list": "Roles List",
  "routes.admin.role-form": "Role Form",
  "routes.admin.inspection-list": "Inspections List",
  "customer.views.listIncompleteReports": "Incomplete Reports",
  "customer.views.incompleteReports.noData": "There are no incomplete reports",
  "customer.views.listCustomer.new": "Add New Customer",
  "customer.views.listCustomer.noData": "There are no Customers registered",
  "customer.views.listInspection.new": "Add New Inspection",
  "customer.views.listReport.noData": "There are no Reports generated",
  "customer.views.devicesInfo.upload":"Upload Devices",
  "customer.views.exportDevices.download": "Click on report to download",
  "customer.views.exportDevices.noData": "No Reports registered",
  "customer.views.devicesInfo.uploadList":"Upload List",
  "customer.views.devicesInfo.step1":"Step 1. Download our bulk customer template",
  "customer.views.devicesInfo.step2":"Step 2. Upload the template",
  "customer.views.devicesInfo.addGroup":"Add Group",
  "employee.views.listEmployee.noData": "There are no Employees registered",
  "employee.views.listEmployee.new": "Add New Employee",
  "inspection.views.listInspection.noData": "There are no Inspections registered",
  "inspection.views.listMissing.noData": "No inspections to be acknowledged",
  "inspection.views.filterEmpty": "No inspections for the selected filters",
  "servicerequest.views.listRequests.noData": "There are no Services requested",
  "servicerequest.views.servicerequest-list": "Service Request List"
};

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/resources/i18n/es-CR.json":[function(require,module,exports){
module.exports=module.exports = {
  "title": "Proyecto Base - Ciris Informatic Solutions",
  "index.loading": "Estamos cargando la aplicación, por favor espere",
  "loadingbar": "Estamos procesando su solicitud, por favor espere.",
  "base.views.403.h1": "Acceso denegado",
  "base.views.403.text": "Lo sentimos, pero tu usuario no tiene los permisos necesarios para realizar la acción solicitada, ponte en contacto con el administrador del sistema.",
  "base.views.404.h1": "Página no encontrada",
  "base.views.404.text": "Lo sentimos, la página que buscas no se encuentra, compruebe que la URL sea correcta y haga clic en el icono 'refrescar' o trate de encontrar algo más dentro de la aplicación",
  "base.views.messages.required": "Este campo es requerido",
  "base.views.messages.minlength": "El valor es muy corto",
  "base.views.messages.maxlength": "El valor es muy largo",
  "base.views.messages.email": "Este campo necesita ser un correo válido",
  "base.views.navigation.logout": "Salir",
  "login.views.login": "Ingreso al Sistema",
  "login.views.user": "Usuario:",
  "login.views.pass": "Contraseña:",
  "login.views.remember": "Recuérdame:",
  "login.views.odoo": "Ingresar con Odoo",
  "login.views.firebase": "Ingresar con Firebase",
  "login.views.forgotPassword": "¿Olvidó su contraseña?",
  "login.views.enterEmail": "Por favor ingrese el correo asociado a su cuenta de Aries donde recibirá las instrucciones para restrablecer su contraseña:",
  "admin.views.formUser.text": "Usted tiene todos los permisos concedidos.",
  "admin.views.index.users": "Usuarios",
  "admin.views.index.roles": "Roles",
  "admin.views.listRole.noData": "No hay roles registrados aún.",
  "admin.views.listRole.new": "Nuevo Rol",
  "admin.views.listUser.noData": "No hay roles registrados aún.",
  "admin.views.listUser.new": "Nuevo Usuario",
  "admin.views.rolePermissions.admin": "Administración",
  "admin.views.rolePermissions.roles": "Roles",
  "admin.views.formUser.user": "Usuario",
  "admin.views.rolePermissions.users": "Usuarios",
  "common.new": "Nuevo",
  "common.create": "Crear",
  "common.read": "Lectura",
  "common.edit": "Editar",
  "common.update": "Actualizar",
  "common.back": "Atrás",
  "common.cancel": "Cancelar",
  "common.save": "Guardar",
  "common.delete": "Borrar",
  "common.remove": "Eliminar",
  "common.rol": "Rol",
  "common.name": "Nombre",
  "common.desc": "Descripción",
  "common.permissions": "Permisos",
  "common.email": "Correo",
  "common.state": "Estado",
  "common.list": "Lista",
  "common.add": "Agregar",
  "common.submit": "Enviar",
  "routes.main.module": "Inicio",
  "routes.base.404": "Página no encontrada",
  "routes.base.403": "Acceso Denegado",
  "routes.admin.module.title": "Módulo de Administración",
  "routes.admin.module.menu": "Administración",
  "routes.admin.user-list": "Lista de Usuarios",
  "routes.admin.user-form": "Form de Usuario",
  "routes.admin.role-list": "Lista de Roles",
  "routes.admin.role-form": "Form de Rol"
};

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-admin/src/resources/js/addressfield.json":[function(require,module,exports){
module.exports="use strict";
module.exports = {
  "label": "Country",
  "options": [
    {
      "label": "Afghanistan",
      "iso": "AF",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{4}$",
                "eg": "1001"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Aland Islands",
      "iso": "AX",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^22\\d{3}$",
                "eg": "22150"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Albania",
      "iso": "AL",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Algeria",
      "iso": "DZ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "American Samoa",
      "iso": "AS",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            },
            {
              "postalcode": {
                "label": "ZIP code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Andorra",
      "iso": "AD",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Angola",
      "iso": "AO",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Anguilla",
      "iso": "AI",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Antarctica",
      "iso": "AQ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Antigua and Barbuda",
      "iso": "AG",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Argentina",
      "iso": "AR",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^((?:[A-HJ-NP-Z])?\\d{4})([A-Z]{3})?$",
                "eg": "B1921"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "B": "Buenos Aires"
                  },
                  {
                    "K": "Catamarca"
                  },
                  {
                    "H": "Chaco"
                  },
                  {
                    "U": "Chubut"
                  },
                  {
                    "C": "Ciudad de Buenos Aires"
                  },
                  {
                    "X": "Córdoba"
                  },
                  {
                    "W": "Corrientes"
                  },
                  {
                    "E": "Entre Ríos"
                  },
                  {
                    "P": "Formosa"
                  },
                  {
                    "Y": "Jujuy"
                  },
                  {
                    "L": "La Pampa"
                  },
                  {
                    "F": "La Rioja"
                  },
                  {
                    "M": "Mendoza"
                  },
                  {
                    "N": "Misiones"
                  },
                  {
                    "Q": "Neuquén"
                  },
                  {
                    "R": "Río Negro"
                  },
                  {
                    "A": "Salta"
                  },
                  {
                    "J": "San Juan"
                  },
                  {
                    "D": "San Luis"
                  },
                  {
                    "Z": "Santa Cruz"
                  },
                  {
                    "S": "Santa Fe"
                  },
                  {
                    "G": "Santiago del Estero"
                  },
                  {
                    "V": "Tierra del Fuego"
                  },
                  {
                    "T": "Tucumán"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Armenia",
      "iso": "AM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Aruba",
      "iso": "AW",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Australia",
      "iso": "AU",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City/suburb"
              }
            },
            {
              "administrativearea": {
                "label": "State",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "ACT": "Australian Capital Territory"
                  },
                  {
                    "NSW": "New South Wales"
                  },
                  {
                    "NT": "Northern Territory"
                  },
                  {
                    "QLD": "Queensland"
                  },
                  {
                    "SA": "South Australia"
                  },
                  {
                    "TAS": "Tasmania"
                  },
                  {
                    "VIC": "Victoria"
                  },
                  {
                    "WA": "Western Australia"
                  }
                ]
              }
            },
            {
              "postalcode": {
                "label": "Postcode",
                "format": "^\\d{4}$",
                "eg": "2000"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Austria",
      "iso": "AT",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{4}$",
                "eg": "3741"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Azerbaijan",
      "iso": "AZ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Bahamas",
      "iso": "BS",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Island"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Bahrain",
      "iso": "BH",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Bangladesh",
      "iso": "BD",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Barbados",
      "iso": "BB",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Belarus",
      "iso": "BY",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Belgium",
      "iso": "BE",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{4}$",
                "eg": "4000"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Belize",
      "iso": "BZ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Benin",
      "iso": "BJ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Bermuda",
      "iso": "BM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Bhutan",
      "iso": "BT",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Bolivia",
      "iso": "BO",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Bosnia and Herzegovina",
      "iso": "BA",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Botswana",
      "iso": "BW",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Bouvet Island",
      "iso": "BV",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Brazil",
      "iso": "BR",
      "fields": [
        {
          "thoroughfare": {
            "label": "Thoroughfare"
          }
        },
        {
          "premise": {
            "label": "Complement"
          }
        },
        {
          "locality": [
            {
              "dependent_localityname": {
                "label": "Neighborhood"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "AC": "Acre"
                  },
                  {
                    "AL": "Alagoas"
                  },
                  {
                    "AM": "Amazonas"
                  },
                  {
                    "AP": "Amapa"
                  },
                  {
                    "BA": "Bahia"
                  },
                  {
                    "CE": "Ceara"
                  },
                  {
                    "DF": "Distrito Federal"
                  },
                  {
                    "ES": "Espirito Santo"
                  },
                  {
                    "GO": "Goias"
                  },
                  {
                    "MA": "Maranhao"
                  },
                  {
                    "MG": "Minas Gerais"
                  },
                  {
                    "MS": "Mato Grosso do Sul"
                  },
                  {
                    "MT": "Mato Grosso"
                  },
                  {
                    "PA": "Para"
                  },
                  {
                    "PB": "Paraiba"
                  },
                  {
                    "PE": "Pernambuco"
                  },
                  {
                    "PI": "Piaui"
                  },
                  {
                    "PR": "Parana"
                  },
                  {
                    "RJ": "Rio de Janeiro"
                  },
                  {
                    "RN": "Rio Grande do Norte"
                  },
                  {
                    "RO": "Rondonia"
                  },
                  {
                    "RR": "Roraima"
                  },
                  {
                    "RS": "Rio Grande do Sul"
                  },
                  {
                    "SC": "Santa Catarina"
                  },
                  {
                    "SE": "Sergipe"
                  },
                  {
                    "SP": "Sao Paulo"
                  },
                  {
                    "TO": "Tocantins"
                  }
                ]
              }
            },
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{5}[\\-]?\\d{3}$",
                "eg": "10025-345"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "British Indian Ocean Territory",
      "iso": "IO",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "British Virgin Islands",
      "iso": "VG",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Brunei",
      "iso": "BN",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Bulgaria",
      "iso": "BG",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Burkina Faso",
      "iso": "BF",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Burundi",
      "iso": "BI",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Cambodia",
      "iso": "KH",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Cameroon",
      "iso": "CM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Canada",
      "iso": "CA",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "AB": "Alberta"
                  },
                  {
                    "BC": "British Columbia"
                  },
                  {
                    "MB": "Manitoba"
                  },
                  {
                    "NB": "New Brunswick"
                  },
                  {
                    "NL": "Newfoundland"
                  },
                  {
                    "NT": "Northwest Territories"
                  },
                  {
                    "NS": "Nova Scotia"
                  },
                  {
                    "NU": "Nunavut"
                  },
                  {
                    "ON": "Ontario"
                  },
                  {
                    "PE": "Prince Edward Island"
                  },
                  {
                    "QC": "Quebec"
                  },
                  {
                    "SK": "Saskatchewan"
                  },
                  {
                    "YT": "Yukon Territory"
                  }
                ]
              }
            },
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ ]?\\d[ABCEGHJ-NPRSTV-Z]\\d$",
                "eg": "K1A 0B1"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Cape Verde",
      "iso": "CV",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Island"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Cayman Islands",
      "iso": "KY",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "administrativearea": {
                "label": "Island"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Central African Republic",
      "iso": "CF",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Chad",
      "iso": "TD",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Chile",
      "iso": "CL",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "AI": "Aysén del General Carlos Ibáñez del Campo"
                  },
                  {
                    "AN": "Antofagasta"
                  },
                  {
                    "AR": "Araucanía"
                  },
                  {
                    "AP": "Arica y Parinacota"
                  },
                  {
                    "AT": "Atacama"
                  },
                  {
                    "BI": "Biobío"
                  },
                  {
                    "CO": "Coquimbo"
                  },
                  {
                    "LI": "Libertador General Bernardo O'Higgins"
                  },
                  {
                    "LL": "Los Lagos"
                  },
                  {
                    "LR": "Los Ríos"
                  },
                  {
                    "MA": "Magallanes y de la Antártica Chilena"
                  },
                  {
                    "ML": "Maule"
                  },
                  {
                    "RM": "Metropolitana de Santiago"
                  },
                  {
                    "TA": "Tarapacá"
                  },
                  {
                    "VS": "Valparaíso"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "label": "China",
      "iso": "CN",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "dependent_localityname": {
                "label": "District"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "BJ": "Beijing"
                  },
                  {
                    "SH": "Shanghai"
                  },
                  {
                    "GD": "Guangdong"
                  },
                  {
                    "TJ": "Tianjin"
                  },
                  {
                    "HE": "Hebei"
                  },
                  {
                    "SX": "Shanxi"
                  },
                  {
                    "NM": "Inner Mongolia"
                  },
                  {
                    "LN": "Liaoning"
                  },
                  {
                    "JL": "Jilin"
                  },
                  {
                    "HL": "Heilongjiang"
                  },
                  {
                    "JS": "Jiangsu"
                  },
                  {
                    "ZJ": "Zhejiang"
                  },
                  {
                    "AH": "Anhui"
                  },
                  {
                    "FJ": "Fujian"
                  },
                  {
                    "JX": "Jiangxi"
                  },
                  {
                    "SD": "Shandong"
                  },
                  {
                    "HA": "Henan"
                  },
                  {
                    "HB": "Hubei"
                  },
                  {
                    "HN": "Hunan"
                  },
                  {
                    "GX": "Guangxi"
                  },
                  {
                    "HI": "Hainan"
                  },
                  {
                    "CQ": "Chongqing"
                  },
                  {
                    "SC": "Sichuan"
                  },
                  {
                    "GZ": "Guizhou"
                  },
                  {
                    "YN": "Yunnan"
                  },
                  {
                    "XZ": "Tibet"
                  },
                  {
                    "SN": "Shaanxi"
                  },
                  {
                    "GS": "Gansu"
                  },
                  {
                    "QH": "Qinghai"
                  },
                  {
                    "NX": "Ningxia Hui"
                  },
                  {
                    "XJ": "Xinjiang Uyghur"
                  }
                ]
              }
            },
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{6}$",
                "eg": "101200"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Christmas Island",
      "iso": "CX",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Cocos (Keeling) Islands",
      "iso": "CC",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Colombia",
      "iso": "CO",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Comoros",
      "iso": "KM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Congo (Brazzaville)",
      "iso": "CG",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Congo (Kinshasa)",
      "iso": "CD",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Cook Islands",
      "iso": "CK",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Costa Rica",
      "iso": "CR",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Cuba",
      "iso": "CU",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Croatia",
      "iso": "HR",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "CuraÁao",
      "iso": "CW",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Cyprus",
      "iso": "CY",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Czech Republic",
      "iso": "CZ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Denmark",
      "iso": "DK",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{4}$",
                "eg": "8660"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Djibouti",
      "iso": "DJ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Dominica",
      "iso": "DM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Dominican Republic",
      "iso": "DO",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Ecuador",
      "iso": "EC",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Egypt",
      "iso": "EG",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Governorate",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "ALX": "Alexandria"
                  },
                  {
                    "ASN": "Aswan"
                  },
                  {
                    "AST": "Asyut"
                  },
                  {
                    "BH": "Beheira"
                  },
                  {
                    "BNS": "Beni Suef"
                  },
                  {
                    "C": "Cairo"
                  },
                  {
                    "DK": "Dakahlia"
                  },
                  {
                    "DT": "Damietta"
                  },
                  {
                    "FYM": "Faiyum"
                  },
                  {
                    "GH": "Gharbia"
                  },
                  {
                    "GZ": "Giza"
                  },
                  {
                    "IS": "Ismailia"
                  },
                  {
                    "KFS": "Kafr el-Sheikh"
                  },
                  {
                    "MT": "Matruh"
                  },
                  {
                    "MN": "Minya"
                  },
                  {
                    "MNF": "Monufia"
                  },
                  {
                    "WAD": "New Valley"
                  },
                  {
                    "SIN": "North Sinai"
                  },
                  {
                    "PTS": "Port Said"
                  },
                  {
                    "KB": "Qalyubia"
                  },
                  {
                    "KN": "Qena"
                  },
                  {
                    "BA": "Red Sea"
                  },
                  {
                    "SHR": "Sharqia"
                  },
                  {
                    "SHG": "Sohag"
                  },
                  {
                    "JS": "South Sinai"
                  },
                  {
                    "SUZ": "Suez"
                  },
                  {
                    "LX": "Luxor"
                  }
                ]
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "El Salvador",
      "iso": "SV",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Equatorial Guinea",
      "iso": "GQ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Eritrea",
      "iso": "ER",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Estonia",
      "iso": "EE",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Ethiopia",
      "iso": "ET",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Falkland Islands",
      "iso": "FK",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Faroe Islands",
      "iso": "FO",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Fiji",
      "iso": "FJ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Finland",
      "iso": "FI",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{5}$",
                "eg": "00550"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "France",
      "iso": "FR",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{2}[ ]?\\d{3}$",
                "eg": "75002"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "French Guiana",
      "iso": "GF",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^9[78]3\\d{2}$",
                "eg": "97300"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "French Polynesia",
      "iso": "PF",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Island"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "French Southern Territories",
      "iso": "TF",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Gabon",
      "iso": "GA",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Gambia",
      "iso": "GM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Georgia",
      "iso": "GE",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Germany",
      "iso": "DE",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{5}$",
                "eg": "60322"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Ghana",
      "iso": "GH",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Gibraltar",
      "iso": "GI",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Greece",
      "iso": "GR",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{3} ?\\d{2}$",
                "eg": "151 24"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Greenland",
      "iso": "GL",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^39\\d{2}$",
                "eg": "3911"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Grenada",
      "iso": "GD",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Guadeloupe",
      "iso": "GP",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^9[78][01]\\d{2}$",
                "eg": "97100"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Guam",
      "iso": "GU",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            },
            {
              "postalcode": {
                "label": "ZIP code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Guatemala",
      "iso": "GT",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Guernsey",
      "iso": "GG",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^GY\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}$",
                "eg": "GY1 1AA"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Guinea",
      "iso": "GN",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Guinea-Bissau",
      "iso": "GW",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Guyana",
      "iso": "GY",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Haiti",
      "iso": "HT",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Heard Island and McDonald Islands",
      "iso": "HM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Honduras",
      "iso": "HN",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Hong Kong S.A.R., China",
      "iso": "HK",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "District"
              }
            },
            {
              "administrativearea": {
                "label": "Area",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "Kowloon": "Kowloon"
                  },
                  {
                    "Hong Kong Island": "Hong Kong Island"
                  },
                  {
                    "New Territories": "New Territories"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Hungary",
      "iso": "HU",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Iceland",
      "iso": "IS",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "India",
      "iso": "IN",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "AP": "Andhra Pradesh"
                  },
                  {
                    "AR": "Arunachal Pradesh"
                  },
                  {
                    "AS": "Assam"
                  },
                  {
                    "BR": "Bihar"
                  },
                  {
                    "CT": "Chhattisgarh"
                  },
                  {
                    "GA": "Goa"
                  },
                  {
                    "GJ": "Gujarat"
                  },
                  {
                    "HR": "Haryana"
                  },
                  {
                    "HP": "Himachal Pradesh"
                  },
                  {
                    "JK": "Jammu and Kashmir"
                  },
                  {
                    "JH": "Jharkhand"
                  },
                  {
                    "KA": "Karnataka"
                  },
                  {
                    "KL": "Kerala"
                  },
                  {
                    "MP": "Madhya Pradesh"
                  },
                  {
                    "MH": "Maharashtra"
                  },
                  {
                    "MN": "Manipur"
                  },
                  {
                    "ML": "Meghalaya"
                  },
                  {
                    "MZ": "Mizoram"
                  },
                  {
                    "NL": "Nagaland"
                  },
                  {
                    "OR": "Odisha"
                  },
                  {
                    "PB": "Punjab"
                  },
                  {
                    "RJ": "Rajasthan"
                  },
                  {
                    "SK": "Sikkim"
                  },
                  {
                    "TN": "Tamil Nadu"
                  },
                  {
                    "TR": "Tripura"
                  },
                  {
                    "UP": "Uttar Pradesh"
                  },
                  {
                    "UT": "Uttarakhand"
                  },
                  {
                    "WB": "West Bengal"
                  },
                  {
                    "": "--"
                  },
                  {
                    "AN": "Andaman and Nicobar Islands"
                  },
                  {
                    "CH": "Chandigarh"
                  },
                  {
                    "DN": "Dadra and Nagar Haveli"
                  },
                  {
                    "DD": "Daman and Diu"
                  },
                  {
                    "LD": "Lakshadweep"
                  },
                  {
                    "DL": "National Capital Territory of Delhi"
                  },
                  {
                    "PY": "Puducherry"
                  }
                ]
              }
            },
            {
              "postalcode": {
                "label": "PIN code",
                "format": "^\\d{6}$",
                "eg": "110005"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Indonesia",
      "iso": "ID",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City/regency"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "administrativearea": {
                "label": "Province",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "AC": "Aceh"
                  },
                  {
                    "BA": "Bali"
                  },
                  {
                    "BB": "Bangka Belitung"
                  },
                  {
                    "BT": "Banten"
                  },
                  {
                    "BE": "Bengkulu"
                  },
                  {
                    "JK": "DKI Jakarta"
                  },
                  {
                    "YO": "D.I. Yogyakarta"
                  },
                  {
                    "GO": "Gorontalo"
                  },
                  {
                    "JA": "Jambi"
                  },
                  {
                    "JB": "Jawa Barat"
                  },
                  {
                    "JT": "Jawa Tengah"
                  },
                  {
                    "JI": "Jawa Timur"
                  },
                  {
                    "KB": "Kalimantan Barat"
                  },
                  {
                    "KS": "Kalimantan Selatan"
                  },
                  {
                    "KT": "Kalimantan Tengah"
                  },
                  {
                    "KI": "Kalimantan Timur"
                  },
                  {
                    "KR": "Kepulauan Riau"
                  },
                  {
                    "LA": "Lampung"
                  },
                  {
                    "MA": "Maluku"
                  },
                  {
                    "MU": "Maluku Utara"
                  },
                  {
                    "NB": "Nusa Tenggara Barat"
                  },
                  {
                    "NT": "Nusa Tenggara Timur"
                  },
                  {
                    "PA": "Papua"
                  },
                  {
                    "PB": "Papua Barat"
                  },
                  {
                    "RI": "Riau"
                  },
                  {
                    "SR": "Sulawesi Barat"
                  },
                  {
                    "SN": "Sulawesi Selatan"
                  },
                  {
                    "ST": "Sulawesi Tengah"
                  },
                  {
                    "SG": "Sulawesi Tenggara"
                  },
                  {
                    "SA": "Sulawesi Utara"
                  },
                  {
                    "SB": "Sumatera Barat"
                  },
                  {
                    "SS": "Sumatera Selatan"
                  },
                  {
                    "SU": "Sumatera Utara"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Iran",
      "iso": "IR",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "dependent_localityname": {
                "label": "Neighborhood"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Iraq",
      "iso": "IQ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Ireland",
      "iso": "IE",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "Town/city"
              }
            },
            {
              "administrativearea": {
                "label": "County",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "CW": "Co Carlow"
                  },
                  {
                    "CN": "Co Cavan"
                  },
                  {
                    "CE": "Co Clare"
                  },
                  {
                    "CO": "Co Cork"
                  },
                  {
                    "DL": "Co Donegal"
                  },
                  {
                    "D": "Co Dublin"
                  },
                  {
                    "D1": "Dublin 1"
                  },
                  {
                    "D2": "Dublin 2"
                  },
                  {
                    "D3": "Dublin 3"
                  },
                  {
                    "D4": "Dublin 4"
                  },
                  {
                    "D5": "Dublin 5"
                  },
                  {
                    "D6": "Dublin 6"
                  },
                  {
                    "D6W": "Dublin 6w"
                  },
                  {
                    "D7": "Dublin 7"
                  },
                  {
                    "D8": "Dublin 8"
                  },
                  {
                    "D9": "Dublin 9"
                  },
                  {
                    "D10": "Dublin 10"
                  },
                  {
                    "D11": "Dublin 11"
                  },
                  {
                    "D12": "Dublin 12"
                  },
                  {
                    "D13": "Dublin 13"
                  },
                  {
                    "D14": "Dublin 14"
                  },
                  {
                    "D15": "Dublin 15"
                  },
                  {
                    "D16": "Dublin 16"
                  },
                  {
                    "D17": "Dublin 17"
                  },
                  {
                    "D18": "Dublin 18"
                  },
                  {
                    "D19": "Dublin 19"
                  },
                  {
                    "D20": "Dublin 20"
                  },
                  {
                    "D21": "Dublin 21"
                  },
                  {
                    "D22": "Dublin 22"
                  },
                  {
                    "D23": "Dublin 23"
                  },
                  {
                    "D24": "Dublin 24"
                  },
                  {
                    "G": "Co Galway"
                  },
                  {
                    "KY": "Co Kerry"
                  },
                  {
                    "KE": "Co Kildare"
                  },
                  {
                    "KK": "Co Kilkenny"
                  },
                  {
                    "LS": "Co Laois"
                  },
                  {
                    "LM": "Co Leitrim"
                  },
                  {
                    "LK": "Co Limerick"
                  },
                  {
                    "LD": "Co Longford"
                  },
                  {
                    "LH": "Co Louth"
                  },
                  {
                    "MO": "Co Mayo"
                  },
                  {
                    "MH": "Co Meath"
                  },
                  {
                    "MN": "Co Monaghan"
                  },
                  {
                    "OY": "Co Offaly"
                  },
                  {
                    "RN": "Co Roscommon"
                  },
                  {
                    "SO": "Co Sligo"
                  },
                  {
                    "TA": "Co Tipperary"
                  },
                  {
                    "WD": "Co Waterford"
                  },
                  {
                    "WH": "Co Westmeath"
                  },
                  {
                    "WX": "Co Wexford"
                  },
                  {
                    "WW": "Co Wicklow"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Isle of Man",
      "iso": "IM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^IM\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}$",
                "eg": "IM99 1PS"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Israel",
      "iso": "IL",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Italy",
      "iso": "IT",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "AG": "Agrigento"
                  },
                  {
                    "AL": "Alessandria"
                  },
                  {
                    "AN": "Ancona"
                  },
                  {
                    "AO": "Valle d'Aosta/VallÈe d'Aoste"
                  },
                  {
                    "AP": "Ascoli Piceno"
                  },
                  {
                    "AQ": "L'Aquila"
                  },
                  {
                    "AR": "Arezzo"
                  },
                  {
                    "AT": "Asti"
                  },
                  {
                    "AV": "Avellino"
                  },
                  {
                    "BA": "Bari"
                  },
                  {
                    "BG": "Bergamo"
                  },
                  {
                    "BI": "Biella"
                  },
                  {
                    "BL": "Belluno"
                  },
                  {
                    "BN": "Benevento"
                  },
                  {
                    "BO": "Bologna"
                  },
                  {
                    "BR": "Brindisi"
                  },
                  {
                    "BS": "Brescia"
                  },
                  {
                    "BT": "Barletta-Andria-Trani"
                  },
                  {
                    "BZ": "Bolzano/Bozen"
                  },
                  {
                    "CA": "Cagliari"
                  },
                  {
                    "CB": "Campobasso"
                  },
                  {
                    "CE": "Caserta"
                  },
                  {
                    "CH": "Chieti"
                  },
                  {
                    "CI": "Carbonia-Iglesias"
                  },
                  {
                    "CL": "Caltanissetta"
                  },
                  {
                    "CN": "Cuneo"
                  },
                  {
                    "CO": "Como"
                  },
                  {
                    "CR": "Cremona"
                  },
                  {
                    "CS": "Cosenza"
                  },
                  {
                    "CT": "Catania"
                  },
                  {
                    "CZ": "Catanzaro"
                  },
                  {
                    "EN": "Enna"
                  },
                  {
                    "FC": "ForlÏ-Cesena"
                  },
                  {
                    "FE": "Ferrara"
                  },
                  {
                    "FG": "Foggia"
                  },
                  {
                    "FI": "Firenze"
                  },
                  {
                    "FM": "Fermo"
                  },
                  {
                    "FR": "Frosinone"
                  },
                  {
                    "GE": "Genova"
                  },
                  {
                    "GO": "Gorizia"
                  },
                  {
                    "GR": "Grosseto"
                  },
                  {
                    "IM": "Imperia"
                  },
                  {
                    "IS": "Isernia"
                  },
                  {
                    "KR": "Crotone"
                  },
                  {
                    "LC": "Lecco"
                  },
                  {
                    "LE": "Lecce"
                  },
                  {
                    "LI": "Livorno"
                  },
                  {
                    "LO": "Lodi"
                  },
                  {
                    "LT": "Latina"
                  },
                  {
                    "LU": "Lucca"
                  },
                  {
                    "MB": "Monza e Brianza"
                  },
                  {
                    "MC": "Macerata"
                  },
                  {
                    "ME": "Messina"
                  },
                  {
                    "MI": "Milano"
                  },
                  {
                    "MN": "Mantova"
                  },
                  {
                    "MO": "Modena"
                  },
                  {
                    "MS": "Massa-Carrara"
                  },
                  {
                    "MT": "Matera"
                  },
                  {
                    "NA": "Napoli"
                  },
                  {
                    "NO": "Novara"
                  },
                  {
                    "NU": "Nuoro"
                  },
                  {
                    "OG": "Ogliastra"
                  },
                  {
                    "OR": "Oristano"
                  },
                  {
                    "OT": "Olbia-Tempio"
                  },
                  {
                    "PA": "Palermo"
                  },
                  {
                    "PC": "Piacenza"
                  },
                  {
                    "PD": "Padova"
                  },
                  {
                    "PE": "Pescara"
                  },
                  {
                    "PG": "Perugia"
                  },
                  {
                    "PI": "Pisa"
                  },
                  {
                    "PN": "Pordenone"
                  },
                  {
                    "PO": "Prato"
                  },
                  {
                    "PR": "Parma"
                  },
                  {
                    "PT": "Pistoia"
                  },
                  {
                    "PU": "Pesaro e Urbino"
                  },
                  {
                    "PV": "Pavia"
                  },
                  {
                    "PZ": "Potenza"
                  },
                  {
                    "RA": "Ravenna"
                  },
                  {
                    "RC": "Reggio di Calabria"
                  },
                  {
                    "RE": "Reggio nell'Emilia"
                  },
                  {
                    "RG": "Ragusa"
                  },
                  {
                    "RI": "Rieti"
                  },
                  {
                    "RM": "Roma"
                  },
                  {
                    "RN": "Rimini"
                  },
                  {
                    "RO": "Rovigo"
                  },
                  {
                    "SA": "Salerno"
                  },
                  {
                    "SI": "Siena"
                  },
                  {
                    "SO": "Sondrio"
                  },
                  {
                    "SP": "La Spezia"
                  },
                  {
                    "SR": "Siracusa"
                  },
                  {
                    "SS": "Sassari"
                  },
                  {
                    "SV": "Savona"
                  },
                  {
                    "TA": "Taranto"
                  },
                  {
                    "TE": "Teramo"
                  },
                  {
                    "TN": "Trento"
                  },
                  {
                    "TO": "Torino"
                  },
                  {
                    "TP": "Trapani"
                  },
                  {
                    "TR": "Terni"
                  },
                  {
                    "TS": "Trieste"
                  },
                  {
                    "TV": "Treviso"
                  },
                  {
                    "UD": "Udine"
                  },
                  {
                    "VA": "Varese"
                  },
                  {
                    "VB": "Verbano-Cusio-Ossola"
                  },
                  {
                    "VC": "Vercelli"
                  },
                  {
                    "VE": "Venezia"
                  },
                  {
                    "VI": "Vicenza"
                  },
                  {
                    "VR": "Verona"
                  },
                  {
                    "VS": "Medio Campidano"
                  },
                  {
                    "VT": "Viterbo"
                  },
                  {
                    "VV": "Vibo Valentia"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Ivory Coast",
      "iso": "CI",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Jamaica",
      "iso": "JM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Parish",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "Clarendon": "Clarendon"
                  },
                  {
                    "Hanover": "Hanover"
                  },
                  {
                    "Kingston": "Kingston"
                  },
                  {
                    "Manchester": "Manchester"
                  },
                  {
                    "Portland": "Portland"
                  },
                  {
                    "St. Andrew": "St. Andrew"
                  },
                  {
                    "St. Ann": "St. Ann"
                  },
                  {
                    "St. Catherine": "St. Catherine"
                  },
                  {
                    "St. Elizabeth": "St. Elizabeth"
                  },
                  {
                    "St. James": "St. James"
                  },
                  {
                    "St. Mary": "St. Mary"
                  },
                  {
                    "St. Thomas": "St. Thomas"
                  },
                  {
                    "Trelawny": "Trelawny"
                  },
                  {
                    "Westmoreland": "Westmoreland"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Japan",
      "iso": "JP",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{3}-?\\d{4}$",
                "eg": "142-0062"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Prefecture",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "Hokkaido": "Hokkaido"
                  },
                  {
                    "Aomori": "Aomori"
                  },
                  {
                    "Iwate": "Iwate"
                  },
                  {
                    "Miyagi": "Miyagi"
                  },
                  {
                    "Akita": "Akita"
                  },
                  {
                    "Yamagata": "Yamagata"
                  },
                  {
                    "Fukushima": "Fukushima"
                  },
                  {
                    "Ibaraki": "Ibaraki"
                  },
                  {
                    "Tochigi": "Tochigi"
                  },
                  {
                    "Gunma": "Gunma"
                  },
                  {
                    "Saitama": "Saitama"
                  },
                  {
                    "Chiba": "Chiba"
                  },
                  {
                    "Tokyo": "Tokyo"
                  },
                  {
                    "Kanagawa": "Kanagawa"
                  },
                  {
                    "Niigata": "Niigata"
                  },
                  {
                    "Toyama": "Toyama"
                  },
                  {
                    "Ishikawa": "Ishikawa"
                  },
                  {
                    "Fukui": "Fukui"
                  },
                  {
                    "Yamanashi": "Yamanashi"
                  },
                  {
                    "Nagano": "Nagano"
                  },
                  {
                    "Gifu": "Gifu"
                  },
                  {
                    "Shizuoka": "Shizuoka"
                  },
                  {
                    "Aichi": "Aichi"
                  },
                  {
                    "Mie": "Mie"
                  },
                  {
                    "Shiga": "Shiga"
                  },
                  {
                    "Kyoto": "Kyoto"
                  },
                  {
                    "Osaka": "Osaka"
                  },
                  {
                    "Hyogo": "Hyogo"
                  },
                  {
                    "Nara": "Nara"
                  },
                  {
                    "Wakayama": "Wakayama"
                  },
                  {
                    "Tottori": "Tottori"
                  },
                  {
                    "Shimane": "Shimane"
                  },
                  {
                    "Okayama": "Okayama"
                  },
                  {
                    "Hiroshima": "Hiroshima"
                  },
                  {
                    "Yamaguchi": "Yamaguchi"
                  },
                  {
                    "Tokushima": "Tokushima"
                  },
                  {
                    "Kagawa": "Kagawa"
                  },
                  {
                    "Ehime": "Ehime"
                  },
                  {
                    "Kochi": "Kochi"
                  },
                  {
                    "Fukuoka": "Fukuoka"
                  },
                  {
                    "Saga": "Saga"
                  },
                  {
                    "Nagasaki": "Nagasaki"
                  },
                  {
                    "Kumamoto": "Kumamoto"
                  },
                  {
                    "Oita": "Oita"
                  },
                  {
                    "Miyazaki": "Miyazaki"
                  },
                  {
                    "Kagoshima": "Kagoshima"
                  },
                  {
                    "Okinawa": "Okinawa"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Jersey",
      "iso": "JE",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^JE\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}$",
                "eg": "JE2 2BT"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Jordan",
      "iso": "JO",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Kazakhstan",
      "iso": "KZ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Kenya",
      "iso": "KE",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Kiribati",
      "iso": "KI",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Island"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Kuwait",
      "iso": "KW",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Kyrgyzstan",
      "iso": "KG",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Laos",
      "iso": "LA",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Latvia",
      "iso": "LV",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Lebanon",
      "iso": "LB",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Lesotho",
      "iso": "LS",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Liberia",
      "iso": "LR",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Libya",
      "iso": "LY",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Liechtenstein",
      "iso": "LI",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^(948[5-9])|(949[0-7])$",
                "eg": "9496"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Lithuania",
      "iso": "LT",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Luxembourg",
      "iso": "LU",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{4}$",
                "eg": "4750"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Macao S.A.R., China",
      "iso": "MO",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Macedonia",
      "iso": "MK",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Madagascar",
      "iso": "MG",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Malawi",
      "iso": "MW",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Malaysia",
      "iso": "MY",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "dependent_localityname": {
                "label": "Village/township"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "Johor": "Johor"
                  },
                  {
                    "Kedah": "Kedah"
                  },
                  {
                    "Kelantan": "Kelantan"
                  },
                  {
                    "Kuala Lumpur": "Kuala Lumpur"
                  },
                  {
                    "Labuan": "Labuan"
                  },
                  {
                    "Melaka": "Melaka"
                  },
                  {
                    "Negeri Sembilan": "Negeri Sembilan"
                  },
                  {
                    "Pahang": "Pahang"
                  },
                  {
                    "Perak": "Perak"
                  },
                  {
                    "Perlis": "Perlis"
                  },
                  {
                    "Pulau Pinang": "Pulau Pinang"
                  },
                  {
                    "Putrajaya": "Putrajaya"
                  },
                  {
                    "Sabah": "Sabah"
                  },
                  {
                    "Sarawak": "Sarawak"
                  },
                  {
                    "Selangor": "Selangor"
                  },
                  {
                    "Terengganu": "Terengganu"
                  }
                ]
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Maldives",
      "iso": "MV",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Mali",
      "iso": "ML",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Malta",
      "iso": "MT",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Marshall Islands",
      "iso": "MH",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            },
            {
              "postalcode": {
                "label": "ZIP code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Martinique",
      "iso": "MQ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^9[78]2\\d{2}$",
                "eg": "97220"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Mauritania",
      "iso": "MR",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Mauritius",
      "iso": "MU",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Mayotte",
      "iso": "YT",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^976\\d{2}$",
                "eg": "97600"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Mexico",
      "iso": "MX",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "dependent_localityname": {
                "label": "Neighborhood"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "AGU": "Aguascalientes"
                  },
                  {
                    "BCN": "Baja California"
                  },
                  {
                    "BCS": "Baja California Sur"
                  },
                  {
                    "CAM": "Campeche"
                  },
                  {
                    "COA": "Coahuila"
                  },
                  {
                    "COL": "Colima"
                  },
                  {
                    "CHP": "Chiapas"
                  },
                  {
                    "CHH": "Chihuahua"
                  },
                  {
                    "DIF": "Distrito Federal"
                  },
                  {
                    "DUG": "Durango"
                  },
                  {
                    "MEX": "Estado de México"
                  },
                  {
                    "GUA": "Guanajuato"
                  },
                  {
                    "GRO": "Guerrero"
                  },
                  {
                    "HID": "Hidalgo"
                  },
                  {
                    "JAL": "Jalisco"
                  },
                  {
                    "MIC": "Michoacán"
                  },
                  {
                    "MOR": "Morelos"
                  },
                  {
                    "NAY": "Nayarit"
                  },
                  {
                    "NLE": "Nuevo León"
                  },
                  {
                    "OAX": "Oaxaca"
                  },
                  {
                    "PUE": "Puebla"
                  },
                  {
                    "QUE": "Queretaro"
                  },
                  {
                    "ROO": "Quintana Roo"
                  },
                  {
                    "SLP": "San Luis Potosí"
                  },
                  {
                    "SIN": "Sinaloa"
                  },
                  {
                    "SON": "Sonora"
                  },
                  {
                    "TAB": "Tabasco"
                  },
                  {
                    "TAM": "Tamaulipas"
                  },
                  {
                    "TLA": "Tlaxcala"
                  },
                  {
                    "VER": "Veracruz"
                  },
                  {
                    "YUC": "Yucatán"
                  },
                  {
                    "ZAC": "Zacatecas"
                  }
                ]
              }
            },
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{5}$",
                "eg": "03400"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Micronesia",
      "iso": "FM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            },
            {
              "postalcode": {
                "label": "ZIP code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Moldova",
      "iso": "MD",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Monaco",
      "iso": "MC",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Mongolia",
      "iso": "MN",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            },            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Montenegro",
      "iso": "ME",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Montserrat",
      "iso": "MS",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Morocco",
      "iso": "MA",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Mozambique",
      "iso": "MZ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Myanmar",
      "iso": "MM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Namibia",
      "iso": "NA",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Nauru",
      "iso": "NR",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "administrativearea": {
                "label": "District"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Nepal",
      "iso": "NP",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Netherlands",
      "iso": "NL",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{4}[ ]?[A-Z]{2}$",
                "eg": "2585 GJ"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Netherlands Antilles",
      "iso": "AN",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "New Caledonia",
      "iso": "NC",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^988\\d{2}$",
                "eg": "98814"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "New Zealand",
      "iso": "NZ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "Town/city"
              }
            },
            {
              "administrativearea": {
                "label": "Region",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "AUK": "Auckland"
                  },
                  {
                    "BOP": "Bay of Plenty"
                  },
                  {
                    "CAN": "Canterbury"
                  },
                  {
                    "HKB": "Hawke's Bay"
                  },
                  {
                    "MWT": "Manawatu-Wanganui"
                  },
                  {
                    "NTL": "Northland"
                  },
                  {
                    "OTA": "Otago"
                  },
                  {
                    "STL": "Southland"
                  },
                  {
                    "TKI": "Taranaki"
                  },
                  {
                    "WKO": "Waikato"
                  },
                  {
                    "WGN": "Wellington"
                  },
                  {
                    "WTC": "West Coast"
                  },
                  {
                    "GIS": "Gisborne District"
                  },
                  {
                    "MBH": "Marlborough District"
                  },
                  {
                    "NSN": "Nelson"
                  },
                  {
                    "TAS": "Tasman District"
                  },
                  {
                    "CIT": "Chatham Islands Territory"
                  }
                ]
              }
            },
            {
              "postalcode": {
                "label": "Postcode"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Nicaragua",
      "iso": "NI",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Department"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Niger",
      "iso": "NE",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Nigeria",
      "iso": "NG",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Niue",
      "iso": "NU",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Norfolk Island",
      "iso": "NF",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Northern Mariana Islands",
      "iso": "MP",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            },
            {
              "postalcode": {
                "label": "ZIP code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "North Korea",
      "iso": "KP",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Norway",
      "iso": "NO",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{4}$",
                "eg": "0025"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Oman",
      "iso": "OM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Pakistan",
      "iso": "PK",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Palau",
      "iso": "PW",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            },
            {
              "postalcode": {
                "label": "ZIP code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Palestinian Territory",
      "iso": "PS",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Panama",
      "iso": "PA",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Papua New Guinea",
      "iso": "PG",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Paraguay",
      "iso": "PY",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Peru",
      "iso": "PE",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "administrativearea": {
                "label": "Region",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "AMA": "Amazonas"
                  },
                  {
                    "ANC": "Ancash"
                  },
                  {
                    "APU": "Apurimac"
                  },
                  {
                    "ARE": "Arequipa"
                  },
                  {
                    "AYA": "Ayacucho"
                  },
                  {
                    "CAJ": "Cajamarca"
                  },
                  {
                    "CAL": "Callao"
                  },
                  {
                    "CUS": "Cusco"
                  },
                  {
                    "HUV": "Huancavelica"
                  },
                  {
                    "HUC": "Huanuco"
                  },
                  {
                    "ICA": "Ica"
                  },
                  {
                    "JUN": "Junin"
                  },
                  {
                    "LAL": "La Libertad"
                  },
                  {
                    "LAM": "Lambayeque"
                  },
                  {
                    "LIM": "Lima"
                  },
                  {
                    "LOR": "Loreto"
                  },
                  {
                    "MDD": "Madre de Dios"
                  },
                  {
                    "MOQ": "Moquegua"
                  },
                  {
                    "PAS": "Pasco"
                  },
                  {
                    "PIU": "Piura"
                  },
                  {
                    "PUN": "Puno"
                  },
                  {
                    "SAM": "San Martin"
                  },
                  {
                    "TAC": "Tacna"
                  },
                  {
                    "TUM": "Tumbes"
                  },
                  {
                    "UCA": "Ucayali"
                  }
                ]
              }
            },
            {
              "localityname": {
                "label": "District"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Philippines",
      "iso": "PH",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "dependent_localityname": {
                "label": "Suburb"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Pitcairn",
      "iso": "PN",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Poland",
      "iso": "PL",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{2}-?\\d{3}$",
                "eg": "00-950"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Portugal",
      "iso": "PT",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{4}-?\\d{3}$",
                "eg": "2725-079"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Puerto Rico",
      "iso": "PR",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "ZIP code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Qatar",
      "iso": "QA",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Reunion",
      "iso": "RE",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^9[78]4\\d{2}$",
                "eg": "97400"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Romania",
      "iso": "RO",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Russia",
      "iso": "RU",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "MOW": "Moskva"
                  },
                  {
                    "SPE": "Sankt-Peterburg"
                  },
                  {
                    "AD": "Adygeya, Respublika"
                  },
                  {
                    "AL": "Altay, Respublika"
                  },
                  {
                    "BA": "Bashkortostan, Respublika"
                  },
                  {
                    "BU": "Buryatiya, Respublika"
                  },
                  {
                    "CE": "Chechenskaya Respublika"
                  },
                  {
                    "CU": "Chuvashskaya Respublika"
                  },
                  {
                    "DA": "Dagestan, Respublika"
                  },
                  {
                    "IN": "Ingushetiya, Respublika"
                  },
                  {
                    "KB": "Kabardino-Balkarskaya Respublika"
                  },
                  {
                    "KL": "Kalmykiya, Respublika"
                  },
                  {
                    "KC": "Karachayevo-Cherkesskaya Respublika"
                  },
                  {
                    "KR": "Kareliya, Respublika"
                  },
                  {
                    "KK": "Khakasiya, Respublika"
                  },
                  {
                    "KO": "Komi, Respublika"
                  },
                  {
                    "ME": "Mariy El, Respublika"
                  },
                  {
                    "MO": "Mordoviya, Respublika"
                  },
                  {
                    "SA": "Sakha, Respublika [Yakutiya]"
                  },
                  {
                    "SE": "Severnaya Osetiya-Alaniya, Respublika"
                  },
                  {
                    "TA": "Tatarstan, Respublika"
                  },
                  {
                    "TY": "Tyva, Respublika [Tuva]"
                  },
                  {
                    "UD": "Udmurtskaya Respublika"
                  },
                  {
                    "ALT": "Altayskiy kray"
                  },
                  {
                    "KAM": "Kamchatskiy kray"
                  },
                  {
                    "KHA": "Khabarovskiy kray"
                  },
                  {
                    "KDA": "Krasnodarskiy kray"
                  },
                  {
                    "KYA": "Krasnoyarskiy kray"
                  },
                  {
                    "PER": "Permskiy kray"
                  },
                  {
                    "PRI": "Primorskiy kray"
                  },
                  {
                    "STA": "Stavropolskiy kray"
                  },
                  {
                    "ZAB": "Zabaykalskiy kray"
                  },
                  {
                    "AMU": "Amurskaya oblast"
                  },
                  {
                    "ARK": "Arkhangelskaya oblast"
                  },
                  {
                    "AST": "Astrakhanskaya oblast"
                  },
                  {
                    "BEL": "Belgorodskaya oblast"
                  },
                  {
                    "BRY": "Bryanskaya oblast"
                  },
                  {
                    "CHE": "Chelyabinskaya oblast"
                  },
                  {
                    "IRK": "Irkutskaya oblast"
                  },
                  {
                    "IVA": "Ivanovskaya oblast"
                  },
                  {
                    "KGD": "Kaliningradskaya oblast"
                  },
                  {
                    "KLU": "Kaluzhskaya oblast"
                  },
                  {
                    "KEM": "Kemerovskaya oblast"
                  },
                  {
                    "KIR": "Kirovskaya oblast"
                  },
                  {
                    "KOS": "Kostromskaya oblast"
                  },
                  {
                    "KGN": "Kurganskaya oblast"
                  },
                  {
                    "KRS": "Kurskaya oblast"
                  },
                  {
                    "LEN": "Leningradskaya oblast"
                  },
                  {
                    "LIP": "Lipetskaya oblast"
                  },
                  {
                    "MAG": "Magadanskaya oblast"
                  },
                  {
                    "MOS": "Moskovskaya oblast"
                  },
                  {
                    "MUR": "Murmanskaya oblast"
                  },
                  {
                    "NIZ": "Nizhegorodskaya oblast"
                  },
                  {
                    "NGR": "Novgorodskaya oblast"
                  },
                  {
                    "NVS": "Novosibirskaya oblast"
                  },
                  {
                    "OMS": "Omskaya oblast"
                  },
                  {
                    "ORE": "Orenburgskaya oblast"
                  },
                  {
                    "ORL": "Orlovskaya oblast"
                  },
                  {
                    "PNZ": "Penzenskaya oblast"
                  },
                  {
                    "PSK": "Pskovskaya oblast"
                  },
                  {
                    "ROS": "Rostovskaya oblast"
                  },
                  {
                    "RYA": "Ryazanskaya oblast"
                  },
                  {
                    "SAK": "Sakhalinskaya oblast"
                  },
                  {
                    "SAM": "Samarskaya oblast"
                  },
                  {
                    "SAR": "Saratovskaya oblast"
                  },
                  {
                    "SMO": "Smolenskaya oblast"
                  },
                  {
                    "SVE": "Sverdlovskaya oblast"
                  },
                  {
                    "TAM": "Tambovskaya oblast"
                  },
                  {
                    "TOM": "Tomskaya oblast"
                  },
                  {
                    "TUL": "Tulskaya oblast"
                  },
                  {
                    "TVE": "Tverskaya oblast"
                  },
                  {
                    "TYU": "Tyumenskaya oblast"
                  },
                  {
                    "ULY": "Ulyanovskaya oblast"
                  },
                  {
                    "VLA": "Vladimirskaya oblast"
                  },
                  {
                    "VGG": "Volgogradskaya oblast"
                  },
                  {
                    "VLG": "Vologodskaya oblast"
                  },
                  {
                    "VOR": "Voronezhskaya oblast"
                  },
                  {
                    "YAR": "Yaroslavskaya oblast"
                  },
                  {
                    "YEV": "Yevreyskaya avtonomnaya oblast"
                  },
                  {
                    "CHU": "Chukotskiy avtonomnyy okrug"
                  },
                  {
                    "KHM": "Khanty-Mansiyskiy avtonomnyy okrug-Yugra"
                  },
                  {
                    "NEN": "Nenetskiy avtonomnyy okrug"
                  },
                  {
                    "YAN": "Yamalo-Nenetskiy avtonomnyy okrug"
                  }
                ]
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Rwanda",
      "iso": "RW",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Saint BarthÈlemy",
      "iso": "BL",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^9[78][01]\\d{2}$",
                "eg": "97100"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Saint Helena",
      "iso": "SH",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^(ASCN|STHL)[ ]?1ZZ$",
                "eg": "STHL 1ZZ"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Saint Kitts and Nevis",
      "iso": "KN",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Island"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Saint Lucia",
      "iso": "LC",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Saint Martin (French part)",
      "iso": "MF",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^9[78][01]\\d{2}$",
                "eg": "97100"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Saint Pierre and Miquelon",
      "iso": "PM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^9[78]5\\d{2}$",
                "eg": "97500"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Saint Vincent and the Grenadines",
      "iso": "VC",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Samoa",
      "iso": "WS",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "San Marino",
      "iso": "SM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Sao Tome and Principe",
      "iso": "ST",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Saudi Arabia",
      "iso": "SA",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Senegal",
      "iso": "SN",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Serbia",
      "iso": "RS",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Seychelles",
      "iso": "SC",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Island"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Sierra Leone",
      "iso": "SL",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Singapore",
      "iso": "SG",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{6}$",
                "eg": "238880"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Slovakia",
      "iso": "SK",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Slovenia",
      "iso": "SI",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Solomon Islands",
      "iso": "SB",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Somalia",
      "iso": "SO",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "South Africa",
      "iso": "ZA",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "Eastern Cape": "Eastern Cape"
                  },
                  {
                    "Free State": "Free State"
                  },
                  {
                    "Gauteng": "Gauteng"
                  },
                  {
                    "KwaZulu-Natal": "KwaZulu-Natal"
                  },
                  {
                    "Limpopo": "Limpopo"
                  },
                  {
                    "Mpumalanga": "Mpumalanga"
                  },
                  {
                    "North West": "North West"
                  },
                  {
                    "Northern Cape": "Northern Cape"
                  },
                  {
                    "Western Cape": "Western Cape"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "label": "South Georgia and the South Sandwich Islands",
      "iso": "GS",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "South Korea",
      "iso": "KR",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "dependent_localityname": {
                "label": "District"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "Seoul": "Seoul"
                  },
                  {
                    "Busan": "Busan"
                  },
                  {
                    "Daegu": "Daegu"
                  },
                  {
                    "Daejeon": "Daejeon"
                  },
                  {
                    "Gwangju": "Gwangju"
                  },
                  {
                    "Incheon": "Incheon"
                  },
                  {
                    "Ulsan": "Ulsan"
                  },
                  {
                    "Chungcheongbuk-do": "Chungcheongbuk-do"
                  },
                  {
                    "Chungcheongnam-do": "Chungcheongnam-do"
                  },
                  {
                    "Gangwon-do": "Gangwon-do"
                  },
                  {
                    "Gyeonggi-do": "Gyeonggi-do"
                  },
                  {
                    "Gyeongsangbuk-do": "Gyeongsangbuk-do"
                  },
                  {
                    "Gyeongsangnam-do": "Gyeongsangnam-do"
                  },
                  {
                    "Jeju-do": "Jeju-do"
                  },
                  {
                    "Jeollabuk-do": "Jeollabuk-do"
                  },
                  {
                    "Jeollanam-do": "Jeollanam-do"
                  },
                  {
                    "Sejong": "Sejong"
                  }
                ]
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Spain",
      "iso": "ES",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "C": "A Coruña"
                  },
                  {
                    "VI": "Alava"
                  },
                  {
                    "AB": "Albacete"
                  },
                  {
                    "A": "Alicante"
                  },
                  {
                    "AL": "Almería"
                  },
                  {
                    "O": "Asturias"
                  },
                  {
                    "AV": "Ávila"
                  },
                  {
                    "BA": "Badajoz"
                  },
                  {
                    "PM": "Baleares"
                  },
                  {
                    "B": "Barcelona"
                  },
                  {
                    "BU": "Burgos"
                  },
                  {
                    "CC": "Cáceres"
                  },
                  {
                    "CA": "Cádiz"
                  },
                  {
                    "S": "Cantabria"
                  },
                  {
                    "CS": "Castellón"
                  },
                  {
                    "CE": "Ceuta"
                  },
                  {
                    "CR": "Ciudad Real"
                  },
                  {
                    "CO": "Córdoba"
                  },
                  {
                    "CU": "Cuenca"
                  },
                  {
                    "GI": "Gerona"
                  },
                  {
                    "GR": "Granada"
                  },
                  {
                    "GU": "Guadalajara"
                  },
                  {
                    "SS": "Guipúzcoa"
                  },
                  {
                    "H": "Huelva"
                  },
                  {
                    "HU": "Huesca"
                  },
                  {
                    "J": "Jaén"
                  },
                  {
                    "LO": "La Rioja"
                  },
                  {
                    "GC": "Las Palmas"
                  },
                  {
                    "LE": "León"
                  },
                  {
                    "L": "Lérida"
                  },
                  {
                    "LU": "Lugo"
                  },
                  {
                    "M": "Madrid"
                  },
                  {
                    "MA": "Málaga"
                  },
                  {
                    "ML": "Melilla"
                  },
                  {
                    "MU": "Murcia"
                  },
                  {
                    "NA": "Navarra"
                  },
                  {
                    "OR": "Ourense"
                  },
                  {
                    "P": "Palencia"
                  },
                  {
                    "PO": "Pontevedra"
                  },
                  {
                    "SA": "Salamanca"
                  },
                  {
                    "TF": "Santa Cruz de Tenerife"
                  },
                  {
                    "SG": "Segovia"
                  },
                  {
                    "SE": "Sevilla"
                  },
                  {
                    "SO": "Soria"
                  },
                  {
                    "T": "Tarragona"
                  },
                  {
                    "TE": "Teruel"
                  },
                  {
                    "TO": "Toledo"
                  },
                  {
                    "V": "Valencia"
                  },
                  {
                    "VA": "Valladolid"
                  },
                  {
                    "BI": "Vizcaya"
                  },
                  {
                    "ZA": "Zamora"
                  },
                  {
                    "Z": "Zaragoza"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Sri Lanka",
      "iso": "LK",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Sudan",
      "iso": "SD",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Suriname",
      "iso": "SR",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Svalbard and Jan Mayen",
      "iso": "SJ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{4}$",
                "eg": "9170"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Swaziland",
      "iso": "SZ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Sweden",
      "iso": "SE",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{3}[ ]?\\d{2}$",
                "eg": "11455"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Switzerland",
      "iso": "CH",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{4}$",
                "eg": "2544"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Syria",
      "iso": "SY",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Taiwan",
      "iso": "TW",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^\\d{3}(\\d{2})?$",
                "eg": "100"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "TXG": "Taichung City"
                  },
                  {
                    "TPE": "Taipei City"
                  },
                  {
                    "TTT": "Taitung County"
                  },
                  {
                    "TNN": "Tainan City"
                  },
                  {
                    "ILA": "Yilan County"
                  },
                  {
                    "HUA": "Hualien County"
                  },
                  {
                    "Kinmen County": "Kinmen County"
                  },
                  {
                    "NAN": "Nantou County"
                  },
                  {
                    "PIF": "Pingtung County"
                  },
                  {
                    "MIA": "Miaoli County"
                  },
                  {
                    "TAO": "Taoyuan County"
                  },
                  {
                    "KHH": "Kaohsiung City"
                  },
                  {
                    "KEE": "Keelung City"
                  },
                  {
                    "Lienchiang County": "Lienchiang County"
                  },
                  {
                    "YUN": "Yunlin County"
                  },
                  {
                    "TPQ": "New Taipei City"
                  },
                  {
                    "HSZ": "Hsinchu City"
                  },
                  {
                    "HSQ": "Hsinchu County"
                  },
                  {
                    "CYI": "Chiayi City"
                  },
                  {
                    "CYQ": "Chiayi County"
                  },
                  {
                    "CHA": "Changhua County"
                  },
                  {
                    "PEN": "Penghu County"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Tajikistan",
      "iso": "TJ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Tanzania",
      "iso": "TZ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Thailand",
      "iso": "TH",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "dependent_localityname": {
                "label": "Suburb"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Province"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Timor-Leste",
      "iso": "TL",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Togo",
      "iso": "TG",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Tokelau",
      "iso": "TK",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Tonga",
      "iso": "TO",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Trinidad and Tobago",
      "iso": "TT",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Tunisia",
      "iso": "TN",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Turkey",
      "iso": "TR",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "administrativearea": {
                "label": "Province",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "Adana": "Adana"
                  },
                  {
                    "Adıyaman": "Adıyaman"
                  },
                  {
                    "Afyon": "Afyon"
                  },
                  {
                    "Ağrı": "Ağrı"
                  },
                  {
                    "Aksaray": "Aksaray"
                  },
                  {
                    "Amasya": "Amasya"
                  },
                  {
                    "Ankara": "Ankara"
                  },
                  {
                    "Antalya": "Antalya"
                  },
                  {
                    "Ardahan": "Ardahan"
                  },
                  {
                    "Artvin": "Artvin"
                  },
                  {
                    "Aydın": "Aydın"
                  },
                  {
                    "Balıkesir": "Balıkesir"
                  },
                  {
                    "Bartın": "Bartın"
                  },
                  {
                    "Batman": "Batman"
                  },
                  {
                    "Bayburt": "Bayburt"
                  },
                  {
                    "Bilecik": "Bilecik"
                  },
                  {
                    "Bingöl": "Bingöl"
                  },
                  {
                    "Bitlis": "Bitlis"
                  },
                  {
                    "Bolu": "Bolu"
                  },
                  {
                    "Burdur": "Burdur"
                  },
                  {
                    "Bursa": "Bursa"
                  },
                  {
                    "Çanakkale": "Çanakkale"
                  },
                  {
                    "Çankırı": "Çankırı"
                  },
                  {
                    "Çorum": "Çorum"
                  },
                  {
                    "Denizli": "Denizli"
                  },
                  {
                    "Diyarbakır": "Diyarbakır"
                  },
                  {
                    "Düzce": "Düzce"
                  },
                  {
                    "Edirne": "Edirne"
                  },
                  {
                    "Elazığ": "Elazığ"
                  },
                  {
                    "Erzincan": "Erzincan"
                  },
                  {
                    "Erzurum": "Erzurum"
                  },
                  {
                    "Eskişehir": "Eskişehir"
                  },
                  {
                    "Gaziantep": "Gaziantep"
                  },
                  {
                    "Giresun": "Giresun"
                  },
                  {
                    "Gümüşhane": "Gümüşhane"
                  },
                  {
                    "Hakkari": "Hakkari"
                  },
                  {
                    "Hatay": "Hatay"
                  },
                  {
                    "Iğdır": "Iğdır"
                  },
                  {
                    "Isparta": "Isparta"
                  },
                  {
                    "İstanbul": "İstanbul"
                  },
                  {
                    "İzmir": "İzmir"
                  },
                  {
                    "Kahramanmaraş": "Kahramanmaraş"
                  },
                  {
                    "Karabük": "Karabük"
                  },
                  {
                    "Karaman": "Karaman"
                  },
                  {
                    "Kars": "Kars"
                  },
                  {
                    "Kastamonu": "Kastamonu"
                  },
                  {
                    "Kayseri": "Kayseri"
                  },
                  {
                    "Kırıkkale": "Kırıkkale"
                  },
                  {
                    "Kırklareli": "Kırklareli"
                  },
                  {
                    "Kırşehir": "Kırşehir"
                  },
                  {
                    "Kilis": "Kilis"
                  },
                  {
                    "Kocaeli": "Kocaeli"
                  },
                  {
                    "Konya": "Konya"
                  },
                  {
                    "Kütahya": "Kütahya"
                  },
                  {
                    "Malatya": "Malatya"
                  },
                  {
                    "Manisa": "Manisa"
                  },
                  {
                    "Mardin": "Mardin"
                  },
                  {
                    "Mersin": "Mersin"
                  },
                  {
                    "Muğla": "Muğla"
                  },
                  {
                    "Muş": "Muş"
                  },
                  {
                    "Nevşehir": "Nevşehir"
                  },
                  {
                    "Niğde": "Niğde"
                  },
                  {
                    "Ordu": "Ordu"
                  },
                  {
                    "Osmaniye": "Osmaniye"
                  },
                  {
                    "Rize": "Rize"
                  },
                  {
                    "Sakarya": "Sakarya"
                  },
                  {
                    "Samsun": "Samsun"
                  },
                  {
                    "Siirt": "Siirt"
                  },
                  {
                    "Sinop": "Sinop"
                  },
                  {
                    "Sivas": "Sivas"
                  },
                  {
                    "Şanlıurfa": "Şanlıurfa"
                  },
                  {
                    "Şırnak": "Şırnak"
                  },
                  {
                    "Tekirdağ": "Tekirdağ"
                  },
                  {
                    "Tokat": "Tokat"
                  },
                  {
                    "Trabzon": "Trabzon"
                  },
                  {
                    "Tunceli": "Tunceli"
                  },
                  {
                    "Uşak": "Uşak"
                  },
                  {
                    "Van": "Van"
                  },
                  {
                    "Yalova": "Yalova"
                  },
                  {
                    "Yozgat": "Yozgat"
                  },
                  {
                    "Zonguldak": "Zonguldak"
                  }
                ]
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Turkmenistan",
      "iso": "TM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Turks and Caicos Islands",
      "iso": "TC",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Tuvalu",
      "iso": "TV",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Island",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "Funafuti": "Funafuti"
                  },
                  {
                    "Funafuti Centre": "Funafuti Centre"
                  },
                  {
                    "Nanumaga": "Nanumaga"
                  },
                  {
                    "Nanumea": "Nanumea"
                  },
                  {
                    "Niulakita": "Niulakita"
                  },
                  {
                    "Niutao": "Niutao"
                  },
                  {
                    "Nui": "Nui"
                  },
                  {
                    "Nukulaelae": "Nukulaelae"
                  },
                  {
                    "Vaitupu": "Vaitupu"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "label": "U.S. Virgin Islands",
      "iso": "VI",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Uganda",
      "iso": "UG",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Ukraine",
      "iso": "UA",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "Region"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "United Arab Emirates",
      "iso": "AE",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "administrativearea": {
                "label": "Emirate",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "AZ": "Abu Dhabi"
                  },
                  {
                    "FU": "Fujairah"
                  },
                  {
                    "UQ": "Umm al-Quwain"
                  },
                  {
                    "SH": "Sharjah"
                  },
                  {
                    "DU": "Dubai"
                  },
                  {
                    "RK": "Ras al-Khaimah"
                  },
                  {
                    "AJ": "Ajmān"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "label": "United Kingdom",
      "iso": "GB",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "Town/city"
              }
            },
            {
              "administrativearea": {
                "label": "County"
              }
            },
            {
              "postalcode": {
                "label": "Postcode",
                "format": "^GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|BX|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\\d{1,4}$",
                "eg": "SE1 0SU"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "United States",
      "iso": "US",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "AL": "Alabama"
                  },
                  {
                    "AK": "Alaska"
                  },
                  {
                    "AZ": "Arizona"
                  },
                  {
                    "AR": "Arkansas"
                  },
                  {
                    "CA": "California"
                  },
                  {
                    "CO": "Colorado"
                  },
                  {
                    "CT": "Connecticut"
                  },
                  {
                    "DE": "Delaware"
                  },
                  {
                    "DC": "District Of Columbia"
                  },
                  {
                    "FL": "Florida"
                  },
                  {
                    "GA": "Georgia"
                  },
                  {
                    "HI": "Hawaii"
                  },
                  {
                    "ID": "Idaho"
                  },
                  {
                    "IL": "Illinois"
                  },
                  {
                    "IN": "Indiana"
                  },
                  {
                    "IA": "Iowa"
                  },
                  {
                    "KS": "Kansas"
                  },
                  {
                    "KY": "Kentucky"
                  },
                  {
                    "LA": "Louisiana"
                  },
                  {
                    "ME": "Maine"
                  },
                  {
                    "MD": "Maryland"
                  },
                  {
                    "MA": "Massachusetts"
                  },
                  {
                    "MI": "Michigan"
                  },
                  {
                    "MN": "Minnesota"
                  },
                  {
                    "MS": "Mississippi"
                  },
                  {
                    "MO": "Missouri"
                  },
                  {
                    "MT": "Montana"
                  },
                  {
                    "NE": "Nebraska"
                  },
                  {
                    "NV": "Nevada"
                  },
                  {
                    "NH": "New Hampshire"
                  },
                  {
                    "NJ": "New Jersey"
                  },
                  {
                    "NM": "New Mexico"
                  },
                  {
                    "NY": "New York"
                  },
                  {
                    "NC": "North Carolina"
                  },
                  {
                    "ND": "North Dakota"
                  },
                  {
                    "OH": "Ohio"
                  },
                  {
                    "OK": "Oklahoma"
                  },
                  {
                    "OR": "Oregon"
                  },
                  {
                    "PA": "Pennsylvania"
                  },
                  {
                    "RI": "Rhode Island"
                  },
                  {
                    "SC": "South Carolina"
                  },
                  {
                    "SD": "South Dakota"
                  },
                  {
                    "TN": "Tennessee"
                  },
                  {
                    "TX": "Texas"
                  },
                  {
                    "UT": "Utah"
                  },
                  {
                    "VT": "Vermont"
                  },
                  {
                    "VA": "Virginia"
                  },
                  {
                    "WA": "Washington"
                  },
                  {
                    "WV": "West Virginia"
                  },
                  {
                    "WI": "Wisconsin"
                  },
                  {
                    "WY": "Wyoming"
                  },
                  {
                    "": "--"
                  },
                  {
                    "AA": "Armed Forces (Americas)"
                  },
                  {
                    "AE": "Armed Forces (Europe, Canada, Middle East, Africa)"
                  },
                  {
                    "AP": "Armed Forces (Pacific)"
                  },
                  {
                    "AS": "American Samoa"
                  },
                  {
                    "FM": "Federated States of Micronesia"
                  },
                  {
                    "GU": "Guam"
                  },
                  {
                    "MH": "Marshall Islands"
                  },
                  {
                    "MP": "Northern Mariana Islands"
                  },
                  {
                    "PW": "Palau"
                  },
                  {
                    "PR": "Puerto Rico"
                  },
                  {
                    "VI": "Virgin Islands"
                  }
                ]
              }
            },
            {
              "postalcode": {
                "label": "ZIP code",
                "format": "^\\d{5}(?:[-\\s]\\d{4})?$",
                "eg": "98103"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "United States Minor Outlying Islands",
      "iso": "UM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            },
            {
              "postalcode": {
                "label": "ZIP code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Uruguay",
      "iso": "UY",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Uzbekistan",
      "iso": "UZ",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Vanuatu",
      "iso": "VU",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Vatican",
      "iso": "VA",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Venezuela",
      "iso": "VE",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State",
                "options": [
                  {
                    "": "--"
                  },
                  {
                    "Z": "Amazonas"
                  },
                  {
                    "B": "Anzoátegui"
                  },
                  {
                    "C": "Apure"
                  },
                  {
                    "D": "Aragua"
                  },
                  {
                    "E": "Barinas"
                  },
                  {
                    "F": "Bolívar"
                  },
                  {
                    "G": "Carabobo"
                  },
                  {
                    "H": "Cojedes"
                  },
                  {
                    "Y": "Delta Amacuro"
                  },
                  {
                    "W": "Dependencias Federales"
                  },
                  {
                    "A": "Distrito Federal"
                  },
                  {
                    "I": "Falcón"
                  },
                  {
                    "J": "Guárico"
                  },
                  {
                    "K": "Lara"
                  },
                  {
                    "L": "Mérida"
                  },
                  {
                    "M": "Miranda"
                  },
                  {
                    "N": "Monagas"
                  },
                  {
                    "O": "Nueva Esparta"
                  },
                  {
                    "P": "Portuguesa"
                  },
                  {
                    "R": "Sucre"
                  },
                  {
                    "S": "Táchira"
                  },
                  {
                    "T": "Trujillo"
                  },
                  {
                    "X": "Vargas"
                  },
                  {
                    "U": "Yaracuy"
                  },
                  {
                    "V": "Zulia"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Vietnam",
      "iso": "VN",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            },
            {
              "administrativearea": {
                "label": "State"
              }
            },
            {
              "postalcode": {
                "label": "Postal code"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Wallis and Futuna",
      "iso": "WF",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code",
                "format": "^986\\d{2}$",
                "eg": "98600"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Western Sahara",
      "iso": "EH",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Yemen",
      "iso": "YE",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Zambia",
      "iso": "ZM",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "postalcode": {
                "label": "Postal code"
              }
            },
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    },
    {
      "label": "Zimbabwe",
      "iso": "ZW",
      "fields": [
        {
          "thoroughfare": {
            "label": "Address 1"
          }
        },
        {
          "premise": {
            "label": "Address 2"
          }
        },
        {
          "locality": [
            {
              "localityname": {
                "label": "City"
              }
            }
          ]
        }
      ]
    }
  ]
}

},{}]},{},["./src/app/index.js"]);
